{
  "common": {
    "knowledgeAreaInfo": {
      "tooltip": "Knowledge Areas Übersicht",
      "title": "Knowledge Areas",
      "description": "Verfügbare Bereiche mit Beschreibung",
      "noDescription": "Keine Beschreibung hinterlegt",
      "empty": "Keine Knowledge Areas verfügbar"
    },
    "changeLanguage": "Sprache ändern",
    "logout": "Abmelden",
    "reset": "Zurücksetzen",
    "search": "Suchen...",
    "resetting": "Zurücksetzen...",
    "loading": "Lädt...",
    "saving": "Speichert...",
    "back": "Zurück",
    "create": "Erstellen",
    "creating": "Erstelle...",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "deleting": "Lösche...",
    "close": "Schließen",
    "open": "Öffnen",
    "show": "Anzeigen",
    "hide": "Ausblenden",
    "on": "An",
    "off": "Aus",
    "actions": "Aktionen",
    "openMenu": "Menü öffnen",
    "copy": "Kopieren",
    "edit": "Bearbeiten",
    "delete": "Löschen",
    "locale": "de-DE",
    "select": "Auswählen...",
    "markAsRead": "Als gelesen markieren",
    "refresh": "Aktualisieren",
    "success": "Erfolgreich",
    "optional": "Optional",
    "add": "Hinzufügen",
    "copied": "In Zwischenablage kopiert",
    "copyFailed": "Kopieren fehlgeschlagen",
    "download": "Herunterladen",
    "of": "von",
    "noResults": "Keine Ergebnisse",
    "eyedropper": "Pipette verwenden",
    "eyedropperUnavailable": "Pipette nicht verfügbar",
    "currentColor": "Aktuelle Farbe",
    "autoVerifyTl1": "Auto-Verify TL1",
    "autoVerifyTl1Description": "Knoten und Kanten direkt als TL1 verifiziert markieren",
    "retry": "Erneut versuchen",
    "info": "Info",
    "error": "Fehler",
    "next": "Weiter",
    "done": "Fertig",
    "all": "Alle",
    "clear": "Leeren",
    "application": "Anwendung",
    "name": "Name",
    "description": "Beschreibung",
    "pleaseSelect": "Bitte wählen",
    "moveUp": "Nach oben",
    "moveDown": "Nach unten",
    "remove": "Entfernen",
    "zoomIn": "Vergrößern",
    "zoomOut": "Verkleinern",
    "zoomReset": "Originalgröße",
    "yes": "Ja",
    "no": "Nein",
    "justNow": "gerade eben",
    "showLess": "Weniger anzeigen",
    "showMore": "Mehr anzeigen",
    "scrollToTop": "Nach oben scrollen",
    "dragToMove": "Zum Verschieben ziehen",
    "switchToLightMode": "Zu hellem Modus wechseln",
    "switchToDarkMode": "Zu dunklem Modus wechseln"
  },
  "notifications": {
    "events": {
      "documentUploadCompletedTitle": "Dokument-Upload abgeschlossen",
      "documentUploadCompletedMessage": "Das Dokument \"{{documentTitle}}\" wurde erfolgreich hochgeladen.",
      "sessionAssignedTitle": "Neue Session zugewiesen",
      "sessionAssignedMessage": "Ihnen wurde die Session \"{{sessionTitle}}\" zugewiesen.",
      "sessionAssignedMessageWithDeadline": "Ihnen wurde die Session \"{{sessionTitle}}\" zugewiesen. Deadline: {{deadline}}.",
      "defaultSessionName": "Session",
      "promptSharedTitle": "Prompt erhalten",
      "promptSharedMessage": "Ihnen wurde der Prompt \"{{promptTitle}}\" geteilt.",
      "newBugReportTitle": "Neuer Bug-Report",
      "newBugReportMessage": "Ein neuer Bug-Report wurde eingereicht: „{{title}}“.",
      "newFeatureRequestTitle": "Neue Feature-Anfrage",
      "newFeatureRequestMessage": "Eine neue Feature-Anfrage wurde eingereicht: \"{{title}}\".",
      "documentUploadFailedTitle": "Upload unvollständig",
      "documentUploadFailedMessage": "{{failed}} von {{total}} Datei(en) nicht hochgeladen: {{files}}",
      "quotaRequestTitle": "Kontingent-Anfrage",
      "quotaRequestMessage": "{{name}} hat das Monatsbudget aufgebraucht und bittet um mehr Kontingent.",
      "quotaClientRequestTitle": "Client-Budget aufgebraucht",
      "quotaClientRequestMessage": "Für {{client}} wird eine Erhöhung des Client-Budgets angefragt.",
      "quotaApprovedTitle": "Kontingent freigegeben",
      "quotaApprovedMessage": "Ihr Kontingent wurde für diesen Monat erhöht. Sie können weiterarbeiten.",
      "quotaDeclinedTitle": "Kontingent-Anfrage abgelehnt",
      "quotaDeclinedMessage": "Ihre Anfrage nach mehr Kontingent wurde abgelehnt.",
      "processingNounVideo": "Video",
      "processingNounDocument": "Dokument",
      "processingCompletedTitle": "{{noun}} „{{name}}“ verarbeitet",
      "processingFailedTitle": "{{noun}} „{{name}}“ fehlgeschlagen",
      "processingCompletedTitleNoName": "{{noun}} verarbeitet",
      "processingFailedTitleNoName": "{{noun}} fehlgeschlagen",
      "processingCompletedMessage": "Im Bereich {{knowledgeArea}} durchsuchbar.",
      "processingFailedMessage": "Die Verarbeitung ist fehlgeschlagen.",
      "transcriptionCompletedTitle": "Transkript „{{name}}“ fertig",
      "transcriptionCompletedTitleNoName": "Transkript fertig",
      "transcriptionCompletedMessage": "Sie können das Transkript jetzt prüfen.",
      "transcriptionFailedTitle": "Transkript „{{name}}“ fehlgeschlagen",
      "transcriptionFailedTitleNoName": "Transkript fehlgeschlagen",
      "transcriptionFailedMessage": "Die Aufnahme konnte nicht transkribiert werden.",
      "bugReportReplyTitle": "Neue Antwort zu „{{reportTitle}}“",
      "bugReportReplyTitleNoName": "Neue Antwort zu einem Ticket",
      "bugReportReplyMessageActorExcerpt": "{{name}}: {{excerpt}}",
      "bugReportReplyMessageActor": "{{name}} hat geantwortet.",
      "bugReportStatusChangedTitle": "Status geändert: „{{reportTitle}}“",
      "bugReportStatusChangedTitleNoName": "Status eines Tickets geändert",
      "bugReportStatusChangedMessage": "Neuer Status: {{status}}",
      "bugReportStatusChangedMessageReason": "Neuer Status: {{status}} ({{reason}})",
      "bugReportStatus": {
        "open": "Offen",
        "in_progress": "In Arbeit",
        "waiting_for_reporter": "Rückfrage an Sie",
        "planned": "Geplant",
        "resolved": "Gelöst",
        "closed": "Geschlossen"
      },
      "bugReportCloseReason": {
        "done": "Erledigt",
        "declined": "Abgelehnt",
        "duplicate": "Duplikat",
        "not_a_bug": "Kein Bug",
        "no_response": "Keine Rückmeldung"
      },
      "bugReportTypeChangedTitle": "Neu eingestuft: „{{reportTitle}}“",
      "bugReportTypeChangedTitleNoName": "Ticket neu eingestuft",
      "bugReportTypeChangedMessage": "Als {{type}} eingestuft (vorher {{fromType}})",
      "bugReportType": {
        "bug": "Bug",
        "feature": "Wunsch"
      },
      "documentUploadBatchCompletedMessage": "{{count}} Datei(en) in „{{knowledgeArea}}“ hochgeladen",
      "reviewTasksTitle": "Prüfvorschläge",
      "reviewTasksMessage": "{{count}} neue Prüfvorschläge in „{{documentTitle}}“"
    }
  },
  "time": {
    "justNow": "Gerade eben",
    "minutesAgo": "Vor {{count}} Min",
    "hoursAgo": "Vor {{count}} Std",
    "daysAgo_one": "Vor {{count}} Tag",
    "daysAgo_other": "Vor {{count}} Tagen",
    "daysAgo": "vor {{count}} Tagen"
  },
  "error": {
    "noActiveSession": "Keine aktive Sitzung",
    "loadApiKeysFailed": "Fehler beim Laden der API-Schlüssel",
    "createApiKeyFailed": "Fehler beim Erstellen des API-Schlüssels",
    "loadingUsers": "Fehler beim Laden der Benutzer",
    "loadingAssignments": "Fehler beim Laden der Benutzerzuweisungen",
    "changingAssignment": "Fehler beim Ändern der Benutzerzuweisung. Siehe Konsole für Details."
  },
  "cortex": {
    "title": "Administration",
    "subtitle": "Benutzer- und App-Verwaltung",
    "tabError": {
      "title": "Bereich konnte nicht geladen werden",
      "message": "Dieser Tab ließ sich nicht laden — meist nach einem Update. Bitte die Seite neu laden.",
      "renderMessage": "Beim Anzeigen dieses Bereichs ist ein Fehler aufgetreten. Bitte melde ihn mit der Meldung unten.",
      "retry": "Neu laden"
    },
    "communicatorHub": {
      "tabs": {
        "tiers": "Tiers",
        "clients": "Clients",
        "skills": "Skills",
        "systems": "Verbundene Systeme",
        "diagnostics": "Diagnostik",
        "settings": "Einstellungen",
        "workflows": "Workflows",
        "benchmark": "Benchmark"
      },
      "skills": {
        "capabilityBadgeHint": "Zugriff wird über Capability-Tiering entschieden (Tiers-Tab) — zusätzlich zu den Rechten hier.",
        "apiKeyBadge": "API-Key",
        "apiKeyBadgeHint": "visibility: public — auch extern über API-Keys erreichbar (external_m2m-Manifest). Änderbar in Skills → Verwaltung.",
        "tabs": {
          "map": "Capability-Map",
          "management": "Verwaltung",
          "manifest": "Manifest"
        }
      },
      "tiers": {
        "title": "Capability-Tiers",
        "subtitle": "Welche Fähigkeiten ein Kunde bekommt — Zeilen aus der Code-Registry, Spalten frei editierbar. Clients ohne Zuweisung fallen auf das Minimal-Verhalten zurück.",
        "newTier": "Neuer Tier",
        "productFilterAll": "Alle Produkte",
        "capabilityColumn": "Capability",
        "systemTier": "System-Tier (nicht löschbar)",
        "assignedCount": "{{count}} Clients",
        "editMeta": "Name/Beschreibung bearbeiten",
        "duplicate": "Als Vorlage duplizieren",
        "saved": "Tier „{{name}}“ gespeichert",
        "saveError": "Speichern fehlgeschlagen",
        "deleted": "Tier „{{name}}“ gelöscht",
        "deleteError": "Löschen fehlgeschlagen",
        "loadError": "Tiers konnten nicht geladen werden.",
        "resetToUnset": "Zurück auf Plattform-Standard (unset)",
        "unsetHint": "In diesem Tier nicht gesetzt — es gilt der Plattform-Standard. Ändern setzt einen expliziten Wert.",
        "unsetMarker": "Std",
        "createTitle": "Neuen Tier anlegen",
        "editTitle": "Tier „{{name}}“ bearbeiten",
        "duplicateHint": "Capability-Werte werden aus der Vorlage übernommen.",
        "productLabel": "Produkt-Label (nur Editor-Filter)",
        "productAny": "— kein Label —",
        "deleteTitle": "Tier „{{name}}“ löschen?",
        "deleteHint": "Zugewiesene Tiers können nicht gelöscht werden — Clients vorher umziehen.",
        "groups": {
          "sources": "Quellen",
          "memory": "Gedächtnis",
          "generation": "Generierung",
          "models": "Modelle",
          "features": "Funktionen",
          "staff": "Staff",
          "connectors": "Verbundene Systeme"
        }
      },
      "clients": {
        "title": "Tier-Zuweisung",
        "subtitle": "Tier pro Client und Produkt. Ohne Zuweisung gilt das Minimal-Verhalten — Bestandskunden brauchen daher eine explizite Zuweisung. Overrides sind seltene Ausnahmen oberhalb des Tiers.",
        "clientColumn": "Client",
        "overridesColumn": "Overrides",
        "productGroup": "cdbChat",
        "productCdb": "OS",
        "productPdb": "Fokus",
        "productPortal": "Portal",
        "notBooked": "nicht gebucht (Minimal)",
        "inheritCdb": "erbt CDB",
        "assignError": "Zuweisung fehlgeschlagen",
        "loadError": "Client-Zuweisungen konnten nicht geladen werden.",
        "viewOverrides": "{{count}} ansehen",
        "addOverride": "Hinzufügen",
        "overridesTitle": "Overrides — {{name}}",
        "overridesHint": "Seltene Ausnahmen oberhalb des zugewiesenen Tiers. „Zurück auf Tier“ entfernt die Ausnahme.",
        "resetToTier": "Zurück auf Tier",
        "tierApplies": "Tier",
        "overrideCta": "Override setzen",
        "restrictionsTitle": "Skill-Rollen-Einschränkungen",
        "restrictionsHint": "Verengt einen Skill innerhalb dieses Clients auf bestimmte Rollen — andere Clients bleiben unberührt. Ohne gewählte Rolle gilt er für alle gesperrt. Zeile entfernen hebt die Einschränkung auf.",
        "restrictedToNobody": "Für alle gesperrt",
        "restrictNobodyCta": "Für alle sperren",
        "restrictNobodyHint": "Keine Rolle gewählt: niemand in diesem Client darf den Skill aufrufen. Admins bleiben ausgenommen.",
        "restrictSomeHint": "Nur Nutzer mit einer der gewählten Rollen dürfen den Skill aufrufen.",
        "noRestrictions": "Keine Einschränkungen — alle Skills gelten clientweit.",
        "removeRestriction": "Einschränkung aufheben",
        "addRestrictionLabel": "Skill einschränken (Upsert bei bestehender Zeile)",
        "pickSkill": "Skill wählen…",
        "noClientRoles": "Keine Rollen für diesen Client verfügbar.",
        "restrictCta": "Einschränken",
        "restrictionError": "Einschränkung konnte nicht gespeichert werden",
        "overrideError": "Override konnte nicht gespeichert werden"
      },
      "workflows": {
        "title": "Workflows",
        "subtitle": "Agent-Workflows sind feste Schrittketten über verbundene Systeme (Nachschlagen, Prüfen, Zuordnen, Rückfragen, Präsentieren). Jeder aktive Workflow ist in cdbChat ein eigenes Werkzeug (wf__<slug>), das der Server ausführt; das Modell liefert die Eingaben und präsentiert das Ergebnis. Die Kette wird hier als JSON gepflegt und per Dry-Run gegen die echte Quelle getestet. Sichtbar nur für Clients mit der Capability features.agent_workflows.",
        "clientScope": {
          "label": "Client",
          "own": "Eigener Client",
          "hint": "Zeigt die Workflows und Pakete dieses Clients und die globalen, die jeder Client sieht."
        },
        "empty": "Noch keine Workflows. Lege einen aus einer Vorlage an.",
        "confirmDelete": "Workflow „{{name}}“ wirklich löschen?",
        "scopeLabel": "Sichtbarkeit",
        "scope": {
          "user": "Nur ich",
          "client": "Meine Organisation",
          "global": "Alle Organisationen"
        },
        "scopeBlocked": {
          "current": "bereits dort",
          "uploaderOnly": "nur der Ersteller"
        },
        "columns": {
          "name": "Name",
          "tool": "Werkzeug",
          "version": "Version",
          "active": "Aktiv",
          "enabled": "Eingeschaltet",
          "actions": "Aktionen",
          "audience": "Sichtbar für"
        },
        "fields": {
          "name": "Name",
          "slug": "Kurzname (Slug)",
          "slugHint": "Werkzeugname im Chat: {{tool}}",
          "description": "Beschreibung für das Modell",
          "descriptionHint": "Das liest das Modell, um zu entscheiden, wann es den Workflow aufruft. Nenne Zweck und typische Formulierungen. {{count}}/1024 Zeichen."
        },
        "create": {
          "button": "Neuer Workflow",
          "title": "Workflow anlegen",
          "description": "Aus einer Vorlage oder leer. Die Schrittkette bearbeitest du danach in der Detailansicht.",
          "template": "Vorlage",
          "blank": "Leer (Grundgerüst)",
          "confirm": "Anlegen",
          "ai": {
            "modeManual": "Leer oder Vorlage",
            "modeAi": "Mit KI entwerfen",
            "text": "Beschreibe den Workflow in einem Satz",
            "textPlaceholder": "z. B. Angebotsvorschlag: Kunde und Artikel suchen, Sperren prüfen, Kopf und Zeile befüllen",
            "language": "Sprache der Definition",
            "sources": "Quellen",
            "sourcesNone": "Keine abfragbaren Quellen. Ohne Quelle entsteht keine Kette.",
            "sourcesHint": "Keine Auswahl = alle Quellen.",
            "tables": "({{count}} Tabellen)",
            "draft": "Entwerfen",
            "redraft": "Neu entwerfen",
            "invalidTitle": "Der Entwurf war nicht gültig",
            "retryHint": "Beschreibe den Ablauf genauer oder versuche es noch einmal.",
            "refineLabel": "Was soll anders sein?",
            "refinePlaceholder": "z. B. „Suche über den Namen, nicht über den Kontakt, und nimm den Preis in die Zeile.“",
            "refine": "Anpassen",
            "fixNotes": "Diese Hinweise beheben",
            "stepsTitle": "Vorgeschlagene Schritte ({{count}})",
            "notesTitle": "Hinweise zum Entwurf",
            "presentLabel": "Ergebnis",
            "confirm": "Als Entwurf anlegen"
          }
        },
        "publish": {
          "button": "Veröffentlichen",
          "title": "Sichtbarkeit ändern",
          "description": "Wo soll „{{name}}“ sichtbar sein?",
          "hint": "Veröffentlichen ist eine Entscheidung, keine Bearbeitung: In der Organisation sehen alle Nutzer das Werkzeug im Chat, sobald es aktiv ist.",
          "confirm": "Übernehmen"
        },
        "detail": {
          "versionHint": "Speichern von Kette, Eingaben oder Slug erhöht die Version.",
          "activeHint": "Aktiv = im Manifest der Nutzer, die den Workflow sehen dürfen.",
          "enabledHint": "Ausgeschaltet bleibt der Workflow erhalten, erscheint aber nicht im Chat.",
          "saveChainFirst": "Erst die Änderungen am Ablauf speichern, dann Name, Kurzname oder Beschreibung.",
          "audienceHint": "„Nur über Pakete“: nur wer eine Rolle mit einem Paket dieses Workflows hat. „Alle im Bereich“: jeder im Client bzw. alle bei globalen Workflows."
        },
        "runs": {
          "empty": "Noch keine Läufe. Jeder Aufruf aus dem Chat erscheint hier mit seinen Schritten.",
          "loadFailed": "Läufe konnten nicht geladen werden.",
          "failed": "Fehler",
          "noInputs": "keine Eingaben",
          "question": "Rückfrage",
          "candidates": "({{n}} Kandidaten)",
          "resolutions": "Angewendete Antworten",
          "warnings": "Hinweise",
          "errors": "Fehler",
          "showInvocations": "Aufrufe dieses Turns"
        },
        "dryRun": {
          "run": "Dry-Run starten",
          "hint": "Läuft gegen die echte Quelle als du selbst, liest nur.",
          "noInputs": "Dieser Workflow deklariert keine Eingaben.",
          "resolutions": "Antworten auf Rückfragen (resolutions)",
          "resolutionPlaceholder": "Wert aus der Rückfrage",
          "trace": "Schritte",
          "status": {
            "completed": "abgeschlossen",
            "aborted": "abgebrochen",
            "needs_input": "Rückfrage",
            "needs_connection": "Konto verbinden"
          },
          "freeAnswer": "Freitext-Antwort: oben unter „{{key}}“ eintragen und erneut starten.",
          "columns": {
            "field": "Feld",
            "value": "Wert",
            "origin": "Herkunft",
            "note": "Hinweis"
          },
          "warnings": "Hinweise",
          "llmSummary": "Was das Modell liest (llm_summary)",
          "knowledge": "Wissen: {{label}} ({{area}})",
          "knowledgeQuery": "Suche: {{query}}",
          "knowledgeEmpty": "Keine Textstellen gefunden.",
          "instructions": "Schreibanweisung an das Modell",
          "source": {
            "graph": "Wissensgraph, ungeprüft",
            "fact": "Wissensgraph, verifiziert"
          },
          "artifact": "Dokument: {{name}}",
          "artifactHint": "Im Testlauf entsteht keine Datei. So sieht der Auftrag aus, den das Modell im Chat bekommt.",
          "artifactContext": "Ergebnisse, die das Modell liest ({{n}} Zeichen)",
          "jsonInvalid": "Kein gültiges JSON ({{type}}) – so startet der Test nicht.",
          "jsonHint": "JSON erwartet ({{type}}).",
          "applied": "{{n}} Werte vom Nutzer übernommen.",
          "resetOverrides": "Bestätigungen zurücksetzen"
        },
        "toasts": {
          "created": "Workflow angelegt",
          "createFailed": "Anlegen fehlgeschlagen",
          "updateFailed": "Speichern fehlgeschlagen",
          "deleted": "Workflow gelöscht",
          "deleteFailed": "Löschen fehlgeschlagen",
          "moved": "Sichtbarkeit geändert",
          "moveFailed": "Sichtbarkeit konnte nicht geändert werden"
        },
        "views": {
          "workflows": "Workflows",
          "packages": "Pakete"
        },
        "audience": {
          "packages": "Nur über Pakete",
          "scope": "Alle im Bereich",
          "personal": "Nur ich"
        },
        "packages": {
          "subtitle": "Ein Paket bündelt Workflows und wird Rollen zugewiesen – wie Wissensbereiche. Wer eine der Rollen hat, sieht alle Workflows des Pakets, die auf „Nur über Pakete“ stehen; alle anderen im Client sehen sie nicht.",
          "create": "Neues Paket",
          "name": "Name",
          "description": "Beschreibung",
          "scope": "Bereich",
          "client": "Client",
          "global": "Global",
          "empty": "Noch keine Pakete.",
          "counts": "{{workflows}} Workflows · {{roles}} Rollen",
          "confirmDelete": "Paket „{{name}}“ löschen? Die Workflows bleiben erhalten, nur die Zuordnung zu den Rollen entfällt.",
          "back": "Zurück zu den Paketen",
          "workflows": "Workflows im Paket",
          "workflowsHint": "Nur geteilte Workflows dieses Clients oder globale – persönliche lassen sich nicht in ein Paket legen.",
          "noWorkflows": "Keine passenden Workflows. Ein Workflow muss erst für den Client veröffentlicht werden.",
          "openHint": "Dieser Workflow ist für alle im Bereich sichtbar – das Paket schränkt ihn nicht ein.",
          "roles": "Rollen mit diesem Paket",
          "rolesHint": "Rollen dieses Clients oder globale Rollen.",
          "noRoles": "Keine passenden Rollen.",
          "users": "{{count}} Nutzer",
          "toasts": {
            "createFailed": "Paket konnte nicht angelegt werden",
            "deleteFailed": "Paket konnte nicht gelöscht werden",
            "saved": "Paket gespeichert",
            "saveFailed": "Paket konnte nicht gespeichert werden"
          }
        }
      },
      "benchmark": {
        "title": "Benchmark",
        "subtitle": "Misst cdbChat mit festen Testfragen: ob die Werkzeugwahl stimmt, wie lange jede Phase dauert, was ein Lauf kostet und wie ein KI-Prüfer die Antworten bewertet. Der Lauf läuft im TQS als Hintergrundauftrag.",
        "env": {
          "staging": "Staging",
          "production": "Production"
        },
        "switchedOff": {
          "title": "Benchmark ist auf dieser Umgebung nicht eingeschaltet",
          "body": "Das TQS beantwortet die Benchmark-Schnittstelle hier nicht. Ein Admin schaltet sie in den Einstellungen des TQS ein; danach diese Seite neu öffnen."
        },
        "loadError": "Der Benchmark konnte nicht geladen werden. Bitte später erneut öffnen.",
        "seed": {
          "button": "Testdaten anlegen",
          "result": "Testdaten im Wissensbereich „{{area}}“: {{created}} neu angelegt, {{existing}} schon vorhanden.",
          "failed": "Die Testdaten konnten nicht angelegt werden."
        },
        "form": {
          "title": "Neuer Lauf",
          "groups": "Fragengruppen",
          "presets": "Konfigurationen",
          "questions_one": "{{count}} Frage",
          "questions_other": "{{count}} Fragen",
          "presetsProductionHint": "Auf Production läuft nur „Heute“, also die eingesetzte Konfiguration. Andere Denkstufen sind dort gesperrt, damit kein Chat von Nutzern verändert werden kann.",
          "presetsOverridesOffHint": "Andere Konfigurationen sind auf dieser Umgebung ausgeschaltet. Ohne den Schalter für Denkstufen pro Anfrage läuft nur die eingesetzte Konfiguration.",
          "repeat": "Wiederholungen",
          "repeatHint": "1 bis {{max}}",
          "label": "Bezeichnung",
          "labelPlaceholder": "z. B. Routing low, 6 s",
          "start": "Lauf starten",
          "starting": "Wird gestartet …",
          "busy": "Solange ein Lauf aktiv ist, startet kein weiterer.",
          "pickBoth": "Mindestens eine Fragengruppe und eine Konfiguration wählen."
        },
        "estimate": {
          "loading": "Dauer und Kosten werden geschätzt …",
          "summary": "{{turns}} Durchläufe · etwa {{minutes}} Min. · etwa {{cost}} (Grenze {{cap}})",
          "notAllowed": "Start nicht möglich: {{reason}}",
          "notAllowedNoReason": "Start nicht möglich.",
          "failed": "Die Schätzung ist fehlgeschlagen. Ohne Schätzung startet kein Lauf."
        },
        "start": {
          "conflict": "Es läuft bereits ein Lauf. Ein neuer lässt sich erst danach starten.",
          "rejected": "Das TQS hat diesen Lauf abgelehnt. Auswahl prüfen und erneut schätzen lassen.",
          "failed": "Der Lauf konnte nicht gestartet werden."
        },
        "progress": {
          "title": "Aktueller Lauf",
          "queued": "Wartet auf den Start …",
          "count": "{{done}} von {{total}} Durchläufen",
          "currentGroup": "gerade: {{group}}",
          "leaveHint": "Die Seite darf geschlossen werden; der Lauf geht im Hintergrund weiter.",
          "cancel": "Lauf abbrechen",
          "cancelConfirm": "Diesen Lauf wirklich abbrechen? Bisherige Ergebnisse bleiben erhalten, der Rest wird nicht mehr gemessen.",
          "keepRunning": "Weiterlaufen lassen",
          "cancelFailed": "Der Lauf konnte nicht abgebrochen werden."
        },
        "result": {
          "title": "Ergebnis",
          "meta": {
            "started": "Gestartet",
            "finished": "Beendet",
            "commit": "Commit",
            "judgeModel": "KI-Prüfer",
            "repeat": "Wiederholungen"
          },
          "failed": "Der Lauf ist fehlgeschlagen.",
          "cancelled": "Der Lauf wurde abgebrochen.",
          "noResult": "Für diesen Lauf liegt kein Ergebnis vor.",
          "perPreset": "Je Konfiguration",
          "phaseHint": "Zeiten je Phase: p50 / p95 in Sekunden.",
          "perGroup": "Je Fragengruppe",
          "comparison": "Vergleich der Konfigurationen",
          "comparisonHint": "Der bessere Wert je Zeile ist hervorgehoben.",
          "better": "besserer Wert",
          "spotChecks": "Stichproben ({{count}})",
          "report": "Bericht anzeigen"
        },
        "spot": {
          "passed": "bestanden",
          "failed": "nicht bestanden",
          "answer": "Antwort",
          "tools": "Werkzeuge",
          "noTools": "Kein Werkzeug benutzt.",
          "judge": "Urteil des KI-Prüfers",
          "score": "Bewertung: {{score}}",
          "noJudge": "Nicht vom KI-Prüfer bewertet."
        },
        "columns": {
          "preset": "Konfiguration",
          "group": "Fragengruppe",
          "pass": "Bestanden",
          "cost": "Kosten",
          "judge": "KI-Prüfer Ø",
          "metric": "Kennzahl",
          "date": "Datum",
          "label": "Bezeichnung",
          "environment": "Umgebung",
          "status": "Status",
          "p50Total": "p50 gesamt",
          "actions": "Aktionen"
        },
        "phases": {
          "first_event": "Erstes Ereignis",
          "router_decision": "Routing",
          "first_tool": "Erstes Werkzeug",
          "first_token": "Erster Text",
          "total": "Gesamt"
        },
        "status": {
          "queued": "wartet",
          "running": "läuft",
          "done": "fertig",
          "failed": "fehlgeschlagen",
          "cancelled": "abgebrochen"
        },
        "history": {
          "title": "Bisherige Läufe",
          "empty": "Noch kein Lauf. Oben lässt sich der erste starten.",
          "openRun": "Lauf „{{label}}“ öffnen",
          "shown": "Angezeigt",
          "newer": "Neuere",
          "older": "Ältere",
          "range": "{{from}}–{{to}} von {{total}}"
        }
      },
      "soul": {
        "title": "Persönlichkeit des Assistenten (Soul)",
        "hint": "Definiert, wer der Assistent in cdbChat ist (Charakter, Werte, Stimme) — getrennt vom persönlichen Gedächtnis. Gilt plattformweit für alle Nutzer und wirkt sofort, ohne Deploy.",
        "body": {
          "label": "Persona (Markdown)"
        },
        "anchor": {
          "label": "Kern-Anker",
          "hint": "Die nicht verhandelbaren Zeilen werden am Ende des Prompts wiederholt (Schutz gegen Abdriften)."
        },
        "locale": {
          "de": "Deutsch",
          "en": "Englisch"
        },
        "version": "Version {{version}}",
        "save": "Speichern",
        "saved": "Soul gespeichert.",
        "saveError": "Speichern fehlgeschlagen.",
        "loadError": "Soul konnte nicht geladen werden."
      },
      "settings": {
        "routingTitle": "Routing-Strategie"
      }
    },
    "voiceAgent": {
      "title": "Voice Agent Widget",
      "settingsTitle": "Voice-Agent-Einstellungen",
      "settingsDescription": "Konfiguriere Transkriptions-Prompt, System-Prompt und Begrüßung für den Voice Agent je Client. System-Prompt und Begrüßung können in Deutsch und Englisch hinterlegt werden.",
      "selectClient": "Client auswählen",
      "selectClientPlaceholder": "Client auswählen...",
      "settingsFor": "Einstellungen für:",
      "errorTitle": "Fehler",
      "errorLoadClients": "Fehler beim Laden der Clients",
      "errorNoAuth": "Keine Authentifizierung",
      "errorLoadSettings": "Fehler beim Laden",
      "errorSelectClient": "Bitte wählen Sie zuerst einen Client aus",
      "errorSave": "Fehler beim Speichern",
      "savedTitle": "Gespeichert",
      "savedDescription": "Einstellungen wurden erfolgreich gespeichert",
      "tabs": {
        "transcription": "Transkriptions-Prompt",
        "system": "System-Prompt",
        "greeting": "Begrüßung"
      },
      "transcriptionLabel": "Transkriptions-Prompt",
      "transcriptionPlaceholder": "z.B. Domain-spezifische Begriffe, Firmennamen, Fachvokabular...",
      "transcriptionHint": "Hinweis für die Whisper-API, der die Genauigkeit der Transkription verbessert (z. B. Fachbegriffe). Wird für beide Sprachen verwendet.",
      "systemLabel": "System-Prompt",
      "systemPlaceholderDe": "Du bist ein hilfreicher Voice Assistant...",
      "systemPlaceholderEn": "You are a helpful voice assistant...",
      "systemHint": "Definiert das Verhalten und die Persönlichkeit des Voice Agents. Ist kein englischer Text hinterlegt, wird der deutsche Text als Fallback verwendet.",
      "greetingLabel": "Initiale Begrüßung",
      "greetingPlaceholderDe": "Hallo! Wie kann ich Ihnen heute helfen?",
      "greetingPlaceholderEn": "Hello! How can I help you today?",
      "greetingHint": "Erste Nachricht, die der Voice Agent beim Start einer Session sagt. Ist kein englischer Text hinterlegt, wird der deutsche Text als Fallback verwendet.",
      "save": "Speichern",
      "saving": "Speichere...",
      "reset": "Zurücksetzen",
      "unsavedChanges": "Ungespeicherte Änderungen"
    },
    "transcriptAssistant": {
      "title": "Transkript-Assistent",
      "infoTitle": "Transkript AI-Assistent Prompts",
      "infoDescription": "Lege System-Prompt und Schnellaktionen je Organisation fest. Ein leeres Feld verwendet den eingebauten Standardtext. Englisch gilt auch für Niederländisch; fehlt es, wird Deutsch verwendet.",
      "selectPrompt": "Prompt",
      "placeholder": "Leer: eingebauter Standardtext",
      "saved": "Einstellungen gespeichert",
      "errorLoad": "Die Einstellungen konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
      "errorSave": "Die Einstellungen konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.",
      "keys": {
        "system_prompt": "System-Prompt (bei allen Aktionen)",
        "shorten": "Zusammenfassung: Kürzen",
        "expand": "Zusammenfassung: Erweitern",
        "formal": "Zusammenfassung: Förmlich",
        "by_topic": "Zusammenfassung: Nach Themen",
        "cleanup": "Transkript: Bereinigen",
        "fix_terms": "Transkript: Begriffe korrigieren"
      }
    },
    "maintenance": {
      "title": "Wartung",
      "description": "Backend-Wartungsendpunkte manuell ausführen",
      "running": "Läuft...",
      "run": "Ausführen",
      "success": "Erfolgreich",
      "error": "Fehler",
      "cleanupDuplicates": {
        "name": "Doppelte Jobs bereinigen",
        "description": "Entfernt doppelte Jobs pro Dokument und behält nur den neuesten."
      }
    },
    "urls": {
      "title": "Portal URLs",
      "description": "Direkte Links zu den CDB OS Portalen",
      "noPassword": "Kein Passwort-Schutz",
      "loginRequired": "Benutzeranmeldung erforderlich",
      "password": "Passwort:",
      "hidePassword": "Passwort verbergen",
      "showPassword": "Passwort anzeigen",
      "copyPassword": "Passwort kopieren",
      "openPortal": "Portal öffnen"
    },
    "apiKeys": {
      "title": "API Keys",
      "tokenLimitInfo": "API-Key-Anfragen werden auf das monatliche Token-Limit des Kunden angerechnet. Wenn das Limit eines Kunden überschritten wird, werden auch API-Aufrufe für diesen Kunden blockiert.",
      "description": "API Keys für programmatischen Zugriff auf cdb_tqs Backend erstellen und verwalten",
      "createKey": "API Key erstellen",
      "loading": "Lade API Keys...",
      "noKeys": "Noch keine API Keys vorhanden.",
      "noKeysHint": "Erstellen Sie einen Key für programmatischen Zugriff.",
      "createDialog": {
        "title": "Neuen API Key erstellen",
        "description": "Erstellen Sie einen API Key für programmatischen Zugriff. Der Key wird nur einmal angezeigt!",
        "nameLabel": "Name *",
        "namePlaceholder": "z.B. Production API Key",
        "descriptionLabel": "Beschreibung",
        "descriptionPlaceholder": "z.B. Wird für Produktiv-Daten-Sync verwendet",
        "clientLabel": "Client (optional)",
        "clientNone": "Kein Client",
        "clientPlaceholder": "Client wählen (optional)",
        "clientHint": "Ordnen Sie den API Key einem Client zu für client-spezifische Voice Agent Prompts",
        "knowledgeAreasLabel": "Knowledge Areas * (mindestens eine)",
        "noKnowledgeAreas": "Keine Knowledge Areas verfügbar",
        "twLevelsLabel": "Erlaubte Trust Levels & Tools",
        "twLevelsHint": "Legt fest, welche Trust Levels und Tools dieser API Key im AI Chat verwenden darf",
        "alwaysActive": "immer aktiv",
        "expiresLabel": "Ablaufdatum (optional)",
        "expiresHint": "Leer lassen für unbegrenzte Gültigkeit",
        "creating": "Erstelle...",
        "validationError": "Name und mindestens eine Knowledge Area sind erforderlich"
      },
      "created": {
        "title": "API Key erfolgreich erstellt!",
        "warning": "Kopieren Sie den Key jetzt - er wird nicht mehr angezeigt!",
        "keyLabel": "Ihr API Key",
        "authHint": "Verwenden Sie diesen Key im Authorization Header:",
        "done": "Fertig"
      },
      "table": {
        "name": "Name",
        "keyPrefix": "Key-Präfix",
        "client": "Client",
        "permissions": "Berechtigungen",
        "knowledgeAreas": "Knowledge Areas",
        "twLevels": "TW Levels",
        "allowlist": "Allowlist",
        "usage": "Nutzung",
        "status": "Status",
        "actions": "Aktionen",
        "calls": "Aufrufe",
        "lastUsed": "Letzter:"
      },
      "status": {
        "active": "Aktiv",
        "revoked": "Widerrufen",
        "expired": "Abgelaufen"
      },
      "revokeTitle": "API Key widerrufen",
      "deleteConfirm": "Möchten Sie den API Key \"{{name}}\" wirklich löschen?",
      "deleteCannotUndo": "Diese Aktion kann nicht rückgängig gemacht werden",
      "allowlist": {
        "label": "Endpoint-Allowlist",
        "hint": "Schränkt diesen Key auf bestimmte Endpoints ein. Eine leere Liste = keine Einschränkung (Default für interne Keys). Ein Pattern pro Zeile, Format: METHOD /pfad, z. B. POST /api/v1/skills/*/invoke.",
        "templateLabel": "Template anwenden",
        "templatePlaceholder": "Template wählen…",
        "templates": {
          "internal_service": "Internal Service Key (keine Einschränkung)",
          "external_toolbox": "External Toolbox Customer (Skills + Tools)",
          "external_webhook": "Externer Webhook-Absender"
        },
        "emptyWarning": "Leer = keine Einschränkung. Für externe Customer-Keys bitte ein Template wählen.",
        "patternsLabel": "Erlaubte Patterns",
        "patternsLabel_one": "Pattern",
        "patternsLabel_other": "Patterns",
        "unrestricted": "keine Einschränkung",
        "unrestrictedTooltip": "Keine Einschränkung — alle Endpoints erreichbar",
        "tableTooltip": "Endpoint-Allowlist (#316): leere Liste = keine Einschränkung",
        "edit": {
          "action": "Allowlist bearbeiten",
          "title": "Endpoint-Allowlist bearbeiten",
          "description": "Key „{{name}}“. Die Änderung gilt sofort für alle Aufrufe mit diesem Key; der Key selbst bleibt gleich.",
          "liftWarningTitle": "Damit wird jede Einschränkung aufgehoben",
          "liftWarning_one": "Dieser Key ist heute auf {{count}} Pattern beschränkt. Mit einer leeren Liste erreicht er alle Endpoints, für die seine Berechtigungen reichen. Zum Bestätigen erneut klicken.",
          "liftWarning_other": "Dieser Key ist heute auf {{count}} Patterns beschränkt. Mit einer leeren Liste erreicht er alle Endpoints, für die seine Berechtigungen reichen. Zum Bestätigen erneut klicken.",
          "confirmLift": "Einschränkung aufheben",
          "invalidPattern": "Mindestens ein Pattern ist ungültig: {{detail}}. Format: METHOD /pfad, z. B. POST /api/v1/documents/upload.",
          "notFound": "Diesen Key gibt es nicht mehr. Bitte die Liste neu laden.",
          "forbidden": "Keine Berechtigung: Nur Admins können die Allowlist ändern. Ggf. neu anmelden.",
          "saveFailed": "Die Allowlist konnte nicht gespeichert werden ({{detail}}). Bitte später erneut versuchen."
        }
      },
      "voiceLive": {
        "action": "Voice One einstellen",
        "badge": "Voice One",
        "badgeTooltip": "Voice One ist für diesen Key erlaubt: Portal-Besucher können mit dem Brain sprechen.",
        "title": "Voice One für diesen Key",
        "description": "Key „{{name}}“. Mit Voice One können Besucher eines Portals mit diesem Key mit dem Brain sprechen, nur über die Wissensbereiche des Keys. Jeder Besucher bekommt seine eigene Sitzung.",
        "allow": "Voice One erlaubt",
        "allowHint": "Standard: aus. Wirkt nur, wenn Voice One auf der Umgebung eingeschaltet ist.",
        "maxConcurrent": "Gleichzeitige Sitzungen",
        "maxMinutes": "Minuten pro Tag",
        "limitsHint": "Leer = Standard (3 Sitzungen, 60 Minuten pro Tag, UTC). Ist ein Limit erreicht, bekommt das Portal eine klare Meldung.",
        "invalidLimit": "Bitte ganze Zahlen eingeben: Sitzungen 1–50, Minuten 1–1440, oder leer lassen.",
        "allowlistWarning": "Die Endpoint-Allowlist dieses Keys enthält keine voice-live-Routen. Bitte „* /api/v1/voice-live/*“ und „GET /api/v1/knowledge-areas“ ergänzen, sonst lehnt TQS die Aufrufe ab.",
        "notFound": "Diesen Key gibt es nicht mehr. Bitte die Liste neu laden.",
        "forbidden": "Keine Berechtigung: Nur Admins können Voice One für einen Key einstellen. Ggf. neu anmelden.",
        "saveFailed": "Die Einstellung konnte nicht gespeichert werden ({{detail}}). Bitte später erneut versuchen."
      },
      "usageNotes": {
        "title": "Hinweise zur API Key Nutzung:",
        "shownOnce": "API Keys werden nur einmal beim Erstellen angezeigt",
        "usage": "Verwendung:",
        "kaRestrict": "Knowledge Areas begrenzen den Zugriff auf Dokumente",
        "noReactivate": "Abgelaufene oder widerrufene Keys können nicht reaktiviert werden"
      }
    },
    "cdbTqsKnowledgeAreas": {
      "title": "Knowledge Areas",
      "description": "Verwalte Knowledge Areas aus dem CDB-TQS System ({{total}} gesamt)",
      "descriptionFiltered": "Verwalte Knowledge Areas aus dem CDB-TQS System ({{shown}} von {{total}})",
      "clientFilterAll": "Alle Clients",
      "clientFilterGlobal": "Global (ohne Client)",
      "clientFilterPlaceholder": "Nach Client filtern",
      "noAreasForClient": "Keine Knowledge Areas für diesen Client",
      "createNew": "Neue Knowledge Area",
      "errorLoading": "Fehler beim Laden der Knowledge Areas",
      "errorHint": "Stelle sicher, dass das CDB-TQS Backend läuft und die VITE_CDB_TQS_API_URL korrekt konfiguriert ist.",
      "noAreas": "Keine Knowledge Areas gefunden",
      "table": {
        "name": "Name",
        "description": "Beschreibung",
        "graphInstance": "Graph Instance",
        "documents": "Dokumente",
        "status": "Status"
      },
      "active": "Aktiv",
      "inactive": "Inaktiv",
      "systemCannotDelete": "System Knowledge Areas können nicht gelöscht werden",
      "deleteTitle": "Knowledge Area löschen"
    },
    "kaWizard": {
      "title": "Neue Knowledge Area",
      "breadcrumbLabel": "Pfad",
      "breadcrumbList": "Knowledge Areas",
      "stepsLabel": "Schritte",
      "stepDone": "erledigt",
      "steps": {
        "name": {
          "title": "Benennen",
          "hint": "Name, Beschreibung, Farbe"
        },
        "access": {
          "title": "Zugriff",
          "hint": "Wer damit arbeiten darf"
        },
        "content": {
          "title": "Inhalte",
          "hint": "Erste Dokumente (optional)"
        }
      },
      "adminOnly": "nur Admin",
      "next": "Weiter",
      "back": "Zurück",
      "backToList": "Zur Liste",
      "retry": "Erneut versuchen",
      "errors": {
        "generic": "Das hat nicht geklappt. Bitte erneut versuchen."
      },
      "colors": {
        "blue": "Blau",
        "green": "Grün",
        "yellow": "Gelb",
        "orange": "Orange",
        "purple": "Lila",
        "red": "Rot",
        "pink": "Pink",
        "gray": "Grau"
      },
      "name": {
        "heading": "Wie soll der Bereich heißen?",
        "intro": "Ein Name, den Ihre Kolleginnen und Kollegen sofort verstehen.",
        "displayNameLabel": "Name",
        "displayNamePlaceholder": "z. B. Kundenservice",
        "idLabel": "ID:",
        "idDerived": "wird aus dem Namen abgeleitet",
        "idEmpty": "—",
        "idUnknown": "wird beim Anlegen vergeben",
        "idChange": "ändern",
        "idReset": "wieder ableiten",
        "idPattern": "Kleinbuchstaben, Zahlen und Unterstriche, am Anfang ein Buchstabe. Leer = wird abgeleitet.",
        "idFixed": "steht nach dem Anlegen fest",
        "descriptionLabel": "Beschreibung",
        "descriptionPlaceholder": "Wofür ist dieser Bereich? Welche Dokumente gehören hinein?",
        "colorLabel": "Farbe",
        "sizeLabel": "Größe",
        "clientLabel": "Client",
        "clientPlaceholder": "Client wählen",
        "clientFixed": "Der Client steht nach dem Anlegen fest.",
        "graphHint": "Der Bereich liegt im Graph des Clients ({{graph}}).",
        "noGraph": "Dieser Client hat noch keinen Graph. Weisen Sie ihm zuerst unter Clients einen Graph zu.",
        "manageClients": "Zu den Clients",
        "createHint": "Mit „Weiter“ wird der Bereich angelegt."
      },
      "size": {
        "tiers": {
          "klein": "Klein",
          "mittel": "Mittel",
          "gross": "Groß",
          "unbegrenzt": "Unbegrenzt"
        },
        "chunks": "{{chunks}} Abschnitte",
        "chunksDefault": "{{chunks}} Abschnitte · Standard",
        "unlimited": "ohne Obergrenze",
        "hint": "Wie viele Abschnitte der Bereich höchstens aufnimmt. Später erweiterbar.",
        "previous": "Bisher: {{chunks}} Abschnitte – keine der Größen. Wählen Sie eine, sonst bleibt der Wert.",
        "previousUnlimited": "Bisher: unbegrenzt – nur Admins können das wählen. Ohne Auswahl bleibt es dabei."
      },
      "content": {
        "label": "Art der Inhalte",
        "default": "Allgemein",
        "defaultHint": "Standardtypen: Personen, Organisationen, Orte, Dokumente, Konzepte, Ereignisse",
        "custom": "Eigene",
        "customHint": "Ontologien des Clients",
        "customSelectLabel": "Ontologie des Clients wählen",
        "customNone": "Für diesen Client gibt es noch keine eigene Ontologie.",
        "customNoClient": "Wählen Sie zuerst einen Client.",
        "hint": "Bestimmt, welche Dinge und Beziehungen der Wissensgraph herausliest.",
        "manage": "Ontologien verwalten"
      },
      "access": {
        "heading": "Wer darf mit „{{name}}“ arbeiten?",
        "intro": "Der Bereich wird den gewählten Rollen von {{client}} hinzugefügt, für die Apps, die die Rolle schon hat. Später änderbar in der Rolle.",
        "legend": "Zugriff",
        "loading": "Rollen werden geladen …",
        "all": "Alle Rollen von {{client}}",
        "allHint_one": "Die {{count}} Rolle des Clients bekommt den Bereich. Rollen, die später neu angelegt werden, nicht automatisch.",
        "allHint_other": "Alle {{count}} Rollen des Clients bekommen den Bereich. Rollen, die später neu angelegt werden, nicht automatisch.",
        "selected": "Nur bestimmte Rollen",
        "selectedHint": "Wählen Sie die Rollen aus, die den Bereich bekommen.",
        "search": "Rollen durchsuchen",
        "rolesLabel": "Rollen",
        "forApps": "für {{apps}}",
        "noApps": "Rolle hat keine App, die mit Knowledge Areas arbeitet",
        "noRoles": "Dieser Client hat noch keine Rollen.",
        "noMatch": "Keine Rolle passt zur Suche.",
        "none": "Noch keiner Rolle zuweisen",
        "noneHint": "Der Bereich ist angelegt, aber für Nutzer noch unsichtbar. Admins und Supervisors sehen ihn in Cortex und können ihn befüllen und später freigeben.",
        "footnote": "Admins sehen die Rollen des in Schritt 1 gewählten Clients, Supervisors die ihres eigenen. Welche App den Bereich lesen oder befüllen darf, bleibt in der Rolle einstellbar."
      },
      "files": {
        "heading": "Erste Dokumente hinzufügen",
        "intro": "Optional. Sie können auch später hochladen.",
        "drop": "Dateien hierher ziehen",
        "or": "oder",
        "choose": "vom Computer auswählen",
        "formats": "PDF, Word, PowerPoint, Text, E-Mails, HTML. Excel-Tabellen über den Knowledge Extractor.",
        "listLabel": "Hochgeladene Dateien",
        "status": {
          "queued": "Wartet …",
          "uploading": "Wird hochgeladen …",
          "uploadingProgress": "Wird hochgeladen … {{progress}} %",
          "uploaded": "Hochgeladen · wird verarbeitet",
          "failed": "Fehlgeschlagen"
        },
        "errors": {
          "unsupported": "Dieses Format kann der Bereich nicht aufnehmen.",
          "tooLarge": "Zu groß (höchstens {{maxMb}} MB).",
          "duplicate": "Dieses Dokument ist schon im Bereich.",
          "rateLimited": "Gerade zu viele Uploads. Bitte später erneut hochladen."
        },
        "waitHint": "Warten, bis alle Dateien hochgeladen sind.",
        "skip": "Überspringen",
        "finish": "Fertig"
      },
      "done": {
        "heading": "{{name}} ist angelegt",
        "intro": "Sie können jetzt Dokumente hinzufügen oder den Bereich im Chat ausprobieren.",
        "processing_one": "{{count}} Dokument wird verarbeitet. Es ist in wenigen Minuten im Chat auffindbar.",
        "processing_other": "{{count}} Dokumente werden verarbeitet. Sie sind in wenigen Minuten im Chat auffindbar.",
        "client": "Client",
        "clientWithGraph": "{{client}} · Graph {{graph}}",
        "access": "Zugriff",
        "accessAll": "Alle Rollen von {{client}}",
        "accessSelected": "Rollen {{roles}}",
        "accessNone": "Noch keiner Rolle zugewiesen",
        "accessUnknown": "—",
        "documents": "Dokumente",
        "documentsNone": "Noch keine",
        "documentsUploaded_one": "{{count}} hochgeladen, in Verarbeitung",
        "documentsUploaded_other": "{{count}} hochgeladen, in Verarbeitung",
        "documentsFailed_one": "{{count}} fehlgeschlagen",
        "documentsFailed_other": "{{count}} fehlgeschlagen",
        "moreDocuments": "Weitere Dokumente",
        "tryInChat": "Im Chat ausprobieren",
        "openArea": "Zur Knowledge Area"
      }
    },
    "kaDetail": {
      "documents_one": "{{formatted}} Dokument",
      "documents_other": "{{formatted}} Dokumente",
      "chunks_one": "{{formatted}} Chunk",
      "chunks_other": "{{formatted}} Chunks",
      "id": "ID",
      "usage": "{{chunks}} von {{limit}} Abschnitten belegt",
      "usageUnlimited_one": "{{chunks}} Abschnitt belegt · ohne Obergrenze",
      "usageUnlimited_other": "{{chunks}} Abschnitte belegt · ohne Obergrenze",
      "usageLabel": "Belegung",
      "saved": "Gespeichert.",
      "tabs": {
        "overview": "Übersicht",
        "access": "Zugriff",
        "contents": "Inhalte",
        "settings": "Einstellungen"
      },
      "overview": {
        "edit": "Bearbeiten",
        "noDescription": "Keine Beschreibung",
        "ontologyUnknown": "Unbekannte Ontologie",
        "sizeOther": "Keine der Größen",
        "created": "Angelegt",
        "updated": "Zuletzt geändert"
      },
      "access": {
        "save": "Zugriff speichern"
      },
      "contents": {
        "heading": "Dokumente",
        "loading": "Dokumente werden geladen …",
        "empty": "Noch keine Dokumente.",
        "columns": {
          "title": "Titel",
          "type": "Typ",
          "status": "Status",
          "date": "Hochgeladen"
        },
        "more": "Die neuesten {{shown}} von {{total}} Dokumenten. Alle Dokumente stehen im Knowledge Extractor.",
        "uploadHeading": "Dokumente hinzufügen",
        "noClient": "Dieser Bereich gehört zu keinem Client. Hochladen geht nur in Bereiche eines Clients."
      },
      "settings": {
        "contentHint": "Gilt für Dokumente, die ab jetzt verarbeitet werden. Bereits verarbeitete bleiben, bis man sie neu einliest.",
        "contentCurrent": "Aktuell: {{name}} – hier nicht wählbar. Ohne andere Auswahl bleibt es dabei.",
        "standardNote": "Textaufbereitung und Abschnittsbildung (Chunking) sind ein globaler Standard und hier nicht einstellbar.",
        "save": "Einstellungen speichern",
        "lifecycleHeading": "Bereich deaktivieren oder löschen",
        "lifecycleHint": "Deaktiviert: unsichtbar, die Daten bleiben. Löschen geht nur, wenn der Bereich leer ist.",
        "deactivate": "Deaktivieren",
        "activate": "Aktivieren",
        "deleteConfirm": "„{{name}}“ endgültig löschen? Das lässt sich nicht rückgängig machen.",
        "deleteBlocked": {
          "default": "Der Standardbereich kann nicht gelöscht werden.",
          "notEmpty_one": "Löschen geht erst, wenn der Bereich leer ist: Er enthält noch {{count}} Dokument ({{chunks}} Abschnitte). Entfernen Sie es im Knowledge Extractor.",
          "notEmpty_other": "Löschen geht erst, wenn der Bereich leer ist: Er enthält noch {{count}} Dokumente ({{chunks}} Abschnitte). Entfernen Sie sie im Knowledge Extractor."
        }
      }
    },
    "tabs": {
      "overview": "Übersicht",
      "accessRequests": "Zugriffsanfragen",
      "users": "Benutzer",
      "roles": "Rollen",
      "permissions": "App-Berechtigungen",
      "appPermissions": "App-Berechtigungen",
      "knowledgeAreas": "Knowledge Areas",
      "kaRelations": "KA-Verknüpfungen",
      "graphInstances": "Graph Instances",
      "communicator": "cdbChat",
      "prompts": "Prompt Library",
      "tools": "Tool Library",
      "themes": "Themes",
      "clients": "Clients",
      "organization": "Organisation",
      "apps": "Apps",
      "clientAppVisibility": "App-Sichtbarkeit",
      "bugReports": "Tickets",
      "tokenUsage": "Token-Nutzung",
      "maintenance": "Wartung",
      "urls": "Portal URLs"
    },
    "sidebar": {
      "sections": {
        "general": "Allgemein",
        "appConfiguration": "App-Konfiguration"
      },
      "collapse": "Sidebar einklappen",
      "expand": "Sidebar ausklappen",
      "bugReportsUnread_one": "{{count}} Ticket mit neuen Antworten",
      "bugReportsUnread_other": "{{count}} Tickets mit neuen Antworten"
    },
    "overview": {
      "title": "System-Übersicht",
      "description": "Statistiken und wichtige Informationen",
      "stats": {
        "pendingRequests": "Offene Zugriffsanfragen",
        "clickToView": "Klicken zum Anzeigen",
        "totalUsers": "Registrierte Benutzer",
        "registeredUsers": "Registrierte Benutzer",
        "activeUsers": "Davon aktiv",
        "totalApps": "Verfügbare Apps",
        "activeApps": "Davon aktiv",
        "knowledgeAreas": "Wissensbereiche",
        "adminUsers": "Administratoren",
        "normalUsers": "Normale Benutzer"
      }
    },
    "accessRequests": {
      "title": "Zugriffsanfragen",
      "description": "Verwalten Sie eingehende Zugriffsanfragen",
      "noPendingRequests": "Keine ausstehenden Zugriffsanfragen",
      "received": "Erhalten",
      "reject": "Ablehnen",
      "approve": "Genehmigen",
      "pending": "Ausstehend",
      "client": "Client"
    },
    "users": {
      "title": "Benutzerverwaltung",
      "description": "Verwalten Sie Benutzerrollen und Status",
      "noApprovedUsers": "Keine genehmigten Benutzer verfügbar",
      "active": "Aktiv",
      "inactive": "Inaktiv",
      "readOnly": "Nur-Lesen",
      "created": "Erstellt",
      "approved": "Genehmigt",
      "searchPlaceholder": "Nach Name oder E-Mail suchen...",
      "allRoles": "Alle Rollen",
      "allClients": "Alle Clients",
      "showingResults": "Zeige {{count}} von {{total}} Benutzern",
      "autoVerifyTl1": "TL1 automatisch verifizieren",
      "autoVerifyTl1Tooltip": "Extrahierte Knoten und Kanten werden automatisch als verifiziert markiert",
      "role": {
        "user": "Benutzer",
        "admin": "Administrator"
      },
      "table": {
        "nameEmail": "Name / E-Mail",
        "client": "Client",
        "userType": "Benutzertyp",
        "roles": "Rollen",
        "role": "Rolle",
        "status": "Status",
        "applications": "Anwendungen",
        "created": "Erstellt",
        "actions": "Aktionen"
      },
      "userTypes": {
        "admin": "Admin",
        "user": "User"
      },
      "deleteUser": "Benutzer löschen",
      "deleteConfirm": "Möchten Sie diesen Benutzer wirklich löschen?",
      "deleteWarning": "Diese Aktion kann nicht rückgängig gemacht werden.",
      "deleteSuccess": "Benutzer erfolgreich gelöscht",
      "deleteError": "Fehler beim Löschen des Benutzers",
      "pending": "Ausstehend",
      "unknownApp": "Unbekannte App",
      "applications": {
        "webos": "WebOS",
        "editor": "Editor",
        "composer": "Composer",
        "pdb": "cdbChat",
        "controlCenter": "Control Center"
      },
      "assignRoles": "Rollen zuweisen",
      "editRoles": "Rollen bearbeiten",
      "roles": "Rollen",
      "deleteConfirmDetails": {
        "willDelete": "Diese Aktion wird folgendes löschen:",
        "userData": "Alle Benutzerdaten in der Datenbank",
        "appAssignments": "Alle App-Zuweisungen",
        "accessRequests": "Alle Zugriffsanfragen",
        "authAccount": "Das Auth-Konto (Sessions, Tokens)",
        "logoutImmediate": "Der Benutzer wird sofort abgemeldet",
        "cannotUndo": "Diese Aktion kann nicht rückgängig gemacht werden!"
      },
      "knowledgeAccess": {
        "dialogTitle": "Wissenszugriff zuweisen",
        "hint": "Gilt zusätzlich zu den Rollen des Nutzers: jede App bekommt die Knowledge Areas, mit denen sie arbeiten darf.",
        "saved": "Wissenszugriff gespeichert"
      },
      "applicationFailed": "Die Anwendung konnte nicht geändert werden. Bitte versuchen Sie es erneut.",
      "noProducts": "Ihre Organisation hat keine Produkte, die Sie vergeben können."
    },
    "roles": {
      "title": "Rollenverwaltung",
      "description": "Erstellen und verwalten Sie Rollen mit App-, Knowledge Area- und Trust Level-Berechtigungen",
      "createRole": "Neue Rolle erstellen",
      "editRole": "Rolle bearbeiten",
      "noRoles": "Keine Rollen vorhanden",
      "roleType": "Rollentyp",
      "roleTypeLabel": "Rollentyp",
      "roleTypeUser": "User-Rolle",
      "roleTypeUserDesc": "Standard-Rolle für Benutzer mit zugewiesenen Berechtigungen",
      "roleTypeSupervisor": "Supervisor",
      "roleTypeSupervisorDesc": "Kann zugewiesene Apps und Trust Levels an User im eigenen Client weitergeben",
      "supervisorBadge": "Supervisor",
      "table": {
        "name": "Name",
        "description": "Beschreibung",
        "client": "Client",
        "apps": "Apps",
        "knowledgeAreas": "KAs",
        "users": "Nutzer",
        "actions": "Aktionen"
      },
      "systemRole": "System-Rolle (nicht editierbar)",
      "supervisorRoleMembersOnly": "Nur Mitglieder verwaltbar – den Inhalt der Supervisor-Rolle ändern Admins",
      "usersRemovesSelf": "Sie entfernen sich selbst aus dieser Supervisor-Rolle. Nach dem Speichern verlieren Sie Ihren Supervisor-Zugriff in Cortex, sofern Sie keine weitere Supervisor-Rolle haben.",
      "basicInfo": "Basis-Informationen",
      "nameLabel": "Name *",
      "namePlaceholder": "z.B. Marketing Manager",
      "descriptionLabel": "Beschreibung",
      "descriptionPlaceholder": "Optionale Beschreibung der Rolle",
      "clientLabel": "Client *",
      "clientPlaceholder": "Client auswählen (erforderlich)",
      "clientKAHint": "Nur Knowledge Areas dieses Clients sind verfügbar",
      "clientFilterPlaceholder": "Nach Client filtern",
      "clientFilterGlobal": "Global",
      "twLevelsTitle": "Erlaubte Trust Levels & Tools (AI Chat)",
      "capabilities": {
        "title": "cdbChat-Fähigkeiten",
        "hint": "Aktiviert = die Rolle erbt die Fähigkeit aus dem Client-Paket. Deaktiviert = für diese Rolle entzogen. Nicht freigeschaltete Fähigkeiten lassen sich nicht hinzufügen.",
        "inherited": "aus Tier geerbt",
        "restricted": "für diese Rolle entzogen",
        "unavailable": "nicht für diesen Client freigeschaltet",
        "global": "globale Rolle – kein Client-Tier",
        "loading": "Client-Berechtigungen werden geladen …",
        "loadError": "Client-Berechtigungen konnten nicht geladen werden. Speichern ist deaktiviert.",
        "items": {
          "sources_fulltext": {
            "label": "Volltextsuche",
            "description": "Sucht wörtlich nach Begriffen in den Dokumenten der Organisation."
          },
          "web_search": {
            "label": "Websuche",
            "description": "Der Assistent darf für seine Antworten im Internet suchen."
          },
          "connectors_microsoft365": {
            "label": "Microsoft 365",
            "description": "Nutzer können Postfach und Kalender verbinden; der Assistent liest Mails, schreibt Entwürfe und plant Termine."
          },
          "sources_router_toolbox": {
            "label": "Angebundene Systeme",
            "description": "Der Assistent darf Daten aus angebundenen Fachsystemen abfragen, z. B. ERP oder Datenbanken."
          },
          "sources_router_free_query": {
            "label": "Freie Abfrage in angebundenen Systemen",
            "description": "Findet eine vorbereitete Abfrage nichts, darf der Assistent selbst eine Abfrage formulieren. Solche Ergebnisse sind weniger abgesichert."
          },
          "skills_structured_query": {
            "label": "Importierte Tabellendaten",
            "description": "Der Assistent beantwortet Fragen auch aus importierten Excel-Daten, z. B. Stücklisten."
          },
          "memory_cross_session": {
            "label": "Gedächtnis über Chats hinweg",
            "description": "Der Assistent erinnert sich an frühere Unterhaltungen und an Vorlieben der Person."
          },
          "features_routines": {
            "label": "Routinen",
            "description": "Nutzer können Fragen einplanen, die regelmäßig automatisch beantwortet werden."
          },
          "skills_office_generation": {
            "label": "Office-Dokumente erstellen",
            "description": "Der Assistent erstellt und bearbeitet Word-, Excel-, PowerPoint- und PDF-Dateien."
          },
          "features_deep_research": {
            "label": "Tiefenrecherche",
            "description": "Der Assistent recherchiert in mehreren Schritten mit Quellenangaben; dauert länger und verbraucht mehr Tokens."
          },
          "features_remote_mcp": {
            "label": "Zugriff aus Claude",
            "description": "Nutzer können Claude mit cdbOS verbinden und von dort in ihren Wissensbereichen suchen. Inhalte gelangen dabei in ihr Claude-Konto."
          },
          "features_agent_workflows": {
            "label": "Workflows",
            "description": "Nutzer können vorbereitete Abläufe im Chat starten, die Schritt für Schritt Daten aus angebundenen Systemen holen."
          },
          "skills_bpmn_generation": {
            "label": "Prozessdiagramme (BPMN)",
            "description": "Der Assistent erstellt und bearbeitet Prozessdiagramme."
          },
          "skills_html_generation": {
            "label": "Webseiten (HTML)",
            "description": "Der Assistent erstellt und bearbeitet HTML-Seiten, z. B. interaktive Übersichten."
          },
          "skills_image_generation": {
            "label": "Bilder erstellen",
            "description": "Der Assistent erstellt und bearbeitet Bilder."
          },
          "widget_table": {
            "label": "Interaktive Tabellen",
            "description": "Große Ergebnisse erscheinen als sortierbare Tabelle mit Excel-Export."
          },
          "ingest_knowledge_area": {
            "label": "In Wissensbereiche aufnehmen",
            "description": "Der Assistent darf Dokumente und Webseiten in Wissensbereiche speichern."
          }
        }
      },
      "trainingModulesTitle": "Training App Modul",
      "trainingModulesHint": "Steuert welche Bereiche des CDB Training Hub Nutzer mit dieser Rolle sehen und nutzen können. Standard ist nur Schulung.",
      "trainingModulesSchulungLabel": "Schulung (Trainings, Materialien, Quiz)",
      "trainingModulesUmfrageLabel": "Umfrage (eigenständige Umfragen)",
      "appPermissions": "App-Berechtigungen",
      "kaPermissions": "Knowledge Area-Berechtigungen",
      "kaSelectClientFirst": "Bitte wählen Sie zuerst einen Client aus",
      "kaNoAreasForClient": "Dieser Client hat keine Knowledge Areas zugewiesen",
      "graphInstanceTitle": "Graph Instance",
      "graphInstanceHint": "Supervisor kann Knowledge Areas in dieser Graph Instance erstellen und verwalten.",
      "graphInstanceNone": "Keine Graph Instances vorhanden. Bitte zuerst eine Graph Instance anlegen.",
      "deleteTitle": "Rolle löschen",
      "deleteConfirm": "Möchten Sie die Rolle \"{{name}}\" wirklich löschen?",
      "deleteWarningUsers": "Warnung: Diese Rolle ist {{count}} Benutzer(n) zugewiesen.",
      "createError": "Fehler beim Erstellen der Rolle",
      "updateError": "Fehler beim Aktualisieren der Rolle",
      "deleteError": "Fehler beim Löschen der Rolle",
      "nameRequired": "Bitte geben Sie einen Rollennamen ein",
      "clientRequired": "Bitte wählen Sie einen Client aus",
      "usersTitle": "Benutzer verwalten: {{name}}",
      "usersRoleAssignment": "Rollenzuweisung für App-Zugriffsanfrage",
      "usersLoadFailed": "Die Zuweisungen konnten nicht geladen werden. Ohne sie lässt sich nichts ändern.",
      "usersSaveFailed": "Nicht gespeichert für: {{users}}. Die übrigen Änderungen sind gespeichert.",
      "usersPendingChanges_one": "{{count}} ungespeicherte Änderung",
      "usersPendingChanges_other": "{{count}} ungespeicherte Änderungen",
      "usersChanged": "Geändert",
      "noUsersForClient": "Keine Benutzer für Client \"{{client}}\" verfügbar",
      "noUsers": "Keine Benutzer verfügbar",
      "requestBadge": "Anfrage",
      "all": "Alle",
      "tabs": {
        "roles": "Rollen",
        "templates": "Vorlagen"
      },
      "copyName": "{{name}} (Kopie)",
      "createFromRole": "Neue Rolle aus dieser Rolle erstellen",
      "saveAsTemplate": "Rolle als Vorlage speichern",
      "templates": {
        "title": "Rollen-Vorlagen",
        "description": "Client-unabhängige Vorlagen für neue Rollen — Client und Knowledge Areas werden erst beim Erstellen der Rolle gewählt",
        "createTemplate": "Neue Vorlage",
        "editTemplate": "Vorlage bearbeiten",
        "noTemplates": "Keine Vorlagen vorhanden",
        "useTemplate": "Rolle erstellen",
        "useTemplateHint": "Neue Rolle aus dieser Vorlage erstellen",
        "namePlaceholder": "z.B. Standard Mitarbeiter",
        "clientAgnosticHint": "Vorlagen enthalten keinen Client und keine Knowledge Areas — diese werden erst beim Erstellen der Rolle gewählt.",
        "nameRequired": "Bitte geben Sie einen Vorlagennamen ein",
        "deleteTitle": "Vorlage löschen",
        "deleteConfirm": "Möchten Sie die Vorlage \"{{name}}\" wirklich löschen? Bereits daraus erstellte Rollen bleiben unverändert.",
        "createError": "Fehler beim Erstellen der Vorlage",
        "updateError": "Fehler beim Aktualisieren der Vorlage",
        "deleteError": "Fehler beim Löschen der Vorlage",
        "table": {
          "name": "Name",
          "description": "Beschreibung",
          "apps": "Apps",
          "actions": "Aktionen"
        },
        "appsKnowledgeHint": "Welche Knowledge Areas die markierten Apps bekommen, wird beim Erstellen der Rolle festgelegt."
      },
      "wizard": {
        "steps": {
          "basics": "Grunddaten",
          "apps": "Apps",
          "knowledge": "Wissenszugriff",
          "communicator": "cdbChat",
          "modules": "Module",
          "review": "Zusammenfassung"
        },
        "stepCounter": "Schritt {{current}} von {{total}} — {{title}}",
        "back": "Zurück",
        "next": "Weiter",
        "appsHint": "Apps, die mit Knowledge Areas arbeiten, bekommen sie im nächsten Schritt zugewiesen.",
        "noKnowledgeApps": "Keine der gewählten Apps arbeitet mit Knowledge Areas. Wähle im vorigen Schritt z. B. cdbChat oder den Knowledge Extractor.",
        "supervisorNoAreas": "Ihre Supervisor-Rolle enthält keine Wissensbereiche. Wenden Sie sich an Ihren Admin.",
        "knowledgeTitle": "Knowledge Areas je App",
        "knowledgeHint": "Jede App bekommt die Knowledge Areas, mit denen sie arbeiten darf. Was sie darin tun kann, ergibt sich aus der App selbst — cdbChat liest, der Extractor speist ein, der Verifier prüft.",
        "reviewNone": "Keine",
        "appColumn": "App",
        "appKnowledgeAware": "Knowledge Areas",
        "locked": "Gesperrt",
        "lockedHint": "Gesperrt: von einem Admin vergeben und nicht Teil Ihrer Supervisor-Rolle. Bleibt beim Speichern unverändert.",
        "areaInactive": "inaktiv",
        "areaRemoved": "Entfernter Wissensbereich",
        "areaRemovedDrop": "Berechtigung entfernen",
        "areaRemovedHint_one": "Eine Berechtigung verweist auf einen Wissensbereich, den es nicht mehr gibt. Sie gewährt keinen Zugriff mehr und kann hier entfernt werden.",
        "areaRemovedHint_other": "{{count}} Berechtigungen verweisen auf Wissensbereiche, die es nicht mehr gibt. Sie gewähren keinen Zugriff mehr und können hier entfernt werden.",
        "verifyMode": {
          "read": "Lesen",
          "verify": "Prüfen",
          "verifierHint": "Im Knowledge Verifier legen Sie je Wissensbereich fest, ob nur gelesen oder auch geprüft werden darf.",
          "verifyNotAllowed": "Prüfen können Sie nur dort freigeben, wo Sie selbst prüfen dürfen."
        },
        "saveRefused": "Speichern abgelehnt"
      },
      "workflowPackages": {
        "title": "Workflow-Pakete",
        "hint": "Wer diese Rolle hat, bekommt alle Workflows der gewählten Pakete im Chat.",
        "none": "Für diesen Client gibt es noch keine Workflow-Pakete.",
        "count": "{{count}} Workflows"
      },
      "ticketTypes": {
        "title": "Tickets",
        "hint": "Welche Tickets Nutzer mit dieser Rolle erstellen dürfen. Hat jemand mehrere Rollen, genügt eine, die es erlaubt. Sind beide aus, sehen sie den Bereich Tickets nicht mehr.",
        "bug": "Fehler melden",
        "feature": "Verbesserung vorschlagen"
      }
    },
    "clients": {
      "description": "Verwalten Sie Clients und deren Storage-Buckets",
      "createNew": "Neuer Client",
      "user": "Benutzer",
      "users": "Benutzer",
      "table": {
        "name": "Name",
        "bucket": "Storage-Bucket",
        "graph": "Graph-Instanz",
        "users": "Benutzer",
        "created": "Erstellt",
        "actions": "Aktionen"
      },
      "createTitle": "Neuen Client erstellen",
      "createDescription": "Erstellen Sie einen neuen Client. Ein Storage-Bucket wird automatisch angelegt.",
      "nameLabel": "Name",
      "nameHint": "Der Bucket wird automatisch erstellt: client-{name}",
      "editTitle": "Client bearbeiten",
      "editDescription": "Ändern Sie die Client-Informationen.",
      "currentBucket": "Aktueller Bucket",
      "bucketWarning": "Achtung: Bucket-Name ändert sich nicht automatisch",
      "graphLabel": "Graph-Instanz",
      "graphPlaceholder": "Graph-Instanz wählen",
      "graphHint": "Alle Knowledge Areas dieses Clients liegen in dieser Graph-Instanz. Sobald der Client Knowledge Areas hat, lässt sie sich nicht mehr ändern.",
      "graphLockedHint": "Der Client hat bereits {{count}} Knowledge Area(s), deshalb lässt sich die Graph-Instanz nicht mehr ändern.",
      "graphNotSet": "Nicht gesetzt",
      "graphHasKnowledgeAreas": "Der Client hat bereits Knowledge Areas, deshalb lässt sich die Graph-Instanz nicht mehr ändern. Der Name wurde gespeichert.",
      "graphSaveError": "Die Graph-Instanz konnte nicht gespeichert werden: {{reason}}. Der Name wurde gespeichert.",
      "graphRequired": "Bitte eine Graph-Instanz wählen.",
      "createGraphError": "Der Client „{{name}}“ wurde angelegt, aber die Graph-Instanz konnte nicht gesetzt werden: {{reason}}. Bitte über „Bearbeiten“ nachholen.",
      "deleteTitle": "Client löschen",
      "deleteDescription": "Sind Sie sicher, dass Sie diesen Client löschen möchten?",
      "deleteWithBucket": "Storage-Bucket ebenfalls löschen",
      "deletingWithBucket": "Wird gelöscht...",
      "noClients": "Keine Clients vorhanden",
      "createError": "Fehler beim Erstellen des Clients",
      "updateError": "Fehler beim Aktualisieren des Clients",
      "deleteError": "Fehler beim Löschen des Clients",
      "deleteErrorHasUsers": "Client mit aktiven Benutzern kann nicht gelöscht werden",
      "deleteBucketHint": "Löscht auch den zugehörigen Storage-Bucket",
      "deleteBucketLabel": "Storage-Bucket löschen",
      "deleteBucketWarning": "Diese Aktion kann nicht rückgängig gemacht werden!",
      "namePlaceholder": "Client-Name eingeben",
      "usersAssigned": "{{count}} Benutzer zugewiesen"
    },
    "themes": {
      "title": "Theme Verwaltung",
      "description": "Hintergrundbild, Icon-Farbe und Button-Farbe festlegen",
      "createTheme": "Neues Theme",
      "noThemes": "Keine Themes vorhanden",
      "table": {
        "name": "Name",
        "background": "Hintergrund",
        "iconColor": "Icon Farbe",
        "buttonColor": "Button Farbe",
        "actions": "Aktionen",
        "noImage": "Kein Bild"
      },
      "actions": {
        "preview": "Vorschau",
        "copy": "Kopieren",
        "edit": "Bearbeiten",
        "delete": "Löschen"
      },
      "modal": {
        "createTitle": "Neues Theme erstellen",
        "editTitle": "Theme bearbeiten",
        "description": "Hintergrundbild und Icon-Farbe für den Desktop festlegen"
      },
      "form": {
        "nameId": "Name (ID) *",
        "nameIdPlaceholder": "z.B. corporate-theme",
        "nameIdHint": "Interner Identifier (nur Kleinbuchstaben und Bindestriche)",
        "cssClass": "CSS-Klasse:",
        "displayName": "Anzeigename *",
        "displayNamePlaceholder": "z.B. Corporate Theme",
        "client": "Client",
        "clientNone": "Kein Client (Global)",
        "clientOptional": "Optional",
        "publicTheme": "Öffentliches Theme (für alle Benutzer)",
        "themeMode": "Theme-Modus",
        "themeModeLight": "Hell",
        "themeModeDark": "Dunkel",
        "themeModePlaceholder": "Theme-Modus wählen",
        "themeModeHint": "Bestimmt, ob das Theme als dunkel oder hell behandelt wird.",
        "backgroundImage": "Hintergrundbild",
        "currentlySelected": "Aktuell ausgewählt:",
        "uploadNew": "Neues Bild hochladen",
        "uploading": "Hochladen...",
        "remove": "Entfernen",
        "maxSize": "Max 5MB, empfohlen: 1920x1080px",
        "deriveFromImage": "Farben aus Hintergrundbild ableiten",
        "applyNow": "Jetzt anwenden",
        "applying": "Wende an...",
        "autoApplyHint": "Wenn aktiv, werden die Farben beim Moduswechsel und Bildwechsel neu abgeleitet.",
        "loadingImages": "Bilder werden geladen...",
        "selectExisting": "Vorhandene Bilder auswählen",
        "selected": "Ausgewählt",
        "noImagesAvailable": "Keine Bilder im Bucket vorhanden. Laden Sie ein neues Bild hoch.",
        "colorsTitle": "Farben"
      },
      "colorFields": {
        "iconColor": "Icon Farbe",
        "iconTextColor": "Icon Text Farbe",
        "textColor": "Textfarbe",
        "secondaryTextColor": "Sekundäre Textfarbe",
        "backgroundColor": "Hintergrundfarbe",
        "taskbarColor": "Taskbar Farbe",
        "titlebarColor": "Fenster Titelleiste Farbe",
        "accentColor": "Button/Toggle Farbe",
        "borderColor": "Umrandungsfarbe",
        "iconColorLabel": "Icon Farbe *",
        "iconColorHint": "Farbe für Desktop-Icons",
        "iconTextColorLabel": "Icon Text Farbe *",
        "iconTextColorHint": "Farbe für Icon-Beschriftungen auf dem Desktop",
        "textColorLabel": "Allgemeine Textfarbe *",
        "textColorHint": "Textfarbe für die gesamte UI",
        "secondaryTextColorLabel": "Sekundäre Textfarbe *",
        "secondaryTextColorHint": "Farbe für Platzhalter-Text, Labels und weniger prominente Textelemente",
        "backgroundColorLabel": "Hintergrundfarbe *",
        "backgroundColorHint": "Hintergrundfarbe für Windows und Surfaces",
        "accentColorLabel": "Button/Toggle Farbe *",
        "accentColorHint": "Farbe für Buttons, Switches, Toggles",
        "taskbarColorLabel": "Taskbar Farbe *",
        "taskbarColorHint": "Hintergrundfarbe der Taskbar",
        "titlebarColorLabel": "Fenster Titelleiste Farbe *",
        "titlebarColorHint": "Hintergrundfarbe der Fenster-Titelleisten",
        "borderColorLabel": "Umrandungsfarbe *",
        "borderColorHint": "Farbe für Umrandungen von Sidebars, Karten, Filter, Textfeldern, Main-Bereichen, etc."
      },
      "warnings": {
        "uppercaseConverted": "Großbuchstaben wurden automatisch in Kleinbuchstaben umgewandelt.",
        "whitespaceConverted": "Leerzeichen wurden in Bindestriche umgewandelt.",
        "invalidCharsRemoved": "Nicht zulässige Zeichen entfernt: {{chars}}",
        "namePatternInvalid": "Name (ID) darf nur Kleinbuchstaben und Bindestriche enthalten.",
        "nameExists": "Name (ID) existiert bereits.",
        "displayNameExists": "Anzeigename existiert bereits.",
        "invalidColors": "Ungültige Farben: {{fields}}",
        "contrastWarning": "Kontrastwarnung: Textfarbe und Hintergrundfarbe können schwer lesbar sein (Ratio {{ratio}}).",
        "secondaryContrastHint": "Hinweis: Sekundäre Textfarbe hat niedrigen Kontrast (Ratio {{ratio}}).",
        "iconContrastHint": "Hinweis: Icon-Textfarbe und Icon-Farbe haben niedrigen Kontrast (Ratio {{ratio}})."
      },
      "alerts": {
        "selectImageFirst": "Bitte zuerst ein Hintergrundbild wählen.",
        "colorDeriveFailed": "Farben konnten nicht aus dem Hintergrundbild abgeleitet werden.",
        "selectImageFile": "Bitte wählen Sie eine Bilddatei aus",
        "imageTooLarge": "Bilddatei ist zu groß (max 5MB)",
        "uploadError": "Fehler beim Hochladen des Bildes",
        "nameRequired": "Name und Anzeigename sind erforderlich",
        "namePatternRequired": "Name (ID) darf nur Kleinbuchstaben und Bindestriche enthalten",
        "nameConflict": "Name oder Anzeigename existiert bereits",
        "invalidHexColors": "Bitte gültige HEX-Farben angeben: {{fields}}",
        "createError": "Fehler beim Erstellen des Themes",
        "updateError": "Fehler beim Aktualisieren des Themes",
        "deleteError": "Fehler beim Löschen des Themes",
        "canvasContextUnavailable": "Canvas-Context nicht verfügbar",
        "noColorData": "Keine Farbdaten gefunden",
        "imageLoadError": "Bild konnte nicht geladen werden"
      },
      "buttons": {
        "cancel": "Abbrechen",
        "saving": "Speichert...",
        "create": "Erstellen",
        "save": "Speichern",
        "deleting": "Löscht...",
        "delete": "Löschen",
        "close": "Schließen"
      },
      "delete": {
        "title": "Theme löschen",
        "confirm": "Möchten Sie das Theme \"{{name}}\" wirklich löschen?"
      },
      "preview": {
        "title": "Theme-Vorschau: {{name}}",
        "nameId": "Name (ID)",
        "public": "Öffentlich",
        "yes": "Ja",
        "no": "Nein",
        "mode": "Modus",
        "darkMode": "Dunkelmodus",
        "lightMode": "Hellmodus",
        "desktopBackground": "Desktop-Hintergrund",
        "noBackground": "Kein Hintergrundbild",
        "themeColors": "Theme-Farben"
      }
    },
    "permissions": {
      "title": "App-Berechtigungsverwaltung",
      "description": "Verwalten Sie App-Zuweisungen für normale Benutzer. Administratoren haben automatischen Zugriff auf alle Apps und benötigen keine Zuweisungen. System-Apps sind automatisch für alle Benutzer verfügbar.",
      "selectUser": "Benutzer auswählen (nur normale Benutzer)",
      "selectUserPlaceholder": "Wählen Sie einen normalen Benutzer aus...",
      "appPermissionsFor": "App-Berechtigungen für",
      "id": "ID",
      "role": "Rolle",
      "adminSelected": "Administrator ausgewählt",
      "adminWarning": "Administratoren haben automatischen Zugriff auf alle verfügbaren Apps und benötigen keine expliziten App-Zuweisungen.",
      "availableApps": "Verfügbare Apps",
      "assignedApps": "Zugewiesene Apps",
      "allAppsAssigned": "Alle verfügbaren Apps sind bereits zugewiesen",
      "noAppsAssigned": "Keine Apps zugewiesen",
      "assigned": "Zugewiesen",
      "notAssigned": "Nicht zugewiesen",
      "appAssignmentsTitle": "App-Zuweisungen",
      "searchApps": "Apps durchsuchen...",
      "assignAll": "Alle zuweisen",
      "removeAllApps": "Alle entfernen",
      "totalApps": "Gesamt Apps",
      "by": "von",
      "selectUserToManage": "Benutzer auswählen",
      "selectUserDescription": "Wählen Sie einen normalen Benutzer aus dem Dropdown-Menü aus, um seine App-Berechtigungen zu verwalten. Administratoren benötigen keine App-Zuweisungen."
    },
    "appPermissions": {
      "title": "App-Berechtigungen",
      "description": "Verwalten Sie, welche Benutzer Zugriff auf welche Apps haben. System- und Admin-Apps werden automatisch verwaltet.",
      "noAssignableApps": "Keine zuweisbaren Apps gefunden",
      "headers": {
        "app": "App",
        "category": "Kategorie",
        "status": "Status",
        "assignedUsers": "Zugewiesene Benutzer",
        "actions": "Aktionen"
      },
      "status": {
        "implemented": "Implementiert",
        "unavailable": "Nicht verfügbar"
      },
      "actions": {
        "manage": "Verwalten"
      },
      "modal": {
        "title": "Benutzer verwalten: {{app}}",
        "description": "Weisen Sie Benutzer dieser App zu oder entfernen Sie sie. Admins haben automatisch Zugriff und werden nicht aufgelistet.",
        "noUsers": "Keine Benutzer gefunden",
        "assign": "Zuweisen",
        "remove": "Entfernen",
        "unknownApp": "Unbekannte App"
      },
      "errors": {
        "load": "Fehler beim Laden der App-Berechtigungen",
        "assignmentChange": "Fehler beim Ändern der Benutzerzuweisung. Siehe Console für Details."
      }
    },
    "appsHub": {
      "tabs": {
        "management": "Verwaltung",
        "visibility": "Sichtbarkeit"
      }
    },
    "organizationHub": {
      "tabs": {
        "organizations": "Organisationen",
        "access": "Zugang & Sitze",
        "knowledgeAreas": "Wissensbereiche",
        "relations": "Relationen",
        "graphs": "Graphen",
        "databases": "Datenbanken",
        "apiKeys": "API Keys",
        "staffAccess": "Staff Access",
        "externalAccess": "Externe Zugriffe",
        "ontologies": "Ontologien"
      },
      "sections": {
        "organizations": "Organisationen",
        "knowledge": "Wissen",
        "infrastructure": "Infrastruktur",
        "accessControl": "Zugriffe"
      },
      "accessControl": {
        "title": "Zugriffe",
        "subtitle": "Wer von außen oder mit erhöhten Rechten auf Organisationen zugreift.",
        "back": "Zurück zu Zugriffe",
        "loadFailed": "Konnte nicht geladen werden.",
        "apiKeys": {
          "title": "API Keys",
          "active": "Aktiv",
          "expiring": "Läuft in 30 Tagen ab",
          "calls": "Aufrufe gesamt",
          "create": "+ Neuer Key",
          "manage": "Alle Keys verwalten"
        },
        "claude": {
          "title": "Claude (MCP)",
          "on": "aktiv",
          "off": "aus",
          "enabledOrgs": "Freigeschaltete Organisationen",
          "users": "Aktive Nutzer (30 Tage)",
          "lastAccess": "Letzter Zugriff",
          "manage": "Konfiguration und Freischaltung"
        },
        "staff": {
          "title": "Staff-Elevation",
          "start": "Elevation starten",
          "active": "Aktiv",
          "none": "keine",
          "activeUntil": "{{organisation}} · bis {{time}}",
          "enforcement": "Durchsetzung",
          "enforced": "prod: erzwungen",
          "notEnforced": "nicht erzwungen",
          "last30": "Letzte 30 Tage",
          "endNow": "Jetzt beenden",
          "endOne": "{{organisation}} beenden",
          "manage": "Elevationen und Protokoll"
        },
        "log": {
          "title": "Protokoll",
          "organisation": "Organisation",
          "kind": "Art",
          "allOrganisations": "Alle Organisationen",
          "allKinds": "Alle Arten",
          "kinds": {
            "claude": "Claude",
            "elevation": "Elevation"
          },
          "columns": {
            "time": "Zeit",
            "kind": "Art",
            "who": "Wer",
            "organisation": "Organisation",
            "what": "Was",
            "status": "Status"
          },
          "elevationStatus": {
            "active": "läuft",
            "endedEarly": "vorzeitig beendet",
            "expired": "abgelaufen"
          },
          "hint": "Claude-Aufrufe und Staff-Elevationen. API-Key-Aufrufe werden nur gezählt, nicht einzeln protokolliert.",
          "empty": "Keine Einträge.",
          "loadMore": "Ältere laden"
        }
      },
      "infrastructure": {
        "title": "Infrastruktur",
        "description": "Graphen und Datenbanken, die Organisationen nutzen. Den Graphen einer Organisation legen Sie in der Organisation fest.",
        "checkAll": "Alle prüfen",
        "add": "Instanz hinzufügen",
        "addGraphProvision": "Graph bei Aura erstellen",
        "addGraphConnect": "Bestehenden Graph verbinden",
        "addDatabase": "Datenbank hinzufügen",
        "tiles": {
          "graphs": "Graphen (Neo4j)",
          "databases": "Datenbanken (Postgres)",
          "cost": "geschätzt pro Monat",
          "costMissing_one": "{{count}} ohne Preis",
          "costMissing_other": "{{count}} ohne Preis",
          "problems": "mit Problemen"
        },
        "filterLabel": "Typ",
        "filter": {
          "all": "Alle",
          "graph": "Graph",
          "database": "Datenbank"
        },
        "rowHint": "Eine Zeile öffnet die Instanz: Bearbeiten, Größe, Passwort und Löschen an einem Ort.",
        "table": {
          "name": "Name",
          "type": "Typ",
          "host": "Host",
          "size": "Größe",
          "content": "Inhalt",
          "organisations": "Organisationen",
          "cost": "Kosten/Monat",
          "state": "Zustand"
        },
        "type": {
          "graph": "Graph",
          "database": "Datenbank"
        },
        "health": {
          "ok": "Erreichbar",
          "problem": "Problem",
          "unknown": "Ungeprüft",
          "checking": "Wird geprüft"
        },
        "noOrganisations": "keine",
        "empty": "Noch keine Instanzen eingerichtet.",
        "emptyFiltered": "Keine Instanz dieses Typs.",
        "loadError": "Die Instanzen konnten nicht geladen werden.",
        "mappingsError": "Welche Organisation welche Instanz nutzt, konnte nicht geladen werden. Die Spalte Organisationen ist deshalb leer.",
        "detail": {
          "noDescription": "Keine Beschreibung",
          "id": "ID",
          "database": "Datenbank",
          "health": "Verbindung",
          "check": "Prüfen",
          "password": "Passwort",
          "graphAssignHint": "Den Graphen einer Organisation legen Sie in der Organisation fest.",
          "databaseFallbackHint": "Organisationen ohne Zuordnung speichern ihre Daten in der Standard-Datenbank.",
          "assignPlaceholder": "Organisation wählen",
          "assign": "Zuordnen",
          "inactiveNoAssign": "Eine inaktive Datenbank nimmt keine weiteren Organisationen auf."
        }
      },
      "knowledge": {
        "filter": {
          "label": "Organisation",
          "all": "Alle Organisationen",
          "global": "Ohne Organisation"
        },
        "areas": {
          "title": "Knowledge Areas",
          "create": "Neue Knowledge Area",
          "loading": "Knowledge Areas werden geladen",
          "loadError": "Knowledge Areas konnten nicht geladen werden: {{reason}}",
          "empty": "Noch keine Knowledge Areas.",
          "emptyFiltered": "Diese Organisation hat noch keine Knowledge Areas.",
          "relationsNote": "„Verknüpft mit“ bearbeiten Sie auf der Detailseite einer Knowledge Area unter Einstellungen › Verknüpfungen."
        },
        "table": {
          "name": "Name",
          "content": "Art der Inhalte",
          "size": "Größe",
          "documents": "Dokumente",
          "access": "Zugriff",
          "linkedWith": "Verknüpft mit",
          "status": "Status"
        },
        "content": {
          "general": "Allgemein",
          "own": "eigene"
        },
        "size": {
          "unlimited": "{{chunks}} / unbegrenzt"
        },
        "access": {
          "all": "Alle Rollen",
          "none": "noch keiner Rolle",
          "roles_one": "{{count}} Rolle",
          "roles_other": "{{count}} Rollen",
          "pickOrganisation": "Wählen Sie eine Organisation, um den Zugriff zu sehen."
        },
        "badge": {
          "system": "System",
          "default": "Standard"
        },
        "status": {
          "active": "Aktiv",
          "inactive": "Inaktiv"
        },
        "ontologies": {
          "title": "Ontologien",
          "titleOrganisation": "Ontologien dieser Organisation"
        },
        "relations": {
          "heading": "Verknüpfungen",
          "hint": "Eine Suche in dieser Knowledge Area bezieht die verknüpften automatisch mit ein.",
          "none": "Diese Organisation hat keine weiteren Knowledge Areas.",
          "otherOrganisation": "andere Organisation: {{name}}",
          "save": "Verknüpfungen speichern",
          "saveError": "Verknüpfungen konnten nicht gespeichert werden: {{reason}}",
          "loadError": "Verknüpfungen konnten nicht geladen werden."
        }
      },
      "organizations": {
        "description": "Alles zu einer Organisation an einem Ort: Zugang, Wissen, Speicher und Zugriffe.",
        "eyebrow": "Organisation",
        "search": "Organisation suchen",
        "filter": {
          "attention": "Braucht Aufmerksamkeit"
        },
        "empty": "Noch keine Organisation angelegt.",
        "loadFailed": "Die Organisationen konnten nicht geladen werden.",
        "notLoaded": "Nicht verfügbar – die Daten konnten nicht geladen werden.",
        "supervisorNoOrganization": "Ihrem Konto ist keine Organisation zugeordnet.",
        "graphNotSet": "Kein Graph",
        "noTenant": "Kein Tenant",
        "autoApprove": "Auto-Freigabe",
        "manualApprove": "Manuelle Freigabe",
        "openPoints_one": "{{count}} Punkt offen",
        "openPoints_other": "{{count}} Punkte offen",
        "columns": {
          "organization": "Organisation",
          "users": "Nutzer",
          "seats": "Sitze",
          "signIn": "Anmeldung",
          "knowledge": "Wissen",
          "storage": "Speicher",
          "status": "Status"
        },
        "status": {
          "ok": "In Ordnung",
          "active": "aktiv",
          "notEnabled": "nicht freigeschaltet",
          "short": {
            "tenantNotOnAllowlist": "Tenant offen",
            "noTenant": "Einrichtung offen",
            "noGraph": "Kein Graph",
            "seatsFull": "Sitze voll",
            "seatsOver": "Über dem Limit"
          }
        },
        "facts": {
          "users_one": "{{count}} Nutzer",
          "users_other": "{{count}} Nutzer",
          "tenants_one": "{{count}} Tenant",
          "tenants_other": "{{count}} Tenants",
          "knowledgeAreas_one": "{{count}} Knowledge Area",
          "knowledgeAreas_other": "{{count}} Knowledge Areas",
          "since": "seit {{date}}"
        },
        "tabs": {
          "overview": "Übersicht",
          "access": "Zugang & Sitze",
          "knowledge": "Wissen",
          "accessControl": "Zugriffe",
          "settings": "Einstellungen"
        },
        "issues": {
          "tenantNotOnAllowlist": "Tenant „{{name}}“ ist zugeordnet, die Anmeldung aber noch nicht freigeschaltet.",
          "noTenant": "Noch kein Entra-Tenant zugeordnet – niemand kann sich für diese Organisation anmelden.",
          "noGraph": "Keine Graph-Instanz gesetzt – ohne sie lassen sich keine Knowledge Areas anlegen.",
          "seatsFull": "Alle Sitze sind belegt – neue Nutzer warten auf manuelle Freigabe.",
          "seatsOver": "Mehr Nutzer als Sitze – automatische Freigaben pausieren.",
          "goTo": {
            "access": "Zu Zugang & Sitze",
            "settings": "Zu Einstellungen"
          }
        },
        "overview": {
          "seats": "Sitze",
          "seatsOf": "{{used}} von {{limit}}",
          "noRole": "Keine Rolle",
          "signIn": "Anmeldung",
          "tenants_one": "{{count}} Entra-Tenant",
          "tenants_other": "{{count}} Entra-Tenants",
          "appsForNewUsers": "Apps für neue Nutzer",
          "knowledge": "Wissen",
          "knowledgeAreas_one": "{{count}} Knowledge Area",
          "knowledgeAreas_other": "{{count}} Knowledge Areas",
          "documents": "Dokumente",
          "activeAreas": "Davon aktiv",
          "storage": "Speicher",
          "accessControl": "Zugriffe",
          "mcp": "Claude (MCP)",
          "mcpEnabled": "freigeschaltet",
          "mcpDisabled": "nicht freigeschaltet",
          "roles": "Benutzerrollen",
          "recent": "Zuletzt"
        },
        "recent": {
          "created": "Organisation angelegt",
          "knowledgeArea": "Knowledge Area „{{name}}“ angelegt",
          "tenant": "Tenant „{{name}}“ zugeordnet"
        },
        "knowledge": {
          "summary_one": "{{count}} Knowledge Area mit {{documents}} Dokumenten.",
          "summary_other": "{{count}} Knowledge Areas mit zusammen {{documents}} Dokumenten.",
          "open": "Wissen dieser Organisation öffnen"
        },
        "accessControl": {
          "summary": "API Keys, externe Zugriffe und Staff-Zugriffe werden unter Zugriffe verwaltet.",
          "open": "Zu Zugriffe"
        },
        "fields": {
          "name": "Name",
          "bucket": "Dateiablage (Storage-Bucket)",
          "graph": "Graph-Instanz",
          "graphPlaceholder": "Graph-Instanz wählen",
          "graphHint": "Alle Knowledge Areas dieser Organisation liegen in dieser Graph-Instanz. Sobald sie Knowledge Areas hat, lässt sie sich nicht mehr ändern."
        },
        "create": {
          "button": "Neue Organisation",
          "title": "Neue Organisation",
          "description": "Legt die Organisation an. Ihre Dateiablage wird automatisch erstellt.",
          "namePlaceholder": "Name der Organisation",
          "nameHint": "Die Dateiablage heißt danach client-{name}.",
          "graphRequired": "Bitte eine Graph-Instanz wählen.",
          "failed": "Die Organisation konnte nicht angelegt werden: {{reason}}",
          "graphFailed": "Die Organisation „{{name}}“ wurde angelegt, aber die Graph-Instanz konnte nicht gesetzt werden: {{reason}}. Bitte unter Einstellungen nachholen."
        },
        "settings": {
          "general": "Allgemein",
          "dangerZone": "Organisation löschen",
          "bucketHint": "Der Name der Dateiablage ändert sich beim Umbenennen nicht.",
          "graphLocked_one": "Die Organisation hat bereits {{count}} Knowledge Area, deshalb lässt sich die Graph-Instanz nicht mehr ändern.",
          "graphLocked_other": "Die Organisation hat bereits {{count}} Knowledge Areas, deshalb lässt sich die Graph-Instanz nicht mehr ändern.",
          "graphHasKnowledgeAreas": "Die Organisation hat inzwischen Knowledge Areas, deshalb lässt sich die Graph-Instanz nicht mehr ändern.",
          "graphSaveFailed": "Die Graph-Instanz konnte nicht gespeichert werden: {{reason}}",
          "saveFailed": "Speichern fehlgeschlagen: {{reason}}",
          "saved": "Einstellungen gespeichert"
        },
        "delete": {
          "title": "Organisation löschen",
          "description": "„{{name}}“ wird endgültig gelöscht.",
          "hint": "Löscht die Organisation. Das geht nur, solange ihr keine Nutzer zugeordnet sind.",
          "hasUsersCount_one": "{{count}} Nutzer ist noch zugeordnet – erst dann lässt sich die Organisation löschen, wenn niemand mehr zugeordnet ist.",
          "hasUsersCount_other": "{{count}} Nutzer sind noch zugeordnet – erst dann lässt sich die Organisation löschen, wenn niemand mehr zugeordnet ist.",
          "hasUsers": "Eine Organisation mit Nutzern lässt sich nicht löschen.",
          "failed": "Löschen fehlgeschlagen: {{reason}}",
          "bucketLabel": "Dateiablage ebenfalls löschen",
          "bucketHint": "Löscht auch alle Dateien im Storage-Bucket der Organisation.",
          "bucketWarning": "Das lässt sich nicht rückgängig machen."
        }
      }
    },
    "usersHub": {
      "tabs": {
        "users": "Benutzer",
        "requests": "Anfragen",
        "roles": "Rollen"
      }
    },
    "clientAppVisibility": {
      "title": "Client-App-Sichtbarkeit",
      "description": "Apps ohne Zuordnung sind für alle Clients sichtbar (generell). Apps mit Zuordnungen sind nur für die zugeordneten Clients sichtbar.",
      "addAssignment": "Zuordnung hinzufügen",
      "generalApps": "Generelle Apps",
      "clientSpecificApps": "Client-spezifische Apps",
      "noClientSpecificApps": "Keine client-spezifischen Apps konfiguriert",
      "allAppsGeneral": "Alle Apps sind derzeit für alle Clients sichtbar",
      "removeAll": "Alle entfernen",
      "table": {
        "app": "App",
        "clients": "Sichtbar für Clients",
        "actions": "Aktionen"
      },
      "addDialog": {
        "title": "Client-App-Zuordnung hinzufügen",
        "description": "Wählen Sie einen Client und eine App aus. Die App wird dann nur für diesen Client sichtbar (und andere zugeordnete Clients).",
        "client": "Client",
        "app": "App",
        "selectClient": "Client auswählen...",
        "selectApp": "App auswählen...",
        "add": "Hinzufügen"
      },
      "errors": {
        "load": "Fehler beim Laden der Client-App-Zuordnungen"
      }
    },
    "knowledgeAreas": {
      "title": "Knowledge Area Verwaltung",
      "description": "Erstellen und verwalten Sie Knowledge Areas. Administratoren haben automatischen Zugriff auf alle Knowledge Areas.",
      "newKnowledgeArea": "Neue Knowledge Area",
      "availableKnowledgeAreas": "Verfügbare Knowledge Areas",
      "noKnowledgeAreas": "Keine Knowledge Areas verfügbar",
      "name": "Name",
      "bucket": "Bucket",
      "active": "Aktiv",
      "inactive": "Inaktiv",
      "delete": "Löschen",
      "createKnowledgeArea": "Knowledge Area erstellen",
      "areaName": "Name der Knowledge Area",
      "areaDescription": "Beschreibung",
      "create": "Erstellen",
      "cancel": "Abbrechen",
      "creating": "Erstelle...",
      "createSuccess": "Knowledge Area erfolgreich erstellt",
      "createError": "Fehler beim Erstellen der Knowledge Area",
      "deleteConfirm": "Knowledge Area löschen",
      "deleteWarning": "Möchten Sie diese Knowledge Area wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
      "deleteSuccess": "Knowledge Area erfolgreich gelöscht",
      "deleteError": "Fehler beim Löschen der Knowledge Area"
    },
    "kaRelations": {
      "title": "Knowledge Area Verknüpfungen",
      "description": "Wenn ein Knowledge Area ausgewählt wird, werden verknüpfte Bereiche automatisch in die Suche einbezogen.",
      "infoBanner": {
        "title": "Wie funktioniert das?",
        "description": "Beispiel: Wenn 'Meeting' mit 'Products' verknüpft ist, werden bei der Auswahl von 'Meeting' automatisch auch Ergebnisse aus 'Products' einbezogen."
      },
      "table": {
        "sourceKA": "Knowledge Area",
        "includes": "Inkludiert automatisch",
        "actions": "Aktion"
      },
      "noAreas": "Keine Knowledge Areas vorhanden",
      "noRelations": "Keine Verknüpfungen",
      "edit": "Bearbeiten",
      "relationTypeLabel": "Typ",
      "dialog": {
        "title": "Verknüpfungen für: {{name}}",
        "description": "Wählen Sie die Bereiche aus, die automatisch in die Suche einbezogen werden sollen."
      },
      "error": "Fehler beim Laden der Verknüpfungen",
      "saveError": "Verknüpfungen konnten nicht gespeichert werden"
    },
    "graphInstances": {
      "title": "Graph Instances",
      "description": "Verwalten Sie Neo4j-Graph-Instanzen, die von Knowledge Areas genutzt werden. {{total}} konfiguriert.",
      "createNew": "Instanz verbinden",
      "noInstances": "Bisher sind keine Graph Instances konfiguriert.",
      "default": "Standard",
      "active": "Aktiv",
      "inactive": "Inaktiv",
      "retry": "Erneut versuchen",
      "table": {
        "displayName": "Anzeigename",
        "name": "Kennung",
        "uri": "URI (Host)",
        "database": "Datenbank",
        "status": "Status",
        "health": "Zustand",
        "actions": "Aktionen",
        "size": "Größe",
        "content": "Inhalt",
        "cost": "Kosten/Monat (geschätzt)"
      },
      "createTitle": "Bestehende Instanz verbinden",
      "createDescription": "Eine bestehende Neo4j-Instanz über ihre Zugangsdaten verbinden. Das Passwort wird verschlüsselt gespeichert und nie zurückgegeben.",
      "editTitle": "Graph Instance bearbeiten",
      "editDescription": "Verbindungsdaten aktualisieren. Das Passwort wird über das Schlüssel-Symbol in der Zeile rotiert.",
      "fields": {
        "name": "Kennung",
        "nameHint": "klein geschrieben, z. B. \"aura-prod-eu\"",
        "displayName": "Anzeigename",
        "description": "Beschreibung",
        "uri": "Neo4j-URI",
        "uriHint": "z. B. neo4j+s://xxxxx.databases.neo4j.io",
        "user": "Benutzer",
        "password": "Passwort",
        "passwordHint": "Schreibgeschützt im Sinne von write-only. Das aktuelle Passwort wird nie zurückgegeben.",
        "database": "Datenbank",
        "databaseHint": "Üblicherweise \"neo4j\"",
        "active": "Aktiv",
        "activeHint": "Inaktive Instanzen werden von Knowledge Areas übersprungen.",
        "memory": "Größe",
        "memoryHint": "Arbeitsspeicher der Aura-Instanz. Aura startet mit dem kleinsten Speicher dazu; mehr Speicher geht später über „Größe ändern“.",
        "displayNameProvisionHint": "Wird bei Aura genau so als Instanzname verwendet, höchstens {{max}} Zeichen.",
        "memoryOption": "{{memory}} · ca. {{cost}} pro Monat"
      },
      "validation": {
        "nameRequired": "Kennung ist erforderlich.",
        "displayNameRequired": "Anzeigename ist erforderlich.",
        "displayNameTooLongForAura": "Aura erlaubt höchstens {{max}} Zeichen für den Instanznamen. Bitte kürzen.",
        "uriRequired": "Neo4j-URI ist erforderlich.",
        "userRequired": "Benutzer ist erforderlich.",
        "passwordRequired": "Passwort ist erforderlich.",
        "databaseRequired": "Datenbank ist erforderlich."
      },
      "testConnection": {
        "label": "Verbindung testen",
        "hint": "Prüft die gespeicherten Zugangsdaten gegen die Neo4j-Instanz. Bearbeitete Felder vorher speichern, um die neuen Werte zu testen.",
        "createHint": "Erst speichern – die Verbindung lässt sich anschließend aus dem Bearbeiten-Dialog testen.",
        "button": "Verbindung testen",
        "testing": "Teste…",
        "success": "Verbindung erfolgreich.",
        "failure": "Verbindung fehlgeschlagen."
      },
      "rotatePassword": {
        "button": "Passwort rotieren",
        "title": "Passwort rotieren",
        "description": "Setzt ein neues, zufälliges Passwort direkt an der Neo4j-Instanz „{{name}}“ und hinterlegt es hier. Das Passwort wird nicht angezeigt; es wird nirgends sonst gebraucht.",
        "submit": "Passwort rotieren",
        "recordLink": "Passwort wurde bereits beim Anbieter geändert? Hier eintragen",
        "recordTitle": "Passwort hinterlegen",
        "recordDescription": "Trage das Passwort ein, das an der Instanz „{{name}}“ bereits gilt. Es wird vor dem Speichern gegen die Instanz geprüft; ein falsches Passwort wird nicht gespeichert.",
        "recordSubmit": "Passwort hinterlegen",
        "backToRotate": "Zurück zur Rotation",
        "staleHint": "Das hinterlegte Passwort gilt an der Instanz nicht mehr. Trage das aktuelle Passwort ein.",
        "newPassword": "Aktuelles Passwort",
        "confirmPassword": "Passwort bestätigen",
        "mismatch": "Passwörter stimmen nicht überein."
      },
      "setDefault": {
        "button": "Als Standard festlegen"
      },
      "delete": {
        "title": "Graph Instance löschen",
        "confirm": "Graph Instance \"{{name}}\" löschen?",
        "warning": "Dies kann nicht rückgängig gemacht werden. Knowledge Areas, die auf diese Instanz zeigen, verlieren ihr Graph-Backend.",
        "checkingRefs": "Prüfe Knowledge Areas, die diese Instanz nutzen…",
        "warningReferenced_one": "{{count}} Knowledge Area referenziert diese Instanz noch:",
        "warningReferenced_other": "{{count}} Knowledge Areas referenzieren diese Instanz noch:",
        "alsoDeleteAura": "Aura-Datenbank ebenfalls löschen",
        "alsoDeleteAuraWarning": "Die Datenbank und alle darin gespeicherten Daten werden unwiderruflich gelöscht.",
        "keepAuraHint": "Nur die Registrierung wird entfernt. Die Aura-Datenbank bleibt bestehen und kann erneut registriert werden."
      },
      "errors": {
        "load": "Fehler beim Laden der Graph Instances",
        "create": "Instanz konnte nicht verbunden werden",
        "update": "Graph Instance konnte nicht aktualisiert werden",
        "delete": "Graph Instance konnte nicht gelöscht werden",
        "rotatePassword": "Passwort konnte nicht rotiert werden",
        "setDefault": "Standard-Instanz konnte nicht gesetzt werden",
        "testConnection": "Verbindungstest fehlgeschlagen",
        "provision": "Instanz konnte nicht erstellt werden"
      },
      "provisionNew": "Instanz erstellen",
      "provisionTitle": "Neue Aura-Instanz erstellen",
      "provisionDescription": "Legt eine neue Neo4j-Aura-Datenbank an und registriert sie in einem Schritt. Zugangsdaten werden von Aura erzeugt und verschlüsselt gespeichert.",
      "provisionHint": "Die Datenbank wird bei Neo4j Aura neu angelegt und ist erst nach einigen Minuten erreichbar. Bis dahin ist kein Verbindungstest möglich.",
      "provisionCostConfirm": "Mir ist bewusst, dass dadurch eine kostenpflichtige Aura-Instanz entsteht, die laufende Kosten verursacht.",
      "provisionSubmit": "Instanz erstellen",
      "provisioning": "Wird erstellt",
      "provisioningFailed": "Fehlgeschlagen",
      "sizeValue": "{{memory}} RAM · {{storage}} Speicher",
      "selfHosted": "selbst gehostet",
      "usageValue": "{{nodes}} Knoten · {{relationships}} Kanten",
      "totalCost": "Geschätzte Kosten: {{amount}} pro Monat (Listenpreis Neo4j Aura)",
      "totalCostMissing_one": "– für {{count}} Instanz unbekannt",
      "totalCostMissing_other": "– für {{count}} Instanzen unbekannt",
      "resizing": "Wird auf {{memory}} umgestellt",
      "resizingHint": "Die Datenbank bleibt währenddessen erreichbar.",
      "resize": {
        "button": "Größe ändern",
        "notPossible": "Nur für Aura-Instanzen, die bereit sind",
        "title": "Größe ändern: {{name}}",
        "description": "Arbeitsspeicher und Speicher der Aura-Instanz anpassen.",
        "storage": "Speicher",
        "costChange": "Geschätzt {{from}} → {{to}} pro Monat",
        "costUnknown": "Für diese Größe ist kein Preis hinterlegt.",
        "costBasis": "Listenpreis von Neo4j Aura: Arbeitsspeicher × Preis pro GB und Stunde × 730 Stunden. Speicher ist im Preis enthalten. Die tatsächliche Rechnung kann abweichen.",
        "duration": "Die Umstellung dauert etwa drei Minuten. Die Datenbank bleibt währenddessen erreichbar.",
        "confirm": "Mir ist bewusst, dass sich dadurch die laufenden Kosten der Aura-Instanz ändern können.",
        "submit": "Größe ändern",
        "error": "Größe konnte nicht geändert werden",
        "loadError": "Verfügbare Größen konnten nicht geladen werden"
      },
      "usageMeasured": "gezählt {{ago}}",
      "usageNever": "noch nicht gezählt",
      "recount": "Neu zählen",
      "recountAll": "Alle neu zählen",
      "recountFailed": "Zählen fehlgeschlagen"
    },
    "postgresInstances": {
      "title": "Postgres-Instanzen",
      "description": "Verwalten Sie PostgreSQL-Tenant-Datenbanken für die mandantenweise Daten-Isolation. {{total}} konfiguriert.",
      "createNew": "Neue Instanz",
      "noInstances": "Bisher sind keine Postgres-Instanzen konfiguriert.",
      "active": "Aktiv",
      "inactive": "Inaktiv",
      "retry": "Erneut versuchen",
      "tabs": {
        "instances": "Instanzen",
        "assignment": "Client-Zuordnung"
      },
      "table": {
        "displayName": "Anzeigename",
        "name": "Kennung",
        "host": "Host:Port",
        "database": "Datenbank",
        "clients": "Clients",
        "status": "Status",
        "health": "Zustand",
        "actions": "Aktionen"
      },
      "createTitle": "Postgres-Instanz anlegen",
      "createDescription": "Eine neue PostgreSQL-Tenant-Datenbank registrieren. Das Passwort wird verschlüsselt gespeichert und nie zurückgegeben.",
      "editTitle": "Postgres-Instanz bearbeiten",
      "editDescription": "Verbindungsdaten aktualisieren. Das Passwort wird über das Schlüssel-Symbol in der Zeile rotiert.",
      "fields": {
        "name": "Kennung",
        "nameHint": "klein geschrieben, z. B. \"tenant-test_a\"",
        "displayName": "Anzeigename",
        "description": "Beschreibung",
        "host": "Host",
        "hostHint": "z. B. psql-cdb-dev-bik.postgres.database.azure.com",
        "port": "Port",
        "database": "Datenbank",
        "databaseHint": "z. B. cdb_tqs_test_a",
        "user": "Benutzer",
        "password": "Passwort",
        "passwordHint": "Schreibgeschützt im Sinne von write-only. Das aktuelle Passwort wird nie zurückgegeben.",
        "active": "Aktiv",
        "activeHint": "Inaktive Instanzen können keinen Clients zugewiesen werden."
      },
      "validation": {
        "nameRequired": "Kennung ist erforderlich.",
        "displayNameRequired": "Anzeigename ist erforderlich.",
        "hostRequired": "Host ist erforderlich.",
        "portInvalid": "Port muss zwischen 1 und 65535 liegen.",
        "databaseRequired": "Datenbank ist erforderlich.",
        "userRequired": "Benutzer ist erforderlich.",
        "passwordRequired": "Passwort ist erforderlich."
      },
      "testConnection": {
        "label": "Verbindung testen",
        "hint": "Prüft die gespeicherten Zugangsdaten gegen die PostgreSQL-Instanz. Bearbeitete Felder vorher speichern, um die neuen Werte zu testen.",
        "createHint": "Prüft die oben eingegebenen Zugangsdaten, ohne zu speichern.",
        "needsConnFields": "Host, Port, Datenbank, Benutzer und Passwort eingeben, um zu testen.",
        "button": "Verbindung testen",
        "testing": "Teste…",
        "success": "Verbindung erfolgreich.",
        "failure": "Verbindung fehlgeschlagen."
      },
      "rotatePassword": {
        "button": "Passwort rotieren",
        "title": "Passwort rotieren",
        "description": "Neues Passwort für \"{{name}}\" setzen. Das aktuelle Passwort lässt sich nicht abrufen.",
        "newPassword": "Neues Passwort",
        "confirmPassword": "Neues Passwort bestätigen",
        "mismatch": "Passwörter stimmen nicht überein.",
        "submit": "Rotieren"
      },
      "delete": {
        "title": "Postgres-Instanz löschen",
        "confirm": "Postgres-Instanz \"{{name}}\" löschen?",
        "warning": "Dies kann nicht rückgängig gemacht werden.",
        "warningClients_one": "{{count}} Client ist dieser Instanz noch zugeordnet. Bitte zuerst neu zuweisen.",
        "warningClients_other": "{{count}} Clients sind dieser Instanz noch zugeordnet. Bitte zuerst neu zuweisen."
      },
      "assign": {
        "panelTitle": "Client-Zuordnung",
        "panelDescription": "Legen Sie fest, welche Postgres-Instanz die Daten eines Clients besitzt. Ohne Zuordnung greift die Standard-Instanz. {{total}} Clients.",
        "noClients": "Keine Clients vorhanden.",
        "title": "Client zuordnen",
        "description": "Postgres-Instanz für \"{{client}}\" auswählen.",
        "instance": "Postgres-Instanz",
        "instancePlaceholder": "Instanz auswählen…",
        "instanceRequired": "Bitte eine Instanz auswählen.",
        "notes": "Notizen",
        "notesHint": "Optional, z. B. Ticket-Referenz oder Provisioning-Datum.",
        "defaultFallback": "Standard",
        "change": "Zuordnung ändern",
        "assign": "Zuordnen",
        "unassign": "Auf Standard zurücksetzen",
        "table": {
          "client": "Client",
          "instance": "Instanz",
          "notes": "Notizen",
          "actions": "Aktionen"
        }
      },
      "errors": {
        "load": "Fehler beim Laden der Postgres-Instanzen",
        "loadMappings": "Fehler beim Laden der Client-Zuordnungen",
        "create": "Postgres-Instanz konnte nicht angelegt werden",
        "update": "Postgres-Instanz konnte nicht aktualisiert werden",
        "delete": "Postgres-Instanz konnte nicht gelöscht werden",
        "rotatePassword": "Passwort konnte nicht rotiert werden",
        "assign": "Client konnte nicht zugeordnet werden",
        "unassign": "Zuordnung konnte nicht aufgehoben werden"
      }
    },
    "supervisorKA": {
      "title": "Knowledge Areas",
      "createNew": "Neue Knowledge Area",
      "noAreas": "Noch keine Knowledge Areas vorhanden",
      "errorLoading": "Fehler beim Laden der Knowledge Areas"
    },
    "voiceAgentPrompts": {
      "infoTitle": "Voice Agent Widget - Prompts Verwaltung",
      "infoDescription": {
        "intro": "Verwalten Sie Prompts für das Voice Agent Widget:",
        "systemPrompts": "Alle Prompts - aktivieren/deaktivieren über Toggle-Switch"
      },
      "tabs": {
        "system": "System Prompts",
        "knowledgeArea": "Knowledge Area Prompts",
        "allKnowledgeAreas": "Alle Knowledge Areas"
      },
      "systemPrompts": {
        "title": "System Prompts",
        "description": "Globale App-Ebene Prompts für den Voice Agent"
      },
      "knowledgeAreaPrompts": {
        "title": "Knowledge Area Prompts",
        "description": "Prompts spezifisch für einzelne Wissensbereiche"
      },
      "allKnowledgeAreasPrompts": {
        "title": "Alle Knowledge Areas Prompts",
        "description": "Prompts die für alle Wissensbereiche gelten"
      }
    },
    "promptManagement": {
      "assignedPrompts": {
        "title": "Zugewiesene Prompts",
        "description": "Aktuell zugewiesene Prompts für diese App/diesen Bereich",
        "empty": "Noch keine Prompts zugewiesen. Ziehen Sie Prompts aus der Prompt Library hierher."
      },
      "dropZone": {
        "hint": "Prompts hier ablegen zum Zuweisen",
        "dropping": "Ablegen zum Zuweisen",
        "description": "Öffnen Sie die Prompt Library, ziehen Sie einen Prompt und legen Sie ihn hier ab"
      },
      "assigning": "Weise Prompt zu...",
      "alreadyAssigned": "Dieser Prompt ist bereits zugewiesen und aktiv",
      "edit": "Prompt bearbeiten",
      "remove": "Zuweisung entfernen",
      "status": {
        "active": "Aktiv",
        "inactive": "Inaktiv"
      },
      "table": {
        "name": "Name",
        "promptKey": "Prompt-Schlüssel",
        "type": "Typ",
        "application": "Anwendung",
        "status": "Status",
        "actions": "Aktionen"
      },
      "editDialog": {
        "title": "Zugewiesenen Prompt bearbeiten",
        "description": "Inhalt und Status dieses Prompts bearbeiten",
        "metadata": "Prompt Informationen",
        "activeStatus": "Aktiv",
        "activeDescription": "Inaktive Prompts werden von der Anwendung nicht verwendet",
        "content": "Prompt Inhalt",
        "characters": "Zeichen"
      },
      "deleteConfirm": {
        "title": "Zuweisung entfernen",
        "description": "Möchten Sie den Prompt \"{{name}}\" wirklich entfernen?",
        "inline": "Zuweisung für \"{{name}}\" entfernen?",
        "inlineHint": "Der Prompt wird auf inaktiv gesetzt",
        "confirm": "Entfernen"
      }
    },
    "prompts": {
      "searchPlaceholder": "Prompts durchsuchen...",
      "languagePlaceholder": "Sprache wählen",
      "loading": "Prompt Library wird geladen...",
      "filters": {
        "placeholder": "Nach Kategorie filtern",
        "all": "Alle Prompts",
        "system": "System",
        "session": "Session",
        "turn": "Turn",
        "answer": "Antwort",
        "tool": "Tool",
        "utility": "Utility"
      },
      "scope": {
        "general": "Allgemein",
        "placeholder": "Bereich wählen",
        "info": "Knowledge-Area-Prompts für \"{{name}}\". Änderungen wirken sich nur auf diese Knowledge Area aus."
      },
      "stats": {
        "visible": "{{visible}} von {{total}} Prompts sichtbar"
      },
      "emptyState": {
        "title": "Keine passenden Prompts",
        "subtitle": "Passe die Filter oder den Suchbegriff an."
      },
      "actions": {
        "edit": "Bearbeiten",
        "createSystem": "Neuen System-Prompt anlegen",
        "delete": "Löschen"
      },
      "editor": {
        "editTitle": "Prompt bearbeiten",
        "createTitle": "System-Prompt anlegen",
        "id": "ID",
        "category": "Kategorie",
        "usage": "Verwendung",
        "mode": "Modus",
        "modePlaceholder": "z. B. system",
        "tags": "Tags (durch Komma getrennt)",
        "tagsPlaceholder": "kontext, system",
        "title": "Titel",
        "titlePlaceholder": "Eindeutiger Name, z. B. Begrüßung Ka",
        "content": "Inhalt",
        "contentPlaceholder": "Schreibe den Prompt-Text...",
        "description": "Beschreibung",
        "descriptionPlaceholder": "Optional: Kontext oder Hinweise für das Team",
        "optional": "optional",
        "cancel": "Abbrechen",
        "save": "Speichern",
        "saving": "Speichert...",
        "generatedIdInfo": "Die Prompt-ID wird automatisch generiert und bleibt eindeutig. Bei bestehenden Prompts kann sie nicht geändert werden.",
        "systemInfo": "Prompts werden automatisch als System-Prompts gespeichert und gelten für die ausgewählte Knowledge Area oder global.",
        "tabs": {
          "new": "Neu erstellen",
          "library": "Vorhandene Prompts"
        },
        "library": {
          "subtitle": "Nutze einen bestehenden Prompt als Vorlage für diese Knowledge Area.",
          "loading": "Prompts werden geladen...",
          "empty": "Es wurden keine passenden Prompts in anderen Knowledge Areas gefunden.",
          "error": "Die Prompt-Vorlagen konnten nicht geladen werden.",
          "knowledgeAreaLabel": "Knowledge Area",
          "actions": {
            "use": "Übernehmen"
          }
        },
        "errors": {
          "requiredId": "Eine ID ist erforderlich.",
          "requiredContent": "Bitte gib Titel und Inhalt an.",
          "duplicateId": "Diese ID wird bereits verwendet."
        },
        "deleteConfirm": "Soll der Prompt \"{{title}}\" wirklich gelöscht werden?"
      },
      "badges": {
        "usage": {
          "system": "System",
          "session": "Session",
          "turn": "Turn",
          "answer": "Antwort",
          "tool": "Tool",
          "utility": "Utility",
          "greeting": "Begrüßung",
          "instruction": "Instruktion"
        },
        "mode": {
          "simple": "Simple",
          "deep": "Deep",
          "web": "Web",
          "system": "System"
        }
      },
      "toasts": {
        "copiedTitle": "Prompt kopiert",
        "copiedDescription": "Der Text wurde in die Zwischenablage übernommen.",
        "copyFailedTitle": "Kopieren fehlgeschlagen",
        "copyFailedDescription": "Bitte kopiere den Prompt manuell."
      },
      "errors": {
        "loadFailed": "Prompt Library konnte nicht geladen werden."
      }
    },
    "aiKnowledgeExtractor": {
      "title": "AI Knowledge Extractor",
      "knowledgeArea": "Knowledge Area",
      "selectDocument": "Dokument auswählen",
      "noDocuments": "Keine PDF-Dokumente verfügbar",
      "noFilterResults": "Keine Dokumente gefunden",
      "errorLoadingDocuments": "Fehler beim Laden der Dokumente",
      "welcomeTitle": "Willkommen beim AI Knowledge Extractor",
      "welcomeDescription": "Wählen Sie ein PDF-Dokument aus der Sidebar, um mit der Knowledge Extraction zu beginnen.",
      "startExtraction": "Extraktion starten",
      "extracting": "Extrahiere...",
      "progress": "Fortschritt: {{progress}}%",
      "extractionComplete": "Extraktion erfolgreich abgeschlossen!",
      "extractionError": "Fehler bei der Extraktion",
      "downloadResults": "Ergebnisse herunterladen",
      "summary": "Zusammenfassung",
      "keywords": "Schlüsselwörter",
      "entities": "Entitäten",
      "extractedText": "Extrahierter Text",
      "searchPlaceholder": "Titel oder Dateiname suchen",
      "filterAll": "Alle Status",
      "filterCompleted": "Abgeschlossen",
      "filterProcessing": "In Bearbeitung",
      "filterPending": "Ausstehend",
      "statusCompleted": "Abgeschlossen",
      "statusProcessing": "In Bearbeitung",
      "statusPending": "Ausstehend",
      "statusFailed": "Fehlgeschlagen",
      "columnFilename": "Dateiname",
      "columnKnowledgeArea": "Wissensbereich",
      "columnCreated": "Erstellt",
      "documentCount": "{{count}} Dokumente",
      "viewResults": "Ergebnisse ansehen",
      "viewGraph": "Wissensgraph ansehen"
    },
    "common": {
      "loading": "Lädt...",
      "saving": "Speichern...",
      "deleting": "Löschen...",
      "error": "Fehler",
      "success": "Erfolgreich",
      "cancel": "Abbrechen",
      "save": "Speichern",
      "delete": "Löschen",
      "edit": "Bearbeiten",
      "close": "Schließen",
      "confirm": "Bestätigen",
      "yes": "Ja",
      "no": "Nein",
      "webSearch": "Websuche"
    },
    "apps": {
      "urlApp": "URL-App",
      "title": "Apps-Verwaltung",
      "description": "Apps erstellen, bearbeiten und verwalten",
      "create": "App erstellen",
      "createTitle": "Neue App erstellen",
      "editTitle": "App bearbeiten",
      "deleteTitle": "App löschen",
      "deleteConfirm": "Möchten Sie diese App wirklich löschen?",
      "deleteWarning": "Diese Aktion kann nicht rückgängig gemacht werden.",
      "createSuccess": "App erfolgreich erstellt",
      "updateSuccess": "App erfolgreich aktualisiert",
      "deleteSuccess": "App erfolgreich gelöscht",
      "deleteError": "Fehler beim Löschen der App",
      "saveError": "Fehler beim Speichern der App",
      "loadError": "Fehler beim Laden der Apps",
      "toggleError": "Fehler beim Ändern des Status",
      "clientVisibilityError": "Fehler beim Aktualisieren der Client-Sichtbarkeit",
      "active": "Aktiv",
      "inactive": "Inaktiv",
      "activated": "App aktiviert",
      "deactivated": "App deaktiviert",
      "noApps": "Keine Apps vorhanden",
      "nameRequired": "Name ist erforderlich",
      "invalidName": "Ungültiger App-Name",
      "allClients": "Alle Clients",
      "form": {
        "name": "Name",
        "nameHint": "Eindeutiger Bezeichner (Kleinbuchstaben, Bindestriche)",
        "displayName": "Anzeigename",
        "description": "Beschreibung",
        "icon": "Icon",
        "category": "Kategorie",
        "isActive": "Aktiv",
        "externalUrl": "Externe URL (optional)",
        "externalUrlHint": "Wenn gesetzt, öffnet diese App die angegebene Adresse statt einer eigenen Oberfläche.",
        "knowledgeAreaAware": "Arbeitet mit Knowledge Areas",
        "knowledgeAreaAwareHint": "Nur solche Apps lassen sich in Rollen Knowledge Areas zuweisen. Was eine App in einer zugewiesenen Area darf, ergibt sich aus ihren Endpoints und ist nicht einstellbar.",
        "openMode": "Öffnen in",
        "openModeWindow": "Im Desktop-Fenster",
        "openModeTab": "Im Browser-Tab",
        "openModeHint": "Im Fenster nur mit https. Manche Seiten verbieten das Einbetten oder brauchen eine Anmeldung, die im Fenster nicht klappt. Dann „Im Browser-Tab“ wählen.",
        "namePlaceholder": "meine-app",
        "displayNamePlaceholder": "Meine App",
        "descriptionPlaceholder": "App-Beschreibung..."
      },
      "table": {
        "name": "Name",
        "displayName": "Anzeigename",
        "category": "Kategorie",
        "status": "Status",
        "clients": "Clients",
        "actions": "Aktionen"
      },
      "urlAppWindow": "URL-App · Fenster",
      "categories": {
        "system": "System",
        "productivity": "Produktivität",
        "multimedia": "Multimedia",
        "admin": "Administration",
        "tools": "Werkzeuge",
        "communication": "Kommunikation"
      }
    },
    "colorPicker": {
      "palette": "Palette",
      "recentlyUsed": "Zuletzt benutzt",
      "openPicker": "Klicken um Color Picker zu öffnen"
    },
    "staffAccess": {
      "title": "Staff-Zugriff (Elevation)",
      "enforced": "Erzwungen (prod)",
      "notEnforced": "Nicht erzwungen (dev/staging)",
      "description": "Zeitbegrenzter, begründeter Zugriff auf die Daten eines anderen Kunden (PIM-lite). Die Elevation ist zugleich ihr Audit-Log-Eintrag und für alle Admins sichtbar. Ohne aktive Elevation bleibt auf prod nur die Control-Plane (Status, Fehler, Dateinamen) zugänglich.",
      "activeTitle_other": "Aktive Elevationen ({{count}})",
      "expiresAt": "läuft ab: {{time}}",
      "endNow": "Jetzt beenden",
      "form": {
        "title": "Neue Elevation",
        "client": "Ziel-Organisation",
        "clientPlaceholder": "Organisation wählen…",
        "reason": "Grund (Pflicht)",
        "reasonPlaceholder": "z. B. Support-Ticket #123: fehlgeschlagener Upload",
        "ttl": "Dauer",
        "ttlHours_other": "{{count}} Stunden",
        "submit": "Elevation starten",
        "hint": "Standard 4 h, maximal 24 h. Die Elevation erscheint sofort im Log und lässt sich jederzeit vorzeitig beenden.",
        "ttlHours_one": "{{count}} Stunde"
      },
      "toast": {
        "created": "Elevation gestartet",
        "createFailed": "Elevation fehlgeschlagen",
        "ended": "Elevation beendet",
        "endFailed": "Beenden fehlgeschlagen"
      },
      "log": {
        "empty": "Noch keine Elevationen protokolliert.",
        "status": "Status",
        "actor": "Admin",
        "client": "Organisation",
        "reason": "Grund",
        "started": "Gestartet",
        "until": "Bis",
        "active": "Aktiv",
        "endedEarly": "Vorzeitig beendet",
        "expired": "Abgelaufen"
      },
      "badge": {
        "single": "Elevation aktiv: {{client}}",
        "multiple": "{{count}} aktive Elevationen"
      },
      "activeTitle_one": "Aktive Elevation ({{count}})"
    },
    "externalAccess": {
      "title": "Externe Zugriffe",
      "subtitle": "Wege, über die Clients außerhalb von cdbOS auf Unternehmenswissen zugreifen. Ein Klick zeigt Konfiguration, Freigaben und Protokoll.",
      "claude": {
        "title": "Claude (MCP-Connector)",
        "description": "Suche in Wissensbereichen aus Claude heraus – mit dem Konto und den Rechten der jeweiligen Person."
      },
      "serverOn": "Auf dieser Umgebung aktiv",
      "serverOff": "Auf dieser Umgebung aus",
      "loadFailed": "Konnte nicht geladen werden.",
      "enabledClients": "Freigeschaltete Organisationen",
      "users30": "Aktive Nutzer (30 Tage)",
      "calls30": "Aufrufe (30 Tage)",
      "lastCall": "Letzter Zugriff",
      "back": "Übersicht",
      "configuration": "Konfiguration",
      "url": "Server-URL",
      "clientId": "OAuth-Client-ID",
      "openEntra": "App-Registrierung in Entra öffnen",
      "revokeHint": "Zugriff widerrufen: in Entra die Sitzungen der Person widerrufen oder die Zustimmung zur App entziehen.",
      "noClients": "Noch keine Organisation freigeschaltet.",
      "capabilityHint": "Freischalten über die Capability „features.remote_mcp“ (cdbChat → Tiers bzw. Clients). Ohne sie lehnt der Server jeden Aufruf ab.",
      "audit": "Protokoll",
      "auditHint": "Werkzeug, durchsuchte Wissensbereiche und Trefferzahl je Aufruf. Suchtexte werden nicht gespeichert.",
      "allClients": "Alle Organisationen",
      "columns": {
        "time": "Zeit",
        "user": "Person",
        "client": "Organisation",
        "tool": "Werkzeug",
        "areas": "Wissensbereiche",
        "results": "Treffer",
        "status": "Status",
        "duration": "Dauer"
      },
      "status": {
        "success": "Erfolgreich",
        "error": "Fehler",
        "rate_limited": "Limit erreicht",
        "permission_denied": "Abgelehnt",
        "timeout": "Zeitüberschreitung"
      },
      "noCalls": "Noch keine Aufrufe.",
      "loadMore": "Weitere laden"
    },
    "organizationAccess": {
      "supervisor": {
        "title": "Supervisor",
        "hint": "Was die Supervisoren dieser Organisation tun dürfen. Admins sind davon nicht betroffen.",
        "createKnowledgeAreas": {
          "label": "Knowledge Areas anlegen",
          "description": "Aus: Supervisoren sehen „Neue Knowledge Area“ nicht mehr. Bestehende Knowledge Areas bearbeiten und löschen sie weiter."
        }
      },
      "title": "Zugang & Sitze",
      "description": "Sitze und automatische Freigabe für neue Nutzer pro Organisation.",
      "organizationPlaceholder": "Organisation wählen",
      "loadFailed": "Die Zugangsdaten der Organisation konnten nicht geladen werden.",
      "seats": {
        "title": "Sitze & Freigabe",
        "used": "Belegte Sitze",
        "usedOfLimit": "{{used}} / {{limit}}",
        "usedUnlimited": "{{used}} · unbegrenzt",
        "full": "Alle Sitze belegt – neue Nutzer warten auf manuelle Freigabe.",
        "over": "Über dem Limit – niemand wird deaktiviert, automatische Freigaben pausieren.",
        "limit": "Anzahl Sitze",
        "limitPlaceholder": "Unbegrenzt",
        "hint": "Aktive Nutzer der Organisation, ohne BIK-Administratoren und Schulungsteilnehmer."
      },
      "autoApprove": {
        "label": "Automatisch freigeben",
        "description": "Neue Nutzer aus den Tenants dieser Organisation sind sofort aktiv, solange ein Sitz frei ist."
      },
      "defaultRole": {
        "label": "Standardrolle",
        "placeholder": "Rolle wählen",
        "hint": "Nur Benutzerrollen dieser Organisation, keine Supervisor-Rollen.",
        "none": "Noch keine Benutzerrolle vorhanden – unter Benutzer → Rollen anlegen, oder ohne Rolle freigeben.",
        "noRole": "Keine Rolle – Supervisor weist zu",
        "noRoleHint": "Neue Nutzer werden angelegt, bekommen aber keine Rolle. Sie bleiben auf dem Anmeldebildschirm, bis ein Supervisor ihnen eine Rolle zuweist."
      },
      "theme": {
        "label": "Standard-Theme",
        "placeholder": "Theme wählen",
        "hint": "Gilt für alle neuen Nutzer der Organisation, auch bei manueller Freigabe.",
        "none": "Kein Theme verfügbar – zuerst unter Themes anlegen."
      },
      "tenants": {
        "title": "Entra-Tenants",
        "hint": "Nutzer aus diesen Tenants gehören zu dieser Organisation.",
        "empty": "Noch kein Tenant zugeordnet.",
        "addedBy": "Hinzugefügt von {{name}} am {{date}}",
        "notOnAllowlist": "Anmeldung noch nicht freigeschaltet",
        "remove": "Tenant entfernen",
        "add": "Tenant-ID",
        "addButton": "Hinzufügen",
        "notOnAllowlistHint": "Der Tenant steht nicht in AZURE_AD_ALLOWED_TENANTS. Nutzer können sich erst anmelden, wenn er dort eingetragen ist.",
        "lookup": {
          "checking": "Tenant wird geprüft …",
          "unknownName": "Name nicht abrufbar – der Tenant kann trotzdem hinzugefügt werden.",
          "mappedHere": "Ist dieser Organisation bereits zugeordnet.",
          "mappedElsewhere": "Gehört bereits zur Organisation „{{name}}“."
        },
        "nameUnknown": "Name unbekannt"
      },
      "errors": {
        "seatLimitInvalid": "Bitte eine ganze Zahl zwischen 0 und {{max}} eingeben oder das Feld leer lassen.",
        "tenantInvalid": "Die Tenant-ID muss eine GUID sein.",
        "entryAppRequired": "Mindestens webOS oder cdbChat auswählen.",
        "themeRequired": "Für die automatische Freigabe ist ein Standard-Theme nötig.",
        "waitingMessageTooLong": "Der Hinweis darf höchstens {{max}} Zeichen lang sein.",
        "productEntryRequired": "Die Organisation braucht mindestens webOS oder cdbChat."
      },
      "toast": {
        "saved": "Einstellungen gespeichert",
        "saveFailed": "Speichern fehlgeschlagen",
        "tenantAdded": "Tenant zugeordnet",
        "tenantAddFailed": "Tenant konnte nicht zugeordnet werden",
        "tenantRemoved": "Tenant entfernt",
        "tenantRemoveFailed": "Tenant konnte nicht entfernt werden"
      },
      "pickOrganization": "Wählen Sie eine Organisation, um Sitze und Tenants zu verwalten.",
      "applications": {
        "label": "Anwendungen",
        "webos": "webOS (Desktop)",
        "cdbChat": "cdbChat",
        "editor": "Editor",
        "composer": "Composer",
        "controlCenter": "Control Center"
      },
      "products": {
        "label": "Produkte der Organisation",
        "hint": "Nur diese Produkte können Nutzern der Organisation gegeben werden, von Admins und Supervisoren.",
        "removedWarning": "Beim Speichern verlieren alle Nutzer der Organisation: {{products}}."
      },
      "waitingMessage": {
        "label": "Hinweis für Wartende",
        "placeholder": "z. B. Rollen vergibt die IT, Tel. 0123 456789",
        "hint": "Erscheint auf dem Anmeldebildschirm bei allen, die noch nicht hineinkommen: ohne Rolle, ohne freien Sitz oder vor der Freigabe. {{count}} / {{max}} Zeichen."
      }
    },
    "ontologies": {
      "title": "Ontologien",
      "new": "Neu",
      "newTitle": "Neue Ontologie",
      "empty": "Noch keine Ontologien.",
      "pick": "Links eine Ontologie wählen oder eine neue anlegen.",
      "systemGroup": "System",
      "readOnly": "Nur lesbar",
      "counts": "{{entities}} Entitätstypen · {{edges}} Beziehungstypen",
      "usedBy_one": "Genutzt von {{count}} Knowledge Area",
      "usedBy_other": "Genutzt von {{count}} Knowledge Areas",
      "unsaved": "Nicht gespeichert",
      "formView": "Formular",
      "jsonView": "JSON-Ansicht",
      "jsonLabel": "Definition als JSON",
      "copyToClient": "Als Kopie für Client anlegen",
      "importFile": "Aus Datei importieren",
      "validate": "Prüfen",
      "deleteInUse_one": "Löschen nicht möglich: {{count}} Knowledge Area nutzt diese Ontologie.",
      "deleteInUse_other": "Löschen nicht möglich: {{count}} Knowledge Areas nutzen diese Ontologie.",
      "systemReadOnly": "Systemvorgabe – nicht änderbar. Für eigene Anpassungen eine Kopie für einen Client anlegen.",
      "valid": "Gültig: {{entities}} Entitätstypen, {{edges}} Beziehungstypen, {{pairs}} erlaubte Verbindungen.",
      "name": "Name",
      "client": "Client",
      "clientPlaceholder": "Client wählen",
      "description": "Beschreibung",
      "clientLocked": "Der Client ist fest, solange Knowledge Areas die Ontologie nutzen.",
      "searchTypes": "Typen durchsuchen",
      "entityTypes": "Entitätstypen",
      "edgeTypes": "Beziehungstypen",
      "deleteTitle": "Ontologie löschen?",
      "deleteConfirm": "„{{name}}“ wird endgültig gelöscht.",
      "discardTitle": "Änderungen verwerfen?",
      "discardDescription": "Die Ontologie hat ungespeicherte Änderungen.",
      "discard": "Verwerfen",
      "copyTitle": "Als Kopie für Client anlegen",
      "copyDescription": "„{{name}}“ wird als eigene, änderbare Ontologie des gewählten Clients angelegt.",
      "copyName": "{{name}} (Kopie)",
      "copyCreate": "Kopie anlegen",
      "columns": {
        "name": "Name",
        "description": "Beschreibung für das Modell",
        "fields": "Felder",
        "pairs": "Erlaubt von → nach"
      },
      "anyEntity": "Beliebiger Typ",
      "unnamed": "Ohne Namen",
      "rowErrors_one": "{{count}} Fehler",
      "rowErrors_other": "{{count}} Fehler",
      "noMatches": "Keine Treffer.",
      "noEntityTypes": "Noch keine Entitätstypen.",
      "noEdgeTypes": "Noch keine Beziehungstypen.",
      "removeType": "„{{name}}“ entfernen",
      "addEntityType": "Entitätstyp hinzufügen",
      "addEdgeType": "Beziehungstyp hinzufügen",
      "entityNamePlaceholder": "z. B. Produkt",
      "edgeNamePlaceholder": "z. B. GEHOERT_ZU",
      "descriptionPlaceholder": "Wann soll das Modell diesen Typ verwenden?",
      "noFields": "Keine Felder.",
      "fieldName": "Feldname",
      "fieldType": "Typ",
      "fieldDescription": "Beschreibung des Felds",
      "removeField": "Feld entfernen",
      "addField": "Feld hinzufügen",
      "pairsHint": "Zwischen welchen Entitätstypen darf diese Beziehung stehen?",
      "pairSource": "Von",
      "pairTarget": "Nach",
      "removePair": "Verbindung entfernen",
      "pairNeedsName": "Zuerst einen Namen vergeben.",
      "addPair": "Verbindung hinzufügen",
      "importNotes": {
        "droppedEntity": "Der leere Typ „Entity“ wurde entfernt, Graphiti verwendet ihn ohnehin für jede Entität.",
        "edgesOpened_one": "{{count}} Beziehungstyp ist jetzt zwischen allen Entitätstypen erlaubt, weil er zu viele Verbindungen für die Extraktion aufzählte: {{names}}",
        "edgesOpened_other": "{{count}} Beziehungstypen sind jetzt zwischen allen Entitätstypen erlaubt, weil sie zu viele Verbindungen für die Extraktion aufzählten: {{names}}"
      },
      "fieldTypes": {
        "text": "Text",
        "integer": "Zahl",
        "number": "Dezimal",
        "boolean": "Ja/Nein",
        "text_list": "Liste von Text",
        "integer_list": "Liste von Zahlen",
        "datetime": "Datum/Zeit",
        "date": "Datum"
      },
      "errors": {
        "validate": "Prüfen fehlgeschlagen.",
        "save": "Speichern fehlgeschlagen.",
        "delete": "Löschen fehlgeschlagen.",
        "import": "Import fehlgeschlagen.",
        "importType": "Bitte eine .py- oder .json-Datei wählen.",
        "importJson": "Die Datei ist keine gültige Ontologie: {{reason}}",
        "json": "Ungültiges JSON: {{reason}}",
        "nameRequired": "Bitte einen Namen eingeben.",
        "clientRequired": "Bitte einen Client wählen.",
        "list": "Ontologien konnten nicht geladen werden: {{reason}}",
        "load": "Ontologie konnte nicht geladen werden: {{reason}}"
      },
      "genericPairs": "Allgemeine Beziehung {{edge}} (ohne eigene Definition): {{pairs}}"
    }
  },
  "languages": {
    "de": "Deutsch",
    "en": "Englisch"
  },
  "roleBasedApp": {
    "checkingAccessHelper": "Bitte einen Moment Geduld.",
    "accessTo": "Zugriff auf {{app}}",
    "accessDenied": "Zugriff verweigert",
    "noPermission": "Für diese Anwendung fehlt die Berechtigung.",
    "roleAdmin": "Administrator",
    "roleUser": "Benutzer",
    "active": "Aktiv",
    "inactive": "Inaktiv",
    "user": "Benutzer: {{email}}",
    "contactAdmin": "Für den Zugriff bitte an einen Administrator wenden."
  },
  "start": {
    "openAria": "Startmenü öffnen",
    "label": "Start",
    "loadingApps": "Lade Apps..."
  },
  "auth": {
    "guest": "Gast",
    "email": "E-Mail",
    "password": "Passwort",
    "name": "Name",
    "message": "Nachricht",
    "emailRequired": "E-Mail-Adresse ist erforderlich",
    "emailInvalid": "Bitte eine gültige E-Mail-Adresse eingeben",
    "passwordRequired": "Passwort ist erforderlich",
    "nameRequired": "Name ist erforderlich",
    "signIn": "Anmelden",
    "signingIn": "Anmeldung...",
    "signUp": "Registrieren",
    "signingUp": "Registrierung...",
    "forgotPassword": "Passwort vergessen?",
    "createAccount": "Konto erstellen",
    "backToLogin": "Zurück zum Login",
    "resetPassword": "Passwort zurücksetzen",
    "loginTitle": "cdbOS - Anmeldung",
    "welcomeBack": "Willkommen zurück",
    "welcome": "Willkommen",
    "loginSuccess": "Erfolgreich angemeldet",
    "loginFailed": "Anmeldung fehlgeschlagen",
    "registerSuccess": "Registrierung erfolgreich",
    "registerFailed": "Registrierung fehlgeschlagen",
    "logoutSuccess": "Abgemeldet",
    "logoutMessage": "Du wurdest erfolgreich abgemeldet.",
    "invalidCredentials": "Ungültige Zugangsdaten",
    "errorOccurred": "Ein Fehler ist aufgetreten",
    "resetNotAvailable": "Nicht verfügbar",
    "resetNotEnabled": "Passwort-Reset ist in dieser Demo nicht aktiviert.",
    "nameMinLength": "Name muss mindestens 2 Zeichen lang sein",
    "nameMaxLength": "Name darf nicht mehr als 100 Zeichen haben",
    "nameInvalidChars": "Name darf nur Buchstaben, Leerzeichen, Bindestriche und Apostrophe enthalten",
    "passwordMinLength": "Passwort muss mindestens 8 Zeichen lang sein",
    "passwordMaxLength": "Passwort darf nicht mehr als 50 Zeichen haben",
    "passwordComplexity": "Passwort muss mindestens einen Kleinbuchstaben, einen Großbuchstaben, eine Zahl und ein Sonderzeichen enthalten",
    "passwordHint": "Passwort muss mindestens 8 Zeichen lang sein und Großbuchstaben, Kleinbuchstaben, Zahlen und Sonderzeichen enthalten.",
    "accessRequestSubmitted": "Zugangsanfrage eingereicht",
    "accessRequestSubmittedMessage": "Ihre Anfrage wurde erfolgreich übermittelt. Ein Administrator wird sie in Kürze bearbeiten.",
    "accessRequestMessagePlaceholder": "Optional: Beschreiben Sie, warum Sie Zugang benötigen...",
    "submitAccessRequest": "Zugang anfragen",
    "submittingRequest": "Anfrage wird übermittelt...",
    "welcomeToCdbOS": "Willkommen bei cdbOS",
    "signInWithCredentials": "Melden Sie sich mit Ihren Zugangsdaten an",
    "requestAccess": "Zugang anfragen",
    "requestAccessDescription": "Fordern Sie einen Zugang zum System an",
    "azureAdDescription": "Melden Sie sich mit Ihrem Microsoft-Konto an",
    "signInWithMicrosoft": "Mit Microsoft anmelden",
    "switchAccount": "Mit anderem Konto anmelden",
    "azureAdHint": "Sie werden zu Microsoft weitergeleitet",
    "pendingApproval": "Zugriff ausstehend",
    "pendingApprovalDescription": "Ihr Konto für {{email}} wurde erstellt und wartet auf Freigabe durch einen Administrator.",
    "pendingApprovalNotification": "Sie erhalten eine Benachrichtigung, sobald Ihr Zugriff aktiviert wurde.",
    "seatLimitReached": "Keine freien Sitze",
    "seatLimitReachedDescription": "Alle Sitze Ihrer Organisation sind belegt. Ihre Anfrage für {{email}} wurde erfasst – bitte wenden Sie sich an Ihren Supervisor.",
    "noRoleAssigned": "Rolle ausstehend",
    "noRoleAssignedDescription": "Ihr Konto für {{email}} ist eingerichtet. Sie können cdbOS nutzen, sobald Ihnen eine Rolle zugewiesen wurde.",
    "organisationMessage": "Hinweis Ihrer Organisation",
    "loginPage": {
      "answerCaption": "Antwort aus Ihrem Wissen",
      "example": "Beispiel",
      "searching": "Durchsucht {{count}} Quellen …",
      "examples": {
        "pump": {
          "q": "Welches Anzugsmoment gilt für die Flanschverbindung an Pumpe P-200?",
          "a": "Für die Flanschverbindung der P-200 gelten 45 Nm, über Kreuz in zwei Durchgängen. Seit Revision C ist eine Nachprüfung nach 24 Betriebsstunden vorgeschrieben.",
          "s1": "Montageanleitung P-200, Rev. C",
          "s1Loc": "S. 14",
          "s2": "Servicebericht 2026-118",
          "s2Loc": "Abschn. 3"
        },
        "leave": {
          "q": "Wie viele Urlaubstage kann ich ins nächste Jahr übertragen?",
          "a": "Sie können bis zu 10 Tage übertragen. Diese müssen bis zum 31. März genommen werden, Ausnahmen genehmigt die Personalabteilung.",
          "s1": "Betriebsvereinbarung Urlaub 2026",
          "s1Loc": "§ 4",
          "s2": "HR-FAQ",
          "s2Loc": "Eintrag 12"
        },
        "supplier": {
          "q": "Welche Lieferanten sind für Edelstahl 1.4404 freigegeben?",
          "a": "Drei Lieferanten: Müller Stahl, Nordmetall und Ferro Süd. Nordmetall ist bis Juni nur unter Vorbehalt freigegeben, weil das Audit noch offen ist.",
          "s1": "Lieferantenliste Einkauf",
          "s1Loc": "Stand 09/2026",
          "s2": "Auditprotokoll Nordmetall",
          "s2Loc": "07/2026",
          "s3": "Werkstoffblatt 1.4404",
          "s3Loc": "S. 2"
        }
      },
      "claimLead": "Ihr Wissen.",
      "claimAccent": "Ihr Potenzial.",
      "claimSub": "Fragen Sie Ihr Unternehmenswissen direkt und erhalten Sie in Sekunden eine belegte Antwort.",
      "signIn": "Mit Microsoft anmelden",
      "redirecting": "Weiterleitung zu Microsoft …",
      "hint": "Sie melden sich mit Ihrem Firmenkonto bei Microsoft an.",
      "noAccount": "Noch kein Kunde?",
      "contactUs": "Kontaktieren Sie uns",
      "mailSubject": "Anfrage Corporate Digital Brain",
      "tags": {
        "email": "E-Mail",
        "documents": "Dokumente",
        "meeting": "Team-Meeting",
        "experts": "Expertenwissen",
        "databases": "Datenbanken",
        "sharepoint": "SharePoint",
        "maintenance": "Wartungsbericht",
        "iot": "IoT-Sensorik",
        "bot": "Knowledge Bot",
        "configurators": "Konfiguratoren",
        "robotics": "Robotics",
        "avatars": "Audio- & Video-Avatare"
      },
      "siemens": {
        "eyebrow": "Knowledge Hub · powered by CDB",
        "claimLead": "Produktwissen.",
        "claimAccent": "Sofort zur Hand.",
        "claimSub": "Fragen Sie nach kommerziellen und technischen Daten zu Ihren Produkten. Jede Antwort kommt mit Quelle aus Graph Studio, Datenblatt oder Handbuch.",
        "signIn": "Mit Siemens-Konto anmelden",
        "hint": "Anmeldung über Microsoft Entra ID mit Ihrem Siemens-Konto.",
        "poweredBy": "powered by Corporate Digital Brain",
        "panelLine": "Produktdaten aus Graph Studio, Datenblätter und Expertenwissen in einer Suche.",
        "factPrimarySource": "Graph Studio als Primärquelle",
        "factSources": "Antworten mit Quelle"
      }
    },
    "noWebOSAccess": "Kein Zugriff auf webOS",
    "noWebOSAccessDescription": "Ihr Konto hat keinen Zugriff auf diese Anwendung. Bitte kontaktieren Sie einen Administrator.",
    "sessionExpiringMessage": "Ihre Sitzung läuft in wenigen Minuten ab.",
    "extendSession": "Sitzung verlängern",
    "sessionExpiredTitle": "Sitzung abgelaufen",
    "sessionExpiredMessage": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an, um fortzufahren.",
    "sessionExpiredButton": "Neu anmelden",
    "tenantNotAllowed": "Kein Zugriff",
    "tenantNotAllowedDescription": "Ihre Organisation ist nicht für diese Anwendung freigeschaltet. Eine erneute Anmeldung ändert daran nichts — bitte wenden Sie sich an Ihre IT.",
    "tenantNotAllowedAccount": "Angemeldet als {{email}}",
    "userStatus": {
      "title": "Benutzerstatus",
      "signedInAs": "Angemeldet als:",
      "email": "E-Mail:",
      "id": "ID:",
      "registered": "Registriert:",
      "dateUnavailable": "Datum nicht verfügbar",
      "notSignedIn": "Nicht angemeldet"
    }
  },
  "apps": {
    "app-store": "App Store",
    "settings": "Einstellungen",
    "widget-settings": "Widget Manager",
    "widget-store": "Widget Store",
    "cortex": "Cortex",
    "cortex-description": "Cortex — Administrationsbereich für Benutzer, Apps und Konfiguration",
    "voice": "Sprachassistent",
    "multimedia": "Multimedia Player",
    "multimedia-description": "Audio- und Video-Wiedergabe",
    "qa": "Q&A Creator",
    "pdf-viewer": "PDF Viewer",
    "pdf-viewer-description": "Anzeige von PDF-Dokumenten",
    "file-preview": "Dateivorschau",
    "file-preview-description": "Vorschau von PDF-, Word-, Excel-, PowerPoint-, Text-, JSON-, XML-, Markdown- und CSV-Dateien",
    "prompt-library": "Prompt Bibliothek",
    "cdb-sessions": "CDB Sessions",
    "cdb-training": "CDB Training Hub",
    "cdb-training-description": "Schulungen und Umfragen in einer App",
    "notes": "Notizen",
    "drive2": "cdbDrive",
    "drive2-description": "Dokumente nach Knowledge Areas durchsuchen und verwalten",
    "inDevelopment": "Diese App ist noch in Entwicklung.",
    "communicator2": "cdbChat",
    "collabora-editor": "Dokument-Editor",
    "ai-knowledge-extractor": "CDB Knowledge Extractor",
    "knowledge-verifier": "CDB Knowledge Verifier",
    "document-editor": "Document Editor",
    "document-editor-description": "Dokumente online erstellen und bearbeiten",
    "access": {
      "accessDeniedTitle": "Zugriff verweigert",
      "accessDeniedMessage": "Sie haben keinen Zugriff auf diese App. Sie können Zugriff über den App Store anfragen."
    },
    "wissenshaus": "Wissenshaus",
    "wissenshaus-description": "Deine Wissensbereiche als Haus: was im Brain passiert ist",
    "harness": "cdbHARNESS",
    "cdb-control": "cdbControl",
    "harness-description": "Agent-Rollen prüfen einen Wissensbereich, du gibst frei (Prototyp)",
    "cdb-control-description": "Aufgaben des Mandanten aus Aufnahmen und von Hand",
    "fallbackTitle": "App {{id}}",
    "fallbackId": "App-ID: {{id}}"
  },
  "sessions": {
    "sidebar": {
      "manage": "Verwalten",
      "play": "Session",
      "episodeLibrary": "Episoden Library",
      "sessionCreator": "Session Creator",
      "sessions": "Knowledge Sessions"
    },
    "library": {
      "title": "Meine Sessions",
      "description": "Verwalten Sie Training-Sessions mit Fragen",
      "loading": "Lade Sessions...",
      "empty": "Noch keine Sessions vorhanden",
      "createFirst": "Erste Session erstellen",
      "createSession": "Session erstellen",
      "deleteConfirm": "Session wirklich löschen?",
      "episodes": "Episoden",
      "questions": "Fragen"
    },
    "episodes": {
      "title": "Episoden-Bibliothek",
      "description": "Verwalten Sie wiederverwendbare Fragen",
      "libraryDescription": "Alle erstellten Fragen. Neue Fragen können im Session Creator erstellt werden.",
      "createHint": "Nutzen Sie den Session Creator, um neue Fragen zu erstellen",
      "dragDropHint": "💡 Tipp: Episodes können per Drag & Drop zum Session Creator hinzugefügt werden",
      "loading": "Lade Fragen...",
      "empty": "Noch keine Fragen vorhanden",
      "createFirst": "Erste Frage erstellen",
      "createQuestion": "Frage erstellen",
      "createEpisode": "Episode erstellen",
      "editQuestion": "Frage bearbeiten",
      "editEpisode": "Episode bearbeiten",
      "deleteConfirm": "Episode wirklich löschen?",
      "deleteTitle": "Episode löschen",
      "deleteConfirmMessage": "Möchten Sie die Frage \"{{question}}\" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
      "deleteSuccess": "Episode gelöscht",
      "deleteSuccessDescription": "Die Frage wurde erfolgreich gelöscht",
      "deleteError": "Fehler beim Löschen",
      "saveSuccess": "Episode gespeichert",
      "saveSuccessDescription": "Die Frage wurde erfolgreich gespeichert",
      "saveError": "Fehler beim Speichern",
      "editorDescription": "Erstellen oder bearbeiten Sie eine Frage",
      "episodeText": "Episodetext",
      "episodeTextPlaceholder": "Geben Sie Ihre Frage ein...",
      "episodeType": "Episodetyp",
      "answerOptions": "Antwortoptionen",
      "option": "Option",
      "addOption": "Option hinzufügen",
      "tags": "Tags",
      "tagsPlaceholder": "Tag hinzufügen...",
      "knowledgeArea": "Knowledge Area",
      "selectKnowledgeArea": "Knowledge Area auswählen",
      "knowledgeAreaHint": "Erforderlich für Bild-Upload",
      "images": "Bilder",
      "uploadImages": "Bilder hochladen",
      "uploadHint": "Klicken zum Hochladen oder Drag & Drop",
      "types": {
        "multipleChoice": "Multiple Choice",
        "singleChoice": "Single Choice",
        "freeText": "Freitext"
      },
      "visibility": {
        "label": "Sichtbarkeit",
        "client": "Gesamter Client (alle User im Client können die Frage nutzen)",
        "sharedUsers": "Einzelne User (nur ausgewählte User können die Frage nutzen)",
        "private": "Privat (nur ich kann die Frage nutzen)",
        "selectUsers": "Wählen Sie User aus:"
      },
      "filters": {
        "all": "Alle Fragen",
        "own": "Meine Fragen",
        "shared": "Geteilte Fragen",
        "onlyMe": "Nur ich",
        "wholeClient": "Gesamter Client"
      },
      "table": {
        "type": "Typ",
        "episode": "Episode",
        "answers": "Antworten",
        "sharedWith": "Geteilt mit",
        "actions": "Aktionen"
      },
      "episodeTextTooShort": "Der Episodentext braucht mindestens {{min}} Zeichen.",
      "usersSelected_one": "1 Nutzer ausgewählt",
      "usersSelected_other": "{{count}} Nutzer ausgewählt",
      "selectAtLeastOneUser": "Wähle mindestens einen Nutzer aus, sonst lässt sich die Episode nicht speichern.",
      "invalidFileType": "Ungültiger Dateityp",
      "notAnImage": "{{name}} ist kein Bild",
      "imagesUploaded": "Bilder hochgeladen",
      "imagesUploadedDescription_one": "{{count}} Bild hochgeladen",
      "imagesUploadedDescription_other": "{{count}} Bilder hochgeladen",
      "uploadFailed": "Upload fehlgeschlagen",
      "imagesSelected": "Bilder ausgewählt",
      "imagesSelectedDescription_one": "{{count}} Bild wird nach dem Speichern hochgeladen",
      "imagesSelectedDescription_other": "{{count}} Bilder werden nach dem Speichern hochgeladen",
      "imageDeleted": "Bild gelöscht",
      "imageDeletedDescription": "Das Bild wurde aus dem Client-Bucket entfernt",
      "imageDeleteFailed": "Löschen fehlgeschlagen",
      "pendingUploadHint": "Bilder werden automatisch hochgeladen, nachdem die Episode gespeichert wurde",
      "uploading": "Lade hoch...",
      "imageLoading": "Lädt...",
      "userCount": "({{count}} User)",
      "loadingUsers": "Lade User...",
      "unknownUser": "Unbekannter User",
      "dragToCreator": "Ziehen Sie diese Episode zum Session Creator"
    },
    "creator": {
      "title": "Session Creator",
      "description": "Erstellen Sie eine neue Training-Session",
      "selectedQuestions": "Ausgewählte Fragen",
      "noEpisodesYet": "Noch keine Fragen hinzugefügt",
      "addQuestions": "Episoden hinzufügen",
      "createNewQuestion": "Neue Frage erstellen",
      "availableQuestions": "Aus Library hinzufügen (klicken zum Hinzufügen)",
      "saveSession": "Session speichern",
      "saveSuccess": "Session erstellt",
      "saveSuccessDescription": "Die Session wurde erfolgreich erstellt",
      "saveError": "Fehler beim Erstellen",
      "sessionCreated": "Session erfolgreich erstellt!",
      "editTitle": "Session bearbeiten",
      "createTitle": "Session erstellen",
      "steps": {
        "info": "Info",
        "episodes": "Episodes",
        "share": "Teilen"
      },
      "titleLabel": "Titel",
      "titleRequired": "Mindestens 3 Zeichen erforderlich",
      "descriptionOptional": "Beschreibung (optional)",
      "descriptionPlaceholder": "Kurze Beschreibung der Session...",
      "shuffleLabel": "Episodes beim Abspielen zufällig mischen",
      "newEpisode": "Neue Episode erstellen",
      "fromLibrary": "Aus Library wählen",
      "dragDropHint": "Öffnen Sie die Episode Library und ziehen Sie Episodes per Drag & Drop hierher",
      "selectedEpisodes": "Ausgewählte Episodes",
      "noEpisodesAdded": "Noch keine Episodes hinzugefügt",
      "createOrSelectHint": "Erstellen Sie eine neue Episode oder wählen Sie aus der Library",
      "imageCount_one": "{{count}} Bild",
      "imageCount_other": "{{count}} Bilder",
      "shareHintAdmin": "Teilen Sie diese Session mit Benutzern aus allen Clients. Sie können dies auch später über den \"Teilen\"-Button machen.",
      "shareHintUser": "Teilen Sie diese Session mit anderen Benutzern. Sie können dies auch später über den \"Teilen\"-Button machen.",
      "selectUsers": "Benutzer auswählen",
      "noUsersAdmin": "Keine Benutzer verfügbar",
      "noUsersClient": "Keine anderen Benutzer im Client verfügbar",
      "alreadyAssigned": "Bereits zugewiesen",
      "client": "Client",
      "next": "Weiter",
      "back": "Zurück",
      "nextToShare": "Weiter zu Teilen",
      "saving": "Speichert...",
      "saveChanges": "Änderungen speichern",
      "saveAndShare": "Speichern & mit {{count}} Benutzer(n) teilen",
      "assignmentsReset": "{{count}} Zuweisung(en) wurden zurückgesetzt.",
      "assignmentsUpdated": "{{added}} hinzugefügt, {{removed}} entfernt",
      "shareFailedHint": "Session wurde erstellt, aber Teilen fehlgeschlagen",
      "libraryWindowTitle": "Episoden-Bibliothek - Drag & Drop",
      "unknownClient": "Unbekannt"
    },
    "table": {
      "title": "Sessions",
      "description": "Alle erstellten Sessions",
      "empty": "Noch keine Sessions vorhanden",
      "createHint": "Nutzen Sie den Session Creator, um eine Session zu erstellen",
      "deleteTitle": "Session löschen",
      "deleteConfirmMessage": "Möchten Sie die Session \"{{session}}\" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
      "deleteSuccess": "Session gelöscht",
      "deleteSuccessDescription": "Die Session wurde erfolgreich gelöscht",
      "deleteError": "Fehler beim Löschen",
      "columns": {
        "title": "Titel",
        "creator": "Ersteller",
        "episodes": "Episoden",
        "created": "Erstellt",
        "status": "Status",
        "actions": "Aktionen"
      },
      "status": {
        "completed": "Abgeschlossen",
        "pending": "Offen"
      },
      "filters": {
        "all": "Alle",
        "own": "Eigene",
        "assigned": "Zugewiesen"
      },
      "actions": {
        "play": "Abspielen",
        "edit": "Bearbeiten",
        "share": "Teilen",
        "delete": "Löschen"
      }
    },
    "builder": {
      "createSession": "Session erstellen",
      "saveFailed": "Session konnte nicht gespeichert werden. Bitte noch einmal versuchen.",
      "editSession": "Session bearbeiten",
      "description": "Erstellen oder bearbeiten Sie eine Session",
      "title": "Titel",
      "titlePlaceholder": "Session-Titel eingeben...",
      "descriptionLabel": "Beschreibung",
      "descriptionPlaceholder": "Optionale Beschreibung...",
      "shuffleEpisodes": "Episoden beim Abspielen mischen",
      "assignmentsReset": "Zuweisungen zurückgesetzt",
      "assignmentsResetDescription": "{{count}} Zuweisung(en) wurden auf \"offen\" zurückgesetzt."
    },
    "player": {
      "loading": "Lade Session...",
      "error": "Fehler beim Laden",
      "noEpisodes": "Keine Fragen in dieser Session",
      "previous": "Zurück",
      "next": "Weiter",
      "episode": "Episode",
      "answerPlaceholder": "Ihre Antwort...",
      "keyboardHint": "Nutze ← → Tasten zur Navigation",
      "backToSessions": "Zurück zu Sessions",
      "complete": "Session abschließen",
      "alreadyCompleted": "Bereits abgeschlossen",
      "completedBanner": "Session abgeschlossen",
      "completedAt": "Zum Wissen hinzugefügt am",
      "lastEpisodeHint": "Letzte Episode - Session abschließen",
      "lastSlideHint": "Letzte Folie - Session abschließen",
      "readOnlyHint": "Diese Session wurde bereits abgeschlossen (nur Lesezugriff)",
      "loadAnswerError": "Fehler beim Laden der Antwort",
      "saveFailed": "Speichern fehlgeschlagen",
      "readOnly": "Nur Lesezugriff",
      "loadingImage": "Lädt Bild...",
      "imageLoadError": "Bild konnte nicht geladen werden",
      "saving": "Speichert...",
      "lastSaved": "Zuletzt gespeichert: {{time}}"
    },
    "share": {
      "title": "Session teilen",
      "description": "Weisen Sie diese Session Benutzern zu mit optionalem Fälligkeitsdatum",
      "sharedWith": "Bereits geteilt mit",
      "notSharedYet": "Diese Session wurde noch nicht geteilt",
      "deadline": "Fälligkeitsdatum (optional)",
      "deadlineHint": "Benutzer sollten die Session bis zu diesem Datum abschließen",
      "addUsers": "Neue Benutzer hinzufügen",
      "selectedCount": "{{count}} ausgewählt",
      "allClients": "Alle Clients",
      "noUsersAvailable": "Keine anderen Benutzer verfügbar",
      "allUsersAssigned": "Alle verfügbaren Benutzer wurden bereits zugewiesen",
      "shareButton": "Mit {{count}} Benutzer(n) teilen",
      "sharing": "Teilt...",
      "removeAssignment": "Zuweisung entfernen",
      "due": "Fällig",
      "unknown": "Unbekannt",
      "episodes": "Episode(s)",
      "pending": "ausstehend",
      "removePending": "Ausstehende Zuweisung entfernen"
    },
    "toasts": {
      "sessionShared": "Session geteilt",
      "sessionSharedDescription": "Session wurde mit {{count}} Benutzer(n) geteilt",
      "shareError": "Session konnte nicht geteilt werden",
      "usersLoadError": "Benutzer konnten nicht geladen werden",
      "assignmentRemoved": "Zuweisung entfernt",
      "assignmentRemovedDescription": "Die Zuweisung wurde erfolgreich entfernt",
      "assignmentRemoveError": "Zuweisung konnte nicht entfernt werden",
      "sessionUpdated": "Session aktualisiert",
      "sessionUpdatedDescription": "Die Änderungen wurden gespeichert",
      "sessionCreatedAndShared": "Session erstellt & geteilt",
      "sessionCreatedAndSharedDescription": "Die Session wurde erstellt und mit {{count}} Benutzer(n) geteilt",
      "sessionCreated": "Session erstellt",
      "sessionCreatedDescription": "Die Session wurde erfolgreich gespeichert",
      "episodeAdded": "Episode hinzugefügt",
      "saveError": "Fehler beim Speichern"
    },
    "summary": {
      "title": "Session-Übersicht & Export",
      "description": "Überprüfen Sie Ihre Antworten und fügen Sie die Session zur Knowledge Base hinzu.",
      "answerPlaceholder": "Ihre Antwort...",
      "documentTitle": "Dokument-Titel",
      "episodeCount": "{{count}} Episoden",
      "episodeCount_one": "{{count}} Episode",
      "answeredCount": "{{count}} beantwortet",
      "noAnswer": "Keine Antwort",
      "save": "Speichern",
      "addToKnowledge": "Zu Wissen hinzufügen",
      "noClientForArea": "Die gewählte Knowledge Area hat keinen Client zugewiesen.",
      "knowledgeArea": "Knowledge Area",
      "loadingKnowledgeAreas": "Lade Knowledge Areas...",
      "selectKnowledgeArea": "Knowledge Area auswählen",
      "editedCount": "{{count}} bearbeitet",
      "edited": "bearbeitet",
      "loadingAnswers": "Lade Antworten...",
      "errors": {
        "noEpisodes": "Keine Episoden zum Hochladen vorhanden",
        "noKnowledgeArea": "Bitte wählen Sie eine Knowledge Area aus",
        "noTitle": "Bitte geben Sie einen Titel ein",
        "noClient": "Kein Client verfügbar"
      }
    }
  },
  "training": {
    "hub": {
      "permissionsFailedTitle": "Berechtigungen konnten nicht geladen werden",
      "permissionsFailedHint": "Bitte lade die Seite neu. Bleibt der Fehler, wende dich an deinen Admin.",
      "pickTitle": "Was möchtest du tun?",
      "pickHint": "Wähle einen Bereich. Du kannst jederzeit zurück wechseln.",
      "schulungTitle": "Schulung",
      "schulungDescription": "Trainings aus Materialien zusammenstellen, optional mit Quiz und Bestehensgrenze am Ende.",
      "umfrageTitle": "Umfrage",
      "umfrageDescription": "Eigenständige Umfragen erstellen, verteilen und automatisch auswerten lassen.",
      "backToPicker": "Bereich wechseln",
      "noModuleTitle": "Kein Bereich freigeschaltet",
      "noModuleHint": "Deine Rolle hat weder Schulungen noch Umfragen freigeschaltet. Bitte wende dich an deinen Admin.",
      "title": "Training Hub",
      "areasLabel": "Bereiche",
      "clientLabel": "Client",
      "clientHint": "Als Admin sehen und bearbeiten Sie Schulungen, Umfragen, Teilnehmer und Material dieses Clients. Die Auswahl gilt für alle Fenster des Training Hubs.",
      "areas": {
        "trainings": "Schulungen",
        "surveys": "Umfragen & Quiz",
        "participants": "Teilnehmer",
        "materials": "Material-Bibliothek"
      },
      "actions": {
        "trainings": "Neues Training",
        "surveys": "Neu anlegen",
        "participants": "Teilnehmer anlegen",
        "materials": "Hochladen"
      },
      "stats": {
        "active": "aktiv",
        "drafts": "Entwürfe",
        "overdue": "überfällig",
        "myOpen": "für dich offen",
        "newAnswers": "neue Antworten",
        "people": "Personen",
        "expiring": "Zugang läuft ab",
        "expired": "abgelaufen",
        "files": "Dateien",
        "folders": "Ordner"
      },
      "foot": {
        "lastChanged": "Zuletzt geändert {{when}} · {{title}}",
        "accessDays": "Zugangsdauer: {{count}} Tage ab erster Anmeldung",
        "accessUnlimited": "Zugang ohne zeitliche Begrenzung",
        "materialsChanged": "Zuletzt geändert {{when}}",
        "materials": "Client-Bibliothek und persönlicher Bereich",
        "unavailable": "Zahlen gerade nicht verfügbar"
      }
    },
    "sidebar": {
      "manage": "Verwalten",
      "play": "Abspielen",
      "materialLibrary": "Material-Bibliothek",
      "trainingCreator": "Training erstellen",
      "trainings": "Trainings",
      "participants": "Teilnehmer"
    },
    "materials": {
      "title": "Material-Bibliothek",
      "subtitle": "Videos, Podcasts und Dokumente für Schulungen",
      "upload": "Material hochladen",
      "uploadFirst": "Erstes Material hochladen",
      "empty": "Noch keine Materialien vorhanden",
      "searchPlaceholder": "Materialien suchen...",
      "allTypes": "Alle Typen",
      "deleteConfirm": "Material wirklich löschen?",
      "deleteConfirmInline": "Dieses Material löschen?",
      "deleteWarning": "Diese Aktion kann nicht rückgängig gemacht werden.",
      "deleted": "Material gelöscht",
      "deletedDescription": "Das Material wurde erfolgreich gelöscht",
      "updated": "Material aktualisiert",
      "updatedDescription": "Das Material wurde erfolgreich aktualisiert",
      "edit": "Material bearbeiten",
      "visibility": "Sichtbarkeit",
      "visibilityOptions": {
        "private": "Privat",
        "shared": "Geteilt",
        "client": "Gesamter Client"
      },
      "filename": "Dateiname",
      "type": "Typ",
      "types": {
        "video": "Video",
        "podcast": "Podcast",
        "document": "Dokument",
        "audio": "Audio",
        "pdf": "PDF",
        "image": "Bild",
        "other": "Sonstiges",
        "docx": "Word",
        "xlsx": "Excel",
        "pptx": "PowerPoint"
      },
      "table": {
        "title": "Titel",
        "filename": "Dateiname",
        "size": "Größe",
        "uploaded": "Hochgeladen",
        "format": "Format"
      },
      "titleRequired": "Der Titel darf nicht leer sein",
      "descriptionPlaceholder": "Beschreibung (optional)"
    },
    "materialLibrary": {
      "root": "Schulungsbibliothek",
      "folders": "Ordner",
      "expand": "Aufklappen",
      "collapse": "Zuklappen",
      "newFolder": "Neuer Ordner",
      "newFolderIn": "Neuer Ordner in {{name}}",
      "renameFolder": "Ordner umbenennen",
      "create": "Anlegen",
      "folderName": "Name",
      "folderNamePlaceholder": "z. B. Onboarding",
      "folderHint": "Ordner ordnen die Bibliothek. Sie haben keine eigenen Rechte – alle Autoren im Client sehen alle Ordner.",
      "folderExists": "Hier gibt es schon einen Ordner mit diesem Namen",
      "folderSaveFailed": "Ordner konnte nicht gespeichert werden",
      "folderDeleted": "Ordner gelöscht",
      "folderNotEmpty": "Der Ordner ist nicht leer. Verschiebe oder lösche zuerst seinen Inhalt.",
      "folderDeleteFailed": "Ordner konnte nicht gelöscht werden",
      "deleteFolderConfirm": "Ordner „{{name}}“ löschen?",
      "move": "Verschieben",
      "moveHere": "Hierher verschieben",
      "moveHint": "Verschieben ändert nur, wo die Datei liegt. Trainings, die sie verwenden, bleiben unverändert.",
      "moveFolder": "„{{name}}“ verschieben",
      "moveMaterial": "„{{name}}“ verschieben",
      "moved": "Verschoben",
      "moveFailed": "Verschieben fehlgeschlagen",
      "moveIntoSelf": "Ein Ordner kann nicht in sich selbst verschoben werden",
      "rename": "Umbenennen",
      "renameFailed": "Umbenennen fehlgeschlagen",
      "searchAll": "In der ganzen Bibliothek suchen …",
      "noSearchResults": "Keine Datei gefunden.",
      "emptyFolder": "„{{name}}“ ist leer. Lade Dateien hoch oder ziehe welche hierher.",
      "loadFailed": "Bibliothek konnte nicht geladen werden",
      "location": "Ort",
      "changed": "Geändert",
      "itemCount_one": "{{count}} Element",
      "itemCount_other": "{{count}} Elemente",
      "usedIn": "Verwendet in",
      "usedInCount_one": "{{count}} Training",
      "usedInCount_other": "{{count}} Trainings",
      "notUsed": "Noch in keinem Training.",
      "notUsedShort": "nicht verwendet",
      "versions": "Versionen",
      "versionLine": "{{size}} · Version {{version}}",
      "versionCurrent": "Version {{version}} · aktuell",
      "versionNumber": "Version {{version}}",
      "restore": "Diese Version wiederherstellen",
      "restored": "Version {{version}} wiederhergestellt",
      "restoreFailed": "Wiederherstellen fehlgeschlagen",
      "replace": "Ersetzen",
      "replaceTitle": "„{{name}}“ ersetzen",
      "replaceDrop": "Neue Fassung hier ablegen oder klicken",
      "replaceHint": "Wird Version {{version}}. Version {{previous}} bleibt wiederherstellbar.",
      "replaceHintUsed": "Wird Version {{version}}. {{trainings}} zeigt ab sofort die neue Fassung. Version {{previous}} bleibt wiederherstellbar.",
      "replaced": "Version {{version}} hochgeladen",
      "replaceFailed": "Ersetzen fehlgeschlagen",
      "deleteBlocked": "Löschen geht erst, wenn kein Training die Datei mehr verwendet.",
      "deleteWarning": "Die Datei und alle ihre Versionen werden endgültig gelöscht.",
      "deleteFailed": "Löschen fehlgeschlagen",
      "downloadFailed": "Download fehlgeschlagen",
      "forbidden": "Das darf nur, wer die Datei hochgeladen hat, ein Supervisor oder ein Admin.",
      "uploadTarget": "Landet in",
      "areaTab": "Knowledge Area",
      "areaHintTitle": "Dokumente aus dem Drive einbauen",
      "areaHintBody": "Weise dem Training eine Knowledge Area zu. Danach kannst du hier Dokumente daraus als Folien einbauen – verknüpft, also immer aktuell.",
      "areaHintChat": "Teilnehmer dürfen diese Knowledge Area dann auch im Schulungsportal befragen. Folie und Chat haben damit dieselbe Grenze.",
      "areaAssign": "Knowledge Area zuweisen",
      "areaSameField": "Das ist dasselbe Feld wie „Knowledge Area für Teilnehmer“ in Schritt 1.",
      "areaLinkedHint": "Dokumente aus „{{name}}“ werden verknüpft, nicht kopiert: Änderungen im Drive erscheinen sofort im Training. Word, PowerPoint und Excel werden als PDF gezeigt.",
      "areaSearch": "In „{{name}}“ suchen …",
      "areaLoadFailed": "Die Dokumente der Knowledge Area konnten nicht geladen werden.",
      "areaEmpty": "„{{name}}“ enthält noch keine Dokumente.",
      "areaOtherHint": "Ein Dokument aus einer anderen Knowledge Area? Lege es im Drive per „Sync mit Brain“ in „{{name}}“ – dann kann auch der Chat es belegen – oder lade eine Kopie in die Schulungsbibliothek.",
      "notLinkable": "Dieses Format kann nicht als Folie gezeigt werden.",
      "notLinkableShort": "{{name}} · als Folie nicht darstellbar",
      "linkFailed": "Das Dokument konnte nicht verknüpft werden.",
      "staleSlides_one": "Eine Folie stammt aus einer Knowledge Area, die dem Training nicht mehr zugewiesen ist. Entferne sie oder weise die Knowledge Area wieder zu – vorher lässt sich nicht speichern.",
      "staleSlides_other": "{{count}} Folien stammen aus einer Knowledge Area, die dem Training nicht mehr zugewiesen ist. Entferne sie oder weise die Knowledge Area wieder zu – vorher lässt sich nicht speichern.",
      "fromDrive": "Aus dem Drive",
      "linkedEntry": "Aus Knowledge Areas verknüpft",
      "linkedEntryHint": "Drive-Dokumente wählst du im Trainings-Assistenten aus der Knowledge Area des Trainings.",
      "linkedViewHint": "Diese Dokumente liegen im Drive und werden dort gepflegt. Trainings zeigen immer die aktuelle Fassung. Nicht mehr verwendete Verknüpfungen kannst du hier entfernen.",
      "linkedEmpty": "Noch kein Training verwendet ein Dokument aus einer Knowledge Area.",
      "linkedLocation": "Drive › {{name}}",
      "linkedHint": "Verknüpft aus „{{name}}“. Umbenennen, ersetzen und löschen passiert im Drive.",
      "unknownArea": "Knowledge Area",
      "unlink": "Verknüpfung entfernen",
      "unlinkWarning": "Nur die Verknüpfung wird entfernt. Das Dokument im Drive bleibt unverändert.",
      "driveImport": "Aus meinem Drive übernehmen",
      "driveImportTitle": "Aus meinem Drive übernehmen",
      "driveImportHint": "Die gewählten Dateien werden als Kopie in die Schulungsbibliothek gelegt und gehören dann dem Client. Dein Original bleibt im Drive; spätere Änderungen daran kommen nicht mit.",
      "driveSearch": "Meine Dokumente durchsuchen …",
      "driveEmpty": "In „Meine Dokumente“ wurde nichts gefunden.",
      "driveMore": "Weitere laden",
      "driveImportButton_one": "{{count}} Datei übernehmen",
      "driveImportButton_other": "{{count}} Dateien übernehmen",
      "driveImported_one": "{{count}} Datei übernommen",
      "driveImported_other": "{{count}} Dateien übernommen",
      "driveImportPartial_one": "{{count}} Datei konnte nicht übernommen werden",
      "driveImportPartial_other": "{{count}} Dateien konnten nicht übernommen werden",
      "driveImportFailed": "Die Übernahme ist fehlgeschlagen.",
      "unlinkConfirm": "Verknüpfung zu „{{name}}“ entfernen?",
      "unlinked": "Verknüpfung entfernt",
      "personalRoot": "Persönlich",
      "personalTab": "Persönlich",
      "libraryTab": "Bibliothek",
      "personalTreeHint": "Nur du siehst diese Dateien und Ordner.",
      "movedToPersonal": "In deinen persönlichen Bereich verschoben",
      "movedToClient": "In die Schulungsbibliothek verschoben",
      "personalBlocked": "Diese Datei wird in einem Training verwendet und kann deshalb nicht persönlich werden – andere Autoren des Trainings würden die Folie nicht mehr sehen.",
      "folderOtherSpace": "Ordner bleiben in ihrem Bereich. Verschiebe stattdessen die einzelnen Dateien.",
      "moveToClientHint": "Die Datei wird in die Schulungsbibliothek verschoben und ist dann für alle Autoren im Client sichtbar.",
      "moveToPersonalHint": "Die Datei wird persönlich: Danach siehst nur noch du sie.",
      "personalHint": "Persönliche Datei – nur du siehst sie.",
      "personalUsedHint": "Persönliche Datei, die ein Training verwendet. Andere Autoren dieses Trainings sehen sie in der Bibliothek nicht; verschiebe sie in die Schulungsbibliothek, damit das Training nicht an dir hängt.",
      "share": "Teilen",
      "shareTitle": "„{{name}}“ teilen",
      "shareHint": "Geteilte Kollegen sehen die Datei unter „Geteilt mit mir“ und können sie in eigene Trainings einbauen. Ändern, ersetzen und löschen kannst weiterhin nur du.",
      "shareSearch": "Kollegen suchen …",
      "shareNoUsers": "Keine Kollegen gefunden.",
      "shareNobody": "Mit niemandem geteilt – nur du siehst die Datei.",
      "shareCount_one": "Mit {{count}} Person geteilt",
      "shareCount_other": "Mit {{count}} Personen geteilt",
      "shareInUse": "Die Freigabe lässt sich nicht entfernen, solange diese Trainings die Datei verwenden: {{trainings}}.",
      "shareFailed": "Die Freigabe konnte nicht gespeichert werden.",
      "shareSave": "Speichern",
      "sharedWithCount_one": "Mit {{count}} Person geteilt",
      "sharedWithCount_other": "Mit {{count}} Personen geteilt",
      "notShared": "Nicht geteilt",
      "sharedToast_one": "Mit {{count}} Person geteilt",
      "sharedToast_other": "Mit {{count}} Personen geteilt",
      "unsharedToast": "Freigabe entfernt – nur du siehst die Datei",
      "sharedEntry": "Geteilt mit mir",
      "sharedViewHint": "Diese Dateien haben Kollegen mit dir geteilt. Du kannst sie ansehen und in eigene Trainings einbauen; ändern kann sie nur, wer sie hochgeladen hat.",
      "sharedEmpty": "Noch hat niemand eine Datei mit dir geteilt.",
      "sharedLocation": "Geteilt von {{name}}",
      "sharedByHint": "Geteilt von {{name}}. Du kannst die Datei in eigenen Trainings verwenden, aber nicht ändern.",
      "personalSharedHint_one": "Persönliche Datei – du und {{count}} Person seht sie.",
      "personalSharedHint_other": "Persönliche Datei – du und {{count}} Personen seht sie.",
      "driveImportHintPersonal": "Die gewählten Dateien werden als Kopie in deinen persönlichen Bereich gelegt – nur du siehst sie. Dein Original bleibt im Drive; spätere Änderungen daran kommen nicht mit."
    },
    "upload": {
      "title": "Material hochladen",
      "materialType": "Material-Typ",
      "file": "Datei",
      "dropzone": "Datei hier ablegen oder klicken zum Auswählen",
      "titleLabel": "Titel",
      "titlePlaceholder": "Titel des Materials",
      "description": "Beschreibung",
      "descriptionPlaceholder": "Optionale Beschreibung...",
      "uploading": "Wird hochgeladen...",
      "uploadButton": "Hochladen",
      "success": "Upload erfolgreich",
      "successDescription": "Das Material wurde erfolgreich hochgeladen",
      "missingFields": "Bitte füllen Sie alle Pflichtfelder aus",
      "invalidFileType": "Ungültiger Dateityp",
      "client": "Client",
      "selectClient": "Client auswählen...",
      "clientHint": "Als Admin können Sie den Ziel-Client für den Upload auswählen",
      "visibility": "Sichtbarkeit",
      "visibilityClient": "Gesamter Client (alle User im Client sehen das Material)",
      "visibilitySharedUsers": "Einzelne User (nur ausgewählte User sehen das Material)",
      "visibilityPrivate": "Privat (nur ich sehe das Material)",
      "selectUsers": "Wählen Sie User aus:",
      "usersSelected": "{{count}} User ausgewählt",
      "loadingUsers": "Lade User...",
      "dropzoneMulti": "Dateien hier ablegen oder klicken zum Auswählen",
      "multiErrorDescription": "Einige Dateien konnten nicht hochgeladen werden",
      "multiSuccessDescription": "Alle Dateien wurden erfolgreich hochgeladen",
      "selectedFiles": "Ausgewählte Dateien",
      "uploadMultiButton": "Alle hochladen"
    },
    "visibility": {
      "label": "Sichtbarkeit",
      "client": "Gesamter Client",
      "sharedUsers": "Einzelne User",
      "private": "Privat",
      "onlyMe": "Nur ich",
      "wholeClient": "Gesamter Client"
    },
    "library": {
      "title": "Trainings",
      "subtitle": "Alle verfügbaren Schulungen",
      "filterAll": "Alle",
      "filterOwn": "Meine",
      "filterAssigned": "Mir zugewiesen",
      "empty": "Noch keine Trainings vorhanden",
      "emptyAssigned": "Dir wurden noch keine Trainings zugewiesen",
      "emptyCompleted": "Du hast noch keine Trainings abgeschlossen",
      "name": "Name",
      "creator": "Ersteller",
      "materials": "Materialien",
      "created": "Erstellt",
      "status": "Status",
      "completed": "Abgeschlossen",
      "alreadyCompleted": "Bereits abgeschlossen",
      "pending": "Ausstehend",
      "play": "Starten",
      "preview": "Vorschau",
      "share": "Teilen",
      "deleteConfirm": "Training wirklich löschen?",
      "deleteConfirmInline": "Dieses Training löschen?",
      "deleteWarning": "Diese Aktion kann nicht rückgängig gemacht werden.",
      "deleted": "Training gelöscht",
      "deletedDescription": "Das Training wurde erfolgreich gelöscht",
      "noMaterials": "Keine Materialien in diesem Training",
      "noActions": "Keine Aktionen verfügbar",
      "assignedTo": "Zugewiesen an",
      "assign": "Zuweisen",
      "users": "Benutzer",
      "tabs": {
        "all": "Alle Trainings",
        "mine": "Meine Trainings",
        "assigned": "Mir zugewiesen",
        "completed": "Abgeschlossen"
      }
    },
    "creator": {
      "portalHeroTitle": "Portal-Darstellung",
      "portalHeroHint": "Im Schulungsportal ersetzt die Schulung die Startseite. Diese Texte stehen dort über dem Player. Aussehen und Farben legst du im Portal-Builder fest. Leer lassen — dann greifen Titel und Beschreibung der Schulung.",
      "portalHeroHeadline": "Überschrift",
      "portalHeroHeadlinePlaceholder": "Titel der Schulung",
      "portalHeroSubtitle": "Unterzeile",
      "portalHeroDescription": "Beschreibung",
      "slideTextPlaceholder": "Text zu dieser Folie (Markdown möglich) — optional",
      "chapterTitlePlaceholder": "Neues Kapitel ab hier (optional)",
      "preview": "Vorschau",
      "previewTitle": "Vorschau",
      "previewEmpty": "Noch keine Materialien ausgewählt.",
      "title": "Training erstellen",
      "editTitle": "Training bearbeiten",
      "step": "Schritt {{current}} von {{total}}",
      "stepInfo": "Informationen",
      "stepMaterials": "Materialien",
      "titleLabel": "Titel",
      "titlePlaceholder": "Titel des Trainings",
      "descriptionLabel": "Beschreibung",
      "descriptionPlaceholder": "Optionale Beschreibung des Trainings...",
      "next": "Weiter",
      "create": "Training erstellen",
      "availableMaterials": "Verfügbare Materialien",
      "selectedMaterials": "Ausgewählte Materialien (Reihenfolge)",
      "noMaterials": "Keine Materialien vorhanden",
      "noMaterialsSelected": "Keine Materialien ausgewählt",
      "created": "Training erstellt",
      "createdDescription": "Das Training wurde erfolgreich erstellt",
      "updated": "Training aktualisiert",
      "updatedDescription": "Das Training wurde erfolgreich aktualisiert",
      "visibility": "Sichtbarkeit",
      "visibilityClient": "Gesamter Client (alle User im Client sehen das Training)",
      "visibilitySharedUsers": "Einzelne User (nur ausgewählte User sehen das Training)",
      "visibilityPrivate": "Privat (nur ich sehe das Training)",
      "selectUsers": "Wählen Sie User aus:",
      "usersSelected": "{{count}} User ausgewählt",
      "loadingUsers": "Lade User...",
      "knowledgeArea": "Knowledge Area für Teilnehmer",
      "knowledgeAreaHint": "Teilnehmer dieses Trainings dürfen im Schulungsportal genau diese Knowledge Area befragen. Ohne Auswahl bekommt die Brain Session keinen Wissensbereich.",
      "knowledgeAreaNone": "Keine Knowledge Area",
      "knowledgeAreaPlaceholder": "Knowledge Area wählen…",
      "knowledgeAreaLoading": "Knowledge Areas werden geladen…",
      "stepQuiz": "Quiz/Umfrage",
      "attachQuizTitle": "Quiz oder Umfrage anhängen (optional)",
      "attachQuizHint": "Verknüpfe diesem Training ein bestehendes Quiz oder eine Umfrage. Verwalten kannst du diese unter Quizzes und Umfragen.",
      "attachQuizFooterHint": "Tipp: Du kannst diese Verknüpfung später jederzeit ändern oder entfernen.",
      "noQuiz": "Kein Quiz anhängen",
      "noQuizHint": "Reines Training ohne Lernerfolgskontrolle.",
      "noQuizzesYet": "Noch keine Quizzes oder Umfragen vorhanden — leg im Tab Quizzes und Umfragen eines an.",
      "availableQuizzes": "Verfügbare Quizzes und Umfragen"
    },
    "share": {
      "title": "Training zuweisen",
      "currentAssignments": "Aktuelle Zuweisungen",
      "noAssignments": "Noch keine Zuweisungen",
      "selectUsers": "Teilnehmer auswählen",
      "searchUsers": "Teilnehmer suchen...",
      "noUsers": "Keine Teilnehmer verfügbar",
      "alreadyAssigned": "Bereits zugewiesen",
      "deadline": "Frist",
      "deadlineHint": "optional, gilt für die nächsten Zuweisungen",
      "shareButton": "Zuweisen",
      "removed": "Zuweisung entfernt",
      "assigned": "Teilnehmer zugewiesen",
      "success": "Training zugewiesen",
      "successDescription": "Training wurde {{count}} Teilnehmer(n) zugewiesen",
      "addUser": "Teilnehmer hinzufügen",
      "searchPlaceholder": "Name oder E-Mail suchen...",
      "noUsersFound": "Keine Teilnehmer gefunden",
      "allUsersAssigned": "Alle Teilnehmer bereits zugewiesen",
      "assignViaCsv": "Per CSV zuweisen",
      "uploadCsvAssign": "CSV hochladen & zuweisen",
      "csvHint": "Format: Semikolon-getrennt (nicht Komma!), UTF-8, Spalten nachname/vorname/e-mail. Doppelte E-Mails werden übersprungen.",
      "csvTemplate": "Vorlage",
      "csvTemplateHint": "Beispiel-CSV im richtigen Format herunterladen",
      "csvExample": "nachname;vorname;e-mail\nMustermann;Max;max@example.com",
      "csvAssigned": "Teilnehmer per CSV zugewiesen",
      "csvAssignedCount": "{{count}} Teilnehmer zugewiesen",
      "removeAll": "Alle entfernen",
      "allRemoved": "Alle Zuweisungen entfernt",
      "tabs": {
        "internal": "Intern",
        "external": "Extern"
      },
      "internalHint": "Mitglieder deines Teams. Sie sehen die Zuweisung im Tab \"Mir zugewiesen\" und füllen direkt im System aus.",
      "externalHint": "Externe Teilnehmer ohne System-Account. Per CSV importieren oder vorhandene Gäste auswählen — sie erhalten einen Link.",
      "deadlineShort": "bis {{date}}",
      "assignmentCompleted": "Diese Person hat das Training abgeschlossen. Die Zuweisung ist ihr Nachweis und kann nicht entfernt werden.",
      "removeFailed": "Zuweisung konnte nicht entfernt werden"
    },
    "player": {
      "slide": "Slide {{current}} von {{total}}",
      "materialsCompleted": "abgeschlossen",
      "previewMode": "Vorschau",
      "notFound": "Training nicht gefunden",
      "noMaterials": "Dieses Training enthält keine Materialien",
      "loadingMaterial": "Material wird geladen...",
      "previous": "Zurück",
      "next": "Weiter",
      "finishTraining": "Training abschließen",
      "closePreview": "Vorschau schließen",
      "completed": "Training abgeschlossen",
      "completedDescription": "Sie haben das Training erfolgreich abgeschlossen",
      "documentPreview": "Vorschau für diesen Dokumenttyp nicht verfügbar",
      "openInNewTab": "In neuem Tab öffnen",
      "download": "Herunterladen",
      "markAsRead": "Als gelesen markieren",
      "openSlides_one": "Noch {{count}} Folie offen – wir springen dorthin.",
      "openSlides_other": "Noch {{count}} Folien offen – wir springen zur ersten.",
      "previewUnavailable": "Die Vorschau ist gerade nicht verfügbar. Sie können die Datei öffnen oder herunterladen."
    },
    "participants": {
      "title": "Titel",
      "subtitle": "Übersicht aller Teilnehmer und ihrer zugewiesenen Trainings",
      "searchPlaceholder": "Teilnehmer suchen...",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "email": "E-Mail",
      "assignedTrainings": "Zugewiesene Trainings",
      "assignedTrainingsCol": "Trainings",
      "assignedQuizzesCol": "Quizzes & Umfragen",
      "trainings": "Trainings",
      "trainingsCount_one": "{{count}} Training",
      "trainingsCount_other": "{{count}} Trainings",
      "quizzesCount_one": "{{count}} Quiz",
      "quizzesCount_other": "{{count}} Quizzes",
      "completed": "abgeschlossen",
      "noAssignments": "Keine Zuweisungen",
      "noUsers": "Keine Teilnehmer vorhanden. CSV hochladen um Teilnehmer zu importieren.",
      "noUsersFound": "Keine Teilnehmer gefunden",
      "assign": "Zuweisen",
      "assigned": "Training zugewiesen",
      "assignTraining": "Training zuweisen",
      "assignTo": "Zuweisen an",
      "selectTraining": "Training auswählen",
      "searchTrainings": "Training suchen...",
      "noTrainingsFound": "Keine Trainings gefunden",
      "allTrainingsAssigned": "Alle Trainings bereits zugewiesen",
      "uploadCsv": "CSV hochladen",
      "uploadSuccess": "Teilnehmer importiert",
      "importedCount": "{{count}} Teilnehmer importiert",
      "duplicatesSkipped": "{{count}} Duplikate übersprungen",
      "deleted": "Teilnehmer gelöscht",
      "addManually": "Teilnehmer anlegen",
      "createTitle": "Neuen Teilnehmer anlegen",
      "created": "Teilnehmer angelegt",
      "access": {
        "column": "Zugang",
        "notStarted": "noch nicht begonnen",
        "expired": "abgelaufen",
        "daysLeft_one": "noch {{count}} Tag",
        "daysLeft_other": "noch {{count}} Tage",
        "extend": "Zugang verlängern",
        "extendTitle": "Zugang verlängern",
        "extendHintActive": "Die Tage kommen bei jedem begonnenen Training von {{name}} zum aktuellen Ende hinzu.",
        "extendHintExpired": "Der Zugang von {{name}} ist abgelaufen. Die Tage zählen ab heute, die Person kann sich sofort wieder anmelden.",
        "extendBy": "Verlängern um",
        "days": "Tage",
        "extended": "Zugang von {{name}} gilt jetzt bis {{date}}",
        "settingsButton": "Zugangsdauer",
        "settingsTitle": "Zugangsdauer im Schulungsportal",
        "settingsHint": "Gilt für alle externen Teilnehmer dieses Clients. Jedes Training hat sein eigenes Fenster ab dem ersten Öffnen; ist das letzte zu, ist das Portal gesperrt, auch für Zertifikate.",
        "limit": "Zugang zeitlich begrenzen",
        "duration": "Dauer",
        "durationHint": "Die Teilnehmer sehen die verbleibenden Tage in der Seitenleiste des Portals.",
        "settingsSaved": "Zugangsdauer gespeichert",
        "nothingToExtend": "{{name}} hat noch kein Training geöffnet – es gibt kein Fenster zu verlängern."
      },
      "certificate": {
        "title": "Zertifikat",
        "hint": "Eine Word-Vorlage mit Platzhaltern je Client. Ohne Vorlage kommt das generische Zertifikat.",
        "upload": "Vorlage hochladen (.docx)",
        "replace": "Vorlage ersetzen",
        "remove": "Vorlage entfernen",
        "uploaded": "Vorlage „{{name}}“ gespeichert",
        "removed": "Vorlage entfernt – es gilt wieder das generische Zertifikat",
        "placeholders": "Platzhalter in der Vorlage:",
        "place": "Ausstellungsort"
      },
      "titleSuffix": "Nachtitel"
    },
    "consumer": {
      "startTraining": "Schulung starten",
      "startShort": "Starten",
      "noContent": "Diese Schulung enthält weder Materialien noch Fragen."
    },
    "fileKind": {
      "pdf": "PDF",
      "video": "Video",
      "audio": "Audio",
      "image": "Bild",
      "other": "Datei"
    },
    "overview": {
      "subtitle": "Schulungen deines Clients verwalten",
      "loadFailed": "Trainings konnten nicht geladen werden",
      "allTrainings": "Alle Trainings",
      "clearFigure": "Filter aufheben",
      "searchPlaceholder": "Trainings durchsuchen …",
      "allAreas": "Alle Knowledge Areas",
      "noArea": "Keine Knowledge Area",
      "mineOnly": "Von mir",
      "emptyFiltered": "Kein Training passt zu diesen Filtern",
      "resetFilters": "Filter zurücksetzen",
      "slides_one": "{{count}} Folie",
      "slides_other": "{{count}} Folien",
      "chapters_one": "{{count}} Kapitel",
      "chapters_other": "{{count}} Kapitel",
      "doneOf": "{{done}} von {{total}} fertig",
      "lateCount_one": "{{count}} überfällig",
      "lateCount_other": "{{count}} überfällig",
      "onTrack": "im Plan",
      "notAssigned": "Noch niemandem zugewiesen",
      "changed": "Geändert {{when}} · {{who}}",
      "someone": "Unbekannt",
      "status": {
        "all": "Alle",
        "draft": "Entwurf",
        "active": "Aktiv",
        "archived": "Archiviert"
      },
      "kpi": {
        "active": {
          "label": "Aktive Trainings",
          "hint": "mindestens eine Person zugewiesen",
          "section": "Aktive Trainings"
        },
        "open": {
          "label": "Offene Zuweisungen",
          "hint": "Teilnehmer noch nicht fertig",
          "section": "Trainings mit offenen Zuweisungen"
        },
        "late": {
          "label": "Überfällig",
          "hint": "Frist verpasst",
          "section": "Trainings mit überfälligen Teilnehmern"
        },
        "stale": {
          "label": "Liegengebliebene Entwürfe",
          "hint": "seit über 14 Tagen unverändert",
          "section": "Liegengebliebene Entwürfe"
        }
      },
      "todo": {
        "title": "Zu erledigen",
        "hint": "Dir zugewiesen",
        "dueIn_one": "fällig morgen",
        "dueIn_other": "fällig in {{count}} Tagen",
        "dueToday": "heute fällig",
        "overdue_one": "seit {{count}} Tag überfällig",
        "overdue_other": "seit {{count}} Tagen überfällig",
        "slidesLeft_one": "{{count}} Folie übrig",
        "slidesLeft_other": "{{count}} Folien übrig",
        "resume": "Fortsetzen"
      },
      "layout": {
        "grid": "Kacheln",
        "list": "Liste"
      },
      "list": {
        "training": "Training",
        "status": "Status",
        "people": "Teilnehmer"
      },
      "actions": {
        "more": "Weitere Aktionen",
        "details": "Details öffnen",
        "duplicate": "Duplizieren",
        "archive": "Archivieren",
        "restore": "Wiederherstellen",
        "preview": "Vorschau",
        "assign": "Zuweisen",
        "deleteBlocked": "Hat Teilnehmer – nur Archivieren ist möglich."
      },
      "toast": {
        "duplicated": "„{{title}}“ als Entwurf angelegt",
        "archived": "„{{title}}“ archiviert",
        "restored": "„{{title}}“ wiederhergestellt"
      },
      "panel": {
        "label": "Details zu {{title}}",
        "tabs": {
          "overview": "Überblick",
          "outline": "Gliederung",
          "people": "Teilnehmer {{count}}",
          "portal": "Portal"
        },
        "area": "Knowledge Area",
        "noAreaHint": "keine – Teilnehmer können im Portal nichts befragen",
        "content": "Inhalt",
        "changed": "Geändert",
        "progress": "Fortschritt",
        "legendDone": "{{count}} fertig",
        "legendLate": "{{count}} überfällig",
        "legendOpen": "{{count}} offen",
        "noSlides": "Noch keine Folien.",
        "linked": "verknüpft",
        "archivedNoAssign": "Archiviert – neue Zuweisungen sind nicht möglich.",
        "noPeople": "Noch keine Teilnehmer.",
        "doneOn": "abgeschlossen am {{date}}",
        "certificateDownloaded": "Zertifikat heruntergeladen am {{date}}",
        "certificateNotDownloaded": "Zertifikat noch nicht heruntergeladen",
        "dueOn": "Frist {{date}}",
        "missedOn": "Frist {{date}} verpasst",
        "assignedOn": "zugewiesen am {{date}}",
        "person": {
          "done": "Fertig",
          "late": "Überfällig",
          "open": "Offen"
        },
        "portalEyebrow": "So erscheint das Training im Schulungsportal",
        "portalHint": "Überschrift, Unterzeile und Beschreibung kommen aus „Portal-Darstellung“ im Assistenten; leer bedeutet Titel und Beschreibung des Trainings.",
        "resume": "Fortsetzen",
        "reopen": "Ansehen",
        "outlineVersion": "Veröffentlichte Version {{version}}",
        "outlineDraft": "Entwurf – noch nicht veröffentlicht"
      },
      "new": {
        "button": "Neues Training",
        "title": "Neues Training",
        "step": {
          "choose": "Womit möchtest du anfangen?",
          "folder": "Ordner wählen – seine Dateien werden Folien, Unterordner werden Kapitel.",
          "area": "Knowledge Area wählen – der Assistent öffnet ihre Dokumente.",
          "duplicate": "Training als Vorlage wählen – die Kopie ist ein Entwurf ohne Teilnehmer."
        },
        "empty": "Leer beginnen",
        "emptyHint": "Titel eingeben, Folien aus der Bibliothek wählen.",
        "folder": "Aus einem Ordner",
        "folderHint": "Alle Dateien eines Bibliotheksordners werden Folien, Unterordner Kapitel.",
        "area": "Aus einer Knowledge Area",
        "areaHint": "Dokumente einer Knowledge Area verknüpfen; die KA ist gleich zugewiesen.",
        "duplicate": "Bestehendes duplizieren",
        "duplicateHint": "Ein Training als Vorlage nehmen und anpassen.",
        "folderEmpty": "Dieser Ordner enthält keine Dateien.",
        "noFolders": "Die Bibliothek hat noch keine Ordner.",
        "continue": "Weiter"
      }
    },
    "people": {
      "title": "Teilnehmer",
      "subtitle": "Wer Trainings und Umfragen bekommt – und wie weit sie sind",
      "kindLabel": "Wo die Person lernt",
      "kind": {
        "internal": "webOS",
        "external": "Schulungsportal"
      },
      "searchPlaceholder": "Person suchen …",
      "searchUsers": "User suchen …",
      "onlyAssigned": "Nur mit Zuweisung",
      "noneFound": "Niemand passt zur Suche",
      "assignButton": "Zuweisen",
      "overdue_one": "{{count}} überfällig",
      "overdue_other": "{{count}} überfällig",
      "internalNote": "Interne User kommen aus der Benutzerverwaltung des Clients. Wer hier fehlt, hat noch kein Konto im webOS.",
      "columns": {
        "person": "Person",
        "trainings": "Trainings",
        "surveys": "Umfragen",
        "role": "Rolle",
        "lastActive": "Zuletzt aktiv"
      },
      "module": {
        "schulung": "Training",
        "umfrage": "Umfrage",
        "quiz": "Quiz"
      },
      "empty": {
        "internal": "Keine internen User",
        "external": "Noch keine externen Teilnehmer"
      },
      "emptyHint": {
        "internal": "Interne User kommen aus der Benutzerverwaltung des Clients.",
        "external": "Externe Teilnehmer anlegen oder per CSV hochladen."
      },
      "assign": {
        "title": "Zuweisen",
        "hint": "Personen und Trainings wählen – jede Kombination wird eine Zuweisung.",
        "loadFailed": "Die Auswahl konnte nicht geladen werden.",
        "forPerson": "Trainings und Umfragen für {{name}} wählen.",
        "forTraining": "Personen für „{{title}}“ wählen.",
        "persons": "Personen",
        "items": "Trainings & Umfragen",
        "alreadyAssigned": "bereits zugewiesen",
        "onlyAssigned": "Nur bereits zugewiesene zeigen ({{count}})",
        "noneAssignedHere": "In diesem Bereich ist noch niemand zugewiesen.",
        "deadlineHint": "optional, gilt für alle – im Schulungsportal endet der Zugang an diesem Tag statt nach der Zugangsdauer",
        "submit_one": "{{count}} Zuweisung anlegen",
        "submit_other": "{{count}} Zuweisungen anlegen",
        "created_one": "{{count}} Zuweisung angelegt",
        "created_other": "{{count}} Zuweisungen angelegt",
        "skipped_one": "{{count}} bestand schon und wurde übersprungen.",
        "skipped_other": "{{count}} bestanden schon und wurden übersprungen.",
        "deadline": "Frist",
        "summary": {
          "both": "{{count}} Zuweisungen: {{portal}} im Schulungsportal, {{webos}} im webOS",
          "portal_one": "{{count}} Zuweisung im Schulungsportal",
          "portal_other": "{{count}} Zuweisungen im Schulungsportal",
          "webos_one": "{{count}} Zuweisung im webOS",
          "webos_other": "{{count}} Zuweisungen im webOS"
        },
        "pickedInTab": "{{count}} gewählt",
        "surveyNotInPortal_one": "{{count}} gewählte Umfrage erscheint nicht im Schulungsportal – das Portal zeigt nur Schulungen. Externe erreichen Umfragen über den Einladungslink.",
        "surveyNotInPortal_other": "{{count}} gewählte Umfragen erscheinen nicht im Schulungsportal – das Portal zeigt nur Schulungen. Externe erreichen Umfragen über den Einladungslink."
      },
      "create": {
        "title": "Externen Teilnehmer anlegen",
        "hint": "Die Person meldet sich im Schulungsportal mit dieser E-Mail-Adresse an; das Konto verknüpft sich bei der ersten Anmeldung.",
        "assignNow": "Direkt Trainings zuweisen",
        "submit": "Anlegen",
        "submitAssign": "Anlegen und zuweisen",
        "created": "{{name}} angelegt"
      },
      "panel": {
        "externalBadge": "Extern · Teilnehmer",
        "internalBadge": "Intern · {{role}}",
        "accessTitle": "Zugang zum Schulungsportal",
        "firstLogin": "Erste Anmeldung {{date}}",
        "noLogin": "Noch keine Anmeldung",
        "accessDays_one": "Zugangsdauer {{count}} Tag je Training",
        "accessDays_other": "Zugangsdauer {{count}} Tage je Training",
        "accessRule": "Jedes Training hat sein eigenes Zeitfenster, das mit dem ersten Öffnen beginnt. Das Portal bleibt offen, solange eines davon läuft.",
        "doneOf": "{{done}} von {{total}} fertig",
        "assignments": "Zuweisungen",
        "nothingAssigned": "Noch nichts zugewiesen.",
        "answered": "Beantwortet",
        "noDeadline": "Ohne Frist",
        "slides": "{{done}} von {{total}} Folien",
        "windowNotStarted": "noch nicht geöffnet",
        "windowExpired": "Zugang abgelaufen",
        "plus30": "+30 Tage",
        "remove": "Zuweisung entfernen",
        "removed": "Zuweisung „{{title}}“ entfernt",
        "delete": "Teilnehmer löschen",
        "deleteTitle": "„{{name}}“ löschen?",
        "deleteBody_one": "Mit der Person werden ihre Zuweisung, der Lernfortschritt, ihre Antworten in Umfragen und Quiz und ihre Portal-Chats gelöscht. Das lässt sich nicht rückgängig machen. Ihr Anmeldekonto im Portal bleibt bestehen, sie sieht dort dann keine Schulung mehr.",
        "deleteBody_other": "Mit der Person werden ihre {{count}} Zuweisungen, der Lernfortschritt, ihre Antworten in Umfragen und Quiz und ihre Portal-Chats gelöscht. Das lässt sich nicht rückgängig machen. Ihr Anmeldekonto im Portal bleibt bestehen, sie sieht dort dann keine Schulung mehr.",
        "deleteConfirm": "Endgültig löschen",
        "deleteBlocked": "Diese Person hat eine Schulung abgeschlossen. Der Abschluss ist ihr Nachweis, deshalb kann sie nicht gelöscht werden.",
        "erase": "Auf Antrag der Person löschen (DSGVO)",
        "eraseHint": "Löscht auch abgeschlossene Schulungen und Zertifikate.",
        "eraseTitle": "„{{name}}“ auf Antrag löschen?",
        "eraseBody": "Gelöscht werden alle Zuweisungen, der Lernfortschritt, abgeschlossene Schulungen samt Zertifikaten, Antworten in Umfragen und Quiz (auch über öffentliche Links unter ihrer E-Mail-Adresse), Portal-Chats und, wenn kein anderer Kunde sie mehr einschreibt, ihr Anmeldeverlauf. Danach lässt sich kein Abschluss mehr belegen. Das lässt sich nicht rückgängig machen.",
        "eraseTypeLabel": "Zur Bestätigung den Namen eingeben: {{name}}",
        "eraseConfirm": "Endgültig löschen",
        "erasedTitle": "Daten gelöscht",
        "erasedSummary": "Gelöscht: {{completions}} Abschlüsse, {{certificates}} Zertifikate, {{answers}} Antworten über öffentliche Links.",
        "erasedCertificatesFailed": "{{count}} Zertifikat-Dateien konnten nicht gelöscht werden. Bitte den Support informieren.",
        "erasedAccountManual": "Das Anmeldekonto der Person im Portal besteht noch. Es muss von der BIK im Tenant „CDB Learning“ gelöscht werden. Objekt-ID: {{id}}",
        "erasedAccountElsewhere": "Das Anmeldekonto im Portal bleibt bestehen, weil ein anderer Kunde die Person noch einschreibt.",
        "erasedAccountNone": "Die Person hat sich nie im Portal angemeldet, es gibt kein Anmeldekonto zu löschen.",
        "extendedOne": "„{{title}}“ ist jetzt bis {{date}} offen",
        "sessionsTitle": "Anmeldungen im Portal",
        "sessionsSummary": "{{logins}} Anmeldungen · {{devices}} Geräte",
        "noSessions": "Noch keine Anmeldung im Portal.",
        "sessionActive": "gerade angemeldet",
        "sessionEnd": {
          "superseded": "von anderem Gerät abgelöst",
          "logout": "abgemeldet",
          "expired": "abgelaufen"
        }
      },
      "where": {
        "external": "Melden sich im Schulungsportal per Einmalcode an und sehen dort ihre Schulungen.",
        "externalLimit_one": "Melden sich im Schulungsportal per Einmalcode an und sehen dort ihre Schulungen. Zugang {{count}} Tag je Schulung ab dem ersten Öffnen.",
        "externalLimit_other": "Melden sich im Schulungsportal per Einmalcode an und sehen dort ihre Schulungen. Zugang {{count}} Tage je Schulung ab dem ersten Öffnen.",
        "internal": "Kolleginnen und Kollegen mit webOS-Konto. Sie sehen ihre Schulungen im Training Hub unter „Für mich“ – ohne Schulungsportal und ohne Zugangsdauer."
      }
    },
    "course": {
      "untitled": "Neue Schulung",
      "untitledChapter": "Kapitel ohne Titel",
      "header": {
        "kind": "Schulung",
        "titlePlaceholder": "Titel der Schulung",
        "draft": "Entwurf",
        "active": "Aktiv",
        "version": "Version {{version}}",
        "draftOf": "Version {{version}} · Entwurf",
        "saved": "Gespeichert {{time}}",
        "autosave": "Speichert automatisch",
        "preview": "Vorschau",
        "assign": "Zuweisen",
        "publish": "Veröffentlichen",
        "publishVersion": "Version {{version}} veröffentlichen"
      },
      "banner": {
        "frozenTitle": "Version {{version}} ist veröffentlicht. Zugewiesen: {{assigned}}, davon schon angefangen: {{started}}.",
        "frozenHint": "Titel und Beschreibung kannst du jederzeit ändern. Änderungen an Kapiteln, Bausteinen oder Materialversionen legen Version {{next}} an. Wer schon angefangen hat, arbeitet auf seiner Version weiter.",
        "newVersion": "Als Version {{version}} bearbeiten",
        "draftHint": "Du bearbeitest Version {{version}} als Entwurf. Bis du sie veröffentlichst, sehen alle weiter Version {{published}}. Beim Veröffentlichen kannst du Zuweisungen, die noch nicht angefangen haben ({{unstarted}}), auf die neue Version umstellen. Wer schon angefangen hat ({{started}}), bleibt auf Version {{published}}, außer du stellst diese Personen ausdrücklich mit um.",
        "discardDraft": "Entwurf verwerfen",
        "pinnedHint": "Sie sehen nichts, was seitdem dazugekommen ist, etwa einen neuen Fragebogen.",
        "liftPinned": "Auf Version {{version}} umstellen",
        "liftConfirmHint": "Bereits angesehene Folien bleiben als erledigt markiert. Enthält die neue Version einen Fragebogen in neuerer Fassung, wird er noch einmal beantwortet. Wer den Kurs schon abgeschlossen hat, bleibt auf seiner Version; das Zertifikat nennt diese Version.",
        "pinnedTitle_one": "Eine Person arbeitet noch auf einer älteren Version.",
        "pinnedTitle_other": "{{count}} Personen arbeiten noch auf einer älteren Version.",
        "liftConfirmTitle_one": "Eine Person auf Version {{version}} umstellen?",
        "liftConfirmTitle_other": "{{count}} Personen auf Version {{version}} umstellen?"
      },
      "structure": {
        "title": "Aufbau",
        "emptyChapter": "Noch kein Baustein – unten „Material“ oder „Fragebogen“ wählen.",
        "questions_one": "{{count}} Frage",
        "questions_other": "{{count}} Fragen",
        "required": "Pflicht",
        "addChapter": "Kapitel",
        "addMaterial": "Material",
        "addQuestionnaire": "Fragebogen",
        "aiQuiz": "Quiz erzeugen"
      },
      "panel": {
        "pick": "Links ein Kapitel oder einen Baustein wählen.",
        "item": "Baustein",
        "chapter": "Kapitel {{n}}",
        "material": "Material",
        "chapterTitle": "Kapiteltitel",
        "chapterDescription": "Beschreibung",
        "chapterDescriptionPlaceholder": "Was lernt man hier? Erscheint im Portal am Kapitelanfang.",
        "inPortal": "Im Portal",
        "inPortalHint": "Kapitel {{n}} steht in der Kapitelnavigation; der Fortschrittsring zählt seine {{count}} Bausteine.",
        "up": "Nach oben",
        "down": "Nach unten",
        "removeChapter": "Kapitel löschen",
        "removeItem": "Aus dem Kurs nehmen",
        "replace": "Ersetzen"
      },
      "material": {
        "pinned": "Gepinnte Version",
        "pinnedHint": "Der Kurs zeigt Version {{version}} dieses Materials, auch wenn es in der Bibliothek eine neuere gibt.",
        "newerAvailable": "In der Bibliothek liegt Version {{version}}.",
        "adoptHint": "Übernehmen tauscht die Folien in diesem Entwurf.",
        "adoptNeedsDraft": "Übernehmen geht erst in der nächsten Kursversion.",
        "adopt": "Version {{version}} übernehmen",
        "text": "Begleittext",
        "textPlaceholder": "Text neben dem Material im Portal (Markdown möglich) – optional",
        "countsAlways": "Zählt zum Abschluss",
        "always": "immer",
        "seenHint": "Gesehen = mit „Weiter“ verlassen; Springen zählt nicht.",
        "mediaHint": "Zählt als gesehen, wenn es zu Ende gespielt oder mit „Weiter“ verlassen wird.",
        "quizGateHint": "Die Schulung hat ein Pflicht-Quiz – das Quiz ist der Nachweis, die Folien sind frei.",
        "free": "frei"
      },
      "questionnaire": {
        "passMark": "Bestehensgrenze {{percent}} %",
        "from": "Aus Umfragen & Quiz",
        "fromHint": "Fragen, Bestehensgrenze und Anzeige-Einstellungen werden dort gepflegt.",
        "openEditor": "Im Quiz-Editor öffnen",
        "required": "Pflicht zum Abschluss",
        "requiredHintOn": "Bestanden nötig (≥ {{percent}} %), sonst bleibt die Schulung offen.",
        "requiredHintOff": "Übung – Ergebnis wird gespeichert, blockiert nichts.",
        "requiredSurvey": "Ausfüllen nötig",
        "requiredSurveyHint": "Eine Umfrage kann Pflicht zum Ausfüllen sein, nie zum Bestehen.",
        "retry": "Wiederholen erlaubt",
        "retryHint": "Ein nicht bestandenes Quiz kann erneut versucht werden.",
        "retryOn": "bis bestanden",
        "draftHint": "Der Fragebogen ist noch Entwurf. Beim Veröffentlichen der Schulung wird er mit veröffentlicht – intern, ohne offenen Link.",
        "newerQuiz": "Der Kurs bewertet mit Version {{pinned}} des Quiz (Bestehensgrenze {{pinnedMark}} %). Die aktuelle Version ist {{current}} (Bestehensgrenze {{currentMark}} %). Teilnehmende bearbeiten weiter Version {{pinned}} und werden danach bewertet.",
        "newerSurvey": "Der Kurs nutzt Version {{pinned}} der Umfrage. Die aktuelle Version ist {{current}}.",
        "newerNeedsVersion": "Damit der Kurs die aktuelle Version nutzt, lege eine neue Kursversion an und veröffentliche sie. Personen, die schon angefangen haben, kannst du danach auf die neue Kursversion umstellen.",
        "newerOnPublish": "Wenn du diese Kursversion veröffentlichst, nutzt sie die aktuelle Version.",
        "newerDot": "Neuere Version {{version}} vorhanden – der Kurs nutzt noch die ältere",
        "requiredHintNoMark": "Bestanden nötig – das Quiz hat noch keine Bestehensgrenze; ohne Grenze zählt jede Abgabe."
      },
      "settings": {
        "title": "Einstellungen",
        "description": "Beschreibung",
        "descriptionPlaceholder": "Worum geht es, für wen, wie lange?",
        "certificate": "Zertifikat",
        "certificateWithResult": "Person, Schulung, Kursversion, Datum, Quiz-Ergebnis – Nachweis ist das Pflicht-Quiz",
        "certificateParticipation": "Teilnahmebescheinigung: Person, Schulung, Kursversion, Datum",
        "certificateOff": "Kein Nachweis nach Abschluss",
        "certificateNoQuizHint": "Ohne Pflicht-Quiz bescheinigt das Zertifikat nur die Teilnahme. Für einen Wissensnachweis ein Quiz auf „Pflicht“ stellen.",
        "certificatePoints": "Punkte",
        "certificateCategory": "Art der Fortbildung",
        "certificateCategoryPlaceholder": "Allgemeine Fortbildung",
        "certificateCredits": "Fortbildungspunkte",
        "certificateCreditAdd": "Art der Fortbildung hinzufügen",
        "certificateCreditRemove": "Zeile entfernen",
        "certificatePointsHint": "Füllt «fortbildung» der Zertifikatsvorlage: alle Arten in einem Satz, z. B. „2,50 Punkten (Allgemeine Fortbildung) und 1,00 Punkten (Ingenieurtechnische Fortbildung)“. Ohne Eintrag entfällt der Satz auf der Urkunde.",
        "certificatePointsInvalid": "Jede Zeile braucht eine Art und Punkte mit höchstens zwei Nachkommastellen, z. B. 2,50. Bis dahin wird nichts gespeichert.",
        "knowledgeArea": "Fragen im Portal",
        "knowledgeAreaHint": "Wissensbereich, den der Chat neben der Folie nutzt.",
        "noKnowledgeArea": "Nur Folientexte",
        "access": "Zugangsdauer",
        "accessDays": "{{days}} Tage ab erstem Öffnen (Einstellung des Clients)",
        "accessUnlimited": "Unbegrenzt (Einstellung des Clients)",
        "accessWhere": "Standard des Clients, ändern unter Teilnehmer › Schulungsportal › Zugangsdauer. Ein festes Enddatum setzen Sie beim Zuweisen („Frist“).",
        "visibility": "Sichtbar für",
        "portal": "Portal-Startseite",
        "heroTitle": "Überschrift",
        "heroSubtitle": "Unterzeile",
        "heroDescription": "Beschreibung",
        "scope": "Umfang",
        "scopeChapters": "{{chapters}} Kapitel · {{items}} Bausteine",
        "scopeSlides": "{{slides}} Folien · {{videos}} Medien",
        "scopeQuiz": "{{quizzes}} Quiz ({{required}} Pflicht) · {{surveys}} Umfragen",
        "scopeMinutes": "ca. {{minutes}} Minuten",
        "certificateCategoryGeneral": "Allgemeine Fortbildung",
        "certificateCategoryEngineering": "Ingenieurtechnische Fortbildung"
      },
      "picker": {
        "title": "Baustein hinzufügen",
        "replaceTitle": "Baustein ersetzen",
        "hint": "Kommt ans Ende von Kapitel „{{chapter}}“. Nichts wird kopiert – der Kurs verweist auf die Bibliothek.",
        "replaceHint": "Der Platz im Kurs bleibt, der Verweis wechselt.",
        "materialTab": "Material-Bibliothek",
        "questionnaireTab": "Umfragen & Quiz",
        "nothing": "Nichts gefunden",
        "inCourse": "im Kurs",
        "materialFooter": "Fehlt etwas? Hochladen in der Material-Bibliothek.",
        "questionnaireFooter": "Neues Quiz? Anlegen in Umfragen & Quiz oder hier mit der KI."
      },
      "ai": {
        "title": "Quiz aus dem Material erzeugen",
        "hint": "Der Frage-Assistent liest die Folientexte dieser Schulung und legt ein Quiz in Umfragen & Quiz an. Es kommt als Entwurf in Kapitel „{{chapter}}“ und wird dort geprüft.",
        "quizTitle": "Titel des Quiz",
        "defaultTitle": "Wissenscheck {{title}}",
        "count": "Anzahl Fragen",
        "levelLabel": "Schwierigkeit",
        "level": {
          "mixed": "gemischt",
          "easy": "leicht",
          "hard": "anspruchsvoll",
          "mixedInstruction": "Mische leichte Verständnisfragen mit anspruchsvolleren Anwendungsfragen.",
          "easyInstruction": "Stelle leichte Verständnisfragen zu den Kernaussagen.",
          "hardInstruction": "Stelle anspruchsvolle Anwendungs- und Transferfragen."
        },
        "focus": "Schwerpunkt",
        "focusPlaceholder": "z. B. Anbieterpflichten und Ausnahmen – optional",
        "focusInstruction": "Schwerpunkt: {{focus}}.",
        "source": "Grundlage: die Folientexte dieser Schulung ({{slides}} Bausteine). Zwischenmodell, im Token-Tracking als „Fragen-Assistent“.",
        "run": "{{count}} Fragen erzeugen",
        "running": "Erzeugt …",
        "done": "{{count}} Fragen erzeugt – „{{title}}“ liegt als Entwurf in Umfragen & Quiz und ist hier als Übung eingehängt."
      },
      "publish": {
        "title": "Version {{version}} veröffentlichen",
        "hintFirst": "Mit dem Veröffentlichen wird Version 1 festgeschrieben: Reihenfolge, Bausteine, Material- und Fragebogenversionen lassen sich darin nicht mehr ändern. Spätere Änderungen daran legen Version 2 an.",
        "hintNext": "Mit dem Veröffentlichen wird Version {{version}} festgeschrieben. Wer die bisherige Version schon angefangen hat ({{started}}), bleibt dort. Zuweisungen, die noch nicht angefangen haben ({{unstarted}}), kannst du auf die neue Version umstellen.",
        "rowTitle": "Titel",
        "rowChapters": "Kapitel gefüllt",
        "rowRule": "Abschlussregel",
        "ruleWithQuiz": "{{quizzes}} Pflicht-Quiz bestanden – die {{slides}} Folien sind frei",
        "ruleNoQuiz": "{{slides}} Folien gesehen – kein Pflicht-Quiz",
        "rowQuestionnaires": "Fragebögen",
        "draftQuizzes_one": "{{count}} Fragebogen noch Entwurf – wird mit veröffentlicht (intern, ohne offenen Link)",
        "draftQuizzes_other": "{{count}} Fragebögen noch Entwurf – werden mit veröffentlicht (intern, ohne offenen Link)",
        "allPublished": "alle veröffentlicht",
        "lift": "Noch nicht gestartete Zuweisungen umstellen",
        "liftHint": "Diese Zuweisungen erhalten Version {{version}} ({{unstarted}}). Wer schon angefangen hat ({{started}}), bleibt auf seiner Version.",
        "go": "Veröffentlichen",
        "goAssign": "Veröffentlichen und zuweisen",
        "problemTitle": "Die Schulung braucht einen Titel",
        "problemNoItems": "Die Schulung hat noch keinen Baustein",
        "problemEmptyChapter": "Kapitel {{n}} „{{title}}“ hat keinen Baustein",
        "problemNoPassMark": "Pflicht-Quiz „{{title}}“ hat keine Bestehensgrenze",
        "liftStarted": "Auch Personen umstellen, die schon angefangen haben",
        "liftStartedHint": "Dann erhalten auch die Personen Version {{version}}, die Version {{published}} angefangen haben ({{started}}), und bis zu {{older}} Personen auf älteren Versionen. Bereits angesehene Folien bleiben als erledigt markiert. Wer den Kurs abgeschlossen hat, bleibt auf seiner Version."
      },
      "toast": {
        "itemRemoved": "Aus dem Kurs genommen – in der Bibliothek bleibt es",
        "lastChapter": "Das letzte Kapitel bleibt",
        "adopted": "„{{title}}“ zeigt jetzt Version {{version}}",
        "published": "Version {{version}} veröffentlicht",
        "newVersion": "Version {{version}} als Entwurf geöffnet",
        "draftDiscarded": "Entwurf verworfen",
        "assigned": "Zugewiesen",
        "passMarkSet": "„{{title}}“: Bestehensgrenze auf {{percent}} % gesetzt – im Quiz-Editor änderbar",
        "passMarkLocked": "„{{title}}“ ist veröffentlicht. Die Bestehensgrenze änderst du im Quiz-Editor über „Als neue Version bearbeiten“. Ohne Bestehensgrenze lässt sich die Schulung nicht veröffentlichen.",
        "lifted_one": "Eine Person auf Version {{version}} umgestellt",
        "lifted_other": "{{count}} Personen auf Version {{version}} umgestellt"
      },
      "quiz": {
        "previewNoSubmit": "Vorschau: es wird nichts abgegeben",
        "requiredPass": "Pflicht: bestanden ab {{percent}} %",
        "requiredFill": "Pflicht: ausfüllen",
        "optional": "Übung",
        "missing_one": "{{count}} Pflichtfrage fehlt noch",
        "missing_other": "{{count}} Pflichtfragen fehlen noch",
        "passMarkHint": "Bestehensgrenze {{percent}} %",
        "resultHidden": "Das Ergebnis wird bei diesem Quiz nicht angezeigt.",
        "retry": "Noch einmal versuchen",
        "correctAnswers": "Richtige Antworten",
        "yourChoice": "deine Wahl"
      },
      "player": {
        "chapters": "Kapitel",
        "openItems_one": "Noch {{count}} Baustein offen",
        "openItems_other": "Noch {{count}} Bausteine offen",
        "requiredOpen": "Ein Pflicht-Quiz ist noch nicht bestanden",
        "certificate": "Zertifikat herunterladen",
        "certificateFailed": "Zertifikat konnte nicht erzeugt werden",
        "completed": "Abgeschlossen am {{date}}",
        "versionNote": "Version {{version}}"
      }
    }
  },
  "pdfViewer": {
    "percent": "{{value}} %",
    "zoomMenu": "Zoom {{value}}, Optionen",
    "fitWholePage": "Ganze Seite zeigen",
    "fitWholeSlide": "Ganze Folie zeigen",
    "fitWholeSheet": "Ganzes Blatt zeigen",
    "actualSize": "Originalgröße",
    "zoomHint": "Strg/⌘ + Mausrad oder Zwei-Finger-Zoom · Strg/⌘ + 0 = 100 %",
    "slide": "Folie",
    "ofTotal": "von {{total}}",
    "slideCounter": "Folie {{current}} von {{total}}",
    "previousSlide": "Vorherige Folie",
    "nextSlide": "Nächste Folie",
    "sheetTabs": "Tabellenblätter",
    "title": "PDF Viewer",
    "currentDocument": "Aktuelles Dokument",
    "documentName": "Dokumentname",
    "fileName": "Dateiname",
    "fileSize": "Dateigröße",
    "totalPages": "Gesamtseitenzahl",
    "pages": "Seiten",
    "noPdfSelected": "Kein PDF ausgewählt",
    "openFromDrive": "Öffnen Sie PDFs über cdbDrive",
    "openFromDriveHint": "Dieser Viewer zeigt nur PDFs an, die von anderen Apps (z.B. cdbDrive) geöffnet werden.",
    "pdfLoading": "PDF wird geladen...",
    "errorLoadingPdf": "Fehler beim Laden der PDF",
    "pdfNoLongerAvailable": "PDF ist nicht mehr verfügbar. Bitte öffnen Sie die Datei erneut über cdbDrive.",
    "retry": "Erneut versuchen",
    "pageCounter": "Seite {{current}} von {{total}}",
    "previousPage": "Vorherige Seite",
    "nextPage": "Nächste Seite",
    "fitToWidth": "An Breite anpassen",
    "fitToPage": "An Seite anpassen",
    "width": "Breite",
    "page": "Seite",
    "zoomOut": "Verkleinern",
    "zoomIn": "Vergrößern",
    "dragToPan": "Ziehen zum Verschieben",
    "scrollToZoom": "Scrollen zum Zoomen",
    "closeTab": "Tab schließen",
    "maxTabsReached": "Maximum von {{max}} Tabs erreicht"
  },
  "filePreview": {
    "title": "Dateivorschau",
    "noFileSelected": "Keine Datei ausgewählt",
    "openFromDrive": "Öffnen Sie Dateien über cdbDrive",
    "errorLoading": "Fehler beim Laden der Datei",
    "temporaryUrlExpired": "Die Datei ist nach dem Neuladen nicht mehr verfügbar. Bitte öffnen Sie die Datei erneut über cdbDrive.",
    "tryAgain": "Bitte versuchen Sie es erneut",
    "invalidJson": "Ungültiges JSON-Format",
    "fileInfo": "Dateiinformationen",
    "fileName": "Dateiname",
    "fileSize": "Dateigröße",
    "fileType": "Dateityp",
    "knowledgeArea": "Knowledge Area",
    "unknownSize": "Unbekannt",
    "viewOptions": "Anzeigeoptionen",
    "lineNumbers": "Zeilennummern",
    "wordWrap": "Zeilenumbruch",
    "htmlPage": "Seite",
    "htmlSource": "Quelltext",
    "actions": "Aktionen",
    "download": "Herunterladen",
    "csvOptions": "CSV-Optionen",
    "csvDelimiter": "Trennzeichen",
    "csvHasHeader": "Erste Zeile als Überschrift",
    "loadingPresentation": "Präsentation wird geladen...",
    "emptyPresentation": "Keine Folien gefunden",
    "fullscreen": "Vollbild",
    "exitFullscreen": "Vollbild beenden (Esc)",
    "search": {
      "placeholder": "Im Dokument suchen...",
      "position": "{{position}} von {{total}}",
      "noHits": "Kein Treffer",
      "previous": "Vorheriger Treffer (Umschalt+Enter)",
      "next": "Nächster Treffer (Enter)"
    },
    "sheetTruncated": "Nicht angezeigt: {{parts}}. Datei herunterladen oder in Collabora öffnen, um alles zu sehen.",
    "sheetEmpty": "Dieses Blatt ist leer.",
    "sheetTruncatedRows": "{{count}} weitere Zeilen",
    "sheetTruncatedCols": "{{count}} weitere Spalten",
    "noPreviewTitle": "Keine Vorschau verfügbar",
    "noPreviewDescription": "Für diesen Dateityp gibt es keine Vorschau. Du kannst die Datei stattdessen herunterladen."
  },
  "promptLibrary": {
    "newPrompt": "Neuer Prompt",
    "editPrompt": "Prompt bearbeiten",
    "deleteConfirm": "Möchten Sie den Prompt \"{{title}}\" wirklich löschen?",
    "titleLabel": "Titel",
    "titlePlaceholder": "z.B. Code Review Prompt",
    "descriptionLabel": "Beschreibung (optional)",
    "descriptionPlaceholder": "Eine kurze Beschreibung des Prompts",
    "promptTextLabel": "Prompt Text",
    "promptTextPlaceholder": "Geben Sie Ihren Prompt hier ein...",
    "editorHint": "Erstellen Sie einen neuen Prompt für Ihre Sammlung.",
    "createSuccess": "Prompt erfolgreich erstellt",
    "updateSuccess": "Prompt erfolgreich aktualisiert",
    "deleteSuccess": "Prompt erfolgreich gelöscht",
    "share": {
      "title": "Prompt teilen",
      "description": "Teilen Sie diesen Prompt mit anderen Benutzern. Es wird eine unabhängige Kopie erstellt.",
      "selectUsers": "Benutzer auswählen",
      "noUsersAvailable": "Keine Benutzer verfügbar",
      "shareButton": "Mit {{count}} Benutzer(n) teilen",
      "sharing": "Wird geteilt...",
      "shareSuccess": "Prompt erfolgreich mit {{count}} Benutzer(n) geteilt",
      "shareError": "Prompt konnte nicht geteilt werden",
      "loadUsersError": "Benutzer konnten nicht geladen werden"
    },
    "errors": {
      "saveFailed": "Prompt konnte nicht gespeichert werden",
      "deleteFailed": "Prompt konnte nicht gelöscht werden",
      "reorderFailed": "Reihenfolge konnte nicht gespeichert werden"
    }
  },
  "drive2": {
    "filter": {
      "media": "Audio und Video"
    },
    "pickForChat": {
      "title": "Dateien für den Chat auswählen",
      "selectedCount": "{{count}} ausgewählt",
      "attach": "An Chat anhängen"
    },
    "sidebar": {
      "title": "cdbDrive",
      "personal": "Meine Dokumente",
      "corporate": "Unternehmen",
      "corporateKnowledgeAreas": "Knowledge Areas",
      "allAreas": "Alle Bereiche",
      "expand": "Sidebar ausklappen",
      "collapse": "Sidebar einklappen",
      "legendPersonal": "Persönlich",
      "legendCorporate": "Unternehmen",
      "personalComingSoon": "Demnächst verfügbar",
      "general": "Allgemein"
    },
    "badge": {
      "personal": "Persönlich",
      "corporate": "Unternehmen"
    },
    "header": {
      "allAreas": "Alle Bereiche",
      "documents": "Dokumente"
    },
    "search": {
      "placeholder": "Dokumente durchsuchen..."
    },
    "table": {
      "name": "Name",
      "format": "Format",
      "knowledgeArea": "Knowledge Area",
      "memoryStatus": "Durchsuchbar",
      "modified": "Geändert",
      "size": "Größe",
      "versionsTitle": "{{count}} Versionen — frühere Versionen ansehen/wiederherstellen"
    },
    "actions": {
      "open": "Öffnen",
      "download": "Herunterladen",
      "downloading": "Wird heruntergeladen...",
      "upload": "Hochladen",
      "delete": "Löschen",
      "deleteConfirm": "Datei wirklich löschen?",
      "useInChat": "In cdbChat verwenden",
      "ingest": "Durchsuchbar machen",
      "copyLink": "Link kopieren",
      "copyLinkDone": "Link kopiert",
      "copyLinkFailed": "Link konnte nicht kopiert werden",
      "shareLink": "Link teilen",
      "rename": "Umbenennen"
    },
    "memory": {
      "ingested": "Durchsuchbar",
      "noText": "Kein Text",
      "none": "Nicht durchsuchbar"
    },
    "empty": {
      "noFilesTitle": "Keine Dokumente",
      "noFilesDescription": "In diesem Bereich sind noch keine Dokumente vorhanden.",
      "noSearchResultsTitle": "Keine Treffer",
      "noSearchResultsDescription": "Für deine Suche wurden keine Dokumente gefunden.",
      "personalEmptyTitle": "Keine persönlichen Dokumente",
      "personalEmptyDescription": "Lade Dokumente über cdbChat hoch, um sie hier zu sehen."
    },
    "loading": "Dokumente werden geladen...",
    "loadingMore": "Weitere laden...",
    "loadMore": "{{loaded}} von {{total}} geladen — Weitere laden",
    "loadMoreMedia": "{{found}} — Weitere laden",
    "mediaFound_one": "{{count}} Audio-/Videodatei in {{loaded}} von {{total}} geladenen Dokumenten",
    "mediaFound_other": "{{count}} Audio-/Videodateien in {{loaded}} von {{total}} geladenen Dokumenten",
    "errorLoadingFiles": "Dokumente konnten nicht geladen werden.",
    "footer": {
      "of": "von",
      "files": "Dokumente"
    },
    "subtitle": {
      "loading": "Wird geladen...",
      "allAreas": "Alle Bereiche"
    },
    "preview": {
      "close": "Vorschau schließen",
      "loadError": "Die Datei konnte nicht geladen werden.",
      "retry": "Erneut versuchen",
      "splitter": "Vorschaubereich anpassen"
    },
    "editor": {
      "collabora": {
        "openCta": "In Collabora bearbeiten",
        "title": "Office-Editor: {{name}}",
        "subtitle": "Collabora Online · Word · Excel · PowerPoint",
        "loading": "Editor wird geladen…",
        "saveNow": "Jetzt speichern",
        "saving": "Speichern…",
        "saved": "Gespeichert",
        "unsaved": "Ungespeichert",
        "close": "Editor schließen",
        "popOut": "In eigenem Fenster öffnen",
        "unavailable": "Der Office-Editor ist derzeit nicht verfügbar.",
        "unsupported": "Dieser Dateityp kann nicht in Collabora bearbeitet werden.",
        "error": "Editor konnte nicht geladen werden."
      }
    },
    "bpmn": {
      "openCta": "Im BPMN-Editor öffnen",
      "title": "BPMN bearbeiten — {{name}}",
      "subtitle": "Änderungen werden als neue Version gespeichert",
      "loading": "Diagramm wird geladen …",
      "renderError": "Das Diagramm konnte nicht dargestellt werden.",
      "save": "Speichern",
      "saving": "Wird gespeichert …",
      "saved": "Gespeichert",
      "saveFailed": "Speichern fehlgeschlagen",
      "saveError": "Die neue Version konnte nicht gespeichert werden.",
      "unsaved": "Nicht gespeichert",
      "manualSave": "Speichern mit Strg/Cmd+S",
      "discardConfirm": "Es gibt ungespeicherte Änderungen. Editor trotzdem schließen?",
      "discard": "Verwerfen",
      "zoomIn": "Vergrößern",
      "zoomOut": "Verkleinern",
      "fit": "Einpassen",
      "close": "Editor schließen"
    },
    "html": {
      "loadFailed": "Die Seite konnte nicht geladen werden.",
      "openCta": "Im Editor öffnen",
      "editTitle": "HTML bearbeiten — {{name}}",
      "editSubtitle": "Änderungen werden als neue Version gespeichert",
      "save": "Speichern",
      "saving": "Wird gespeichert …",
      "saved": "Gespeichert",
      "saveFailed": "Speichern fehlgeschlagen",
      "saveError": "Die neue Version konnte nicht gespeichert werden.",
      "unsaved": "Nicht gespeichert",
      "discardConfirm": "Es gibt ungespeicherte Änderungen. Editor trotzdem schließen?",
      "discard": "Verwerfen",
      "close": "Editor schließen",
      "showPreview": "Vorschau einblenden",
      "hidePreview": "Vorschau ausblenden",
      "refreshPreview": "Vorschau aktualisieren",
      "lineCount_one": "{{count}} Zeile",
      "lineCount_other": "{{count}} Zeilen",
      "link": {
        "request": "Diese Seite möchte öffnen:",
        "open": "Öffnen",
        "cancel": "Abbrechen"
      }
    },
    "exportPdf": {
      "cta": "Als PDF speichern",
      "running": "PDF wird erstellt …",
      "doneTitle": "PDF gespeichert",
      "doneBody": "„{{name}}“ liegt jetzt in deinen Dateien.",
      "doneIncomplete": "„{{name}}“ liegt jetzt in deinen Dateien. Inhalte, die die Seite erst im Browser berechnet — etwa Diagramme —, fehlen darin.",
      "failedTitle": "Export fehlgeschlagen",
      "failedBody": "Die Seite konnte nicht als PDF gespeichert werden.",
      "tooLargeBody": "Die Seite ist zu groß für den PDF-Export.",
      "unavailableBody": "In dieser Umgebung steht der PDF-Export nicht zur Verfügung."
    },
    "details": {
      "title": "Details",
      "knowledgeSection": "Wissen",
      "openPreview": "Vorschau öffnen"
    },
    "multiselect": {
      "selectAll": "Alle auswählen",
      "selectedCount": "{{count}} ausgewählt",
      "deleteSelected": "Löschen",
      "clearSelection": "Auswahl aufheben",
      "deleteConfirm": "{{count}} Dokument(e) wirklich löschen?",
      "syncToBrain": "Sync mit Brain"
    },
    "brainSync": {
      "title": "Sync mit Brain",
      "successTitle": "An Brain übergeben – Verarbeitung läuft",
      "successDescription": "{{count}} Datei(en) angenommen. Den Stand der Verarbeitung zeigt das Drive an jeder Datei.",
      "noneAccepted": "Keine Datei wurde übernommen.",
      "precheckSummary": "{{count}} von {{total}} Datei(en) können übernommen werden.",
      "filesHeading": "Auswahl",
      "checkingFormats": "Unterstützte Formate werden geprüft…",
      "willSend": "Wird übernommen",
      "willSkip": "Wird übersprungen",
      "confirmCount": "{{count}} synchronisieren",
      "progress": "Datei {{current}} von {{total}}: {{name}}",
      "rateLimitWait": "Upload-Limit erreicht – nächster Versuch in {{seconds}} s",
      "stop": "Anhalten",
      "problemsHint": "{{count}} Datei(en) wurden nicht übernommen. Was sich erneut versuchen lässt, bleibt ausgewählt.",
      "resultsHeading": "Ergebnis",
      "result": {
        "accepted": "Übergeben – Verarbeitung läuft",
        "acceptedUnlinked": "Übergeben – der Status ist im Drive nicht verfolgbar",
        "duplicate": "Bereits in {{knowledgeArea}} ({{status}})",
        "duplicateUnknown": "Identischer Inhalt ist bereits vorhanden",
        "reprocess": "Neu verarbeiten",
        "reprocessStarted": "Neu gestartet",
        "reprocessFailed": "Neu verarbeiten ist fehlgeschlagen.",
        "rateLimited": "Upload-Limit erreicht – bitte später erneut versuchen",
        "cancelled": "Nicht gesendet (angehalten)",
        "failed": "Fehlgeschlagen: {{message}}"
      },
      "reason": {
        "convertToJpeg": "{{extension}} wird nicht verarbeitet – vorher in JPEG umwandeln",
        "excelImport": "Tabellen ({{extension}}) über den Excel-Import im Knowledge Extractor übernehmen",
        "exportPdf": "HTML-Seiten vorher als PDF exportieren",
        "imagesDisabled": "Bilder werden in Knowledge Areas derzeit nicht verarbeitet",
        "tooLarge": "Größer als {{maxMb}} MB",
        "format": "Dateityp {{extension}} kann nicht verarbeitet werden",
        "noExtension": "Dateien ohne Endung können nicht verarbeitet werden",
        "driveVideoTooLarge": "Videos über {{maxMb}} MB lassen sich aus Drive noch nicht übertragen – bitte direkt im Knowledge Extractor hochladen"
      }
    },
    "linkedDocument": {
      "errorTitle": "Dokument konnte nicht geöffnet werden",
      "errorMessage": "Der geteilte Link verweist auf ein Dokument, das gerade nicht geladen werden kann."
    },
    "shareLink": {
      "title": "Datei per Link teilen",
      "description": "Wer diesen Link öffnet, kann „{{filename}}“ ansehen — immer in der aktuellen Fassung. Die Datei wird nicht kopiert.",
      "create": "Link erstellen",
      "copy": "Link kopieren",
      "notDisplayable": "Für diese Datei gibt es einen gültigen Link, er lässt sich aber nicht mehr anzeigen. Widerrufe ihn und erstelle einen neuen.",
      "createdOn": "Erstellt am {{date}}",
      "viewers": "Angesehen von: {{count}}",
      "noViews": "Noch niemand hat die Datei geöffnet",
      "unknownUser": "Unbekannt",
      "revoke": "Widerrufen",
      "revoked": "Link widerrufen",
      "revokeFailed": "Der Link konnte nicht widerrufen werden",
      "copyFailed": "Der Link konnte nicht kopiert werden",
      "createFailed": "Der Link konnte nicht erstellt werden",
      "loadFailed": "Der Link konnte nicht geladen werden",
      "copyNote": "Es gibt genau einen Link pro Datei — du kannst ihn beliebig oft kopieren. Ein Widerruf wirkt sofort, auch bei jemandem, der die Datei gerade geöffnet hat."
    },
    "delete": {
      "failedTitle": "Löschen fehlgeschlagen",
      "failedBody": "Die Datei konnte nicht gelöscht werden und ist noch da. Bitte versuche es erneut.",
      "bulkFailedBody_one": "{{count}} von {{total}} Dateien konnte nicht gelöscht werden und ist noch da. Bitte versuche es erneut.",
      "bulkFailedBody_other": "{{count}} von {{total}} Dateien konnten nicht gelöscht werden und sind noch da. Bitte versuche es erneut."
    },
    "rename": {
      "title": "Datei umbenennen",
      "description": "Die Dateiendung bleibt unverändert — sie entscheidet, wie die Datei angezeigt und bearbeitet wird.",
      "failedTitle": "Umbenennen fehlgeschlagen",
      "failedBody": "Der Name konnte nicht geändert werden. Bitte versuche es erneut."
    },
    "brainStatus": {
      "label": "Brain",
      "section": "Brain (Knowledge Area)",
      "queued": "In Warteschlange",
      "processing": "In Verarbeitung",
      "completed": "Verarbeitet",
      "failed": "Fehlgeschlagen",
      "unsupported": "Nicht unterstützt",
      "notSynced": "Nicht synchronisiert",
      "outdated": "ältere Version",
      "outdatedHint": "Synchronisiert ist eine ältere Version dieser Datei.",
      "processedAt": "Verarbeitet am {{when}}"
    }
  },
  "changelog": {
    "title": "Changelog",
    "version": "Version",
    "latest": "Aktuell",
    "types": {
      "feature": "Neu",
      "improvement": "Verbessert",
      "fix": "Behoben"
    },
    "howTo": "So geht's",
    "loading": "Neuigkeiten werden geladen …",
    "loadError": "Die Neuigkeiten konnten nicht geladen werden.",
    "empty": "Noch keine Neuigkeiten.",
    "loadMore": "Ältere anzeigen",
    "loadingMore": "Ältere werden geladen …",
    "loadMoreError": "Ältere Einträge konnten nicht geladen werden.",
    "dontShowAgain": "Beim Start nicht mehr anzeigen",
    "confirm": "Verstanden!",
    "settingsHint": "Du findest den Changelog jederzeit in der Taskleiste",
    "footer": "ESC drücken oder außerhalb klicken zum Schließen"
  },
  "commandPalette": {
    "title": "Schnellzugriff",
    "spotlightPlaceholder": "Spotlight-Suche",
    "taskbarLabel": "Schnellzugriff ({{shortcut}})",
    "groups": {
      "app": "Apps",
      "document": "Dokumente",
      "personalDocument": "Meine Dokumente"
    },
    "hintNavigate": "Navigieren",
    "hintOpen": "Öffnen"
  },
  "upload": {
    "fileTooLarge": "Dateien dürfen maximal {{max}} MB groß sein",
    "tooManyFiles": "Zu viele Dateien ausgewählt"
  },
  "taskbar": {
    "aria": "Taskleiste",
    "timeBerlin": "Uhrzeit in Berlin",
    "openTour": "Desktop-Tour starten",
    "stopTour": "Desktop-Tour beenden",
    "preview": {
      "windowCount_one": "{{count}} Fenster",
      "windowCount_other": "{{count}} Fenster",
      "active": "Aktiv",
      "minimized": "Minimiert",
      "restore": "Wiederherstellen",
      "minimize": "Minimieren",
      "close": "Schließen"
    },
    "voiceAgentActive": "Voice Agent aktiv",
    "voiceAgentSession": "Voice Agent Sitzung läuft",
    "toggleWidgetArea": "Widget-Bereich umschalten"
  },
  "bugReport": {
    "myReports": {
      "title": "Meine Tickets",
      "description": "Verfolgen Sie den Stand Ihrer Meldungen und Wünsche und beantworten Sie Rückfragen des Teams.",
      "createTicket": "Ticket erstellen",
      "groups": {
        "label": "Tickets filtern",
        "active": "Aktiv ({{count}})",
        "done": "Erledigt ({{count}})"
      },
      "groupEmpty": {
        "active": "Keine offenen Tickets.",
        "done": "Noch keine erledigten Tickets."
      },
      "listLabel": "Ihre Tickets",
      "empty": "Sie haben noch keine Tickets eingereicht.",
      "emptyHint": "Wenn Ihnen ein Fehler auffällt, melden Sie ihn über „Ticket erstellen“. Das Team kann Ihnen direkt hier antworten.",
      "loadError": "Ihre Tickets konnten nicht geladen werden.",
      "retry": "Erneut versuchen",
      "notFound": "Dieses Ticket wurde nicht gefunden.",
      "selectHint": "Wählen Sie ein Ticket aus, um den Verlauf zu sehen.",
      "unread_one": "{{count}} neue Antwort",
      "unread_other": "{{count}} neue Antworten",
      "submittedOn": "eingereicht am {{date}}",
      "showReport": "Meine Meldung ansehen",
      "hideReport": "Meldung ausblenden",
      "attachments": "Anhänge der Meldung",
      "back": "Zurück zur Liste",
      "progressLabel": "Fortschritt",
      "steps": {
        "submitted": "Eingereicht",
        "inProgress": "In Bearbeitung",
        "question": "Rückfrage",
        "resolved": "Gelöst",
        "closed": "Geschlossen",
        "planned": "Geplant"
      },
      "questionBanner": {
        "title": "Das Team hat eine Rückfrage.",
        "body": "Bitte antworten Sie, damit wir weitermachen können."
      },
      "resolvedHint": "Das Team hat das Ticket als gelöst markiert. Besteht das Problem weiter, antworten Sie innerhalb von 14 Tagen – das Ticket wird dann wieder geöffnet, sonst automatisch geschlossen."
    },
    "category": {
      "ui": "UI / Design",
      "functionality": "Funktionalität",
      "performance": "Performance",
      "data_loss": "Datenverlust",
      "new_feature": "Neue Funktion",
      "improvement": "Verbesserung",
      "ui_ux": "UI / UX",
      "workflow": "Workflow & Produktivität",
      "integration": "Integration",
      "other": "Sonstiges"
    },
    "system": {
      "portal": "Portal",
      "webos": "webOS",
      "document_editor": "Document Editor",
      "pdb": "PDB",
      "chat": "Chat"
    },
    "form": {
      "titleLabel": "Titel",
      "titlePlaceholder": "Kurzer Fehler-Titel",
      "categoryLabel": "Kategorie",
      "systemLabel": "System",
      "systemPlaceholder": "System auswählen",
      "descriptionLabel": "Beschreibung",
      "descriptionPlaceholder": "Was ist passiert? Wie kann der Fehler reproduziert werden?",
      "attachmentsLabel": "Anhänge (optional)",
      "attachmentsHint": "Bis zu {{max}} Dateien, jeweils max. {{maxMb}} MB (PNG, JPG, GIF, WEBP, MP4, WEBM).",
      "removeAttachment": "Anhang entfernen",
      "attachmentsSummary": "{{used}} von {{max}} Anhängen verwendet"
    },
    "dialog": {
      "title": "Bug melden",
      "description": "Beschreiben Sie den Fehler möglichst präzise. Screenshots oder kurze Videos helfen der Analyse.",
      "replyNotice": "Das Team kann Ihnen zu diesem Report antworten.",
      "submit": "Bug-Report senden",
      "submitting": "Wird gesendet...",
      "successTitle": "Bug-Report gesendet",
      "successDescription": "Danke für Ihren Hinweis. Das Admin-Team prüft den Report.",
      "errorTitle": "Bug-Report fehlgeschlagen",
      "errorDescription": "Der Bug-Report konnte nicht gespeichert werden. Bitte später erneut versuchen."
    },
    "validation": {
      "titleRequiredTitle": "Titel erforderlich",
      "titleRequired": "Bitte geben Sie einen Titel ein.",
      "descriptionRequiredTitle": "Beschreibung erforderlich",
      "descriptionRequired": "Bitte geben Sie eine Beschreibung ein.",
      "systemRequiredTitle": "System erforderlich",
      "systemRequired": "Bitte wählen Sie ein System aus.",
      "tooManyFilesTitle": "Zu viele Dateien",
      "tooManyFiles": "Es sind maximal {{max}} Dateien erlaubt.",
      "fileTooLargeTitle": "Datei zu groß",
      "fileTooLarge": "{{name}} überschreitet {{max}} MB.",
      "invalidTypeTitle": "Ungültiger Dateityp",
      "invalidType": "{{name}} hat einen nicht unterstützten Dateityp."
    },
    "errors": {
      "BUG_REPORT_MAX_FILES_EXCEEDED": "Es sind maximal 6 Anhänge erlaubt.",
      "BUG_REPORT_FILE_TOO_LARGE": "Mindestens eine Datei ist größer als 10 MB.",
      "BUG_REPORT_INVALID_FILE_TYPE": "Mindestens eine Datei hat einen ungültigen Typ.",
      "BUG_REPORT_SYSTEM_REQUIRED": "Bitte wählen Sie ein System aus.",
      "BUG_REPORT_NOT_AUTHENTICATED": "Sie sind nicht angemeldet. Bitte melden Sie sich erneut an.",
      "BUG_REPORT_UPLOAD_FAILED": "Anhänge konnten nicht hochgeladen werden.",
      "BUG_REPORT_CLOSE_REASON_REQUIRED": "Bitte wählen Sie einen Grund für das Schließen."
    },
    "status": {
      "open": "Offen",
      "in_progress": "In Bearbeitung",
      "waiting_for_reporter": "Rückfrage",
      "planned": "Geplant",
      "resolved": "Gelöst",
      "closed": "Geschlossen"
    },
    "closeReason": {
      "done": "Erledigt / umgesetzt",
      "declined": "Abgelehnt",
      "duplicate": "Duplikat",
      "not_a_bug": "Kein Bug",
      "no_response": "Keine Rückmeldung",
      "suggested": "Vorschlag"
    },
    "type": {
      "bug": "Bug",
      "feature": "Wunsch"
    },
    "admin": {
      "description": "Bugs und Wünsche aller Clients. Karte ziehen = Status ändern, der Melder wird benachrichtigt.",
      "empty": "Keine Tickets gefunden",
      "unknownUser": "Unbekannter Nutzer",
      "filters": {
        "all": "Alle",
        "noClient": "Ohne Zuordnung",
        "allClients": "Alle Organisationen",
        "search": "Tickets durchsuchen",
        "searchPlaceholder": "Suchen: Titel, ID, Melder",
        "allSystems": "Alle Systeme",
        "allCategories": "Alle Kategorien",
        "onlyUnread": "Nur mit neuen Antworten ({{count}})",
        "button": "Filter",
        "activeCount_one": "{{count}} Filter aktiv",
        "activeCount_other": "{{count}} Filter aktiv",
        "reset": "Filter zurücksetzen",
        "client": "Organisation",
        "system": "System",
        "category": "Kategorie",
        "status": "Status"
      },
      "table": {
        "status": "Status",
        "category": "Kategorie",
        "system": "System",
        "title": "Titel",
        "reporter": "Gemeldet von",
        "attachments": "Anhänge",
        "actions": "Aktionen",
        "client": "Organisation",
        "noReporter": "—",
        "lastActivity": "Letzte Aktivität",
        "unread": "Neu",
        "type": "Typ"
      },
      "details": {
        "noAttachments": "Keine Anhänge vorhanden.",
        "screenshots": "Screenshots",
        "recordings": "Bildschirmaufnahmen",
        "documents": "Dokumente",
        "preview": "Vorschau",
        "previewLoading": "Vorschau wird geladen …",
        "previewError": "Die Vorschau konnte nicht geladen werden. Laden Sie die Datei herunter, um sie zu öffnen.",
        "download": "Herunterladen",
        "downloadErrorTitle": "Download fehlgeschlagen",
        "downloadErrorDescription": "\"{{name}}\" konnte nicht heruntergeladen werden.",
        "status": "Status"
      },
      "loadErrorTitle": "Tickets konnten nicht geladen werden",
      "loadErrorDescription": "Bitte versuchen Sie es erneut.",
      "saveErrorClosed": "Das Ticket ist geschlossen. Öffnen Sie es wieder, um eine Notiz zu ergänzen.",
      "emptyFiltered": "Keine Tickets für diese Filter.",
      "board": {
        "viewLabel": "Ansicht",
        "viewBoard": "Board",
        "viewList": "Liste",
        "columnLabel": "{{status}} ({{count}})",
        "collapse": "Einklappen",
        "expand": "Anzeigen",
        "hint": {
          "open": "neu eingegangen",
          "in_progress": "wird bearbeitet",
          "waiting_for_reporter": "wartet auf Melder",
          "resolved": "Fix ausgerollt",
          "closed": "abgeschlossen",
          "planned": "nur Wünsche"
        },
        "emptyColumn": "Hier ablegen",
        "closedHint": "Eingeklappt. Hier ablegen = schließen.",
        "dragHandle": "„{{title}}“ verschieben",
        "unreadPrefix": "Neue Antworten:",
        "unread_one": "{{count}} neue Antwort",
        "unread_other": "{{count}} neue Antworten",
        "moveErrorTitle": "Status nicht geändert",
        "moveErrorDescription": "„{{title}}“ bleibt auf „{{status}}“. Bitte versuchen Sie es erneut.",
        "moveRefusedTitle": "„{{status}}“ nicht möglich",
        "plannedNotAllowed": "„Geplant“ gibt es nur für Wünsche. Stufen Sie den Bug im Ticket erst als Wunsch ein.",
        "dropReason": {
          "label": "Grund für das Schließen von „{{title}}“",
          "heading": "Schließen als …",
          "cancelHint": "Esc bricht ab, die Karte bleibt, wo sie war."
        }
      },
      "drawer": {
        "copyLink": "Link kopieren",
        "linkCopied": "Link kopiert",
        "linkCopyFailed": "Link konnte nicht kopiert werden",
        "reportedBy": "gemeldet von {{name}}",
        "noReporter": "ohne Melder",
        "attachments": "Anhänge ({{count}})",
        "history": "Verlauf",
        "submitted": "Eingereicht",
        "visibility": "Sichtbarkeit: Der Melder sieht Beschreibung, Anhänge, Status und alle Antworten. Interne Notizen sieht nur das BIK-Team.",
        "loadErrorTitle": "Verlauf konnte nicht geladen werden",
        "loadErrorDescription": "Bitte versuchen Sie es erneut.",
        "notFound": "Dieses Ticket wurde nicht gefunden.",
        "showDetails": "Details anzeigen",
        "hideDetails": "Details ausblenden",
        "type": "Typ",
        "closeAs": "Geschlossen als …",
        "reopenFirst": "erst wieder öffnen",
        "typeChanged": "Als {{type}} eingestuft",
        "typeErrorTitle": "Typ nicht geändert",
        "typeErrorDescription": "Der Typ konnte nicht geändert werden. Bitte versuchen Sie es erneut."
      },
      "github": {
        "button": "In GitHub anlegen",
        "chip": "GitHub #{{number}}",
        "chipTitle": "Issue {{ref}} in GitHub öffnen",
        "dialogTitle": "Issue in GitHub anlegen",
        "privacyNote": "Aus Report und Verlauf entsteht ein Entwurf nach unseren Issue-Regeln, den Sie vor dem Anlegen prüfen. Name, E-Mail-Adresse und ID der meldenden Person werden nicht übertragen; Anhänge bleiben im Ticket, das Issue verlinkt darauf.",
        "repo": "Repository",
        "repoPlaceholder": "Repository wählen",
        "includeNotes": "Interne Notizen einbeziehen",
        "draft": "Entwurf erstellen",
        "redraft": "Neu entwerfen",
        "drafting": "Entwurf wird erstellt …",
        "draftingHint": "Das dauert einige Sekunden.",
        "typeLabel": "Art",
        "type": {
          "bug": "Fehler",
          "feature": "Funktion",
          "chore": "Wartung",
          "intent": "Anliegen (braucht Spezifikation)"
        },
        "titleLabel": "Titel",
        "bodyLabel": "Beschreibung (Markdown)",
        "edit": "Bearbeiten",
        "preview": "Vorschau",
        "labels": "Labels",
        "addLabel": "Label hinzufügen",
        "removeLabel": "Label {{label}} entfernen",
        "labelUnknown": "Im Repo nicht vorhanden",
        "labelUnknownHint": "Dieses Label gibt es im gewählten Repository nicht. Es wird nicht gesetzt.",
        "labelUnknownNote": "Durchgestrichene Labels gibt es in {{repo}} nicht und werden nicht gesetzt.",
        "dismissUnknownLabel": "Hinweis zu „{{label}}“ entfernen",
        "unknownLabelsError": "Einige Labels gibt es in diesem Repository nicht. Sie wurden entfernt – bitte legen Sie das Issue erneut an.",
        "create": "Issue anlegen",
        "creating": "Issue wird angelegt …",
        "successText": "Das Issue {{ref}} wurde angelegt und mit diesem Ticket verknüpft.",
        "openIssue": "In GitHub öffnen",
        "unavailable": "Die GitHub-Anbindung ist in dieser Umgebung nicht eingerichtet. Bitte wenden Sie sich an das Plattform-Team.",
        "configError": "Die GitHub-Einstellungen konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
        "draftError": "Der Entwurf konnte nicht erstellt werden. Bitte versuchen Sie es erneut.",
        "createError": "Das Issue konnte nicht angelegt werden. Bitte versuchen Sie es erneut.",
        "exists": "Zu diesem Ticket gibt es bereits ein Issue."
      },
      "typeFilter": {
        "label": "Typ",
        "all": "Alle",
        "bug": "Bugs",
        "feature": "Wünsche",
        "count": "{{label}} ({{count}})"
      }
    },
    "stepper": {
      "details": "Details",
      "screenshot": "Screenshot",
      "recording": "Aufnahme",
      "documents": "Anhänge"
    },
    "documents": {
      "hint": "Hängen Sie optional Dokumente an, die zu dem Fehler geführt haben – zum Beispiel die Datei, deren Upload fehlgeschlagen ist. Erlaubt sind PDF-, Word- und Excel-Dateien.",
      "selectLabel": "Dokumente auswählen"
    },
    "screenshot": {
      "hint": "Nehmen Sie optional einen Screenshot auf. Sie können den Bereich anschließend zuschneiden.",
      "capture": "Screenshot aufnehmen",
      "retake": "Neu aufnehmen",
      "remove": "Entfernen",
      "crop": "Zuschneiden",
      "cropHint": "Ziehen Sie ein Rechteck über den Bereich, den Sie behalten möchten.",
      "cropApply": "Zuschnitt anwenden",
      "cropReset": "Zurücksetzen",
      "cropError": "Zuschnitt fehlgeschlagen",
      "capturing": "Aufnahme wird gestartet...",
      "manualLabel": "Oder Screenshot-Datei hochladen",
      "readyToCapture": "Bereit zur Aufnahme",
      "captureNow": "Screenshot jetzt aufnehmen",
      "streamingHint": "Navigieren Sie zur gewünschten Ansicht und klicken Sie auf „Screenshot jetzt aufnehmen“."
    },
    "recording": {
      "hint": "Nehmen Sie optional eine kurze Bildschirmaufnahme auf (max. 30 Sekunden).",
      "start": "Aufnahme starten",
      "stop": "Aufnahme stoppen",
      "retake": "Neu aufnehmen",
      "remove": "Entfernen",
      "recording": "Aufnahme läuft",
      "maxDuration": "Maximale Dauer: {{seconds}} Sekunden",
      "manualLabel": "Oder Videoaufnahme hochladen",
      "inProgressHint": "Aufnahme läuft im Hintergrund. Nutze die schwebende Leiste zum Stoppen."
    },
    "navigation": {
      "next": "Weiter",
      "back": "Zurück",
      "submit": "Bug-Report senden",
      "skipToSubmit": "Direkt senden"
    },
    "thread": {
      "label": "Verlauf",
      "empty": "Noch keine Nachrichten.",
      "newDivider": "Neu",
      "event": "{{name}}: {{from}} → {{to}}",
      "system": "System",
      "reporter": "Melder",
      "team": "BIK-Team",
      "internal": "Intern",
      "internalNoteBy": "Interne Notiz von {{name}}",
      "messageBy": "Nachricht von {{name}}",
      "downloadAttachment": "{{name}} herunterladen",
      "typeEvent": "{{name}}: als {{to}} eingestuft (vorher {{from}})"
    },
    "composer": {
      "label": "Nachricht verfassen",
      "modeLabel": "Art der Nachricht",
      "modeReply": "Antwort an Melder",
      "modeNote": "Interne Notiz",
      "noReporter": "Ohne Melder – nur interne Notizen möglich.",
      "replyHint": "{{name}} wird im Notification Center benachrichtigt.",
      "noteHint": "Nur für das BIK-Team sichtbar, niemand wird benachrichtigt.",
      "messageLabel": "Nachricht",
      "replyPlaceholder": "Antwort schreiben …",
      "notePlaceholder": "Interne Notiz schreiben …",
      "attachments": "Anhänge",
      "removeAttachment": "{{name}} entfernen",
      "attach": "Datei anhängen",
      "statusAfter": "Status danach:",
      "statusUnchanged": "Unverändert",
      "send": "Senden",
      "closedAdmin": "Dieses Ticket ist geschlossen. Zum Antworten erst wieder öffnen.",
      "closedReporter": "Dieses Ticket ist geschlossen.",
      "sendErrorTitle": "Nachricht nicht gesendet",
      "sendErrorDescription": "Die Nachricht konnte nicht gesendet werden. Ihr Entwurf bleibt erhalten.",
      "closeReason": "Grund:",
      "closeReasonPlaceholder": "Grund wählen",
      "closeReasonMissing": "Bitte wählen Sie einen Grund für das Schließen.",
      "sendAndClose": "Senden und schließen"
    },
    "context": {
      "title": "Kontext",
      "system": "System",
      "app": "App",
      "window": "Fenster",
      "route": "Seite",
      "app_version": "Version",
      "browser": "Browser",
      "os": "Betriebssystem",
      "client_name": "Organisation",
      "captured_at": "Erfasst"
    }
  },
  "ticketPanel": {
    "title": "Ticket erstellen",
    "entry": {
      "feature": "Verbesserung vorschlagen"
    },
    "type": {
      "label": "Art des Tickets",
      "bug": "Fehler melden",
      "feature": "Verbesserung vorschlagen"
    },
    "form": {
      "titleLabel": {
        "bug": "Was ist passiert?",
        "feature": "Was schlagen Sie vor?"
      },
      "titlePlaceholder": {
        "bug": "Kurz zusammengefasst, z. B. „PDF-Vorschau bleibt leer“",
        "feature": "Kurz zusammengefasst, z. B. „Lieferscheine nach Datum sortieren“"
      },
      "descriptionLabel": "Beschreibung",
      "descriptionPlaceholder": {
        "bug": "Was haben Sie getan, was ist passiert und was hätten Sie erwartet?",
        "feature": "Welches Problem würde das lösen, und wie arbeiten Sie heute?"
      },
      "categoryLabel": "Kategorie",
      "optional": "optional",
      "categoryNone": "Keine Angabe"
    },
    "validation": {
      "title": "Bitte geben Sie einen Titel ein.",
      "description": "Bitte beschreiben Sie Ihr Anliegen."
    },
    "attachments": {
      "label": "Anhänge",
      "count": "{{used}} von {{max}}",
      "screenshot": "Bildschirmfoto",
      "recording": "Aufnahme",
      "file": "Datei",
      "kind": {
        "screenshot": "Bildschirmfoto",
        "screenshotMarked": "Bildschirmfoto mit Markierung",
        "recording": "Bildschirmaufnahme"
      },
      "capturedHint": "aufgenommen ohne dieses Panel",
      "mark": "Markieren",
      "remove": "{{name}} entfernen"
    },
    "capture": {
      "ready": "Wählen Sie die Ansicht, die Sie zeigen möchten.",
      "now": "Jetzt aufnehmen",
      "recording": "Aufnahme läuft",
      "secondsLeft": "noch {{seconds}} s",
      "stop": "Beenden",
      "unsupported": "Ihr Browser unterstützt keine Bildschirmaufnahme. Sie können stattdessen eine Datei anhängen.",
      "failed": "Die Aufnahme ist fehlgeschlagen. Bitte versuchen Sie es erneut."
    },
    "markup": {
      "title": "Bildschirmfoto markieren",
      "toolsLabel": "Werkzeug",
      "tool": {
        "rect": "Rechteck",
        "arrow": "Pfeil"
      },
      "undo": "Letzte Markierung entfernen",
      "hint": "Ziehen Sie auf dem Bild, um eine Stelle zu markieren.",
      "canvasLabel_one": "Bildschirmfoto mit {{count}} Markierung",
      "canvasLabel_other": "Bildschirmfoto mit {{count}} Markierungen",
      "failed": "Das Bildschirmfoto konnte nicht geladen werden.",
      "apply": "Übernehmen"
    },
    "context": {
      "title": "Automatisch erfasst",
      "attach": "anhängen",
      "version": "Version {{version}}",
      "excluded": "Diese Angaben werden nicht mitgesendet."
    },
    "footer": {
      "replyNotice": "Das Team kann Ihnen antworten.",
      "submit": "Ticket senden",
      "submitting": "Wird gesendet …"
    },
    "success": {
      "title": "Vielen Dank – Ihr Ticket ist eingegangen.",
      "text": "Antworten des Teams finden Sie unter „Meine Tickets“. Sie werden benachrichtigt, sobald es Neuigkeiten gibt.",
      "open": "Meine Tickets öffnen",
      "another": "Weiteres Ticket erstellen"
    },
    "errors": {
      "submitTitle": "Ticket konnte nicht gesendet werden",
      "submit": "Bitte versuchen Sie es erneut. Ihre Eingaben bleiben erhalten.",
      "typeDisabled": {
        "bug": "Fehlermeldungen sind für Ihre Rolle nicht freigeschaltet. Bitte wenden Sie sich an Ihre Administration.",
        "feature": "Verbesserungsvorschläge sind für Ihre Rolle nicht freigeschaltet. Bitte wenden Sie sich an Ihre Administration."
      }
    },
    "similar": {
      "title": "Ähnliche Tickets gefunden",
      "own": "von Ihnen gemeldet",
      "noClient": "ohne Zuordnung",
      "open": "Öffnen",
      "openLabel": "„{{title}}“ öffnen",
      "append": "Ergänzen",
      "appendLabel": "„{{title}}“ ergänzen"
    },
    "append": {
      "title": "Zu bestehendem Ticket ergänzen",
      "hint": "Ihre Beschreibung und Anhänge werden als Antwort zu diesem Ticket gesendet – es entsteht kein neues Ticket.",
      "cancel": "Doch neues Ticket",
      "descriptionLabel": "Ihre Ergänzung",
      "descriptionPlaceholder": "Was ist neu oder zusätzlich passiert?",
      "submit": "Ergänzung senden",
      "successTitle": "Vielen Dank – Ihre Ergänzung ist eingegangen.",
      "successText": "Sie steht im Ticket unter „Meine Tickets“. Das Team wird benachrichtigt.",
      "successOpen": "Ticket öffnen",
      "errorTitle": "Ergänzung konnte nicht gesendet werden",
      "closed": "Das Ticket wurde inzwischen geschlossen. Sie können Ihr Anliegen als neues Ticket senden – Ihre Eingaben bleiben erhalten."
    },
    "suggestion": {
      "type": {
        "bug": "Klingt eher nach einem Fehler",
        "feature": "Klingt eher nach einem Wunsch",
        "bugWithCategory": "Klingt eher nach einem Fehler ({{category}})",
        "featureWithCategory": "Klingt eher nach einem Wunsch ({{category}})"
      },
      "category": "Passende Kategorie: {{category}}",
      "apply": "übernehmen",
      "dismiss": "Vorschlag ausblenden"
    }
  },
  "settings": {
    "title": "Einstellungen",
    "description": "Passen Sie Ihr cdb-webOS an",
    "saving": "Speichert Einstellungen...",
    "desktopIcons": "Desktop-Icons",
    "showIcons": "Symbole anzeigen",
    "showIconsDesc": "Desktop-Symbole ein- oder ausblenden",
    "showLabels": "Beschriftungen",
    "showLabelsDesc": "Text unter Symbolen anzeigen",
    "taskbarDisplayMode": "Taskleistenanzeige",
    "iconAndName": "Symbol und Name",
    "iconOnly": "Nur Symbol",
    "nameOnly": "Nur Name",
    "sections": {
      "theme": "Theme & Sprache",
      "desktop": "Desktop-Icons",
      "taskbar": "Taskleiste",
      "claude": "Claude verbinden"
    },
    "theme": {
      "label": "Theme",
      "description": "Wählen Sie ein Theme für Ihr cdb-webOS",
      "automaticSettings": "Automatische Einstellungen",
      "iconColor": "Icon-Farbe",
      "textColor": "Text-Farbe"
    },
    "language": {
      "label": "Sprache",
      "description": "Ändern Sie die Sprache der Benutzeroberfläche"
    },
    "desktop": {
      "visibility": "Sichtbarkeit",
      "showIcons": "Icons anzeigen",
      "showIconsDescription": "Desktop-Icons ein- oder ausblenden",
      "showLabels": "Icon-Beschriftungen anzeigen",
      "showLabelsDescription": "Text unter den Icons anzeigen"
    },
    "taskbar": {
      "displayMode": "Anzeigemodus",
      "displayModeDescription": "Wählen Sie, wie Apps in der Taskleiste angezeigt werden",
      "displayBoth": "Symbol und Name",
      "displayIconOnly": "Nur Symbol",
      "displayNameOnly": "Nur Name"
    },
    "reset": {
      "title": "Zurücksetzen",
      "description": "Setzen Sie alle Einstellungen auf die Standardwerte zurück",
      "button": "Einstellungen zurücksetzen",
      "confirmMessage": "Möchten Sie wirklich alle Einstellungen zurücksetzen? Diese Aktion kann nicht rückgängig gemacht werden.",
      "confirm": "Ja, zurücksetzen",
      "cancel": "Abbrechen"
    },
    "selectLanguage": "Sprache auswählen",
    "selectDisplayMode": "Anzeigemodus auswählen",
    "selectTheme": "Theme auswählen",
    "claude": {
      "description": "Verbinde Claude (claude.ai, Claude Desktop, Claude Code) mit cdbOS. Claude durchsucht dann die Wissensbereiche, auf die du auch hier Zugriff hast – nur lesend.",
      "url": "Server-URL",
      "clientId": "OAuth-Client-ID",
      "copy": "Kopieren",
      "steps": {
        "add": "In Claude: Einstellungen → Connectors → Benutzerdefinierten Connector hinzufügen und die Server-URL eintragen.",
        "clientId": "Unter „OAuth-Client“ „Eigenen OAuth-Client verwenden“ wählen, die Client-ID eintragen und das Secret-Feld leer lassen.",
        "signIn": "Verbinden und dich im Browser mit deinem cdbOS-Konto anmelden."
      },
      "disconnect": "Zum Trennen den Connector in Claude wieder entfernen.",
      "noSecret": "Ein Client-Secret ist nicht nötig – das Feld bleibt leer."
    }
  },
  "appstore": {
    "title": "App Store",
    "subtitle": "Durchsuchen und verwalten Sie Ihre Apps",
    "searchPlaceholder": "Apps suchen...",
    "searchAria": "App-Suche",
    "count": "{{count}} Apps",
    "countAria": "{{count}} Treffer",
    "installed": "Installiert",
    "available": "Verfügbar",
    "install": "Installieren",
    "reinstall": "Neu installieren",
    "uninstall": "Deinstallieren",
    "installNotImplemented": "Installation ist in dieser Version noch nicht implementiert.",
    "systemApp": "System-App",
    "notRemovable": "Diese App ist systemrelevant und kann nicht deinstalliert werden.",
    "defaultDescription": "App für cdb-webOS.",
    "addToDesktop": "Zum Desktop hinzufügen",
    "removeFromDesktop": "Vom Desktop entfernen",
    "category": "Kategorie",
    "description": "Beschreibung",
    "filters": {
      "all": "Alle Apps",
      "assigned": "Freigeschaltete Apps"
    },
    "categories": {
      "title": "Kategorien",
      "system": "System",
      "multimedia": "Multimedia",
      "productivity": "Produktivität",
      "admin": "Administration",
      "other": "Sonstiges",
      "clear": "Filter zurücksetzen"
    },
    "descriptions": {
      "app-store": "Durchsuche alle verfügbaren Apps nach Kategorie, füge sie deinem Desktop hinzu oder fordere Zugriff auf geschützte Anwendungen an.",
      "settings": "Passe Theme, Sprache, Desktop-Symbole und Taskleisten-Anzeige an deine Vorlieben an.",
      "cortex": "Verwalte Benutzer, Rollen, App-Zuweisungen, Zugriffsanfragen, Knowledge Areas, Clients und Themes zentral in Cortex, der Administrationsoberfläche.",
      "voice": "Sprachassistent (Platzhalter).",
      "multimedia": "Spiele Audio- und Videodateien aus deinen Knowledge Areas ab — mit Wiedergabesteuerung, Lautstärkeregler und Vollbildmodus.",
      "qa": "Erstellen Sie Q&A Inhalte (Platzhalter).",
      "notes": "Diese App befindet sich in Entwicklung und wird in einem zukünftigen Update verfügbar sein.",
      "pdf-viewer": "Öffne PDF-Dokumente direkt im Fenster mit Seitennavigation, stufenlosem Zoom, Drag-to-Pan und Tastatur-Steuerung.",
      "file-preview": "Universeller Datei-Viewer für PDF (mit Zoom, Pan, Seitennavigation), Word (.docx), Excel (.xlsx mit Sheet-Tabs) und textbasierte Dateien (Code, JSON, CSV, Markdown, XML).",
      "cdb-sessions": "Erstelle interaktive Quiz-Sessions mit Multiple Choice, Single Choice und Freitext-Fragen aus der Episoden-Bibliothek und spiele sie als Lerneinheiten ab.",
      "cdb-training": "Zwei Bereiche in einer App: Schulungen aus Materialien (Videos, Dokumente, Podcasts) mit optionalem Quiz — und eigenständige Umfragen mit automatischer Auswertung.",
      "communicator2": "Konversationsassistent der nächsten Generation mit persistentem Gedächtnis — stelle Folgefragen, und der Assistent erinnert sich an den Kontext deiner Unterhaltung.",
      "ai-knowledge-extractor": "Lade Dokumente in eine Knowledge Area hoch und lasse Q&A-Paare, Fakten und Entitäten automatisch per KI extrahieren.",
      "knowledge-verifier": "Prüfe und verifiziere extrahierte Q&A-Paare, Fakten und Entitäten einer Knowledge Area und verwalte den Wissensgraphen.",
      "document-editor": "Erstelle und bearbeite Dokumente direkt im Browser — öffnet in einem neuen Tab.",
      "wissenshaus": "Deine Wissensbereiche als begehbares 3D-Haus: Jeder Bereich ist ein Raum, und du siehst, was heute, diese Woche oder diesen Monat im Brain passiert ist.",
      "harness": "Prototyp: Ein Prüfer und ein Redakteur gehen offene Fakten eines Wissensbereichs durch und schlagen Bestätigungen oder Korrekturen mit Quellen vor. Erst deine Freigabe ändert das Brain.",
      "cdb-control": "Alle Aufgaben deines Mandanten an einem Ort: als Liste oder Kanban, mit Verantwortlichen und Deadline. Aufgaben aus Aufnahmen im Knowledge Extractor behalten ihre Quelle. Zunächst nur für Admins."
    },
    "access": {
      "noAccess": "Kein Zugriff",
      "noAccessButton": "Kein Zugriff"
    },
    "openViaDrive": "Öffne Dateien via cdbDrive"
  },
  "communicator2": {
    "usage": {
      "cost": "Kosten",
      "unlimited": "Unbegrenzt",
      "overLimit": "Limit überschritten",
      "budget": "Verbrauch",
      "ofBudget": "des Monatsbudgets"
    },
    "warnings": {
      "limitExceeded": {
        "title": "Limit erreicht",
        "description": "Dein Token- oder Kostenlimit für diesen Zeitraum ist erreicht. Bitte wende dich an deinen Administrator."
      }
    },
    "welcome": {
      "title": "cdbChat"
    },
    "subtitle": {
      "idle": "Bereit",
      "active": "Unterhaltung"
    },
    "input": {
      "placeholder": "Nachricht eingeben…",
      "hint": "Enter zum Senden · Shift+Enter für neue Zeile",
      "disclaimer": "KI kann Fehler machen – bitte wichtige Angaben prüfen.",
      "charsLeft_one": "Noch {{count}} Zeichen",
      "charsLeft_other": "Noch {{count}} Zeichen",
      "tooLong_one": "{{count}} Zeichen zu lang — bitte kürzen oder als Datei anhängen",
      "tooLong_other": "{{count}} Zeichen zu lang — bitte kürzen oder als Datei anhängen",
      "pastedAsFile": "Der eingefügte Text war zu lang für eine Nachricht und wurde als Datei angehängt."
    },
    "models": {
      "button": "Modelle",
      "languageSection": "Sprachmodell",
      "auto": {
        "label": "Automatisch",
        "desc": "Unser Standard: das gründlichste Modell, mit Quellenangaben."
      },
      "vendor": {
        "openai": "OpenAI",
        "google": "Google",
        "anthropic": "Anthropic"
      },
      "vendorHint": "Alle Modelle laufen über unsere EU-Datenzone – der Anbietername sagt nichts darüber, wohin Ihre Daten gehen.",
      "vendorCount": "{{count}} Modelle"
    },
    "websearchDepth": {
      "button": "Websuche",
      "section": "Suchtiefe",
      "auto": "Automatisch",
      "autoDesc": "Das Modell wählt die Suchtiefe passend zur Frage.",
      "quick": "Schnell",
      "quickDesc": "Erste verlässliche Quellen, kürzeste Antwortzeit — für einfache Faktenfragen.",
      "deep": "Gründlich",
      "deepDesc": "Breite Recherche über mehrere Quellen — dauert länger."
    },
    "deepResearch": {
      "label": "Recherche",
      "hint": "Mehrstufige Recherche: zerlegt die Frage, befragt alle angebundenen Quellen und belegt das Ergebnis. Dauert länger."
    },
    "imageModels": {
      "section": "Bildmodell",
      "nanoBanana": {
        "label": "Nano Banana 2",
        "desc": "Googles Bildmodell (Gemini, EU) – Standard."
      },
      "gptImage": {
        "label": "GPT Image",
        "desc": "Bildmodell von Azure OpenAI."
      }
    },
    "actions": {
      "send": "Senden",
      "stop": "Stoppen",
      "copy": "Antwort kopieren",
      "copied": "Kopiert",
      "regenerate": "Antwort neu erzeugen",
      "readFromStart": "Antwort von oben lesen",
      "clear": "Unterhaltung löschen"
    },
    "memory": {
      "button": "Gedächtnis",
      "pageTitle": "Gedächtnis",
      "empty": "Das Gedächtnis baut sich über Gespräche auf.",
      "deleteConclusion": "Erkenntnis löschen",
      "reset": "Gedächtnis zurücksetzen",
      "resetConfirm": "Alle Erkenntnisse und die Zusammenfassung werden gelöscht. Dies kann nicht rückgängig gemacht werden.",
      "resetConfirmAction": "Zurücksetzen",
      "cancel": "Abbrechen",
      "back": "Zurück zum Chat",
      "brainTitle": "Dein Brain",
      "brainSubtitle": "Cross-Session-Wissen, das dein Personal Digital Brain aus euren Gesprächen abgeleitet hat.",
      "profileTitle": "Brain-Profil",
      "profileEmpty": "Noch kein Brain-Profil vorhanden. Wird nach einigen Gesprächen automatisch erstellt.",
      "insightsTitle": "Brain-Erkenntnisse",
      "reload": "Neu laden",
      "rebuild": "Profil erzeugen",
      "rebuilding": "Wird erstellt …",
      "rebuildHint": "Brain-Profil jetzt aus den Erkenntnissen erzeugen",
      "rebuildNoResult": "Noch kein Profil möglich — dafür braucht es ein paar persönliche Angaben im Chat (z. B. Name, Rolle, Vorlieben). Reine Sachfragen reichen dafür noch nicht.",
      "rebuildUnavailable": "Dein persönliches Gedächtnis ist gerade nicht erreichbar. Versuch es später noch einmal.",
      "editProfile": "Bearbeiten",
      "doneEditing": "Fertig",
      "editEmpty": "Noch keine Fakten. Füge unten welche hinzu.",
      "addFact": "Hinzufügen",
      "factPlaceholder": "Neuen Fakt eingeben …",
      "removeFact": "Fakt entfernen",
      "sourceChat": "aus „{{title}}“",
      "sourceChatFallback": "Chat",
      "sourceDrive": "aus hochgeladenen Dateien",
      "sourceInferred": "abgeleitet aus mehreren Erkenntnissen",
      "factFromChat": "aus „{{title}}“ vom {{date}}",
      "factFromChats": "aus {{count}} Chats",
      "factFromChatsHide": "weniger anzeigen",
      "factByUser": "von dir eingetragen",
      "factFromDeletedChat": "aus einem gelöschten Chat",
      "sessionsTitle": "Deine Sessions",
      "sessionsSubtitle": "Die Chats, aus denen dein Gedächtnis lernt. Klick öffnet den Chat; löschen entfernt die Session samt Verlauf.",
      "sessionsEmpty": "Noch keine Sessions.",
      "sessionOpen": "Chat öffnen",
      "sessionDelete": "Session löschen",
      "sessionDeleteTitle": "Session löschen?",
      "sessionDeleteHint": "Entfernt die Session samt Verlauf endgültig. Gespeicherte Anhänge bleiben in Meine Dokumente.",
      "projects": {
        "title": "Projekt-Gedächtnis",
        "hint": "Was du in einem Projekt sagst, bleibt in diesem Projekt. Nur dort kennt der Chat diese Fakten.",
        "factCount_one": "{{count}} Fakt",
        "factCount_other": "{{count}} Fakten",
        "nothingYet": "noch nichts gelernt",
        "empty": "Aus den Chats dieses Projekts ist noch nichts gelernt.",
        "factPlaceholder": "Fakt zum Projekt hinzufügen …",
        "clear": "Alles löschen",
        "open": "Projekt-Gedächtnis"
      }
    },
    "sidebar": {
      "newChat": "Neuer Chat",
      "discover": "Entdecken"
    },
    "create": {
      "title": "Neu erstellen",
      "word": "Word-Dokument",
      "presentation": "Präsentation",
      "spreadsheet": "Excel-Tabelle",
      "bpmn": "BPMN-Diagramm",
      "html": "HTML-Seite",
      "image": "Bild",
      "error": "Erstellen fehlgeschlagen"
    },
    "preview": {
      "open": "Vorschau öffnen",
      "close": "Vorschau schließen",
      "openTab": "In neuem Tab öffnen",
      "loading": "Vorschau wird geladen…",
      "failed": "Vorschau konnte nicht geladen werden.",
      "notAvailable": "Für diese Datei ist noch keine Vorschau verfügbar.",
      "firstOpenHint": "Die erste Vorschau einer Datei kann einige Sekunden dauern (Konvertierung) — danach öffnet sie sofort.",
      "textFallback": "Original-Vorschau nicht verfügbar — angezeigt wird der extrahierte Text.",
      "driveDeleted": "Die Datei wurde im Drive gelöscht – angezeigt wird die Kopie aus dem Chat.",
      "openInCollabora": "In Collabora öffnen (volle Ansicht)",
      "versions": {
        "title": "Versionen",
        "label": "V{{n}}",
        "active": "aktiv",
        "setActive": "Als aktuelle Version wiederherstellen"
      },
      "openInBpmnEditor": "Im BPMN-Editor öffnen",
      "openInHtmlEditor": "Im HTML-Editor öffnen"
    },
    "attach": {
      "dropTitle": "Dateien hier ablegen",
      "dropHint": "Die Dateien werden an die Nachricht angehängt.",
      "dropRejected_one": "Dieser Dateityp wird nicht unterstützt: {{files}}",
      "dropRejected_other": "Diese Dateitypen werden nicht unterstützt: {{files}}",
      "button": "Datei anhängen",
      "remove": "Entfernen",
      "uploading": "Wird hochgeladen…",
      "extracting": "Text wird gelesen…",
      "uploadNew": "Neue Datei hochladen",
      "fromDrive": "Aus dem Drive anhängen",
      "drivePickerTitle": "Datei aus dem Drive auswählen",
      "failed": "Upload fehlgeschlagen",
      "dismiss": "Ausblenden"
    },
    "sessions": {
      "title": "Unterhaltungen",
      "collapse": "Seitenleiste einklappen",
      "expand": "Seitenleiste ausklappen",
      "empty": "Noch keine Unterhaltungen. Stelle deine erste Frage.",
      "untitled": "Neue Unterhaltung",
      "rename": "Umbenennen",
      "delete": "Löschen",
      "renameTitle": "Unterhaltung umbenennen",
      "titleLabel": "Titel",
      "titlePlaceholder": "Titel der Unterhaltung",
      "cancel": "Abbrechen",
      "save": "Speichern",
      "working": "Antwortet gerade"
    },
    "projects": {
      "title": "Projekte",
      "create": "Neues Projekt",
      "createTitle": "Neues Projekt",
      "renameTitle": "Projekt umbenennen",
      "rename": "Umbenennen",
      "delete": "Löschen",
      "deleteTitle": "Projekt löschen",
      "deleteConfirm": "Projekt \"{{name}}\" wirklich löschen? Die enthaltenen Chats bleiben erhalten und erscheinen wieder ohne Projekt.",
      "nameLabel": "Projektname",
      "namePlaceholder": "z. B. Marketing Q3",
      "empty": "Noch keine Projekte. Lege eines an, um Chats zu gruppieren.",
      "dropHint": "Chat hierher ziehen",
      "allGrouped": "Alle Chats sind einem Projekt zugeordnet.",
      "newChatIn": "Neuer Chat in diesem Projekt",
      "dragHandle": "Chat in ein Projekt ziehen"
    },
    "filter": {
      "label": "Wissensbereiche"
    },
    "sources": {
      "title": "Quellen auswählen",
      "corporate": "Corporate",
      "websearch": "Websuche",
      "router": "Externe Systeme",
      "corporateHint": "Im Unternehmenswissen suchen (Dokumente, Graph, Fakten)",
      "websearchHint": "Im Web suchen (Quellen werden im Text zitiert)",
      "routerHint": "In angebundenen externen Systemen suchen (Router-Quellen)",
      "unavailable": {
        "corporate": "Dir sind keine Wissensbereiche zugewiesen."
      },
      "skillsBucket": "Werkzeuge",
      "toolboxSection": "Werkzeuge",
      "corporateSourcesLabel": "Unternehmensquellen",
      "web": "Web",
      "graphFact": "Graph-Fakt",
      "sourcesCount": "Quellen · {{count}}",
      "sourcesToggleHint": "Quellen-Details ein-/ausblenden",
      "openHint": "Quelle öffnen",
      "usedLabel": "Verwendete Quellen",
      "graphPreviewError": "Graph-Vorschau konnte nicht geladen werden."
    },
    "corporate": {
      "title": "Internes Wissen",
      "strategy": {
        "vector": "Dokumente durchsuchen",
        "graph": "Wissensgraph abfragen",
        "facts": "Verifizierte Fakten prüfen",
        "structured": "Strukturierte Daten durchsuchen"
      },
      "refCount": "{{count}} Treffer",
      "refCount_one": "{{count}} Treffer",
      "refCount_other": "{{count}} Treffer"
    },
    "memoryToggle": {
      "label": "Persönliches Gedächtnis",
      "hint": "Aus: Der Assistent erinnert sich nicht mehr über Unterhaltungen hinweg und lernt nichts Neues über dich. Bisherige Erkenntnisse bleiben einsehbar und löschbar."
    },
    "memoryIngest": {
      "label": "Angehängte Dateien in Meine Dokumente speichern",
      "hint": "Angehängte Dateien bleiben in Meine Dokumente, auch nach dem Chat, und lassen sich später über ihren Inhalt wiederfinden. Aus: Die Datei gehört nur zu diesem Chat."
    },
    "settings": {
      "button": "Einstellungen",
      "title": "cdbChat-Einstellungen",
      "saved": "Gespeichert.",
      "saveError": "Speichern fehlgeschlagen.",
      "loadError": "Einstellungen konnten nicht geladen werden.",
      "back": "Zurück",
      "saving": "Wird gespeichert…",
      "personal": {
        "title": "Persönliche Einstellungen",
        "hint": "Änderungen werden automatisch gespeichert."
      },
      "name": {
        "label": "Wie soll ich dich nennen?",
        "hint": "Lass das Feld leer, damit ich keinen festen Namen verwende."
      },
      "address": {
        "label": "Anrede",
        "auto": "Automatisch",
        "du": "Du",
        "Sie": "Sie"
      },
      "tone": {
        "label": "Ton",
        "neutral": "Neutral",
        "locker": "Locker",
        "formell": "Formell",
        "direkt": "Direkt"
      },
      "connectors": {
        "title": "Verbundene Konten",
        "hint": "Konten, mit denen cdbChat in deinem Namen arbeiten darf.",
        "connect": "Verbinden",
        "disconnect": "Trennen",
        "connectedSince": "Verbunden seit {{date}}",
        "connectedStatus": "Verbunden",
        "limits": "Sendet nichts ohne deine Bestätigung. Fremde Postfächer nur, wenn du sie selbst hinzufügst und Microsoft 365 dir Zugriff gibt; Kalender nur, wenn sie mit dir geteilt sind",
        "permissions": {
          "mail": {
            "read": "E-Mails durchsuchen und lesen",
            "draft": "Entwürfe in deinem Postfach anlegen",
            "shared": {
              "read": "Geteilte Postfächer durchsuchen und lesen, die du hinzufügst",
              "draft": "Entwürfe in einem geteilten Postfach anlegen, nach deiner Bestätigung"
            }
          },
          "calendar": {
            "read": "Termine lesen und freie Zeiten finden, auch mit Kollegen",
            "write": "Eigene Termine verwalten und auf Einladungen antworten"
          },
          "people": {
            "read": "Personen in häufigen Kontakten, Kontakten und im Verzeichnis deiner Organisation finden"
          }
        },
        "items": {
          "outlook": {
            "description": "cdbChat kann in deinem Outlook-Postfach nach E-Mails suchen, sie lesen und Antwortentwürfe für dich anlegen."
          },
          "microsoft365": {
            "description": "cdbChat arbeitet mit deinem Microsoft-365-Konto: mit den Bereichen, die du einschaltest."
          }
        },
        "confirmConnect": {
          "title": "{{name}} verbinden?",
          "revocable": "Du kannst die Verbindung jederzeit trennen.",
          "pickAreas": "Wähle, womit cdbChat arbeiten darf."
        },
        "confirmDisconnect": {
          "title": "{{name}} trennen?",
          "body": "cdbChat kann danach nicht mehr auf dein {{name}}-Konto zugreifen. Du kannst es jederzeit wieder verbinden."
        },
        "connected": "{{name}} ist verbunden.",
        "disconnected": "{{name}} wurde getrennt.",
        "connectError": "{{name}} konnte nicht verbunden werden. Bitte versuche es später erneut.",
        "consentRefused": "Microsoft hat den Zugriff nicht freigegeben. {{name}} lässt sich verbinden, sobald deine IT der App zustimmt.",
        "disconnectError": "{{name}} konnte nicht getrennt werden. Bitte versuche es später erneut.",
        "details": "Details",
        "areas": {
          "mail": {
            "name": "E-Mail",
            "description": "In deinem Postfach suchen, Mails und Anhänge lesen, Entwürfe anlegen."
          },
          "calendar": {
            "name": "Kalender",
            "description": "Termine lesen, freie Zeiten auch mit Kollegen finden, eigene und geteilte Kalender verwalten, auf Einladungen antworten."
          },
          "shared_mailboxes": {
            "name": "Geteilte Postfächer",
            "description": "Postfächer wie info@ oder vertrieb@, die du in Outlook öffnen darfst. Du fügst jedes selbst hinzu; Microsoft 365 prüft deinen Zugriff."
          },
          "people": {
            "name": "Personen & Kontakte",
            "description": "Adressen zu Namen finden: häufige Kontakte, Outlook-Kontakte und das Verzeichnis deiner Organisation. Es wird nichts gespeichert."
          }
        },
        "editAreas": "Bereiche ändern",
        "save": "Speichern",
        "areasSaved": "Bereiche von {{name}} gespeichert.",
        "confirmAreas": {
          "title": "Bereiche von {{name}}"
        },
        "mailboxes": {
          "title": "Geteilte Postfächer",
          "hint": "Füge ein Postfach hinzu, das du in Outlook öffnen darfst. Microsoft 365 prüft deinen Zugriff, bevor es hier erscheint.",
          "placeholder": "z. B. info@firma.de",
          "add": "Hinzufügen",
          "remove": "{{address}} entfernen",
          "recheck": "Erneut prüfen",
          "statusVerified": "Geprüft",
          "statusNoAccess": "Kein Zugriff",
          "verified": "{{address}} ist geprüft und verbunden.",
          "errors": {
            "invalid_address": "Bitte eine gültige E-Mail-Adresse eingeben.",
            "own_mailbox": "Das ist dein eigenes Postfach – es ist schon verbunden.",
            "too_many_mailboxes": "Es können höchstens 20 Postfächer verbunden werden.",
            "mailbox_access_denied": "Auf dieses Postfach hast du in Microsoft 365 keinen Zugriff.",
            "mailbox_not_found": "Dieses Postfach gibt es in deiner Organisation nicht, oder du hast keinen Zugriff darauf.",
            "area_inactive": "Bitte zuerst den Bereich „Geteilte Postfächer“ einschalten.",
            "consent_required": "Deine IT muss den Zugriff auf geteilte Postfächer erst freigeben.",
            "generic": "Das Postfach konnte gerade nicht geprüft werden. Bitte versuche es später erneut."
          }
        }
      }
    },
    "allSources": {
      "label": "Alle Quellen",
      "hint": "Der Assistent wählt pro Frage selbst, welche Wissensquellen er durchsucht. Aus: Es wird nur in den ausgewählten Quellen gesucht. Werkzeuge wie Word oder Bilder sind immer verfügbar.",
      "pillsAllAllowed": "Alle Quellen sind erlaubt. Schalte „Alle Quellen“ aus, um die Suche auf einzelne Quellen zu beschränken.",
      "chip": "Auto",
      "chipScoped": "Quellen",
      "chipNoTools": "Ohne Quellen beantwortet",
      "freeQuery": "Freie Abfrage",
      "freeQueryHint": "Die vorbereiteten Abfragen haben nichts gefunden. Diese Antwort beruht auf einer Abfrage, die das Modell selbst geschrieben hat — bitte mit mehr Vorsicht prüfen."
    },
    "feedback": {
      "up": "Hilfreich",
      "down": "Nicht hilfreich",
      "reasonTitle": "Grund (optional)",
      "noReason": "Ohne Grund",
      "reasons": {
        "wrong_route": "Falsche Route/Quelle",
        "incomplete": "Unvollständig",
        "incorrect": "Inhaltlich falsch",
        "too_slow": "Zu langsam",
        "other": "Sonstiges"
      }
    },
    "meta": {
      "steps": "{{count}} Schritte",
      "toolsHint": "Werkzeug-Schritte anzeigen",
      "memory": "Gedächtnis",
      "memoryHint": "Verwendeten Gedächtnis-Kontext anzeigen",
      "toolsDone": "{{count}} Werkzeuge · fertig",
      "filesDone": "{{count}} Dateien",
      "research": "Recherche · {{count}} Teilfrage",
      "research_other": "Recherche · {{count}} Teilfragen",
      "researchHint": "Dieser Turn lief als Recherche: die Frage wurde zerlegt und je Teilfrage in den Quellen nachgesehen. Klicken zeigt die Teilfragen."
    },
    "activity": {
      "working": "Arbeitet …",
      "summary": "Aktivität · {{count}} Schritte",
      "toolsTitle": "Werkzeuge",
      "failed_one": "1 Schritt fehlgeschlagen",
      "failed_other": "{{count}} Schritte fehlgeschlagen"
    },
    "widget": {
      "table": {
        "title": "Tabelle",
        "rowCount_one": "{{count}} Zeile",
        "rowCount_other": "{{count}} Zeilen",
        "export": "Als Excel herunterladen",
        "exportShort": "Excel",
        "exportFailed": "Die Excel-Datei konnte nicht erstellt werden. Bitte versuche es noch einmal.",
        "exportIncomplete": "Die Datei enthält {{count}} Zeilen, die Quelle hat mehr. Sie ist also unvollständig.",
        "loadMore": "Weitere laden",
        "loadMoreFailed": "Weitere Zeilen konnten nicht geladen werden. Bitte versuche es noch einmal.",
        "rowCount": "{{count}} Zeilen",
        "rowsShown": "{{shown}} von {{count}} Zeilen",
        "truncated": "Unvollständig: Die Quelle hat mehr als diese {{count}} Zeilen.",
        "truncatedWithExport": "Unvollständig: Hier sind {{count}} Zeilen, die Quelle hat mehr. Die ganze Liste gibt es über „Excel“."
      },
      "fileRef": {
        "title": "Dateien",
        "count_one": "{{count}} Datei",
        "count_other": "{{count}} Dateien",
        "corporate": "Corporate",
        "personal": "Persönlich",
        "open": "Vorschau öffnen",
        "count": "{{count}} Dateien"
      },
      "confirm": {
        "title": "Bitte bestätigen",
        "submit": "Bestätigen",
        "sent": "Bestätigt – wird übernommen",
        "superseded": "Durch einen neueren Vorschlag ersetzt.",
        "message": "Felder bestätigt."
      },
      "outlookAttachment": {
        "fromOutlook": "aus Outlook",
        "attachedMail": "angehängte E-Mail",
        "open": "Vorschau öffnen",
        "fromMailbox": "aus {{mailbox}}"
      },
      "interactive": {
        "title": "Interaktive Ansicht",
        "loading": "Ansicht wird geladen …",
        "missing": "Die interaktive Ansicht ist nicht mehr vorhanden.",
        "loadFailed": "Die interaktive Ansicht konnte nicht geladen werden.",
        "retry": "Erneut versuchen",
        "expand": "Vergrößern",
        "collapse": "Verkleinern",
        "aiHint": "KI-generierte interaktive Ansicht – Inhalte und Berechnungen prüfen.",
        "promptRequest": "Diese Seite möchte eine Nachricht senden:",
        "send": "Senden",
        "discard": "Verwerfen",
        "busy": "Senden ist möglich, sobald die laufende Antwort fertig ist.",
        "wait": "Bitte einen Moment warten und erneut senden.",
        "navigated": "Die Seite hat versucht, sich selbst neu zu laden/wegzunavigieren — angehalten.",
        "fromPage": "aus interaktiver Seite",
        "openBeside": "Rechts öffnen",
        "openedBeside": "Rechts geöffnet —",
        "showHere": "Hier anzeigen",
        "showInChat": "Im Chat anzeigen",
        "closePanel": "Schließen (zurück in den Chat)",
        "versionOf": "Version {{version}} von {{latest}}",
        "versionShort": "v{{version}}",
        "prevVersion": "Vorherige Version",
        "nextVersion": "Nächste Version",
        "olderVersion": "Ältere Version",
        "showLatest": "Neueste anzeigen",
        "newerAvailable": "Neuere Version vorhanden (v{{version}})",
        "show": "anzeigen",
        "history": "Verlauf",
        "historyLoading": "Verlauf wird geladen …",
        "historyFailed": "Der Verlauf konnte nicht geladen werden.",
        "restoredFrom": "wiederhergestellt aus v{{version}}",
        "latestLabel": "neueste",
        "current": "angezeigt",
        "view": "Anzeigen",
        "restore": "Wiederherstellen",
        "restoreFailed": "Wiederherstellen fehlgeschlagen.",
        "edit": "Bearbeiten",
        "editing": "Wird bearbeitet",
        "editChip": "Bearbeitet:",
        "editChipClear": "Bearbeiten beenden"
      },
      "productImages": {
        "title": "Bilder",
        "count_one": "{{count}} Bild",
        "count_other": "{{count}} Bilder",
        "image": "Bild",
        "enlarge": "Vergrößern",
        "notPublic": "Nicht öffentlich",
        "unavailable": "Nicht verfügbar",
        "more_one": "{{count}} weiteres Bild nicht angezeigt",
        "more_other": "{{count}} weitere Bilder nicht angezeigt"
      }
    },
    "errors": {
      "generic": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
      "sendFailed": "Nachricht konnte nicht gesendet werden. Bitte versuche es erneut.",
      "empty": "Es kam keine Antwort an. Bitte versuche es erneut.",
      "cancelled": "Antwort gestoppt.",
      "historyFailed": "Die Unterhaltung konnte nicht geladen werden. Bitte versuche es erneut."
    },
    "uploadErrors": {
      "generic": "Der Grund ist unbekannt. Bitte versuche es noch einmal.",
      "gateway_timeout": "Die Verarbeitung hat zu lange gedauert. Versuche eine kleinere Datei.",
      "too_many_files": "Diese Unterhaltung hat mit {{limit}} Dateien das Maximum erreicht. Entferne eine, bevor du die nächste anhängst.",
      "file_too_large": "Die Datei ist zu groß. Erlaubt sind bis zu {{max_mb}} MB.",
      "file_empty": "Die Datei ist leer.",
      "filename_too_long": "Der Dateiname ist zu lang. Erlaubt sind bis zu {{max_chars}} Zeichen.",
      "unsupported_format": "Dieses Dateiformat wird nicht unterstützt. Möglich sind PDF, Word, PowerPoint, Excel, E-Mails, Audiodateien, Bilder (PNG, JPG, WEBP, GIF, SVG) und Textformate.",
      "extraction_timeout": "Das Auslesen der Datei hat zu lange gedauert. Versuche es bitte noch einmal.",
      "extraction_failed_file": "Die Datei konnte nicht gelesen werden. Bitte prüfe, ob sie unbeschädigt ist.",
      "extraction_failed_server": "Die Datei konnte nicht verarbeitet werden. Versuche es bitte noch einmal — scheitert es wieder, liegt es nicht an deiner Datei.",
      "audio_too_long": "Die Aufnahme ist zu lang. Erlaubt sind bis zu {{max_minutes}} Minuten pro Datei.",
      "audio_failed": "Die Aufnahme konnte nicht transkribiert werden.",
      "image_failed": "Das Bild ließ sich nicht auswerten. Versuche es erneut oder prüfe die Datei.",
      "storage_unavailable": "Der Dateispeicher ist gerade nicht erreichbar. Versuche es bitte noch einmal.",
      "personal_file_not_found": "Diese Datei liegt nicht mehr in deinem Drive. Wahrscheinlich wurde sie zwischenzeitlich gelöscht.",
      "limit_exceeded": "Dein Token- oder Kostenlimit für diesen Zeitraum ist erreicht. Bitte wende dich an deinen Administrator."
    },
    "files": {
      "indexed": "Indexiert",
      "version": "v{{version}}",
      "versionTitle": "Version {{version}} dieser Datei im Drive",
      "download": "Herunterladen",
      "editInCollabora": "In Collabora bearbeiten",
      "openBpmnEditor": "Im BPMN-Editor öffnen",
      "openHtmlEditor": "Im HTML-Editor öffnen",
      "exportPdf": "Als PDF speichern",
      "collaboraComingSoon": "Der Collabora-Editor für Office-Dokumente ist in Vorbereitung.",
      "pending": "Wird erstellt …",
      "failed": "Konnte nicht erstellt werden.",
      "unknownNumbers": "Enthält Zahlen, die nicht aus dem Workflow stammen: {{numbers}} — bitte prüfen."
    },
    "activeFile": {
      "use": "Diese Datei verwenden",
      "label": "Aktive Datei:",
      "clear": "Aktive Datei entfernen",
      "editHint": "Änderungen werden als neue Version dieser Datei gespeichert."
    },
    "resizePanel": "Breite ziehen zum Anpassen",
    "resizeSidebar": "Breite der Chat-Liste anpassen",
    "resizePanelHint": "Ziehen zum Anpassen · Doppelklick zum Zurücksetzen",
    "stackedPane": {
      "label": "Chat oder Vorschau anzeigen",
      "chat": "Chat",
      "panel": "Vorschau"
    },
    "focusView": {
      "button": "Fokus-Ansicht"
    },
    "collaboraWindow": {
      "missing": "Kein Dokument zum Öffnen angegeben."
    },
    "templates": {
      "upload": "Vorlage hochladen",
      "uploadHint": "Erlaubt sind .docx- und .pptx-Dateien (max. 20 MB).",
      "nameLabel": "Name",
      "namePlaceholder": "z. B. Angebot Brief­vorlage",
      "selectFile": "Datei auswählen",
      "preview": "Vorschau",
      "previewFailed": "Vorschau konnte nicht geladen werden.",
      "layouts": "Layouts",
      "styles": "Formatvorlagen",
      "fonts": "Schriften",
      "layoutOn": "Aktiv",
      "layoutOff": "Aus",
      "fontsUpload": "Schrift hochladen",
      "fontsUploaded": "Schrift(en) hochgeladen.",
      "fontsUploadFailed": "Schrift konnte nicht hochgeladen werden.",
      "fontsDeleteFailed": "Schrift konnte nicht gelöscht werden.",
      "fontCovered": "Vorhanden (hochgeladen)",
      "fontMissing": "Fehlt — als .ttf/.otf hochladen",
      "enrich": {
        "pending": "Vorlage wird analysiert …",
        "done": "Analysiert",
        "failed": "Analyse fehlgeschlagen",
        "none": "Noch nicht analysiert",
        "timedOut": "Analyse dauert ungewöhnlich lange",
        "retry": "Erneut analysieren"
      },
      "toast": {
        "patchFailed": "Änderung konnte nicht gespeichert werden.",
        "reenrichFailed": "Analyse konnte nicht gestartet werden."
      },
      "prepared": {
        "title": "Für Dokumente aufbereitet",
        "status": {
          "review": "Aufbereitet – Dokumente nutzen noch die hochgeladene Datei, bis die Fassung freigegeben ist.",
          "approved": "Freigegeben {{date}} – Dokumente nutzen die aufbereitete Fassung.",
          "not_needed": "Die Vorlage enthält die Felder schon und wird direkt genutzt.",
          "failed": "Die Vorlage konnte nicht aufbereitet werden. Dokumente nutzen die hochgeladene Datei."
        },
        "cover": "Deckblatt",
        "coverImage": "Deckblattbild",
        "coverImageSlot": "Bildplatz für ein eigenes Bild",
        "back": "Rückseite",
        "running": "Kopf- und Fußzeile",
        "lists": "Listen",
        "listCreated": "neu angelegt",
        "table": "Tabellenstil",
        "kinds": "Sonderformate",
        "removed": "Entfernt",
        "removedValue": "{{blocks}} Musterabsätze, {{footnotes}} Beispiel-Fußnoten",
        "found": "erkannt",
        "notFound": "nicht erkannt",
        "none": "keine",
        "field": {
          "topline": "Topline",
          "title": "Titel",
          "subtitle": "Untertitel",
          "author": "Autor",
          "date": "Datum",
          "meta": "Autor | Datum",
          "classification": "Klassifizierung",
          "year": "Jahr"
        },
        "kind": {
          "callout": "Hinweis",
          "quote": "Zitat",
          "topline": "Topline",
          "margin_note": "Randnotiz",
          "caption": "Bildunterschrift",
          "wide": "volle Breite"
        },
        "unrecognized": "Nicht zugeordnete Platzhalter: {{items}}. Sie bleiben als Text stehen.",
        "warning": {
          "no_cover": "Kein Deckblatt erkannt: Dokumente beginnen direkt mit dem Inhalt.",
          "no_title_field": "Kein Feld für den Titel gefunden: der Titel erscheint als erste Überschrift."
        },
        "release": "Freigeben",
        "withdraw": "Freigabe zurücknehmen",
        "releaseHint": "Prüfen Sie das Probedokument. Nach der Freigabe nutzen neue Dokumente diese Fassung.",
        "withdrawHint": "Danach nutzen neue Dokumente wieder die hochgeladene Datei.",
        "releaseFailed": "Die Freigabe konnte nicht gespeichert werden.",
        "preview": {
          "template": "Vorlage",
          "sample": "Probedokument"
        }
      }
    },
    "brandKits": {
      "button": "Brand Kits",
      "pageTitle": "Brand Kits",
      "description": "Ein Brand Kit hält alles, was Ausgaben zu euren macht: Farben, Schriften, Logos und Vorlagen. Es wirkt auch ohne Vorlage — auf Word, PowerPoint, Excel, HTML-Seiten und Bilder.",
      "pickerTitle": "Brand Kit",
      "pickerNone": "Kein Brand Kit",
      "source": {
        "thread": "Für diesen Chat gewählt",
        "preference": "Deine Vorauswahl",
        "organisation": "Standard deiner Organisation",
        "none": "Kein Brand Kit"
      },
      "scope": {
        "user": "Nur für mich",
        "client": "Meine Organisation",
        "global": "Alle"
      },
      "create": "Brand Kit anlegen",
      "createTitle": "Neues Brand Kit",
      "nameLabel": "Name",
      "namePlaceholder": "z. B. Corporate",
      "descriptionLabel": "Beschreibung",
      "scopeLabel": "Sichtbarkeit",
      "empty": "Noch kein Brand Kit angelegt.",
      "emptyHint": "Lege eins an – aus einer Vorlage oder selbst zusammengestellt.",
      "defaultBadge": "Standard",
      "disabledBadge": "Deaktiviert",
      "assembledBadge": "Automatisch zusammengesetzt",
      "makeDefault": "Als Standard vorbelegen",
      "clearDefault": "Vorbelegung aufheben",
      "colors": "Farben",
      "fonts": "Schriften",
      "logos": "Logos",
      "noColors": "Noch keine Farben hinterlegt.",
      "colorIncomplete": "Unvollständig: {{roles}}. Eine Farbe braucht 3 oder 6 Stellen – sonst wird die Rolle nicht gespeichert.",
      "noLogos": "Noch kein Logo hinterlegt.",
      "role": {
        "ink": "Text",
        "surface": "Hintergrund",
        "primary": "Primär",
        "secondary": "Sekundär",
        "accent": "Akzent",
        "display": "Überschrift",
        "body": "Fließtext"
      },
      "assetKind": {
        "logo_light": "Logo (heller Grund)",
        "logo_dark": "Logo (dunkler Grund)",
        "logo_mono": "Logo (einfarbig)",
        "mark": "Bildmarke"
      },
      "uploadTemplate": "Vorlage hochladen",
      "downloadTemplate": "Vorlage herunterladen",
      "publish": "Veröffentlichen",
      "publishTitle": "Brand Kit veröffentlichen",
      "publishHint": "Wer darf dieses Brand Kit künftig nutzen?",
      "duplicate": "Duplizieren",
      "copySuffix": "{{name}} (Kopie)",
      "delete": "Brand Kit löschen",
      "deleteConfirm": "„{{name}}“ wird gelöscht. Farben, Schriften und Logos des Kits gehen dabei verloren.",
      "deleteBlocked": "Dieses Brand Kit enthält noch Vorlagen. Verschiebe oder lösche sie zuerst.",
      "divergenceTitle": "Weicht von der Vorlage ab",
      "divergenceHint": "Diese Vorlage bringt andere Werte mit als das Kit. Die Datei bleibt maßgeblich für Word und PowerPoint – geändert wird hier nichts automatisch.",
      "blocked": {
        "current": "Ist bereits diese Sichtbarkeit.",
        "uploaderOnly": "Das kann nur zurücknehmen, wer das Kit angelegt hat."
      },
      "replaceTemplate": "Vorlage ersetzen",
      "slotEmpty": {
        "docx": "Noch keine Word-Vorlage",
        "pptx": "Noch keine PowerPoint-Vorlage"
      },
      "slotHint": "Ein Kit hält je Format eine Vorlage. Ein Upload ersetzt die vorhandene.",
      "edit": "Bearbeiten",
      "editTitle": "Brand Kit bearbeiten",
      "editHint": "Name, Beschreibung und ob das Kit nutzbar ist. Die Sichtbarkeit änderst du über „Veröffentlichen\".",
      "enabledLabel": "Nutzbar",
      "enabledHint": "Ein deaktiviertes Kit erscheint für niemanden im Chat, bleibt hier aber erhalten.",
      "fontHint": "Diese Schriftdateien werden ins Dokument eingebettet.",
      "deleteTemplate": "Vorlage entfernen",
      "deleteTemplateConfirm": "Diese Vorlage wirklich entfernen? Die Datei wird gelöscht — lade sie vorher herunter, falls du sie noch brauchst.",
      "disableTemplate": "Vorlage deaktivieren",
      "moveTemplate": "In ein anderes Kit verschieben",
      "moveTemplateTitle": "„{{name}}“ verschieben",
      "moveTemplateHint": "Wähle das Kit, in das die Vorlage wandern soll. Kits, deren Platz für dieses Format schon belegt ist, lassen sich nicht wählen.",
      "enableTemplate": "Vorlage aktivieren",
      "disabledHint": "Eine deaktivierte Vorlage bleibt erhalten, wird aber nicht mehr verwendet. Dokumente dieses Formats entstehen dann nur mit den Farben des Kits.",
      "imageStyle": "Bildstil",
      "imageStylePlaceholder": "z. B. flache Vektorillustration, viel Weißraum, keine Verläufe",
      "imageStyleHint": "Wird an jede Bildanfrage angehängt, zusammen mit den Farben des Kits. Eine Anfrage, die selbst einen Stil nennt, hat Vorrang.",
      "deleteTitle": "Brand Kit löschen",
      "deleteBlocked_one": "Dieses Kit hält noch eine Vorlage. Verschiebe oder lösche sie zuerst — beim Löschen des Kits bliebe ihre Datei im Speicher zurück.",
      "deleteBlocked_other": "Dieses Kit hält noch {{count}} Vorlagen. Verschiebe oder lösche sie zuerst — beim Löschen des Kits blieben ihre Dateien im Speicher zurück.",
      "htmlStyle": "Seitenstil",
      "htmlStylePlaceholder": "z. B. viel Weißraum, keine Schlagschatten, ruhige Typografie",
      "htmlStyleHint": "Wird dem Modell für erzeugte HTML-Seiten mitgegeben. Farben und Schriften landen ohnehin in der Seite — das hier ist der Teil, den eine Palette nicht ausdrückt.",
      "saving": "Wird gespeichert …",
      "saved": "Gespeichert",
      "notSaved": "Nicht gespeichert – bitte Eingabe prüfen.",
      "createHint": "Woher kommt eure Marke? Aus einer Vorlage übernehmen oder selbst zusammenstellen – beides lässt sich danach ändern.",
      "createMode": {
        "template": {
          "title": "Aus einer Vorlage übernehmen",
          "hint": "PowerPoint- oder Word-Vorlage hochladen. Farben, Schriften und Logo werden daraus gelesen."
        },
        "compose": {
          "title": "Selbst zusammenstellen",
          "hint": "Farbpalette, Schriften und Stil aus Vorschlägen wählen. Dauert eine Minute."
        }
      },
      "createFromTemplateHint": ".pptx, .potx, .docx oder .dotx. Die Vorlage wird danach für dieses Format genutzt.",
      "palette": {
        "navyOrange": "Navy & Orange",
        "petrol": "Petrol",
        "forest": "Waldgrün",
        "signal": "Signalrot",
        "violet": "Violett",
        "graphite": "Graphit"
      },
      "roleHint": {
        "ink": "Text, dunkle Folien",
        "surface": "helle Flächen",
        "primary": "Akzente, Diagramme",
        "secondary": "zweite Diagrammreihe",
        "accent": "Hervorhebungen"
      },
      "contrast": {
        "good": "Gut lesbar: Primär auf Hintergrund {{ratio}} : 1. Auf dunklen Folien hellen wir die Akzentfarbe bei Bedarf automatisch auf.",
        "primary": "Primär ist auf hellem Grund schwach ({{ratio}} : 1). Für Text dunkeln wir sie automatisch ab – Flächen bleiben wie gewählt.",
        "text": "Text und Hintergrund unterscheiden sich zu wenig ({{ratio}} : 1). Dokumente nutzen dann neutrale Text- und Hintergrundfarben."
      },
      "fontPair": {
        "clear": "Klar",
        "office": "Office-Standard",
        "serious": "Seriös",
        "classic": "Klassisch",
        "technical": "Technisch",
        "elegant": "Elegant",
        "own": "Aus der Vorlage"
      },
      "fontPairHint": "Nur Schriften, die mit Microsoft Office kommen – so sieht das Dokument auf jedem Rechner gleich aus.",
      "imagePreset": {
        "photo": {
          "name": "Foto, realistisch",
          "text": "Realistische Fotografie, natürliches Licht, echte Menschen und Orte, ruhige Komposition"
        },
        "flat": {
          "name": "Flache Illustration",
          "text": "Flache Vektorillustration, klare Formen, viel Weißraum, keine Verläufe"
        },
        "isometric": {
          "name": "Isometrisch 3D",
          "text": "Isometrische 3D-Illustration, sanftes Licht, klare Kanten, reduzierte Details"
        },
        "line": {
          "name": "Linien",
          "text": "Feine Linienzeichnung, einfarbige Striche auf hellem Grund, sparsame Akzente"
        },
        "abstract": {
          "name": "Abstrakt",
          "text": "Abstrakte geometrische Formen, Farbflächen, kein Text im Bild"
        }
      },
      "pagePreset": {
        "airy": {
          "name": "Ruhig & luftig",
          "hint": "viel Weißraum, wenig Farbe",
          "text": "Viel Weißraum, ruhige Typografie, Farbe nur als Akzent, keine Schlagschatten"
        },
        "bold": {
          "name": "Kräftig & farbig",
          "hint": "große Titel, Farbflächen",
          "text": "Große, kräftige Überschriften, farbige Flächen und Abschnitte, deutliche Kontraste"
        },
        "compact": {
          "name": "Kompakt & sachlich",
          "hint": "dichter, für Berichte",
          "text": "Kompaktes, sachliches Layout, dichte Informationen, Tabellen und klare Gliederung"
        }
      },
      "ownText": "Eigener Text – unter „Erweitert“ änderbar.",
      "logo": "Logo",
      "advanced": "Erweitert",
      "exactColors": "Exakte Farbwerte",
      "imageStyleText": "Bildstil als Text",
      "htmlStyleText": "Seitenstil als Text",
      "logoVariants": "Weitere Logo-Varianten",
      "fontFiles": "Schriftdateien",
      "preview": {
        "heading": "Vorschau",
        "eyebrow": "Portfolio 2026",
        "title": "Unsere Kernaussage auf einen Blick",
        "section": "Ergebnisse",
        "contentTitle": "Was sich verändert hat",
        "kpi": "weniger Durchlaufzeit",
        "withTemplate": "PowerPoint nutzt die hochgeladene Vorlage. Die Vorschau zeigt die Kit-Farben für alles andere.",
        "withoutTemplate": "So sehen Präsentationen ohne eigene Vorlage aus: CDB-Musterfolien in euren Farben, Schriften und mit eurem Logo."
      },
      "templatesOptional": "Vorlagen (optional)",
      "templatesHint": "Ohne Vorlage entstehen Word und PowerPoint trotzdem in den Farben, Schriften und mit dem Logo des Kits.",
      "target": {
        "noKits": "Du kannst noch kein Kit bearbeiten. Lege zuerst ein Brand Kit an.",
        "loadingKits": "Kits werden geprüft …",
        "slotTaken": "Hat bereits eine {{format}}-Vorlage."
      },
      "createQuestion": "Woher kommt eure Marke?",
      "createLead": "Ein Brand Kit macht Word, PowerPoint, Excel, HTML-Seiten und Bilder zu euren. Ihr könnt alles später ändern – fangt dort an, wo es am schnellsten geht.",
      "createDrop": ".pptx, .potx, .docx oder .dotx hierher ziehen",
      "createDropPick": "oder Datei auswählen",
      "createDropReplace": "Andere Datei wählen",
      "createDropRejected": "Diese Datei ist keine PowerPoint- oder Word-Vorlage (.pptx, .potx, .docx, .dotx).",
      "createRecommended": "Empfohlen, wenn es eine Firmenvorlage gibt",
      "createSameEditor": "Beide Wege enden im selben Editor. Was die Vorlage schon liefert – Farben, Schriften, Logo –, ist dort bereits übernommen.",
      "releasePending": "Freigabe ausstehend",
      "sampleWorkbook": {
        "title": "Excel",
        "hint": "Arbeitsmappen aus dem Chat übernehmen Farben, Schriften und Logo des Kits – ohne eigene Vorlage. Das Logo steht neben dem Titel der Übersicht und in der Kopfzeile beim Drucken.",
        "show": "Mustermappe ansehen",
        "hide": "Mustermappe ausblenden",
        "download": "Mustermappe herunterladen",
        "failed": "Die Mustermappe konnte nicht erzeugt werden.",
        "headerLogoHint": "Das Logo in der Druck-Kopfzeile zeigt nur Excel, nicht diese Vorschau."
      }
    },
    "routines": {
      "button": "Routinen",
      "title": "Routinen",
      "new": "Neue Routine",
      "empty": "Routinen führen wiederkehrende Anfragen automatisch nach Zeitplan aus.",
      "createFirst": "Erste Routine anlegen",
      "active": "Aktiv",
      "paused": "Pausiert",
      "pause": "Routine pausieren",
      "resume": "Routine aktivieren",
      "nextRun": "nächster Lauf",
      "runNow": "Jetzt ausführen",
      "runStarted": "Routine wird ausgeführt …",
      "openConversation": "Konversation öffnen",
      "edit": "Bearbeiten",
      "delete": "Löschen",
      "history": "Verlauf",
      "noRuns": "Noch keine Läufe.",
      "deleteConfirmTitle": "Routine löschen?",
      "deleteConfirm": "{{name}} wirklich löschen? Der Verlauf geht dabei verloren.",
      "status": {
        "running": "läuft",
        "completed": "erfolgreich",
        "failed": "fehlgeschlagen"
      },
      "trigger": {
        "cron": "geplant",
        "manual": "manuell"
      },
      "errors": {
        "saveFailed": "Routine konnte nicht gespeichert werden.",
        "runFailed": "Routine konnte nicht gestartet werden.",
        "deleteFailed": "Routine konnte nicht gelöscht werden.",
        "loadFailed": "Routinen konnten nicht geladen werden."
      },
      "picker": {
        "title": "Neue Routine",
        "blank": "Von Grund auf",
        "blankHint": "Leeres Formular – du baust die Routine selbst."
      },
      "form": {
        "createTitle": "Neue Routine",
        "editTitle": "Routine bearbeiten",
        "name": "Name",
        "namePlaceholder": "z. B. Tägliche Zusammenfassung",
        "description": "Beschreibung",
        "descriptionPlaceholder": "Wozu dient diese Routine?",
        "prompt": "Anweisung",
        "promptPlaceholder": "Was soll die Routine bei jedem Lauf tun?",
        "promptHint": "Platzhalter wie {date}, {weekday} oder {week} werden bei jedem Lauf ersetzt.",
        "promptCounter": "{{chars}} / {{max}} Zeichen",
        "promptTooLong": "{{over}} Zeichen zu viel — maximal {{max}}. Kürze die Anweisung, bevor du speicherst.",
        "schedule": "Zeitplan",
        "sources": "Quellen",
        "model": "Modell",
        "enabled": "Aktiviert",
        "cancel": "Abbrechen",
        "save": "Speichern"
      },
      "schedule": {
        "freq": {
          "manual": "Manuell",
          "hourly": "Stündlich",
          "daily": "Täglich",
          "weekly": "Wöchentlich",
          "monthly": "Monatlich",
          "custom": "Benutzerdefiniert"
        },
        "hour": "Stunde",
        "minute": "Minute",
        "dayOfMonth": "Tag im Monat",
        "berlinTime": "Berliner Zeit",
        "weekday": {
          "mon": "Mo",
          "tue": "Di",
          "wed": "Mi",
          "thu": "Do",
          "fri": "Fr",
          "sat": "Sa",
          "sun": "So"
        },
        "customEmpty": "Bitte einen Cron-Ausdruck eingeben."
      },
      "retry": "Erneut versuchen",
      "wizard": {
        "basics": "Grundlagen",
        "task": "Aufgabe",
        "schedule": "Zeitplan",
        "options": "Optionen",
        "back": "Zurück",
        "next": "Weiter",
        "create": "Routine erstellen",
        "summarySchedule": "Läuft automatisch nach Zeitplan.",
        "summaryManual": "Kein Zeitplan — nur manueller Start."
      }
    },
    "timeline": {
      "understand": "Anfrage verstehen",
      "compose": "Antwort wird formuliert",
      "composeDone": "Antwort formuliert",
      "detailsHint": "Details anzeigen",
      "tool": {
        "graph": "Wissensgraph abfragen",
        "facts": "Fakten prüfen",
        "script": "Skript ausführen",
        "image": "Bild erzeugen",
        "document": "Dokument erstellen",
        "search": "Wissen durchsuchen",
        "searchDocuments": "Dokumente durchsuchen",
        "getDocumentContent": "Dokumentinhalt lesen",
        "findFiles": "Dateien suchen",
        "queryStructured": "Strukturierte Daten abfragen",
        "editDocument": "Dokument bearbeiten",
        "createHtml": "HTML-Seite erstellen",
        "editHtml": "HTML-Seite bearbeiten",
        "createBpmn": "BPMN-Diagramm erstellen",
        "editBpmn": "BPMN-Diagramm bearbeiten",
        "editImage": "Bild bearbeiten",
        "readAttachment": "Anhang lesen",
        "readChatFile": "Datei aus dem Chat lesen",
        "enrichExcel": "Excel-Daten anreichern",
        "ingestDocument": "Dokument aufnehmen",
        "ingestFromUrl": "Inhalt von einer URL aufnehmen",
        "ingestResult": "Aufnahme prüfen",
        "listClients": "Organisationen auflisten",
        "listKnowledgeAreas": "Knowledge Areas auflisten",
        "readDocument": "Dokument lesen",
        "renameDocument": "Datei umbenennen",
        "dataSource": "Datenquelle abfragen",
        "dataSourceNamed": "{{source}} abfragen",
        "generic": "Werkzeug ausführen",
        "outlookSearch": "Outlook durchsuchen",
        "outlookRead": "E-Mail lesen",
        "outlookDraft": "Outlook-Entwurf anlegen",
        "outlookReadAttachment": "Outlook-Anhang lesen",
        "outlookSaveAttachment": "Anhang in Meine Dokumente speichern",
        "calendarList": "Kalender ansehen",
        "calendarRead": "Termin lesen",
        "calendarFreeTime": "Freie Zeit suchen",
        "calendarCreate": "Termin anlegen",
        "calendarUpdate": "Termin ändern",
        "calendarCancel": "Termin absagen",
        "calendarCalendars": "Kalender auflisten",
        "calendarRespond": "Auf Einladung antworten",
        "peopleFind": "Person suchen",
        "peopleRead": "Person nachschlagen",
        "documentDocx": "Word-Dokument erstellen",
        "documentPptx": "Präsentation erstellen",
        "documentXlsx": "Excel-Tabelle erstellen",
        "createInteractive": "Interaktive Ansicht erstellen",
        "editInteractive": "Interaktive Ansicht bearbeiten"
      },
      "toolRunning": {
        "document": "Dokument wird erstellt",
        "documentDocx": "Word-Dokument wird erstellt",
        "documentPptx": "Präsentation wird erstellt",
        "documentXlsx": "Excel-Tabelle wird erstellt",
        "editDocument": "Dokument wird bearbeitet",
        "createHtml": "HTML-Seite wird erstellt",
        "editHtml": "HTML-Seite wird bearbeitet",
        "createInteractive": "Interaktive Ansicht wird erstellt",
        "editInteractive": "Interaktive Ansicht wird bearbeitet",
        "createBpmn": "BPMN-Diagramm wird erstellt",
        "editBpmn": "BPMN-Diagramm wird bearbeitet",
        "image": "Bild wird erzeugt",
        "editImage": "Bild wird bearbeitet"
      },
      "workflow": {
        "run": "Workflow ausführen",
        "runNamed": "Workflow „{{name}}“",
        "paused": "Workflow wartet auf deine Bestätigung",
        "pausedNamed": "Workflow „{{name}}“ wartet auf deine Bestätigung",
        "needsConnection": "Workflow braucht Microsoft 365",
        "needsConnectionNamed": "Workflow „{{name}}“ braucht Microsoft 365",
        "stepStatus": {
          "ok": "erledigt",
          "skipped": "übersprungen",
          "warning": "mit Hinweis",
          "failed": "fehlgeschlagen",
          "asked": "Rückfrage"
        },
        "write": {
          "simulated": "{{label}}: im Test simuliert, nichts angelegt",
          "created": "{{label}}{{key}} angelegt",
          "createdLines": "{{label}}{{key}} angelegt, {{n}} Zeilen",
          "partial": "{{label}}{{key}} angelegt, {{done}} von {{n}} Zeilen – Rest nicht angelegt",
          "lineUnknown": "{{label}}{{key}} angelegt, {{done}} von {{n}} Zeilen – bei einer Zeile unklar, ob angelegt",
          "appended": "{{label}}{{key}}: {{done}} Zeilen angehängt",
          "appendedPartial": "{{label}}{{key}}: {{done}} von {{n}} Zeilen angehängt – Rest nicht angelegt",
          "appendedUnknown": "{{label}}{{key}}: {{done}} von {{n}} Zeilen angehängt – bei einer Zeile unklar, ob angelegt",
          "unknown": "{{label}}: unklar, ob angelegt – in der Quelle prüfen",
          "asked": "{{label}}: wartet auf Bestätigung",
          "skipped": "{{label}}: übersprungen",
          "notCreated": "{{label}}: nicht angelegt"
        }
      }
    },
    "research": {
      "save": "Als Dokument speichern",
      "saveHint": "Recherche mit Quellenverzeichnis als Markdown-Dokument in deiner Drive ablegen",
      "saved": "Recherche gespeichert",
      "saveError": "Recherche konnte nicht gespeichert werden"
    },
    "quota": {
      "request": "Mehr Kontingent anfragen",
      "submit": "Anfrage senden",
      "messagePlaceholder": "Wofür brauchst du das Kontingent? (optional)",
      "pending": "Deine Anfrage wurde gesendet und wartet auf Freigabe.",
      "pendingEscalated": "Deine Anfrage liegt bei den Admins — das Client-Budget muss erhöht werden.",
      "clientBlocked": "Das Budget deiner Organisation ist aufgebraucht. Die Anfrage geht an die Admins."
    },
    "voice": {
      "dictate": "Diktieren — Text landet im Eingabefeld",
      "speakAndSend": "Sprechen und direkt absenden"
    },
    "clarification": {
      "pick": "Antwort wählen:",
      "reply": "Gemeint ist: {{label}}",
      "replyMany": "Gemeint sind: {{labels}}",
      "sendAnswers": "Antworten senden ({{n}}/{{total}})",
      "allow": "Ja, erlaube das.",
      "deny": "Nein, bitte nicht."
    },
    "workflows": {
      "button": "Workflows",
      "title": "Workflows",
      "subtitle": "Feste Schrittketten über verbundene Systeme – im Chat je ein eigenes Werkzeug.",
      "new": "Neuer Workflow",
      "empty": "Noch keine Workflows. Ein Workflow schlägt Kunden nach, prüft Regeln und baut daraus einen Vorschlag – deterministisch, im Chat als ein Werkzeug.",
      "createFirst": "Ersten Workflow anlegen",
      "edit": "Bearbeiten",
      "view": "Ansehen",
      "publish": "Veröffentlichen",
      "startInChat": "Im Chat starten",
      "startSentence": "Starte den Workflow „{{name}}“: ",
      "confirmDelete": "Workflow „{{name}}“ wirklich löschen?",
      "readOnly": "nur lesen",
      "disabled": "ausgeschaltet",
      "scope": {
        "user": "Nur ich",
        "client": "Meine Organisation",
        "global": "Alle Organisationen"
      },
      "status": {
        "draft": "Entwurf",
        "active": "Aktiv"
      },
      "types": {
        "lookup": "Nachschlagen",
        "check": "Prüfung",
        "map": "Zuordnung",
        "ask": "Rückfrage",
        "present": "Präsentieren",
        "compute": "Berechnung",
        "route": "Entscheidung",
        "each": "Für jede Position",
        "retrieve": "Wissen abrufen",
        "artifact": "Dokument erstellen",
        "connector": "Microsoft 365",
        "write": "In Quelle anlegen"
      },
      "severity": {
        "hard": "hart",
        "soft": "weich"
      },
      "ops": {
        "eq": "ist gleich",
        "ne": "ist ungleich",
        "in": "ist in",
        "not_in": "ist nicht in",
        "gt": ">",
        "gte": "≥",
        "lt": "<",
        "lte": "≤",
        "contains": "enthält",
        "not_contains": "enthält nicht",
        "starts_with": "beginnt mit",
        "ends_with": "endet mit",
        "matches": "passt auf Muster",
        "empty": "ist leer",
        "not_empty": "ist nicht leer",
        "truthy": "ist wahr",
        "falsy": "ist falsch"
      },
      "toasts": {
        "saved": "Gespeichert",
        "createFailed": "Anlegen fehlgeschlagen",
        "deleteFailed": "Löschen fehlgeschlagen",
        "moved": "Sichtbarkeit geändert",
        "moveFailed": "Sichtbarkeit konnte nicht geändert werden"
      },
      "versions": {
        "hint": "Jede gespeicherte Änderung an den Schritten oder Eingaben ist eine Version. Wiederherstellen legt den alten Stand als neue Version an – nichts geht verloren.",
        "dirtyHint": "Erst speichern oder die Änderungen verwerfen, dann wiederherstellen.",
        "empty": "Noch keine Versionen gespeichert.",
        "current": "aktuell",
        "steps": "{{count}} Schritte",
        "view": "Ansehen",
        "restore": "Wiederherstellen",
        "restoredFrom": "Wiederhergestellt aus Version {{version}}",
        "confirmRestore": "Version {{version}} wiederherstellen? Sie wird als neue Version angelegt; die aktuelle bleibt in der Liste.",
        "restored": "Version {{version}} wiederhergestellt – jetzt v{{now}}.",
        "restoreFailed": "Wiederherstellen fehlgeschlagen",
        "loadFailed": "Versionen konnten nicht geladen werden."
      },
      "builder": {
        "tabBuilder": "Builder",
        "tabTest": "Test",
        "tabRuns": "Läufe",
        "whenPrefix": "wenn",
        "patternPlaceholder": "regulärer Ausdruck, z. B. ^MAGDOS",
        "listPlaceholder": "Liste, z. B. [\"A\", \"B\"]",
        "pickVariable": "Variable einfügen",
        "variablesInputs": "Eingaben",
        "variablesNow": "Zeit",
        "variablesNone": "Keine Variablen vor diesem Schritt.",
        "variablesRowAny": "beliebige Spalte – Spalten in „columns“ nennen, dann erscheinen sie hier",
        "inputs": "Eingaben",
        "noInputs": "keine Eingaben deklariert",
        "inputsHint": "Was das Modell aus der Nutzeranfrage liefern muss. Wird zum Parameter-Schema des Werkzeugs.",
        "inputDescription": "Beschreibung für das Modell",
        "required": "Pflicht",
        "addInput": "Eingabe hinzufügen",
        "conditional": "bedingt",
        "unsaved": "ungespeichert",
        "addStep": "Schritt hinzufügen",
        "addAfter": "Nach dem gewählten Schritt einfügen",
        "emptyInspector": "Wähle einen Schritt auf dem Canvas, um ihn zu bearbeiten.",
        "emptyInspectorHint": "Der Startknoten hält die Eingaben. Die Reihenfolge der Kette ist die Reihenfolge der Ausführung.",
        "stepId": "Schritt-ID",
        "stepIdHint": "Wird in Ausdrücken verwendet: steps.<id>.row.<feld>",
        "label": "Bezeichnung",
        "title": "Titel des Abschnitts",
        "when": "Nur ausführen wenn (Bedingung)",
        "valuePlaceholder": "Wert",
        "source": "Quelle",
        "sourceHint": "Name der Router-Quelle",
        "operation": "Operation",
        "table": "Tabelle",
        "term": "Suchbegriff",
        "filters": "Filter",
        "addFilter": "Filter hinzufügen",
        "columns": "Spalten",
        "attempts": "Suchwege",
        "attemptsHint": "Der erste Suchweg, der Treffer liefert, zählt – die Schritte danach lesen dieselbe Zeile.",
        "eachBlock": "für jede Position · {{label}}",
        "eachItems": "Liste",
        "eachItemsHint": "Pfad zur Liste, z. B. inputs.positionen.",
        "eachAs": "Name des Elements",
        "eachAsHint": "Im Block als pos.feld ansprechbar.",
        "eachSteps": "Schritte im Block",
        "eachStepsHint": "Die so vielen Schritte direkt darunter laufen je Position – erlaubt sind Lookup, Prüfung, Zuordnung und Berechnung.",
        "eachItemLabel": "Positionsname",
        "eachItemLabelHint": "Wie eine Position in Rückfragen und der Tabelle heißt.",
        "eachMax": "Höchstens Positionen",
        "arrayFields": "Felder je Element (im Block als pos.<Feld>):",
        "routeHint": "Der erste Zweig, dessen Bedingung zutrifft, läuft; die anderen werden übersprungen. Jeder Zweig besteht aus den nächsten Schritten darunter, Zweig für Zweig, zuletzt „sonst“.",
        "branchLabel": "Zweig",
        "branchId": "ID",
        "branchSteps": "Schritte",
        "branchWhen": "Wenn",
        "addBranch": "Zweig hinzufügen",
        "defaultLabel": "Sonst",
        "defaultHint": "Läuft, wenn kein Zweig zutrifft.",
        "defaultPlaceholder": "sonst",
        "tabVersions": "Versionen",
        "columnsHint": "Kommagetrennt. Ohne Angabe liefert die Quelle nur Standardspalten – Prüfungen auf fehlende Spalten brechen ab.",
        "limit": "Zeilenlimit",
        "expect": "Erwartung",
        "expectOne": "genau eine Zeile",
        "expectMany": "Liste",
        "onMany": "Bei mehreren Treffern",
        "onManyAsk": "Nutzer fragen",
        "onManyFirst": "erste nehmen (Hinweis)",
        "onManyFail": "abbrechen",
        "key": "Schlüsselspalte",
        "keyHint": "Wert der Rückfrage-Option",
        "display": "Anzeige-Spalten",
        "askPrompt": "Rückfragetext (optional)",
        "optional": "Optional",
        "optionalHint": "Kein Treffer oder ein Quellfehler ist dann kein Abbruch.",
        "assert": "Bedingung, die gelten muss",
        "severityLabel": "Schwere",
        "message": "Meldung bei Verstoß",
        "messageHint": "Vorlage, z. B. Debitor {{steps.debitor.row.name}} ist gesperrt.",
        "fields": "Felder",
        "addField": "Feld hinzufügen",
        "literal": "fester Wert",
        "origin": "Herkunft",
        "note": "Hinweis",
        "prompt": "Frage an den Nutzer",
        "optionsFrom": "Optionen aus (Ausdruck)",
        "optionsFromHint": "z. B. steps.artikel.rows – leer = Freitext",
        "optionValue": "Wert-Spalte",
        "optionLabel": "Anzeige-Spalten",
        "sections": "Abschnitte (Zuordnungen)",
        "noMapSteps": "Noch keine Zuordnung in der Kette.",
        "summary": "Zusammenfassung",
        "summaryHint": "Erster Satz des Ergebnisses; Vorlage mit {{…}}.",
        "moveUp": "nach oben",
        "moveDown": "nach unten",
        "testUnsaved": "Der Test läuft mit dem gespeicherten Stand – erst speichern.",
        "invalidJson": "Kein gültiges JSON mit definition.steps.",
        "applyJson": "JSON übernehmen",
        "applyJsonHint": "Übernimmt in den Builder; speichern nicht vergessen.",
        "expression": "Rechnung",
        "expressionHint": "Pfade und Zahlen mit + − × / und Klammern, z. B. inputs.minuten * inputs.geraete / 60. Mit ?? gibt es einen Ersatzwert: inputs.stundensatz ?? steps.bench.row.stundensatz_eur. Das Ergebnis steht danach unter steps.<id>.value.",
        "round": "Nachkommastellen",
        "roundHint": "Leer = ungerundet, 0 = ganze Zahl.",
        "knowledgeAreas": "Wissensbereiche",
        "knowledgeAreasHint": "Jeder Bereich wird für sich durchsucht, mit den Rechten der Person, die den Workflow nutzt. Wer einen Bereich nicht lesen darf, bekommt einen Hinweis, keine Suche in anderen Bereichen.",
        "addKnowledgeArea": "Bereich hinzufügen",
        "strategies": "Suchen",
        "strategiesHint": "Laufen in jedem Bereich. Der Graph liefert automatisch extrahierte, ungeprüfte Einträge; die Faktensuche nur verifizierte.",
        "strategy": {
          "vector": "Dokumente",
          "graph": "Wissensgraph (alle Einträge)",
          "facts": "Verifizierte Fakten"
        },
        "query": "Suchanfrage",
        "queryHint": "Fest vorgegeben, was immer gesucht wird; mit einer optionalen Eingabe steuert die Anfrage des Nutzers einen Teil mit, z. B. {{inputs.fokus ?? \"\"}}. Ob „nichts gefunden“ ein Abbruch ist, entscheidet eine Prüfung auf steps.<id>.count.",
        "topK": "Textstellen",
        "topKHint": "Je Suche und Bereich.",
        "maxChars": "Zeichen je Textstelle",
        "instructions": "Schreibanweisung",
        "instructionsHint": "Wie das Modell aus dem Ergebnis den Text schreibt (z. B. die Felder einer Karte). Ersetzt die Standardvorgabe „zwei, drei Sätze, dann nachfragen“; dass die Tabellen schon angezeigt werden, weiß das Modell weiterhin.",
        "triggers": "Auslöse-Begriffe",
        "triggersHint": "Ein Begriff pro Zeile, z. B. „Pain Card“. Kommt einer davon in einer Nachricht vor, bekommt das Modell den Hinweis, dass dieser Workflow wahrscheinlich passt. Es ist ein Hinweis, kein erzwungener Start – der bleibt bei „Im Chat starten“.",
        "triggersPlaceholder": "Pain Card\nKosten des Nichtstuns",
        "userStated": "Nur vom Nutzer genannt",
        "userStatedHint": "Setzt das Modell hier eine Zahl oder ein Datum ein, das in den Nachrichten des Nutzers nicht vorkommt, wird der Wert verworfen und die hinterlegte Annahme gilt. Anderer Text wird nicht geprüft.",
        "requestKey": "Kennzeichnet den Vorgang",
        "requestKeyHint": "Zum Beispiel der Kunde. Nennt eine Folge-Nachricht hier einen anderen Wert, startet ein neuer Vorschlag. Ändert sie andere Angaben, bleiben bestätigte und korrigierte Werte erhalten. Ohne Markierung beginnt neu, sobald sich irgendeine schon genannte Angabe ändert.",
        "artifactFormat": "Format",
        "artifactFormats": {
          "docx": "Word (docx)",
          "pptx": "PowerPoint (pptx)",
          "xlsx": "Excel (xlsx)"
        },
        "artifactModel": "Modell",
        "artifactModelHint": "Leer = das Modell des Chats.",
        "artifactFilename": "Dateiname",
        "artifactFilenameHint": "Ohne Endung. Läuft der Workflow im selben Chat erneut, entsteht eine neue Version dieser Datei.",
        "artifactInstructions": "Was ins Dokument soll",
        "artifactInstructionsHint": "Inhalt und Aufbau. Das Modell schreibt das Dokument im Chat aus dieser Anweisung und den gewählten Ergebnissen, während die Antwort schon läuft. Zahlen übernimmt es aus den Ergebnissen; eine Zahl, die dort nicht vorkommt, wird unter der Datei angezeigt.",
        "artifactContext": "Ergebnisse für das Dokument",
        "artifactContextHint": "Keine Auswahl = alle Ergebnisse vor diesem Schritt.",
        "artifactNoContext": "Vor diesem Schritt gibt es noch keine Ergebnisse.",
        "artifactOutline": "Gliederung (optional)",
        "artifactOutlineHint": "Eine Überschrift, Folie oder Tabelle pro Zeile, in dieser Reihenfolge. Leer = das Modell entscheidet.",
        "assistant": "KI-Assistent",
        "addStepShort": "Schritt",
        "drop": {
          "mainChain": "Hauptkette",
          "intoBlock": "in „{{name}}“",
          "intoBranch": "in Zweig „{{name}}“",
          "refusal": {
            "block_type": "In einen „Für jede Position“-Block passen nur Nachschlagen, Prüfung, Zuordnung und Berechnung.",
            "branch_type": "In einen Zweig passen Nachschlagen, Prüfung, Zuordnung, Berechnung, Rückfrage und Wissen abrufen.",
            "artifact_order": "Ein Dokument-Schritt muss nach den Schritten stehen, die er liest."
          }
        },
        "zoomToSelection": "Auf Auswahl zoomen",
        "confirm": "Vom Nutzer bestätigen",
        "confirmHint": "Der berechnete Wert ist nur ein Vorschlag; der Nutzer bestätigt oder ändert ihn im Chat, bevor der Vorschlag fertig ist.",
        "confirmOptions": "Auswahl",
        "confirmFreeText": "Freitext (keine Liste)",
        "confirmValueColumn": "Spalte mit dem Wert",
        "confirmLabelColumns": "Anzeige-Spalten, Komma-getrennt",
        "confirmNoLists": "Eine Liste kommt aus einem Nachschlagen-Schritt, der mehrere Zeilen liefert (Ergebnis: mehrere).",
        "confirmWhen": "Nur bestätigen lassen, wenn",
        "toAttempts": "Weiteren Suchweg anlegen",
        "fromAttempts": "Nur den ersten Suchweg behalten",
        "addAttempt": "Suchweg hinzufügen",
        "attemptWhen": "Nur versuchen, wenn",
        "attemptLabelPlaceholder": "Bezeichnung, z. B. Artikelnummer",
        "orderBy": "Sortierung",
        "orderAsc": "aufsteigend",
        "orderDesc": "absteigend",
        "addOrder": "Sortierung hinzufügen",
        "addElementField": "Feld hinzufügen",
        "tabSettings": "Einstellungen",
        "writeField": "In die Quelle schreiben",
        "writeFieldHint": "Ein Schreibschritt sendet dieses Feld an die Quelle; leere Werte bleiben weg.",
        "writeHint": "Legt einen Datensatz an (POST), erst nachdem die Person im Chat „Erlauben“ geklickt hat. Gesendet werden die Felder der Zuordnung, die auf „In die Quelle schreiben“ stehen.",
        "writeOperation": "Operation (anlegen)",
        "writeOperationHint": "Der POST-Endpunkt der Quelle; jedes gesendete Feld muss dort als Body-Parameter angelegt sein.",
        "writeMap": "Datensatz aus Zuordnung",
        "writeMapHint": "Eine Zuordnung außerhalb eines Positionsblocks, vor diesem Schritt.",
        "writeKey": "Schlüsselfeld der Antwort",
        "writeKeyHint": "Das Feld, das den angelegten Datensatz benennt, z. B. „No“ – lesbar als steps.<id>.key. Es muss in der Antwort-Whitelist des Endpunkts stehen.",
        "writeLines": "Mit Zeilen",
        "writeLinesHint": "Eine Zeile pro Position eines Positionsblocks, angelegt nach dem Kopf.",
        "writeLinesEach": "Positionsblock",
        "writeLinesMap": "Zeile aus Zuordnung",
        "writeLinkField": "Verknüpfungsfeld der Zeile",
        "writeLinkFieldHint": "Bekommt den Schlüssel des Kopfs, z. B. „Document_No“.",
        "writeLinkFrom": "aus Kopf-Feld",
        "writeLinkFromHint": "Das Feld der Kopf-Antwort mit dem Schlüssel, z. B. „No“."
      },
      "assist": {
        "title": "KI-Assistent",
        "subtitle": "Fragen, erklären, Änderungen vorschlagen",
        "intro": "Frag mich zu diesem Workflow – was ein Schritt tut, warum ein Test scheitert, was sich verbessern lässt. Ich schaue bei Bedarf in den Quellen des Workflows nach. Ändern tue ich nur, wenn du es willst: Du bekommst einen Vorschlag und entscheidest.",
        "ephemeral": "Das Gespräch wird nicht gespeichert und endet, wenn du den Builder schließt.",
        "suggestExplain": "Erkläre den Workflow",
        "suggestLastRun": "Warum ist der letzte Test so ausgegangen?",
        "suggestImprove": "Was könnte man verbessern?",
        "placeholder": "Frage oder Änderungswunsch …",
        "hint": "Enter sendet, Umschalt+Enter macht eine neue Zeile.",
        "withRun": "Der letzte Test aus dem Test-Tab ist dabei.",
        "send": "Senden",
        "stop": "Stopp",
        "reset": "Neues Gespräch",
        "proposing": "Vorschlag wird vorbereitet – das kann eine Minute dauern …",
        "lookingUp": "Schaue nach ({{tool}}) …",
        "unavailable": "Der Assistent ist auf diesem Server noch nicht verfügbar.",
        "proposal": "Vorschlag",
        "apply": "Übernehmen",
        "applyAnyway": "Trotzdem übernehmen",
        "discard": "Verwerfen",
        "applied": "Übernommen – noch nicht gespeichert.",
        "discarded": "Verworfen.",
        "stale": "Du hast den Workflow geändert, seit der Vorschlag angefragt wurde. Übernehmen überschreibt diese Änderungen.",
        "kind": {
          "added": "neu",
          "changed": "geändert",
          "removed": "entfernt"
        },
        "fields": "Felder: {{fields}}",
        "moved": "verschoben von {{from}} nach {{to}}",
        "mainChain": "Hauptkette",
        "inputsAdded": "neu {{names}}",
        "inputsRemoved": "entfernt {{names}}",
        "inputsChanged": "geändert {{names}}",
        "triggers": "Auslöser",
        "order": "Reihenfolge der Schritte",
        "identity": "Name/Beschreibung ({{fields}})",
        "unrequested": "Nicht angefragt – bitte vor dem Übernehmen prüfen:"
      },
      "connector": {
        "area": "Bereich",
        "action": "Aktion",
        "tools": {
          "outlook": "Mail",
          "calendar": "Kalender",
          "people": "Personen"
        },
        "actions": {
          "outlook": {
            "search": "Mails suchen",
            "read": "Mail lesen",
            "create_draft": "Entwurf anlegen"
          },
          "calendar": {
            "list": "Termine auflisten",
            "free_time": "Freie Zeiten finden",
            "create": "Termin anlegen"
          },
          "people": {
            "find": "Person finden"
          }
        },
        "confirmBadge": "Bestätigung im Chat",
        "confirmHint": "Bevor dieser Schritt etwas anlegt, fragt der Chat „Erlauben / Nicht erlauben“. Im Testlauf wird er nur simuliert.",
        "unknownAction": "Diese Aktion gibt es nicht (mehr). Wähle eine andere.",
        "mailbox": "Postfach",
        "mailboxMode": {
          "own": "Eigenes Postfach",
          "address": "Feste Adresse",
          "variable": "Aus einer Variable"
        },
        "mailboxHint": {
          "own": "Das Postfach der Person, die den Workflow startet.",
          "address": "Ein geteiltes Postfach. Wer den Workflow nutzt, muss es unter „Verbundene Konten“ hinzugefügt haben.",
          "variable": "Zum Beispiel eine Eingabe; leer oder „me“ heißt eigenes Postfach."
        },
        "args": {
          "query": "Suchbegriff",
          "sender": "Absender",
          "since": "Seit (JJJJ-MM-TT)",
          "until": "Bis (JJJJ-MM-TT)",
          "unread_only": "Nur ungelesene",
          "folder": "Ordner",
          "limit": "Höchstens",
          "thread_id": "Unterhaltung",
          "message_id": "Mail-ID",
          "body": "Text",
          "mode": "Art",
          "reply_to_id": "Antwort auf (Mail-ID)",
          "to": "An",
          "cc": "Cc",
          "subject": "Betreff",
          "start": "Beginn",
          "end": "Ende",
          "minutes": "Dauer (Minuten)",
          "working_hours_only": "Nur Arbeitszeit",
          "attendees": "Teilnehmende",
          "calendar_id": "Kalender",
          "location": "Ort",
          "show_as": "Anzeigen als",
          "online_meeting": "Teams-Besprechung",
          "all_day": "Ganztägig"
        },
        "default": "Standard",
        "listPlaceholder": "a@firma.de, b@firma.de oder {{…}}",
        "optional": "Fehler nur als Hinweis",
        "optionalHint": "Ist Microsoft 365 nicht verbunden oder antwortet es nicht, läuft der Workflow mit leerem Ergebnis weiter.",
        "simulated": "Simuliert",
        "simulatedHint": "Schreibende Microsoft-365-Schritte werden im Testlauf nur simuliert: Es entsteht kein Entwurf und kein Termin. Lesende Schritte laufen mit deinem eigenen Konto."
      },
      "connection": {
        "connectTo": "Verbinde {{what}} in Microsoft 365, um diesen Workflow zu nutzen.",
        "and": " und ",
        "mailbox": "das geteilte Postfach {{address}}",
        "notEnabled": "Dieser Workflow nutzt Microsoft 365, das für deine Organisation nicht freigeschaltet ist.",
        "generic": "Dieser Workflow braucht eine Verbindung zu Microsoft 365.",
        "open": "Verbundene Konten öffnen",
        "listHint": "{{what}} verbinden, um diesen Workflow zu nutzen"
      }
    },
    "roomQuestion": {
      "seed": "Frage an den Raum „{{room}}“:"
    },
    "writeRecords": {
      "title": "„{{label}}“ in {{source}} anlegen",
      "appendTitle": "An „{{label}}“ {{record}} in {{source}} anhängen",
      "appendNote": "{{record}} ist schon angelegt – nur die fehlenden Zeilen werden gesendet.",
      "lines_one": "{{count}} Zeile",
      "lines_other": "{{count}} Zeilen",
      "more_one": "… und {{count}} weitere Zeile",
      "more_other": "… und {{count}} weitere Zeilen"
    }
  },
  "sharedChat": {
    "extractedImage": "Extrahiertes Bild aus Dokument",
    "openDocument": "Dokument öffnen",
    "filter": {
      "loading": "Lade Wissensbereiche...",
      "noAreas": "Keine Wissensbereiche",
      "noAreasAvailable": "Keine Wissensbereiche verfügbar",
      "selectArea": "Wissensbereich auswählen",
      "selectMultiple": "Wissensbereiche auswählen"
    },
    "sources": {
      "aiGenerated": "KI-erstellt",
      "aiGeneratedHint": "Dieses Dokument wurde vom System geschrieben (z. B. eine gespeicherte Recherche) und ist keine Primärquelle.",
      "graph": {
        "documentsHeading": "Dokumente",
        "entitiesHeading": "Entitäten",
        "entityFallback": "Entität",
        "factFallback": "Graph-Fakt",
        "factsHeading": "Fakten",
        "heading": "Graph-Quellen",
        "relevanceTooltip": "Relevanz"
      },
      "image": "Bild",
      "status": {
        "open": "offen",
        "rejected": "abgelehnt",
        "updated": "aktualisiert",
        "verified": "verifiziert",
        "outdated": "veraltet"
      },
      "untitled": "Unbenannte Quelle",
      "relevance": "{{value}} % Relevanz",
      "chunk": "Chunk {{index}}",
      "loadingFullText": "Vollständiger Text wird geladen…",
      "chunkUnavailable": "Der Chunk-Inhalt konnte nicht geladen werden.",
      "chunkLoadError": "Fehler beim Laden des vollständigen Textes.",
      "summaryLabel": "KI-Kernaussage",
      "summaryHint": "Von der KI aus dem Bild abgeleitet, nicht wörtlich im Bild enthalten.",
      "review": {
        "corrected": "korrigiert",
        "automatic": "automatisch bestätigt",
        "automaticHint": "Beim Hochladen automatisch als bestätigt markiert, nicht von einer Person geprüft."
      },
      "derivation": {
        "ocr": "Texterkennung (Scan)",
        "transcript": "Transkript maschinell",
        "image": "Bild KI-beschrieben",
        "video": "Aus Video maschinell",
        "hint": "Dieser Text wurde maschinell erstellt, nicht von einer Person geschrieben."
      },
      "olderVersion": "Ältere Version",
      "olderVersionHint": "Dieser Abschnitt stammt aus einer älteren Version des Dokuments.",
      "contested": "Widerspruch offen",
      "contestedHint": "Eine Angabe dieses Dokuments widerspricht einer geprüften Aussage; die Klärung steht noch aus.",
      "sourceFlagged": "Als falsch markiert",
      "sourceFlaggedHint": "Fachleute haben eine Angabe dieses Dokuments als falsch markiert.",
      "archivedVersion": "Archivierte Version",
      "archivedVersionHint": "Dieser Abschnitt stammt aus einer inzwischen archivierten Version des Dokuments.",
      "openHint": "Quelle öffnen"
    },
    "externalImage": "Externes Bild „{{name}}“ nicht geladen"
  },
  "multimedia": {
    "checkingAccess": "Berechtigungen werden geprüft...",
    "checkingAccessHint": "Bitte einen Moment Geduld.",
    "title": "Multimedia Player",
    "mediaType": "Medientyp",
    "all": "Alle",
    "audio": "Audio",
    "video": "Video",
    "playlist": "Playlist",
    "items": "Dateien",
    "play": "Abspielen",
    "pause": "Pausieren",
    "playing": "Wiedergabe",
    "selected": "Ausgewählt",
    "loading": "Lädt...",
    "noMediaSelected": "Keine Datei ausgewählt",
    "selectFromPlaylist": "Wählen Sie eine Datei aus der Playlist aus",
    "noMediaFound": "Keine Medien-Dateien gefunden",
    "errorLoadingMediaList": "Fehler beim Laden der Medien-Liste",
    "errorLoadingMedia": "Fehler beim Laden des Mediums",
    "errorPlaying": "Fehler beim Abspielen"
  },
  "knowledgeExtractor": {
    "title": "Knowledge Hub",
    "entityInfoReadonly": "Entity Info (schreibgeschützt)",
    "previousNotes": "Vorherige Notizen:",
    "metadata": "Metadaten",
    "created": "Erstellt:",
    "updated": "Aktualisiert:",
    "noOutgoingRelations": "Keine ausgehenden Beziehungen",
    "noIncomingRelations": "Keine eingehenden Beziehungen",
    "noConnectedDocuments": "Keine verbundenen Dokumente",
    "knowledgeArea": "Wissensbereich:",
    "noKnowledgeArea": "Kein Wissensbereich ausgewählt",
    "openFromHub": "Bitte öffnen Sie diese App über den Knowledge Hub.",
    "errorLoadingDocuments": "Fehler beim Laden der Dokumente",
    "loading": "Lädt...",
    "loaded": "Geladen",
    "noAccessibleAreas": "Keine zugänglichen Wissensbereiche",
    "selectArea": "Wissensbereich auswählen",
    "document": "Dokument",
    "documents": "Dokumente",
    "searchPlaceholder": "Titel oder Dateiname suchen...",
    "uploadDocument": "Datei hochladen",
    "filterAll": "Alle Status",
    "filterAllAreas": "Alle Bereiche",
    "filterCompleted": "Abgeschlossen",
    "filterMine": "Meine Uploads",
    "qaBrowserComingSoon": "Q&A Browser",
    "qaBrowserDescription": "Diese Funktion wird in Kürze verfügbar sein.",
    "tabs": {
      "documentExtractor": "Document Extractor",
      "verifier": "Knowledge Verifier"
    },
    "verifier": {
      "title": "Knowledge Verifier",
      "description": "Verifizieren und reviewen Sie extrahiertes Wissen",
      "selectView": "View wählen",
      "preview": {
        "toggle": "Vorschau anzeigen",
        "error": "Vorschau konnte nicht geladen werden.",
        "show": "Dokument einblenden",
        "hide": "Dokument ausblenden"
      },
      "docFilter": {
        "all": "Alle",
        "empty": "Keine Dokumente",
        "searchPlaceholder": "Dokumente suchen...",
        "selected": "Ausgewählt"
      },
      "documentOverview": {
        "title": "Dokumente zur Verifikation",
        "empty": "Keine Dokumente zur Verifikation",
        "emptyDescription": "Sobald Dokumente extrahiert wurden, erscheinen sie hier mit ihrem Verifikationsfortschritt.",
        "clickHint": "Klicken Sie auf ein Dokument, um dessen Begriffe und Aussagen zu prüfen.",
        "factsColumn": "Aussagen",
        "nodesColumn": "Begriffe",
        "progressColumn": "Fortschritt",
        "uploadDate": "Hochgeladen"
      },
      "nodeDetail": {
        "properties": "Eigenschaften",
        "nameLabel": "Begriff",
        "summaryLabel": "Beschreibung"
      },
      "actions": {
        "verify": "Verifizieren",
        "reject": "Ablehnen",
        "edit": "Bearbeiten",
        "backToOverview": "Übersicht",
        "saveCorrection": "Korrektur speichern"
      },
      "facts": {
        "title": "Aussagen",
        "statusLabel": "Aussagen",
        "empty": "Keine Aussagen zu diesem Begriff.",
        "emptyFiltered": "Keine Aussagen mit diesem Status.",
        "outgoing": "ausgehend",
        "incoming": "eingehend",
        "countsSummary": "{{v}} verifiziert, {{r}} abgelehnt, {{o}} zu prüfen",
        "jumpToNode": "Zu diesem Begriff springen",
        "sourceDocument": "Quelle: {{title}}",
        "sourceUnavailable": "Quelle nicht in diesem Wissensbereich verfügbar",
        "toggleNode": "Begriff ein-/ausklappen",
        "linkedCount": "+{{count}} aus anderen Dokumenten",
        "mentionedCount_one": "in {{count}} Aussage genannt",
        "mentionedCount_other": "in {{count}} Aussagen genannt",
        "mentionedInStatements_one": "Wird in {{count}} Aussage dieses Dokuments genannt.",
        "mentionedInStatements_other": "Wird in {{count}} Aussagen dieses Dokuments genannt.",
        "noneFromThisDocument": "Keine Aussage aus diesem Dokument.",
        "emptyConceptFilter": "Kein Begriff mit diesem Status.",
        "shownCounts": "{{concepts}} Begriffe · {{statements}} Aussagen"
      },
      "views": {
        "qa": "Q&A",
        "facts": "Aussagen",
        "nodes": "Begriffe",
        "blocks": "Blocks"
      },
      "status": {
        "editedMarker": "bearbeitet"
      },
      "overview": {
        "title": "Zu prüfen",
        "summary": "{{open}} von {{total}} Dokumenten offen",
        "done": "fertig",
        "back": "Übersicht",
        "columnDocument": "Dokument",
        "columnUploaded": "Hochgeladen"
      },
      "document": {
        "progress": "geprüft",
        "noStatements": "Aus diesem Dokument wurde nichts extrahiert."
      },
      "searchDocuments": "Dokumente durchsuchen...",
      "searchStatements": "Aussagen durchsuchen...",
      "graph": {
        "title": "Wissensgraph",
        "toggle": "Graph anzeigen",
        "noNeighbors": "Keine verbundenen Begriffe",
        "spacing": "Abstand",
        "usedHint": "Hervorgehoben = für die Antwort verwendet",
        "detail": {
          "centre": "Im Graph zentrieren"
        },
        "ownEdge": "aus diesem Dokument",
        "linkedEdge": "aus einem anderen",
        "fit": "Alles zeigen",
        "spacingPreset": {
          "compact": "Eng",
          "normal": "Mittel",
          "spacious": "Weit"
        },
        "labelHint": "{{count}} Begriffe aus anderen Dokumenten — Namen beim Hineinzoomen oder Überfahren",
        "hideOutside": "Nur dieses Dokument",
        "showOutside": "{{count}} Begriffe außerhalb zeigen",
        "budgetNote": "Zu viele Begriffe für eine Netzansicht — gezeigt werden die {{shown}} am stärksten verbundenen von {{total}}."
      },
      "documents": {
        "empty": "Keine Dokumente zur Verifikation.",
        "emptySearch": "Kein Dokument passt zu „{{term}}\"."
      },
      "leftMode": {
        "document": "Dokument",
        "connections": "Zusammenhänge",
        "review": "Durchlauf"
      },
      "conceptStatusLabel": "Begriffe",
      "review": {
        "empty": "Keine Aussagen zum Durchgehen.",
        "done": "{{done}} von {{total}} geprüft",
        "aboutConcept": "Zum Begriff",
        "findInDocument": "Im Dokument suchen",
        "agenda": "Begriffe",
        "kindConcept": "Begriff",
        "kindStatement": "Aussage",
        "keysStep": "blättern",
        "keysChapter": "Begriff wechseln",
        "keysDecide": "verifizieren · bearbeiten · ablehnen",
        "back": "Zurück zum Durchlauf",
        "cameFromHere": "Ihre Stelle",
        "cameFromHereTitle": "Hier haben Sie den Durchlauf verlassen"
      },
      "assignment": {
        "column": "Verantwortlich",
        "unassigned": "Niemand zugewiesen",
        "unknownUser": "Unbekannte Person",
        "change": "Verantwortliche Person ändern",
        "noCandidates": "Niemand mit Zugriff auf diesen Wissensbereich",
        "myTasks": "Meine Aufgaben"
      },
      "tasks": {
        "title": "Vorschläge ({{count}})",
        "kind": {
          "sameStatement": "Gleiche Aussage?",
          "drift": "Zahl geändert",
          "contested": "Angefochten",
          "missingInVersion": "Fehlt in neuer Version",
          "sourcesConflict": "Widerspruch zwischen Quellen",
          "passageConflict": "Widerspruch in Textstellen",
          "other": "Vorschlag"
        },
        "similarity": "{{value}} % ähnlich",
        "later": "Später",
        "new": "Neu",
        "reviewed": "Geprüft",
        "incoming": "Neu extrahiert",
        "sameStatement": "Gleiche Aussage",
        "verifyNew": "Neue verifizieren",
        "rejectNew": "Neue ablehnen",
        "laterAction": "Später",
        "dismiss": "Kein Handlungsbedarf",
        "onlyWithSuggestions": "Mit Vorschlägen",
        "badge": "{{count}} Vorschläge",
        "contestedHint": "Ein anderes Dokument nennt eine andere Zahl.",
        "hint": {
          "sameStatement": "Neu extrahiert und ähnlich wie eine geprüfte Aussage. Ist es dieselbe?",
          "drift": "Dieses Dokument nennt jetzt einen anderen Wert als die geprüfte Aussage.",
          "contested": "Ein anderes Dokument nennt einen anderen Wert als die geprüfte Aussage.",
          "missingInVersion": "Diese Aussage war geprüft und steht in der neuen Version des Dokuments nicht mehr. Gilt sie noch?",
          "sourcesConflict": "Zwei Dokumente nennen unterschiedliche Werte, keine der Aussagen ist geprüft. Welcher Wert gilt?",
          "passageConflict": "Zwei Dokumente nennen an diesen Stellen unterschiedliche Werte. Welcher gilt?",
          "other": "Ein Fall, den diese Ansicht noch nicht kennt. Bitte später erneut ansehen."
        },
        "reviewedIn": "Geprüft · aus {{document}}",
        "newApplies": "Neuer Wert gilt",
        "newAppliesHint": "Die neue Aussage wird verifiziert, die geprüfte als veraltet markiert.",
        "oldApplies": "Bisheriger Wert gilt",
        "oldAppliesHint": "Die neue Aussage wird abgelehnt, ihre Quelle als falsch markiert.",
        "bothApply": "Beide stimmen",
        "bothApplyHint": "Beide stimmen, z. B. verschiedene Varianten oder Zeiträume. Die neue Aussage wird verifiziert.",
        "suggested": "Siehe Vorschlag",
        "suggestedHint": "Zu dieser Aussage gibt es oben einen Vorschlag.",
        "stillValid": "Gilt weiter",
        "stillValidHint": "Die Aussage bleibt als geprüft bestehen, auch ohne die neue Version als Quelle.",
        "markOutdated": "Veraltet",
        "markOutdatedHint": "Die Aussage galt früher und gilt nicht mehr; sie fällt aus den Antworten.",
        "markWrong": "Falsch",
        "markWrongHint": "Die Aussage war nie richtig; sie wird abgelehnt.",
        "fromDocument": "Aus {{document}}",
        "unknownDocument": "Dokument",
        "valueApplies": "Wert aus {{document}} gilt",
        "valueAppliesHint": "Diese Aussage wird verifiziert, die andere abgelehnt und ihre Quelle als falsch markiert.",
        "bothApplySourcesHint": "Beide stimmen, z. B. verschiedene Varianten oder Zeiträume. Beide Aussagen werden verifiziert.",
        "aiReason": "Einschätzung der KI: {{reason}}",
        "valueAppliesPassageHint": "Die andere Textstelle wird als falsch markiert. Antworten, die sich auf ihr Dokument stützen, weisen darauf hin.",
        "bothApplyPassageHint": "Beide stimmen, z. B. verschiedene Varianten oder Bedingungen. Nichts wird markiert."
      },
      "sourceDeleted": {
        "open": "Quelle gelöscht",
        "title": "Geprüft, Quelle gelöscht",
        "hint": "Diese Aussagen wurden geprüft und beim Löschen ihres Dokuments behalten. Sie fließen weiter in Antworten ein, ohne Quelle. Wer sie nicht mehr gelten lassen will, lehnt sie ab.",
        "empty": "Keine Aussagen ohne Quelle."
      },
      "reason": {
        "sourceWrongCorrection": "Die Quelle selbst ist falsch oder veraltet",
        "rejectSourceWrong": "Ablehnen: Quelle falsch oder veraltet"
      },
      "sourceArchived": {
        "open": "Quelle archiviert",
        "title": "Geprüft, Quelle archiviert",
        "hint": "Diese Aussagen wurden bestätigt, nachdem die Version ihres Dokuments archiviert wurde. Sie fließen weiter in Antworten ein; die archivierte Version bleibt herunterladbar. Wer sie nicht mehr gelten lassen will, lehnt sie ab.",
        "empty": "Keine bestätigten Aussagen aus archivierten Versionen."
      },
      "readOnly": {
        "label": "Nur lesen",
        "hint": "Sie können Inhalte ansehen, aber nicht prüfen. Das Prüfrecht vergibt ein Admin oder Supervisor über die Rolle."
      }
    },
    "status": {
      "completed": "Abgeschlossen",
      "processing": "In Bearbeitung",
      "failed": "Fehler",
      "pending": "Ausstehend",
      "queued": "Wartend",
      "converting": "Konvertierung",
      "cleaning": "Bereinigung",
      "chunking": "Chunking",
      "graph": "Graph",
      "vector": "Vector",
      "uploaded": "Hochgeladen",
      "markdown_ready": "In Bearbeitung"
    },
    "table": {
      "filename": "Dateiname",
      "knowledgeArea": "Wissensbereich",
      "status": "Status",
      "verificationStatus": "Verifikationsstatus",
      "verificationFacts": "Facts",
      "verificationNodes": "Nodes",
      "groupVerification": "Verifikation",
      "groupExtraction": "Extraktion",
      "verificationTooltip": "Offen: {{open}} · Verifiziert: {{verified}} · Aktualisiert: {{updated}} · Abgelehnt: {{rejected}} · Veraltet: {{outdated}}",
      "verificationError": "Verifikationsstatus nicht verfügbar: {{message}}",
      "chunks": "Chunks",
      "knowledgeGraph": "Wissensgraph",
      "created": "Erstellt",
      "noDocuments": "Keine Dokumente gefunden",
      "nodes": "{{count}} Knoten",
      "edges": "{{count}} Kanten",
      "autoVerifyTl1": "Auto-Verify TL1"
    },
    "actions": {
      "view": "Ansehen",
      "edit": "Bearbeiten",
      "reprocess": "Neu verarbeiten",
      "openDocument": "Dokument öffnen",
      "delete": "Löschen"
    },
    "upload": {
      "title": "Dokumente hochladen",
      "description": "Laden Sie PDF-, Office-, Text- oder E-Mail-Dateien hoch.",
      "fileLabel": "Datei(en)",
      "fileSelected": "Datei ausgewählt",
      "filesSelected": "Dateien ausgewählt",
      "prefixLabel": "Titel-Präfix (optional)",
      "prefixPlaceholder": "z.B. SENTRON",
      "prefixHint": "Optional: Präfix wird vor jeden Dateinamen gesetzt",
      "clientLabel": "Client (für Storage)",
      "noClientsAvailable": "Keine Clients verfügbar",
      "knowledgeAreaLabel": "Wissensbereich",
      "noKnowledgeAreasAvailable": "Keine Knowledge Areas verfügbar",
      "selectKnowledgeArea": "Knowledge Area wählen",
      "knowledgeAreaHint": "Dokument wird dieser Knowledge Area zugeordnet",
      "noKnowledgeArea": "Kein Bereich ausgewählt",
      "uploading": "Wird hochgeladen...",
      "uploadFiles": "{{count}} Datei(en) hochladen",
      "upload": "Hochladen",
      "extractorLimitExceeded": "Monatliches Extractor-Token-Limit erreicht",
      "extractorLimitExceededDescription": "Dokument-Uploads sind gesperrt, da Ihr monatliches Extractor-Token-Limit überschritten wurde. Kontaktieren Sie Ihren Administrator, um das Limit zu erhöhen.",
      "extractorLimitWarning": "Extractor-Token-Nutzung bei {{percentage}}%",
      "extractorLimitWarningDescription": "Sie nähern sich Ihrem monatlichen Extractor-Token-Limit. Uploads könnten bald gesperrt werden.",
      "chunkLimitExceeded": "Chunk-Limit erreicht",
      "chunkLimitExceededDescription": "Löschen Sie bestehende Dokumente oder erhöhen Sie das Limit.",
      "chunkLimitWarning": "Chunk-Limit fast erreicht ({{percentage}}%)",
      "chunkLimitUsage": "{{current}} / {{maximum}} Chunks",
      "noClientAssigned": "Kein Client zugewiesen",
      "noKnowledgeAreaSelected": "Kein Wissensbereich ausgewählt",
      "partialErrorTitle": "Teilweiser Upload-Fehler",
      "selectKnowledgeAreaFirst": "Bitte zuerst einen Wissensbereich auswählen",
      "successTitle": "Upload erfolgreich",
      "successDescription": "Das Dokument wurde erfolgreich hochgeladen",
      "selectFiles": "Dateien auswählen",
      "selectFolder": "Ordner auswählen",
      "folderFiltered": "{{supported}} von {{total}} Dateien unterstützt ({{filtered}} gefiltert)",
      "noSupportedFilesInFolder": "Keine unterstützten Dateien im Ordner",
      "emptyFolder": "Der Ordner ist leer",
      "tooManyFiles": "Maximal {{max}} Dateien pro Upload erlaubt",
      "tooManyExcelFiles": "Maximal {{max}} Excel-Dateien pro Upload erlaubt",
      "fileTooLarge": "Dateien dürfen maximal {{max}} MB groß sein",
      "duplicateToastTitle": "{{count}} Datei(en) bereits im System vorhanden",
      "duplicateToastDescription": "Der Inhalt ist identisch mit bereits hochgeladenen Dokumenten. Die betroffenen Dateien sind in der Liste markiert.",
      "duplicateBadge": "Bereits im System vorhanden",
      "duplicateIn": "Bereits vorhanden in „{{knowledgeArea}}“ als „{{title}}“",
      "rateLimitedToastTitle": "{{count}} Datei(en) wegen Server-Uploadlimit zurückgestellt",
      "rateLimitedToastDescription": "Das Upload-Limit des Servers ist erreicht. Die Dateien bleiben in der Liste — in ein paar Minuten einfach erneut „Hochladen“ klicken.",
      "rateLimitedBadge": "Server-Uploadlimit — später erneut „Hochladen“ klicken",
      "rateLimitWaiting": "Server-Uploadlimit erreicht — der Upload wird automatisch fortgesetzt. Du kannst auch abbrechen und es später erneut versuchen.",
      "cancelUpload": "Upload abbrechen",
      "reasonRateLimited": "Server-Uploadlimit",
      "reasonDuplicate": "bereits vorhanden",
      "andMoreFiles": " und {{count}} weitere",
      "largeSelectionTitle": "Große Auswahl — Upload läuft in Etappen",
      "largeSelectionDescription": "Der Server nimmt {{window}} Dateien pro {{minutes}} Minuten an. Lass den Dialog einfach geöffnet — der Upload setzt automatisch fort, bis alles hochgeladen ist.",
      "uploadProgress": "{{done}} von {{total}} Datei(en) hochgeladen",
      "uploadingProgress": "Wird hochgeladen… ({{done}}/{{total}})",
      "recentPrefixes": "Zuletzt:",
      "summaryComplete": "Alle {{total}} Datei(en) sind in der Knowledge Area.",
      "summaryIncomplete": "{{open}} von {{total}} Datei(en) fehlen noch — sie sind unten markiert.",
      "summaryDetail": "{{uploaded}} hochgeladen · {{duplicates}} bereits vorhanden · {{open}} offen",
      "versions": {
        "title_one": "Neue Version ({{count}})",
        "title_other": "Neue Versionen ({{count}})",
        "hint": "Diese Dateien heißen wie vorhandene Dokumente im Wissensbereich und werden als deren neue Version hochgeladen. Abwählen, um sie als eigenes Dokument hochzuladen.",
        "asVersion": "Neue Version von „{{title}}“ (v{{from}} → v{{to}})",
        "asSeparate": "Wird als eigenes Dokument hochgeladen, „{{title}}“ bleibt unverändert",
        "error": {
          "default": "Konnte nicht als neue Version hochgeladen werden.",
          "identical_to_current_version": "Identisch mit der aktuellen Version (v{{version}}) – nichts zu tun.",
          "version_conflict": "Das Dokument wurde inzwischen geändert. Bitte Datei erneut auswählen.",
          "version_target_not_current": "Das Dokument hat inzwischen eine neuere Version. Bitte Datei erneut auswählen.",
          "version_target_not_found": "Das Dokument gibt es nicht mehr.",
          "version_target_other_area": "Eine neue Version muss im selben Wissensbereich liegen wie das Dokument.",
          "document_versions_disabled": "Versionen sind für diese Organisation nicht freigeschaltet."
        }
      }
    },
    "edit": {
      "title": "Dokument bearbeiten",
      "description": "Ändern Sie die Metadaten des Dokuments.",
      "titleLabel": "Titel",
      "titlePlaceholder": "Dokumenttitel",
      "filenameLabel": "Dateiname",
      "knowledgeAreaLabel": "Wissensbereich",
      "knowledgeAreaHint": "Der Wissensbereich kann nicht geändert werden.",
      "updating": "Wird gespeichert...",
      "save": "Speichern"
    },
    "delete": {
      "title": "Dokument löschen",
      "description": "Möchten Sie das folgende Dokument wirklich löschen?",
      "warning": "Diese Aktion kann nicht rückgängig gemacht werden. Alle Chunks und Vektoren werden ebenfalls gelöscht.",
      "deleting": "Wird gelöscht...",
      "confirm": "Löschen",
      "verdicts": {
        "summary": "Dieses Dokument trägt {{statements}} geprüfte Aussagen und {{concepts}} geprüfte Konzepte.",
        "openVerifier": "Im Verifier ansehen",
        "deleteToo": "Geprüftes Wissen mitlöschen",
        "keep": "Als geprüftes Wissen ohne Quelle behalten",
        "keepHint": "Die Aussagen bleiben in Antworten, gekennzeichnet als „Quelle gelöscht“, und stehen im Verifier unter „Quelle gelöscht“."
      }
    },
    "view": {
      "title": "Dokument anzeigen",
      "processingInfo": "Verarbeitungsinformationen",
      "noContent": "Kein Inhalt verfügbar",
      "noRawMarkdown": "Kein Raw Markdown verfügbar",
      "noCleanedMarkdown": "Kein Cleaned Markdown verfügbar",
      "noChunks": "Keine Chunks verfügbar",
      "documentNotFound": "Dokument nicht gefunden",
      "tabs": {
        "details": "Details",
        "content": "Content",
        "rawMarkdown": "Raw Markdown",
        "cleanedMarkdown": "Cleaned MD",
        "chunks": "Chunks"
      },
      "chunks": {
        "showFullContent": "Vollständigen Inhalt anzeigen",
        "title": "Chunk #{{index}}",
        "characters": "{{count}} Zeichen",
        "embedded": "✓ Eingebettet"
      },
      "fields": {
        "status": "Status",
        "knowledgeArea": "Wissensbereich",
        "chunks": "Chunks",
        "created": "Erstellt am",
        "processed": "Verarbeitet am",
        "documentId": "Dokument-ID"
      },
      "knowledgeGraph": {
        "title": "Knowledge Graph",
        "nodes": "Graph Knoten",
        "edges": "Graph Kanten"
      }
    },
    "factsBrowser": {
      "loading": "Lade Facts...",
      "noResults": "Keine Facts gefunden",
      "resultsCount": "{{count}} von {{total}} Facts angezeigt",
      "factsLabel": "Facts",
      "total": "Gesamt",
      "today": "Heute",
      "yesterday": "Gestern",
      "daysAgo": "vor {{count}} Tagen",
      "search": {
        "placeholder": "Facts, Entitäten oder Beziehungen durchsuchen..."
      },
      "table": {
        "fact": "Fact",
        "entities": "Entitäten",
        "relationship": "Beziehung",
        "knowledgeArea": "Wissensbereich",
        "status": "Status",
        "updated": "Aktualisiert",
        "actions": "Aktionen"
      },
      "filter": {
        "allStatus": "Alle Status",
        "allAreas": "Alle Bereiche",
        "selectStatus": "Status auswählen",
        "selectKnowledgeArea": "Wissensbereich auswählen"
      },
      "status": {
        "open": "Offen",
        "verified": "Verifiziert",
        "updated": "Bearbeitet",
        "rejected": "Abgelehnt",
        "outdated": "Veraltet"
      },
      "relationshipType": "Beziehungstyp",
      "knowledgeArea": "Wissensbereich",
      "createdAt": "Erstellt am",
      "updatedAt": "Aktualisiert am",
      "reviewNotes": "Review-Notizen",
      "originalFact": "Original",
      "actions": {
        "verify": "Verifizieren",
        "reject": "Ablehnen",
        "edit": "Bearbeiten"
      },
      "loadMore": {
        "button": "Weitere {{amount}} laden",
        "loading": "Lade weitere...",
        "remaining": "verbleibend"
      },
      "empty": {
        "title": "Keine Facts verfügbar",
        "description": "Für diesen Wissensbereich wurden noch keine Facts extrahiert. Versuchen Sie es mit einem anderen Filter oder Suchbegriff."
      },
      "editDialog": {
        "title": "Fact bearbeiten",
        "description": "Ändern Sie den Status oder Inhalt des Facts.",
        "entities": "Entities (schreibgeschützt)",
        "factText": "Fact Text",
        "original": "Original",
        "characters": "Zeichen",
        "status": "Status",
        "statusOpen": "🟡 Offen - Noch nicht geprüft",
        "statusVerified": "🟢 Verifiziert - Bestätigt und korrekt",
        "statusRejected": "🔴 Abgelehnt - Fact ist nicht korrekt/verwendbar",
        "statusUpdated": "🔵 Bearbeitet - Fact Text wurde angepasst",
        "reviewNotes": "Review Notizen (optional)",
        "reviewNotesPlaceholder": "Optionale Notizen zur Änderung...",
        "cancel": "Abbrechen",
        "save": "Änderungen speichern",
        "saving": "Speichert..."
      }
    },
    "nodesBrowser": {
      "title": "Nodes Browser",
      "loading": "Lade Entities...",
      "entitiesLabel": "Entities",
      "statusCounts": "{{open}} offen, {{verified}} verifiziert, {{updated}} bearbeitet, {{rejected}} abgelehnt",
      "noAccessibleAreas": "Keine Wissensbereiche zugewiesen",
      "empty": {
        "title": "Keine Entities gefunden",
        "description": "Keine Entities verfügbar oder alle wurden gefiltert."
      },
      "status": {
        "open": "zu prüfen",
        "verified": "verifiziert",
        "updated": "verifiziert",
        "rejected": "abgelehnt",
        "outdated": "veraltet"
      },
      "filters": {
        "search": "Name oder Summary durchsuchen...",
        "clearFilters": "Filter zurücksetzen",
        "status": {
          "all": "Alle Status",
          "placeholder": "Status"
        },
        "knowledgeArea": {
          "all": "Alle Bereiche",
          "placeholder": "Knowledge Area"
        },
        "entityType": {
          "all": "Alle Typen",
          "placeholder": "Entity Type"
        }
      },
      "table": {
        "name": "Name",
        "type": "Type",
        "summary": "Summary",
        "area": "Area",
        "status": "Status",
        "updated": "Zuletzt geändert",
        "actions": "Aktionen",
        "noEntities": "Keine Entities gefunden",
        "noSummary": "Kein Summary",
        "reviewedBy": "von {{reviewer}}"
      },
      "actions": {
        "verify": "Verifizieren",
        "reject": "Ablehnen",
        "edit": "Bearbeiten"
      },
      "dialog": {
        "title": "Entity bearbeiten",
        "originalName": "Original Name",
        "entityName": "Entity Name",
        "namePlaceholder": "Entity-Name...",
        "originalSummary": "Original Summary",
        "entitySummary": "Entity Summary",
        "summaryPlaceholder": "Entity-Summary...",
        "contentChangedWarning": "Name oder Summary wurde geändert. Status wird automatisch auf \"Bearbeitet\" gesetzt. Das Original wird in original_name und original_summary gespeichert.",
        "status": "Status",
        "notes": "Review Notizen (optional)",
        "outgoingRelationships": "Ausgehende Beziehungen",
        "incomingRelationships": "Eingehende Beziehungen",
        "relatedQA": "Verbundene Q&A Paare",
        "relatedDocs": "Verbundene Dokumente",
        "cancel": "Abbrechen",
        "save": "Änderungen speichern",
        "saving": "Speichern...",
        "type": "Typ",
        "targetType": "Zieltyp",
        "sourceType": "Quelltyp",
        "characters": "{{count}} Zeichen",
        "statusOpen": "🟡 Offen – noch nicht geprüft",
        "statusVerified": "🟢 Verifiziert – bestätigt und korrekt",
        "statusUpdated": "🔵 Bearbeitet – Name/Summary wurde angepasst",
        "statusUpdatedHint": "(nur verfügbar, wenn Name oder Summary geändert wurde)",
        "statusRejected": "🔴 Abgelehnt – Entity ist nicht korrekt/verwendbar",
        "notesPlaceholder": "Optionale Notizen zur Änderung...",
        "moreItems": "... und {{count}} weitere",
        "unknownDocument": "Unbekanntes Dokument"
      }
    },
    "viewers": {
      "pdfViewer": "PDF Viewer",
      "multimedia": "Multimedia Player",
      "filePreview": "Dateivorschau",
      "download": "Herunterladen",
      "noViewer": "Kein Viewer verfügbar"
    },
    "blocksBrowser": {
      "search": {
        "placeholder": "Q&A oder Entities durchsuchen..."
      },
      "knowledgeBlock": "Knowledge Block",
      "knowledgeBlocksList": "Knowledge Blocks",
      "blocks": "Blocks",
      "noBlocks": "Keine Knowledge Blocks gefunden",
      "noBlocksHint": "Passen Sie die Filter an oder verarbeiten Sie Dokumente",
      "noSelection": "Kein Knowledge Block ausgewählt",
      "selectBlock": "Wählen Sie einen Knowledge Block aus der Liste, um Details anzuzeigen",
      "loadingBlocks": "Lade Knowledge Blocks...",
      "loadingBlock": "Lade Knowledge Block...",
      "expandAll": "Alle öffnen",
      "collapseAll": "Alle schließen",
      "facts": "Facts",
      "entities": "Entities",
      "verified": "verifiziert",
      "totalProgress": "Gesamt-Fortschritt",
      "expand": "{{count}} Entities anzeigen",
      "qaPair": "Q&A Paar",
      "viewFile": "Datei anzeigen",
      "edit": "Bearbeiten",
      "verify": "Verifizieren",
      "reject": "Ablehnen",
      "question": "Frage",
      "answer": "Antwort",
      "document": "Dokument",
      "chunk": "Chunk",
      "fact": "Fact"
    },
    "allAreas": "Alle Bereiche",
    "entityCount": "{{count}} Entity",
    "entityCount_plural": "{{count}} Entities",
    "errors": {
      "loadFacts": "Facts konnten nicht geladen werden",
      "verifyFact": "Fact konnte nicht verifiziert werden",
      "rejectFact": "Fact konnte nicht abgelehnt werden",
      "updateFact": "Fact konnte nicht aktualisiert werden",
      "loadEntities": "Entities konnten nicht geladen werden",
      "verifyEntity": "Entity konnte nicht verifiziert werden",
      "rejectEntity": "Entity konnte nicht abgelehnt werden",
      "updateEntity": "Entity konnte nicht aktualisiert werden"
    },
    "excel": {
      "wizard": {
        "title": "Excel Import Konfiguration",
        "subtitle": "Konfigurieren Sie, wie die Excel-Daten in den Knowledge Graph importiert werden sollen.",
        "steps": {
          "mapping": "Mapping",
          "sheets": "Sheets",
          "relationships": "Beziehungen",
          "description": "Beschreibung",
          "review": "Übersicht"
        }
      },
      "mappingStep": {
        "title": "Mapping auswählen",
        "description": "Wählen Sie ein bestehendes Mapping oder erstellen Sie ein neues.",
        "newMapping": "Neues Mapping erstellen",
        "existingMapping": "Bestehendes Mapping verwenden",
        "selectMapping": "Mapping auswählen...",
        "noMappingsAvailable": "Keine Mappings für diese Knowledge Area verfügbar.",
        "headerRow": "Header-Zeile",
        "headerRowHint": "Zeilenindex der Spaltenüberschriften (0 = erste Zeile)",
        "deleteConfirm": "Mapping „{{name}}“ wirklich löschen?"
      },
      "sheetStep": {
        "title": "Sheets konfigurieren",
        "description": "Konfigurieren Sie jeden Sheet, der importiert werden soll.",
        "enableSheet": "Sheet importieren",
        "disabledSheet": "Deaktiviert",
        "entityType": "Entity-Typ",
        "entityTypeHint": "Name des Node-Labels in Neo4j",
        "primaryKey": "Primary Key Spalten",
        "primaryKeyHint": "Spalte(n), die jeden Datensatz eindeutig identifizieren. Mehrere Spalten für Composite Key.",
        "selectPrimaryKeyColumns": "Spalten für Primary Key auswählen...",
        "nameTemplate": "Name-Template",
        "nameTemplateHint": "Template für den Node-Namen, z.B. {Nr}: {Beschreibung}",
        "nameTemplatePlaceholder": "{Spalte1}: {Spalte2}",
        "groupId": "Knowledge Area",
        "groupIdHint": "Knowledge Area, der die Daten zugeordnet werden",
        "selectKnowledgeArea": "Knowledge Area auswählen...",
        "generateEmbeddings": "Embeddings generieren",
        "generateEmbeddingsHint": "Vektoreinbettungen für semantische Suche erstellen",
        "sampleData": "Beispieldaten",
        "hideSampleData": "Beispieldaten ausblenden",
        "rowCount": "{{count}} Zeilen",
        "columns": "{{count}} Spalten",
        "noSheetsEnabled": "Mindestens ein Sheet muss aktiviert sein.",
        "searchColumn": "Spalte suchen..."
      },
      "relationshipStep": {
        "title": "Beziehungen definieren",
        "description": "Definieren Sie Beziehungen zwischen den Sheets oder zu externen Entities.",
        "addRelationship": "Beziehung hinzufügen",
        "editRelationship": "Beziehung bearbeiten",
        "deleteRelationship": "Beziehung löschen",
        "sourceSheet": "Quell-Sheet",
        "sourceColumn": "FK-Spalte",
        "sourceColumnHint": "Spalte mit dem Fremdschlüssel",
        "targetSheet": "Ziel-Sheet",
        "externalReference": "Externe Referenz",
        "externalType": "Externer Entity-Typ",
        "externalTypeHint": "Entity-Typ, der in einem anderen Import existiert",
        "targetColumn": "PK-Spalte",
        "targetColumnHint": "Primary Key Spalte im Ziel",
        "relationshipType": "Beziehungstyp",
        "relationshipTypeHint": "Name der Beziehung in Neo4j, z.B. HAT_WERKSTOFF",
        "noRelationships": "Keine Beziehungen definiert.",
        "noRelationshipsHint": "Beziehungen sind optional. Sie können diesen Schritt überspringen.",
        "crossExcelNote": "Diese Beziehung verweist auf einen externen Entity-Typ.",
        "externalTypePlaceholder": "z. B. Werkstoff",
        "targetColumnPlaceholder": "z. B. Code",
        "relationshipTypePlaceholder": "HAT_WERKSTOFF"
      },
      "descriptionStep": {
        "title": "Dataset-Beschreibung",
        "description": "Optional: Geben Sie eine Beschreibung für diesen Upload an. Diese wird als Attribut in jede erstellte Node eingebettet."
      },
      "reviewStep": {
        "title": "Konfiguration prüfen",
        "description": "Prüfen Sie Ihre Konfiguration und starten Sie den Import.",
        "sheetsTab": "Sheets ({{count}})",
        "relationshipsTab": "Beziehungen ({{count}})",
        "configTab": "JSON Konfiguration",
        "saveMapping": "Mapping für zukünftige Uploads speichern",
        "mappingName": "Mapping-Name",
        "mappingNamePlaceholder": "z.B. Produktkatalog-Mapping",
        "mappingNameRequired": "Mapping-Name ist erforderlich wenn gespeichert werden soll.",
        "mappingDescription": "Beschreibung (optional)",
        "mappingDescriptionPlaceholder": "Kurze Beschreibung des Mappings",
        "uploadDescription": "Dataset-Beschreibung",
        "uploadDescriptionPlaceholder": "z.B. Hochdruck-Kreiselpumpen aus dem Produktkatalog 2024",
        "uploadDescriptionHint": "Wird als Attribut in jede erstellte Node eingebettet (optional, max. 1000 Zeichen)",
        "generateEmbeddings": "Embeddings für TL 3 Vector Search generieren",
        "generateEmbeddingsDescription": "Aktiviert semantische Suche in Excel-Daten via TL 3",
        "summary": {
          "title": "Zusammenfassung",
          "sheets": "{{count}} Sheet(s) werden importiert",
          "relationships": "{{count}} Beziehung(en) werden erstellt",
          "embeddings": "Embeddings: {{status}}",
          "embeddingsEnabled": "Ja ({{count}} Entity-Typen)",
          "embeddingsDisabled": "Nein",
          "embeddingsAuto": "TL3 Embeddings: automatisch aktiviert für alle Sheets"
        }
      },
      "actions": {
        "back": "Zurück",
        "next": "Weiter",
        "process": "Excel verarbeiten",
        "cancel": "Abbrechen",
        "save": "Speichern",
        "loadMapping": "Mapping laden"
      },
      "validation": {
        "primaryKeyRequired": "Primary Key Spalte ist erforderlich.",
        "entityTypeRequired": "Entity-Typ ist erforderlich.",
        "atLeastOneSheet": "Mindestens ein Sheet muss aktiviert sein.",
        "relationshipIncomplete": "Alle Felder einer Beziehung müssen ausgefüllt sein.",
        "mappingNameRequired": "Mapping-Name ist erforderlich.",
        "invalidEntityType": "Entity-Typ darf nur Buchstaben, Zahlen und Unterstriche enthalten."
      },
      "process": {
        "starting": "Import wird gestartet...",
        "success": "Excel-Import wurde gestartet",
        "successDescription": "Der Import läuft im Hintergrund. Sie können den Fortschritt in der Job-Übersicht verfolgen.",
        "completed": "Excel-Import abgeschlossen",
        "error": "Fehler beim Starten des Imports",
        "errorDescription": "Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
        "completedDescription": "{{nodes}} Nodes, {{relationships}} Beziehungen",
        "queuedDescription": "Import-Job {{job}}... wurde eingeplant.",
        "mappingCreated": "Mapping erstellt",
        "mappingCreatedDescription": "Mapping „{{name}}“ wurde erstellt.",
        "mappingDeleted": "Mapping gelöscht",
        "mappingDeletedDescription": "Das Mapping wurde gelöscht."
      },
      "preview": {
        "loading": "Excel-Datei wird analysiert...",
        "error": "Fehler beim Lesen der Excel-Datei",
        "fileInfo": "{{sheets}} Sheets, {{size}}"
      },
      "fileDetected": {
        "title": "Excel/CSV-Datei erkannt",
        "description": "Die ausgewählte Datei ist eine Excel- oder CSV-Datei. Möchten Sie den Import-Wizard starten?",
        "startWizard": "Import-Wizard starten",
        "cancel": "Abbrechen"
      }
    },
    "qaBrowser": {
      "status": {
        "open": "Offen"
      }
    },
    "loadMore": "Weitere {{amount}} laden",
    "pageSizeLabel": "Dokumente pro Seite",
    "pageSizeValue": "{{amount}} pro Seite",
    "shell": {
      "navLabel": "Bereiche des Knowledge Extractors",
      "nav": {
        "start": "Start",
        "contents": "Inhalte im Brain",
        "drafts": "Entwürfe",
        "addGroup": "Neu hinzufügen",
        "upload": "Dateien hochladen",
        "record": "Audio aufnehmen"
      },
      "start": {
        "title": "Was möchten Sie heute in Wissen umwandeln?",
        "subtitle": "Wählen Sie eine Quelle. Die CDB zieht daraus Aussagen heraus, die Sie anschließend im Knowledge Verifier prüfen.",
        "uploadTitle": "Dateien hochladen",
        "uploadBody": "Dokumente, Excel-Tabellen, Bilder und Videos. Audiodateien werden als Entwurf transkribiert. Mehrere Dateien oder ganze Ordner; große Dateien laden in Blöcken.",
        "uploadAction": "Dateien auswählen",
        "recordTitle": "Audio aufnehmen",
        "recordBody": "Experteninterview, Besprechung oder Diktat. Die Aufnahme wird transkribiert; Sie prüfen das Transkript und übernehmen es ins Brain.",
        "recordAction": "Aufnahme vorbereiten",
        "status": "Status",
        "inProgress": "In Verarbeitung",
        "draftsReady": "Entwürfe bereit zur Übernahme",
        "failed": "Fehlgeschlagen",
        "recent": "Zuletzt hinzugefügt",
        "showAll": "Alle Inhalte anzeigen",
        "docStatus": {
          "pending": "Ausstehend",
          "uploaded": "Hochgeladen",
          "processing": "In Verarbeitung",
          "markdown_ready": "In Verarbeitung",
          "completed": "Fertig",
          "failed": "Fehlgeschlagen"
        },
        "eyebrow": "Knowledge Extractor"
      },
      "expand": "Seitenleiste ausklappen",
      "collapse": "Seitenleiste einklappen",
      "quota": "Extractor-Kontingent",
      "quotaValue": "{{percent}} % in diesem Monat"
    },
    "drafts": {
      "count": "Entwürfe ({{count}})",
      "inControl_one": "{{count}} Aufgabe in cdbControl",
      "inControl_other": "{{count}} Aufgaben in cdbControl",
      "emptyTitle": "Keine Entwürfe",
      "emptyBody": "Alle Aufnahmen sind im Brain. Neue Aufnahmen erscheinen hier, bis Sie sie übernehmen.",
      "step": {
        "recorded": "Aufgenommen",
        "transcribed": "Transkribiert",
        "edited": "Bearbeitet",
        "inBrain": "Im Brain"
      },
      "subtitle": "Ihre Aufnahmen, die noch nicht im Brain sind; nur Sie sehen sie. Nach der Übernahme finden alle mit Zugriff auf den Wissensbereich sie unter „Inhalte im Brain“.",
      "newRecording": "Neue Aufnahme",
      "privateHint": "Nur für Sie sichtbar, bis Sie den Entwurf ins Brain übernehmen",
      "stand": "Stand",
      "stepDone": "(erledigt)",
      "stepCurrent": "(aktuell)",
      "excerpt": "Transkript (Auszug)",
      "waitingBody": "Das Transkript erscheint hier, sobald die Transkription fertig ist. Sie können das Fenster schließen.",
      "failedBody": "Die Transkription ist fehlgeschlagen. Die Aufnahme selbst ist gespeichert.",
      "recordedBody": "Noch kein Transkript. Starten Sie die Transkription, um den Text zu prüfen und zu übernehmen.",
      "fileTitle": "Ins Brain übernehmen",
      "fileArea": "Wissensbereich",
      "fileDocTitle": "Titel des Dokuments",
      "fileAction": "Ins Brain übernehmen",
      "editTranscript": "Transkript bearbeiten",
      "deriveTasks": "Aufgaben ableiten"
    },
    "record": {
      "showDrafts": "Zu den Entwürfen",
      "fileHint": "Liegt die Aufnahme schon als Datei vor?"
    },
    "contents": {
      "count": "{{shown}} von {{total}}",
      "draftsHintBefore": "Aufnahmen, die noch nicht übernommen sind, finden Sie unter",
      "draftsHintAfter": ".",
      "statements_one": "{{count}} Aussage",
      "statements_other": "{{count}} Aussagen",
      "column": {
        "title": "Titel",
        "type": "Typ",
        "area": "Wissensbereich",
        "status": "Status",
        "date": "Datum"
      },
      "kind": {
        "pdf": "PDF",
        "word": "Word",
        "powerpoint": "PowerPoint",
        "excel": "Excel",
        "image": "Bild",
        "audio": "Audio",
        "video": "Video",
        "web": "Webseite",
        "text": "Text",
        "other": "Datei"
      },
      "review": "Prüfen",
      "retry": "Erneut verarbeiten",
      "typeFilter": {
        "label": "Typ",
        "all": "Alle",
        "document": "Dokumente",
        "image": "Bilder",
        "video": "Videos"
      }
    },
    "uploadPage": {
      "dropTitle": "Dateien hierher ziehen",
      "formats": "Dokumente (PDF, Word, PowerPoint, HTML, Text), Excel, Bilder und Videos. Audiodateien (MP3, M4A, WAV …) werden als Entwurf angelegt und transkribiert. Videos und Dateien über 95 MB laden in Blöcken.",
      "nextTitle": "So geht es weiter",
      "next": {
        "convert": "Die CDB wandelt jede Datei in Text um. Audio und Video werden transkribiert, Videos zusätzlich mit Standbildern.",
        "extract": "Daraus entstehen Aussagen und Verknüpfungen im Wissensbereich.",
        "review": "Sie prüfen die Aussagen im Knowledge Verifier."
      },
      "selected_one": "{{count}} Datei ausgewählt",
      "selected_other": "{{count}} Dateien ausgewählt",
      "audioGroup_one": "{{count}} Audiodatei: wird ein Entwurf",
      "audioGroup_other": "{{count}} Audiodateien: werden Entwürfe",
      "audioHint": "wird als Entwurf angelegt und transkribiert",
      "audioRemove": "{{name}} entfernen",
      "audioNoClient": "Ihrem Konto ist kein Client zugeordnet; Audiodateien lassen sich so nicht anlegen.",
      "audioDone_one": "Die Audiodatei ist unter Entwürfe und wird transkribiert.",
      "audioDone_other": "{{count}} Audiodateien sind unter Entwürfe und werden transkribiert.",
      "audioFailed_one": "Eine Audiodatei ließ sich nicht hochladen. Sie steht noch in der Liste.",
      "audioFailed_other": "{{count}} Audiodateien ließen sich nicht hochladen. Sie stehen noch in der Liste."
    },
    "editor": {
      "aiBadge": "KI",
      "back": "Zurück",
      "backToDrafts": "Zurück zu den Entwürfen",
      "cancel": "Abbrechen",
      "retry": "Erneut versuchen",
      "loading": "Entwurf wird geladen …",
      "noTranscript": "Noch kein Transkript. Starten Sie die Transkription unter „Entwürfe“.",
      "private": "nur für Sie sichtbar",
      "recordedOn": "Aufgenommen am {{date}}",
      "speakers_one": "{{count}} Sprecher",
      "speakers_other": "{{count}} Sprecher",
      "saved": "Gespeichert",
      "savedVersion": "Gespeichert · Version {{version}}",
      "saving": "Wird gespeichert …",
      "unsaved": "Ungespeicherte Änderungen",
      "saveFailed": "Die Änderungen konnten nicht gespeichert werden.",
      "conflict": {
        "changedElsewhere": "Das Transkript wurde in einem anderen Fenster geändert. „Neu laden“ verwirft Ihre letzten Änderungen hier, „Meine Fassung übernehmen“ macht sie zur neuen Version. Der andere Stand bleibt im Verlauf.",
        "inBrain": "Liegt schon im Brain. Änderungen hier werden nicht mehr gespeichert.",
        "reload": "Neu laden",
        "keepMine": "Meine Fassung übernehmen",
        "summaryChanged": "Die Zusammenfassung wurde in einem anderen Fenster geändert. Hier sehen Sie jetzt den neuen Stand. Bitte prüfen Sie ihn und übernehmen Sie dann erneut.",
        "reloadFailed": "Das Transkript konnte nicht neu geladen werden."
      },
      "saveFailedRetry": "Speichern fehlgeschlagen · erneut versuchen",
      "versionN": "Version {{version}}",
      "currentVersion": "aktuelle Version",
      "trackKnowledge": "Wissen",
      "trackTasks": "Aufgaben",
      "tools": "Werkzeuge",
      "tab": {
        "tasks": "Aufgaben",
        "assist": "Assistent"
      },
      "player": {
        "play": "Abspielen",
        "pause": "Pause",
        "position": "Position in der Aufnahme",
        "speed": "Geschwindigkeit {{speed}}-fach",
        "failed": "Die Aufnahme konnte nicht geladen werden."
      },
      "transcript": {
        "jumpTo": "Ab {{time}} abspielen",
        "editPassage": "Abschnitt bearbeiten",
        "clickToEdit": "Zum Bearbeiten klicken",
        "taskChip": "Aufgabe {{number}}",
        "hint": "Text direkt bearbeiten · Zeitstempel spielt die Aufnahme ab dort · Änderungen speichern sich selbst",
        "hintNoTimes": "Text direkt bearbeiten · Änderungen speichern sich selbst · Dieses Transkript ist älter und hat keine Zeitstempel"
      },
      "tasks": {
        "intro": "Aus dem Gespräch vorgeschlagen. Jede Aufgabe verweist auf ihre Stelle; Sie entscheiden, welche bleiben.",
        "extracting": "Aufgaben werden aus dem Gespräch gelesen …",
        "none": "Im Gespräch wurden keine Aufgaben gefunden.",
        "failed": "Die Aufgaben konnten nicht vorgeschlagen werden. Versuchen Sie es erneut.",
        "loadFailed": "Die Aufgaben konnten nicht geladen werden.",
        "saveFailed": "Die Aufgabe konnte nicht gespeichert werden.",
        "state": {
          "proposed": "Vorschlag",
          "accepted": "Übernommen",
          "dropped": "Verworfen"
        },
        "source": "Quelle",
        "due": "Fällig",
        "noDue": "Kein Termin genannt",
        "dueFrom": "{{date}} (aus „{{hint}}“)",
        "manual": "Selbst angelegt",
        "noSource": "Ohne Zeitstempel",
        "accept": "Übernehmen",
        "edit": "Bearbeiten",
        "drop": "Verwerfen",
        "undo": "Rückgängig",
        "save": "Speichern",
        "titleLabel": "Aufgabe",
        "dueLabel": "Fällig am",
        "add": "Aufgabe selbst anlegen",
        "again": "Neu vorschlagen",
        "send_one": "{{count}} Aufgabe an cdbControl senden",
        "send_other": "{{count}} Aufgaben an cdbControl senden",
        "sendHint": "Gesendet werden die übernommenen Aufgaben, die noch nicht in cdbControl sind. Dort sieht sie der ganze Mandant; geändert werden sie ab dann in cdbControl.",
        "stayHint": "Übernommene Aufgaben bleiben an der Aufnahme.",
        "sent_one": "{{count}} Aufgabe an cdbControl gesendet",
        "sent_other": "{{count}} Aufgaben an cdbControl gesendet",
        "sendFailed_one": "{{count}} Aufgabe konnte nicht gesendet werden. Versuchen Sie es erneut.",
        "sendFailed_other": "{{count}} Aufgaben konnten nicht gesendet werden. Versuchen Sie es erneut.",
        "inControl": "In cdbControl",
        "openInControl": "In cdbControl öffnen",
        "assignee": "Zuständig",
        "unassigned": "Niemand zugewiesen",
        "countProposed": "{{count}} vorgeschlagen",
        "countAccepted": "{{count}} übernommen"
      },
      "file": {
        "title": "Ins Brain übernehmen",
        "savedState": "Übernommen wird der gespeicherte Stand ({{version}}). Ungespeicherte Änderungen werden vorher gespeichert.",
        "summaryHeading": "Zusammenfassung",
        "transcriptHeading": "Transkript",
        "summarizing": "Zusammenfassung wird erstellt …",
        "summaryFailed": "Die Zusammenfassung konnte nicht erstellt werden.",
        "summarySaveFailed": "Die Zusammenfassung konnte nicht gespeichert werden.",
        "regenerate": "Zusammenfassung neu erstellen",
        "goes": "Geht ins Brain",
        "stays": "Bleibt hier",
        "goesSummary": "Zusammenfassung (KI, von Ihnen geprüft)",
        "goesTranscript": "Transkript mit Sprechern und Zeitstempeln, inkl. Ihrer Änderungen",
        "staysTranscript": "Das Transkript (bleibt beim Entwurf, nur für Sie)",
        "staysTasks": "Aufgaben",
        "staysSuggestions": "Nicht übernommene Vorschläge",
        "staysAudio": "Die Audiodatei",
        "chooseArea": "Wissensbereich wählen",
        "areaAudience": "Danach sehen es alle mit Zugriff auf „{{area}}“.",
        "areaRequired": "Wählen Sie einen Wissensbereich, um zu übernehmen.",
        "docTitle": "Titel im Brain",
        "afterHint": "Danach liegt das Gespräch unter „Inhalte im Brain“.",
        "outdated": "Die Zusammenfassung stammt von einem älteren Stand des Transkripts und enthält neuere Änderungen nicht. Trotzdem übernehmen?",
        "action": "Übernehmen",
        "actionAnyway": "Trotzdem übernehmen",
        "filed": "Ins Brain übernommen: {{area}}",
        "titleWithChoice": "Ins Brain übernehmen · {{choice}}",
        "choice": {
          "summary": "nur Zusammenfassung",
          "transcript": "nur Transkript",
          "both": "Zusammenfassung + Transkript",
          "none": "nichts ausgewählt"
        },
        "bothOneDocument": "Beides als ein Dokument. Die Auswahl ändern Sie an den Blöcken links.",
        "changeChoice": "Die Auswahl ändern Sie an den Blöcken links.",
        "nothingChosen": "Nichts ausgewählt: Haken Sie links die Zusammenfassung, das Transkript oder beides an."
      },
      "toBrain": "Ins Brain",
      "summary": {
        "current": "passt zum Transkript",
        "currentVersion": "passt zum Transkript (Version {{version}})",
        "updating": "wird noch aktualisiert",
        "updatingHint": "Wird an das geänderte Transkript angepasst …",
        "failed": "nicht aktualisiert",
        "edited": "von Ihnen bearbeitet",
        "stale": "Das Transkript hat sich geändert, seit die Zusammenfassung bearbeitet wurde. „Neu erstellen“ ersetzt Ihre Fassung.",
        "regenerate": "Neu erstellen",
        "keep": "So lassen",
        "back": "Zurück",
        "backHint": "Zurück zu Ihrer bearbeiteten Fassung",
        "backFailed": "Ihre Fassung konnte nicht zurückgeholt werden.",
        "collapse": "Zusammenfassung einklappen",
        "expand": "Zusammenfassung aufklappen"
      },
      "proposal": {
        "badge": "KI-Vorschlag",
        "apply": "Übernehmen",
        "before": "Vorher",
        "after": "Nachher",
        "view": "Ansicht des Vorschlags",
        "onlyChanged": "Nur geänderte Absätze",
        "transcriptDetail": "{{action}} · {{changes}} Änderungen in {{passages}} von {{total}} Absätzen",
        "hidden": "{{count}} unveränderte Absätze ausgeblendet",
        "dropped": "Der Text hat sich geändert. Der Vorschlag passt nicht mehr, erstellen Sie ihn bei Bedarf neu."
      }
    },
    "filterInProgress": "In Verarbeitung",
    "filterFailed": "Fehlgeschlagen"
  },
  "tokenUsage": {
    "dashboard": {
      "period": "Zeitraum",
      "lastDays": "{{n}} T",
      "removeFilter": "Filter entfernen",
      "clearAll": "Alle löschen",
      "exportCsv": "CSV-Export",
      "custom": "Benutzerdefiniert",
      "fromDate": "Von",
      "toDate": "Bis",
      "pivotTitle": "Modell × Kunde",
      "filters": "Filter",
      "noFilters": "Keine — Segment anklicken zum Filtern",
      "loadError": "Daten konnten nicht geladen werden.",
      "retry": "Erneut versuchen",
      "metricTokens": "Tokens",
      "metricCost": "Kosten",
      "other": "Andere"
    },
    "dimensions": {
      "model": "Modell",
      "provider": "Provider",
      "source": "Quelle",
      "client_id": "Kunde",
      "user_id": "Benutzer",
      "knowledge_area": "Knowledge Area",
      "call_type": "Tätigkeit",
      "day": "Tag"
    },
    "title": "Token Usage",
    "subtitle": "LLM Token-Verbrauch & Kosten",
    "period": "Zeitraum",
    "days7": "7 Tage",
    "days30": "30 Tage",
    "days90": "90 Tage",
    "currentMonth": "Aktueller Monat",
    "allClients": "Alle Kunden",
    "lastUpdated": "Aktualisiert vor {{minutes}} Min.",
    "justUpdated": "Gerade aktualisiert",
    "refresh": "Aktualisieren",
    "pricing": {
      "refreshPrices": "Preise aktualisieren",
      "refreshed": "Preise aktualisiert: {{updated}}, übersprungen: {{skipped}}",
      "refreshFailed": "Preis-Aktualisierung fehlgeschlagen"
    },
    "refreshing": "Wird aktualisiert...",
    "tabs": {
      "overview": "Übersicht",
      "byUser": "Client-Nutzung",
      "clients": "Kunden",
      "user": "Nutzer",
      "limits": "Limits",
      "backendLimits": "Backend-Limits",
      "apiLimits": "Client-API-Limits",
      "quotaRequests": "Anfragen"
    },
    "month": {
      "prev": "Vorheriger Monat",
      "next": "Nächster Monat",
      "pick": "Monat wählen"
    },
    "mode": {
      "frontend": "Frontend",
      "backend": "Backend"
    },
    "my": {
      "chatTitle": "Meine Chat-Tokens (diesen Monat)",
      "backendTitle": "Meine Dokument-Tokens (diesen Monat)",
      "limitLabel": "Limit",
      "noLimit": "Kein Limit",
      "overLimit": "Limit überschritten",
      "requests": "Anfragen",
      "requestsLabel": "API-Aufrufe",
      "requests_one": "{{count}} Anfrage",
      "requests_other": "{{count}} Anfragen",
      "errorTitle": "Token-Nutzung konnte nicht geladen werden",
      "errorMessage": "Der Token-Nutzungsdienst ist nicht erreichbar. Bitte erneut versuchen."
    },
    "summary": {
      "totalTokens": "Tokens gesamt",
      "totalCost": "Kosten (USD)",
      "totalRequests": "API-Aufrufe",
      "topModel": "Top-Modell"
    },
    "charts": {
      "trendByModel": "Verbrauch über Zeit nach Modell",
      "perModel": "Je Modell",
      "perClient": "Je Kunde",
      "perKnowledgeArea": "Je Wissensbereich",
      "topConsumers": "Top {{dim}}",
      "usage": "Verbrauch",
      "noData": "Keine Daten für diesen Zeitraum",
      "heatmapHint": "Farbintensität = Anteil an der stärksten Zelle.",
      "dailyTrend": "Täglicher Verlauf",
      "byModel": "Nach Modell",
      "byCallType": "Nach Aufruftyp",
      "bySource": "Nach Quelle",
      "byActivity": "Nach Tätigkeit",
      "tokens": "Tokens",
      "cost": "Kosten",
      "requests": "Aufrufe",
      "clientUsageBySource": "Client-Nutzung: Chat vs Backend",
      "userUsageBySource": "Benutzer-Nutzung: Chat vs Backend",
      "perCallType": "Nach Tätigkeit"
    },
    "tables": {
      "byClient": "Nach Kunde",
      "byKnowledgeArea": "Nach Knowledge Area",
      "byUser": "Token-Verbrauch nach Benutzer",
      "combinedClientUsage": "Kombinierte Client-Nutzung (alle Aufruftypen)",
      "tokenLimits": "Token-Limits",
      "clientLimits": "Chat-Client-Limits",
      "backendClientLimits": "Backend-Client-Limits",
      "client": "Kunde",
      "user": "Benutzer",
      "knowledgeArea": "Knowledge Area",
      "tokens": "Tokens",
      "cost": "Kosten (USD)",
      "requests": "Aufrufe",
      "knowledgeAreas": "Knowledge Areas",
      "noData": "Keine Daten für den gewählten Zeitraum.",
      "role": "Rolle",
      "limit": "Monatliches Limit",
      "used": "Diesen Monat verwendet",
      "remaining": "Verbleibend",
      "usage": "Nutzung %",
      "status": "Status",
      "percentage": "% des Kunden"
    },
    "byUser": {
      "period": "Aktueller Monat",
      "totalUsers": "{{count}} von {{total}} Benutzern",
      "searchPlaceholder": "Benutzer suchen...",
      "allRoles": "Alle Rollen",
      "admins": "Admins",
      "supervisors": "Supervisoren",
      "users": "Benutzer"
    },
    "limits": {
      "exceeded": "Überschritten",
      "warning": "Warnung",
      "normal": "Normal",
      "unlimited": "Unbegrenzt",
      "actions": "Aktionen",
      "setLimit": "Limit festlegen",
      "setCostLimit": "Kostenlimit",
      "warningThreshold": "Warnschwelle",
      "active": "Aktiv",
      "save": "Speichern",
      "cancel": "Abbrechen",
      "edit": "Bearbeiten",
      "remove": "Entfernen",
      "userLimits": "Benutzer-Limits",
      "noUserLimits": "Keine Benutzer gefunden.",
      "setUserLimit": "Benutzer-Limit festlegen",
      "clientLimitApplies": "Client-Limit: {{limit}}",
      "userLimitRemoveConfirm": "Chat-Token-Limit für {{user}} entfernen? Das Client-Chat-Limit gilt weiterhin.",
      "inheritsClientLimit": "Erbt Client-Limit",
      "noExplicitLimit": "Kein Limit gesetzt",
      "searchUsers": "Benutzer suchen...",
      "showingUsers": "{{shown}} von {{total}} Benutzern",
      "assigned": "Gesamtlimit",
      "remaining": "Verbleibend",
      "allocatedToUsers": "An Benutzer vergeben",
      "unallocated": "Nicht vergeben",
      "limitSaved": "Limit gespeichert",
      "saveFailed": "Limit konnte nicht gespeichert werden",
      "limitRemoved": "Limit entfernt",
      "removeFailed": "Limit konnte nicht entfernt werden",
      "noLimitsConfigured": "Es sind noch keine Chat-Token-Limits konfiguriert.",
      "infoTitle": "Chat-Aufruftypen",
      "infoDescription": "Chat-Limits gelten für interaktive KI-Operationen: Chat-Streaming, Vektorsuche, GraphRAG, Websuche, Sprach-Sessions und Query-Verarbeitung.",
      "grantedThisMonth": "Zusätzlich gewährt für diesen Monat"
    },
    "backendLimits": {
      "userLimits": "Benutzer-Backend-Limits",
      "noLimitsConfigured": "Es sind noch keine Backend-Token-Limits konfiguriert.",
      "infoTitle": "Backend-Aufruftypen",
      "infoDescription": "Backend-Limits gelten für alle Backend-Ingestion- und Verarbeitungsvorgänge: Dokument-Embedding (Batch & Einzel), Wissensgraph-Extraktion (Graphiti), RAG-Pipeline & DB-Ingestion, QA-Paar-Generierung, Neo4j-QA-Generierung und Audio-Transkription (Standard & Chunked). Diese decken den gesamten Dokument-Lebenszyklus ab — Upload, Chunking, Embedding, KG-Extraktion, QA-Erstellung und Indexierung.",
      "callTypes": "Enthaltene Aufruftypen",
      "removeConfirm": "Möchten Sie das Backend-Token-Limit für {{client}} wirklich entfernen?",
      "userLimitRemoveConfirm": "Backend-Token-Limit für {{user}} entfernen? Das Client-Backend-Limit gilt weiterhin."
    },
    "apiLimits": {
      "chatLimits": "API-Chat-Limits",
      "backendLimits": "API-Backend-Limits",
      "noLimitsConfigured": "Es sind noch keine API-Token-Limits konfiguriert.",
      "infoDescription": "API-Token-Limits sind unabhängig von Benutzer-/Chat-Limits. Sie gelten für Chat-Anfragen über API-Keys und werden pro Client konfiguriert.",
      "removeConfirm": "Möchten Sie das API-Token-Limit für {{client}} wirklich entfernen?"
    },
    "callTypes": {
      "tw4_streaming": "TW4 Streaming",
      "tw3_vector_answer": "TW3 Vektor-Antwort",
      "tw2_harmonization": "TW2 Harmonisierung",
      "tw2_graph_rag": "TW2 Graph-RAG",
      "tw1_verified_rag": "TW1 Verifiziert",
      "websearch": "Web-Suche",
      "embedding": "Embedding",
      "embedding_batch": "Embedding (Batch)",
      "transcription": "Transkription",
      "transcription_chunked": "Transkription (Chunks)",
      "summary_streaming": "Zusammenfassung",
      "rag_pipeline": "RAG-Pipeline",
      "structured_retrieval": "Struct. Retrieval",
      "realtime_session": "Realtime Session",
      "graphiti_kg": "Knowledge Graph (Graphiti)",
      "qa_generation": "QA-Generierung (Chunks)",
      "qa_neo4j_generation": "QA-Generierung (Neo4j)",
      "training_question_assist": "Fragen-Assistent",
      "activity_import": "Fragebogen-Import (Markdown)",
      "activity_summary": "Umfrage-Zusammenfassung",
      "activity_sentiment": "Umfrage-Stimmung",
      "activity_themes": "Freitext-Themen (Umfrage)"
    },
    "sources": {
      "extractor": "Backend / Extractor",
      "other": "Sonstige",
      "training": "Training Hub"
    },
    "quota": {
      "title": "Offene Kontingent-Anfragen",
      "empty": "Keine offenen Anfragen.",
      "approve": "Genehmigen",
      "decline": "Ablehnen",
      "grant": "Kontingent vergeben",
      "escalate": "Client-Budget bei Admins anfragen",
      "escalated": "Anfrage an die Admins weitergegeben",
      "approved": "Kontingent vergeben",
      "declined": "Anfrage abgelehnt",
      "actionFailed": "Aktion fehlgeschlagen",
      "amountRequired": "Bitte einen Token- oder Kostenbetrag angeben",
      "bonusTokens": "Zusätzliche Tokens",
      "bonusCost": "Zusätzliches Budget (USD)",
      "consumed": "Verbraucht: {{tokens}} Tokens · {{cost}}",
      "clientRequest": "Client-Budget: {{client}}",
      "clientBudgetBlocks": "Das Client-Budget ist aufgebraucht — ein persönliches Kontingent hebt die Sperre nicht auf.",
      "adminOnly": "Nur Admins können das Client-Budget erhöhen.",
      "statusEscalated": "Bei Admins",
      "dimension": {
        "tokens": "Token-Limit",
        "cost": "Kostenlimit",
        "both": "Token- und Kostenlimit"
      },
      "linkedHint": "Token und Budget sind verknüpft — umgerechnet über den bisherigen Verbrauch dieser Person. Beide Felder lassen sich überschreiben.",
      "focus": {
        "approved": "Die Anfrage von {{name}} wurde am {{date}} bereits genehmigt.",
        "declined": "Die Anfrage von {{name}} wurde am {{date}} bereits abgelehnt.",
        "resolved": "Die Anfrage von {{name}} ist erledigt: Das Client-Budget wurde am {{date}} erhöht.",
        "decided": "Die Anfrage von {{name}} ist nicht mehr offen.",
        "missing": "Diese Anfrage ist nicht mehr verfügbar."
      }
    }
  },
  "realtime": {
    "title": "Sprachassistent",
    "openWidget": "Sprachassistent öffnen",
    "restoreWidget": "Sprachassistent wiederherstellen",
    "minimize": "Minimieren",
    "close": "Schließen",
    "user": "Sie",
    "assistant": "Assistent",
    "connect": "Verbinden",
    "disconnect": "Trennen",
    "mute": "Stumm",
    "unmute": "Ton an",
    "clearTranscript": "Löschen",
    "insertToSession": "In Session einfügen",
    "typeMessage": "Nachricht eingeben...",
    "sendMessage": "Nachricht senden",
    "error": "Fehler",
    "functionCall": "Funktionsaufruf",
    "connectTooltip": "Sprachkonversation mit KI-Assistent starten",
    "disconnectTooltip": "Sprachkonversation beenden",
    "clearTranscriptTooltip": "Gesprächsverlauf löschen",
    "insertToSessionTooltip": "Konversation in aktuelle Brain Session einfügen",
    "noTranscript": "Noch keine Konversation",
    "noTranscriptHint": "Sprechen Sie um eine Konversation zu starten",
    "insertedToSession": "In Brain Session eingefügt",
    "insertedToSessionHint": "Die Konversation wurde zu Ihrer aktuellen Session hinzugefügt",
    "connected": "Verbunden",
    "status": {
      "disconnected": "Getrennt",
      "connecting": "Verbinde...",
      "connected": "Verbunden",
      "listening": "Hört zu...",
      "speaking": "Spricht...",
      "processing": "Verarbeite..."
    },
    "waveform": {
      "idle": "Inaktiv",
      "ready": "Bereit",
      "listening": "Hört zu",
      "speaking": "KI spricht",
      "connectToStart": "Verbinden um Konversation zu starten"
    },
    "transcript": {
      "empty": {
        "disconnected": "Noch keine Konversation",
        "connected": "Beginnen Sie zu sprechen",
        "disconnectedHint": "Verbinden um eine Sprachkonversation zu starten",
        "connectedHint": "Die KI hört zu und wird auf Ihre Stimme antworten"
      }
    },
    "modal": {
      "title": "Konversation speichern?",
      "description": "Möchten Sie diese Konversation in Ihre Brain Session übertragen, bevor Sie die Verbindung trennen?",
      "transfer": "Übernehmen",
      "discard": "Verwerfen"
    }
  },
  "tour": {
    "controls": {
      "next": "Weiter",
      "prev": "Zurück",
      "done": "Fertig",
      "progress": "Schritt {{current}} von {{total}}"
    },
    "desktopIntro": {
      "startMenu": {
        "title": "Startmenü",
        "description": "Öffne Apps und Einstellungen über das Startmenü. Ein Klick auf das Raster zeigt alle installierten Anwendungen."
      },
      "desktop": {
        "title": "Desktop-Apps",
        "description": "Starte eine App mit einem Klick auf ihr Desktop-Symbol.",
        "detailButton": "Apps im Detail"
      },
      "taskbar": {
        "title": "Taskleiste",
        "description": "Die Taskleiste listet alle geöffneten Fenster. Ein Klick fokussiert ein Fenster, ein weiterer Klick minimiert es, halten Sie den Mauszeiger über ein Fenster-Symbol, um die verschiedenen Instanzen der gleichen App zu sehen."
      },
      "widgets": {
        "title": "Uhr & Widgets",
        "description": "Die Uhr öffnet den Widget-Bereich mit anpassbaren Widgets wie Kalender, Uhr, Benachrichtigungen und mehr."
      },
      "commandPalette": {
        "title": "Schnellzugriff",
        "description": "Öffne mit ⌘K (oder Strg K) den Schnellzugriff — durchsuche Apps, Dokumente und Chats. Von dort erreichst du auch Bug-Reports, Feature-Anfragen und den Changelog."
      },
      "notificationBell": {
        "title": "Benachrichtigungen",
        "description": "Hier siehst du alle systemweiten Benachrichtigungen, z. B. wenn dir eine App zugewiesen oder eine Session geteilt wurde."
      },
      "helpButton": {
        "title": "Tour-Hilfe",
        "description": "Nutze diesen Hilfe-Button, um die Tour jederzeit erneut zu starten oder zu beenden."
      },
      "cdbChat": {
        "title": "Fragen zur Oberfläche?",
        "description": "Bei Fragen zur Bedienung von cdb-webOS öffne cdbChat. Der \"cdbOS Guide\" Wissensbereich steht allen Nutzern zur Verfügung und beantwortet Fragen zur Oberfläche."
      }
    },
    "desktopAppsDetail": {
      "title": "{{app}}",
      "defaultDescription": "{{app}} geöffnet? Nutze das Symbol, um das Fenster zu fokussieren oder über das Kontextmenü weitere Aktionen auszuführen.",
      "next": "Weiter",
      "prev": "Zurück",
      "done": "Fertig",
      "progressText": "App {{current}} von {{total}}",
      "knowledgeHubDetailButton": "zur App",
      "descriptions": {
        "app-store": "Durchsuche alle verfügbaren Apps nach Kategorie und füge sie deinem Desktop hinzu.",
        "settings": "Passe Theme, Sprache, Desktop-Symbole und Taskleisten-Anzeige an deine Vorlieben an.",
        "cortex": "Verwalte Benutzer, Rollen, App-Berechtigungen, Knowledge Areas, Clients und Themes zentral in Cortex, der Administrationsoberfläche.",
        "ai-knowledge-extractor": "Lade Dokumente in eine Knowledge Area hoch und lasse Q&A-Paare, Fakten und Entitäten automatisch per KI extrahieren.",
        "knowledge-verifier": "Prüfe und verifiziere extrahierte Q&A-Paare, Fakten und Entitäten einer Knowledge Area und verwalte den Wissensgraphen.",
        "notes": "Diese App befindet sich in Entwicklung und wird in einem zukünftigen Update verfügbar sein.",
        "pdf-viewer": "Öffne PDF-Dokumente direkt im Fenster mit Seitennavigation, stufenlosem Zoom, Drag-to-Pan und Tastatur-Steuerung.",
        "multimedia": "Spiele Audio- und Videodateien aus deinen Knowledge Areas ab — mit Wiedergabesteuerung, Lautstärkeregler und Vollbildmodus.",
        "cdb-sessions": "Erstelle interaktive Quiz-Sessions mit Multiple Choice, Single Choice und Freitext-Fragen und spiele sie als Lerneinheiten ab.",
        "cdb-training": "Zwei Bereiche in einer App: Schulungen aus Materialien mit optionalem Quiz — und eigenständige Umfragen mit automatischer Auswertung.",
        "wissenshaus": "Wissensbereiche als 3D-Haus mit allem, was im Brain passiert ist",
        "harness": "Agent-Rollen prüfen Fakten, du gibst frei",
        "cdb-control": "Aufgaben des Mandanten aus Aufnahmen und von Hand"
      }
    }
  },
  "widgetBar": {
    "prompts": {
      "copy": "{{title}} kopieren",
      "share": "Teilen",
      "expand": "Prompts vergrößern",
      "collapse": "Detailansicht schließen",
      "panelLabel": "Prompts, Detailansicht",
      "new": "Neuer Prompt",
      "search": "Prompts durchsuchen",
      "noHits": "Keine Treffer",
      "empty": "Noch keine Prompts vorhanden.",
      "loadFailed": "Die Prompts konnten nicht geladen werden.",
      "retry": "Erneut versuchen",
      "toChat": "In den Chat übernehmen",
      "taken": "Prompt übernommen. Bitte prüfen, ergänzen und dann absenden.",
      "count_one": "Prompt",
      "count_other": "Prompts"
    },
    "voice": {
      "name": "Sprachassistent",
      "idleHint": "Fragen stellen oder Apps und Dokumente per Sprache öffnen.",
      "start": "Sprachassistent starten",
      "connecting": "Verbindung wird aufgebaut",
      "cancel": "Abbrechen",
      "listening": "Hört zu",
      "processing": "Verarbeitet",
      "processingShort": "Moment",
      "speaking": "Antwortet",
      "muted": "Stummgeschaltet",
      "mutedShort": "Stumm",
      "mutedText": "Das Mikrofon ist aus. Der Assistent hört nichts.",
      "listeningHint": "Sprechen Sie einfach los.",
      "mute": "Stummschalten",
      "unmute": "Mikrofon einschalten",
      "end": "Gespräch beenden",
      "errorMicTitle": "Kein Zugriff auf das Mikrofon",
      "errorMicText": "Bitte erlauben Sie das Mikrofon in Ihrem Browser.",
      "errorNetTitle": "Verbindung unterbrochen",
      "errorNetText": "Das Gespräch wurde beendet. Bitte versuchen Sie es erneut.",
      "retry": "Erneut versuchen"
    },
    "calendar": {
      "title": "Termine",
      "next": "Nächster Termin",
      "free": "Heute keine weiteren Termine",
      "tomorrow": "Morgen, {{time}}",
      "allDay": "Ganztägig",
      "now": "Jetzt · noch {{minutes}} Min.",
      "connectHint": "Termine hier anzeigen",
      "connect": "Verbinden",
      "expired": "Termine nicht verfügbar",
      "renew": "Erneuern",
      "failed": "Termine gerade nicht erreichbar",
      "retry": "Erneut versuchen",
      "monthLabel": "Monatsansicht {{month}}, heute ist der {{day}}."
    },
    "title": "Widgets",
    "edit": "Bearbeiten",
    "editing": "Widgets bearbeiten",
    "done": "Fertig",
    "add": "Widget hinzufügen",
    "addToBar": "Zur Leiste hinzufügen",
    "inBar": "in der Leiste",
    "search": "Widgets durchsuchen",
    "noResults": "Keine Widgets gefunden",
    "close": "Schließen",
    "empty": "Noch keine Widgets in der Leiste.",
    "remove": "{{name}} entfernen",
    "moved": "Größe",
    "names": {
      "clock": "Datum & Uhrzeit",
      "calendar": "Kalender",
      "voice-agent": "Sprachassistent",
      "prompt-library": "Prompts"
    },
    "descriptions": {
      "clock": "Uhrzeit und heutiges Datum, digital oder analog.",
      "calendar": "Ihre nächsten Termine, wenn Microsoft 365 verbunden ist, sonst der Monat.",
      "voice-agent": "Fragen stellen oder Apps und Dokumente per Sprache öffnen.",
      "prompt-library": "Ihre Prompts, mit einem Klick im Chat."
    },
    "variants": {
      "small": "Klein",
      "medium": "Breit",
      "smallDigital": "Klein, digital",
      "smallAnalog": "Klein, analog"
    }
  },
  "widgetStore": {
    "title": "Widget-Bereich",
    "subtitle": "Widgets verwalten und anpassen",
    "openSettings": "Widget-Einstellungen öffnen",
    "editDesktopIcons": "Desktop Icons bearbeiten",
    "editModeActive": "Bearbeitungsmodus aktiv",
    "search": "Widgets suchen...",
    "allCategories": "Alle Kategorien",
    "noResults": "Keine Widgets gefunden",
    "noWidgets": "Keine Widgets verfügbar",
    "loading": "Widgets werden geladen...",
    "manageHint": "Nutze das Einstellungen-Symbol, um Widgets zu aktivieren",
    "resetToDefaults": "Auf Standardeinstellungen zurücksetzen",
    "reset": "Zurücksetzen",
    "pin": "Anheften",
    "unpin": "Lösen",
    "size": "Größe",
    "sizes": {
      "small": "Klein (1x1)",
      "medium": "Breit (1x2)",
      "tall": "Hoch (2x1)",
      "large": "Groß (2x2)"
    },
    "customSettings": "Widget-Einstellungen",
    "stats": "{{enabled}} von {{total}} Widgets aktiv",
    "hint": "Änderungen werden automatisch gespeichert",
    "editWidgets": "Widgets bearbeiten...",
    "enabledLabel": "Aktiviert",
    "disabledLabel": "Deaktiviert",
    "dragToEnable": "Zum Desktop oder in die Sidebar ziehen, um zu aktivieren",
    "dragToDisable": "In den Widget-Bereich ziehen, um zu deaktivieren",
    "previewUnavailable": "Keine Vorschau für dieses Widget verfügbar",
    "maxItems": "Maximale Anzahl",
    "filterArea": "Nach Bereich filtern",
    "filterAreaHint": "Der Filter wird direkt im Widget gesetzt",
    "showFavoritesOnly": "Nur Favoriten anzeigen",
    "cycleClockStyle": "Uhrstil ändern",
    "clockStyle": "Uhrstil",
    "clockStyles": {
      "analog": "Analog",
      "digital": "Digital",
      "minimal": "Minimal"
    },
    "cycleCalendarStyle": "Kalenderstil ändern",
    "calendarStyle": "Kalenderstil",
    "calendarStyles": {
      "day": "Tagesansicht",
      "month": "Monatsansicht"
    },
    "calendarMonthViewDisabled": "Nur in Größe Large verfügbar"
  },
  "widgets": {
    "categories": {
      "system": "System",
      "apps": "Apps",
      "productivity": "Produktivität",
      "admin": "Verwaltung"
    },
    "overview": {
      "title": "Schnell-Widgets"
    },
    "calendar": {
      "title": "Kalender",
      "description": "Heutige Termine und anstehende Meetings"
    },
    "clock": {
      "title": "Uhr",
      "description": "Aktuelle Uhrzeit in deiner Zeitzone"
    },
    "notifications": {
      "title": "Benachrichtigungen",
      "description": "Neueste System- und App-Mitteilungen",
      "justNow": "Gerade eben",
      "minsAgo": "vor {{mins}} Min.",
      "hoursAgo": "vor {{hours}} Std.",
      "daysAgo": "vor {{days}} Tag(en)",
      "noNotifications": "Keine neuen Benachrichtigungen",
      "clickForAll": "Alle anzeigen"
    },
    "voice-agent": {
      "title": "Voice Agent",
      "description": "Sprachassistent für freihändiges Arbeiten"
    },
    "app-store": {
      "title": "App Store",
      "description": "Empfohlene und neue Apps entdecken"
    },
    "appStore": {
      "title": "App Store",
      "description": "Empfohlene und neue Apps entdecken",
      "noApps": "Keine Apps verfügbar"
    },
    "url-linked": {
      "title": "Schnellzugriff",
      "description": "Schnellzugriff auf Ihre Lieblingswebseiten",
      "noLinks": "Noch keine Links hinzugefügt",
      "addLinksHint": "Öffnen Sie die Widget-Einstellungen, um Links hinzuzufügen",
      "links": "Links",
      "addLink": "Link hinzufügen",
      "titlePlaceholder": "Link-Titel",
      "urlRequired": "URL ist erforderlich",
      "httpsOnly": "Nur HTTPS-URLs sind erlaubt",
      "invalidUrl": "Ungültiges URL-Format",
      "titleRequired": "Titel ist erforderlich",
      "maxLinksReached": "Maximal 5 Links erlaubt",
      "displayMode": "Anzeigemodus",
      "listMode": "Liste",
      "compactMode": "Kompakt",
      "manageLinks": "Links verwalten",
      "noLinksConfigured": "Keine Links eingerichtet",
      "limitReached": "Limit erreicht"
    },
    "settings": {
      "title": "Einstellungen",
      "description": "Schnellzugriff auf wichtige Optionen",
      "darkMode": "Dunkelmodus",
      "lightMode": "Hellmodus",
      "language": "Sprache",
      "currentTheme": "Theme",
      "themeLight": "Hell",
      "themeCdbLight": "CDB Hell",
      "themeDark": "Dunkel",
      "themeCdbDark": "CDB Dunkel",
      "themeAqua": "Aqua",
      "themeForest": "Wald",
      "themeOcean": "Ozean"
    },
    "knowledgeHub": {
      "title": "Knowledge Hub",
      "description": "Aktuelle Wissensbereiche und Dokumente",
      "noAreas": "Keine Wissensbereiche",
      "allAreas": "Alle Bereiche",
      "documents": "Dokumente",
      "apps": "Knowledge Apps"
    },
    "aiChat": {
      "title": "KI-Chat",
      "description": "Neueste Unterhaltungen und neuer Chat",
      "newChat": "Neuer Chat",
      "noChats": "Keine Chats"
    },
    "promptLibrary": {
      "title": "Prompt-Bibliothek",
      "description": "Favorisierte und zuletzt genutzte Prompts",
      "noPrompts": "Keine Prompts"
    },
    "cdb-sessions": {
      "title": "CDB Sessions",
      "description": "Training-Sessions mit Fragen erstellen und durchführen",
      "noSessions": "Keine Sessions"
    },
    "pdf-viewer": {
      "title": "PDF Viewer",
      "description": "Zuletzt geöffnete PDFs",
      "noPDFs": "Keine PDFs",
      "pages": "Seiten"
    },
    "pdfViewer": {
      "title": "PDF Viewer",
      "description": "Zuletzt geöffnete PDFs",
      "noPDFs": "Keine PDFs",
      "pages": "Seiten"
    },
    "multimedia": {
      "title": "Multimedia",
      "description": "Aktuell/zuletzt wiedergegebene Medien",
      "noMedia": "Keine Medien"
    },
    "admin": {
      "title": "Cortex",
      "description": "Systemstatus und Statistiken",
      "status": "Status",
      "healthy": "Stabil",
      "warning": "Warnung",
      "error": "Fehler",
      "unknown": "Unbekannt",
      "users": "Benutzer",
      "uptime": "Laufzeit"
    },
    "desktop": {
      "removeFromDesktop": "Vom Desktop entfernen",
      "folder": "Ordner",
      "folderAppCount": "{{count}} Apps",
      "createFolder": "Ordner erstellt",
      "deleteFolder": "Ordner löschen",
      "renameFolder": "Ordner umbenennen",
      "emptyFolder": "Dieser Ordner ist leer",
      "unpackFolder": "Ordner auflösen?",
      "unpackFolderHint": "Nur noch 1 App im Ordner. Möchten Sie den Ordner auflösen?"
    }
  },
  "voiceAgent": {
    "widget": {
      "title": "Voice Agent",
      "clickToStart": "Klicken zum Starten"
    },
    "greetingFallbackCDB": "Begrüße den Nutzer kurz auf Deutsch als Corporate Digital Brain und frage, wie du helfen kannst.",
    "greetingFallback": "Begrüße den Nutzer kurz auf Deutsch und frage, wie du helfen kannst.",
    "azureGreetingWrapper": "Bitte begrüße mich mit exakt folgendem Text, ohne jegliche Variation oder Interpretation:\n\"{{greetingText}}\"",
    "greetingSessionInstruction": "WICHTIG - ERSTE NACHRICHT:\nWenn dies deine allererste Nachricht in dieser Sitzung ist, musst du EXAKT folgenden Text sagen, ohne jegliche Variation oder Interpretation:\n\"{{greetingText}}\"\n\nSage diesen Text wortwörtlich als deine erste Antwort. Nach dieser ersten Begrüßung kannst du dann normal mit dem Nutzer interagieren."
  },
  "notificationCenter": {
    "title": "Benachrichtigungen",
    "unreadBadge": "{{count}} neu",
    "bellLabelUnread_one": "Benachrichtigungen, {{count}} neue",
    "bellLabelUnread_other": "Benachrichtigungen, {{count}} neue",
    "markAllAsRead": "Alle als gelesen markieren",
    "deleteRead": "Gelesene löschen",
    "filterLabel": "Nach Kategorie filtern",
    "onlyUnread": "Nur neue",
    "maximize": "Vergrößern",
    "restore": "Verkleinern",
    "loading": "Benachrichtigungen werden geladen …",
    "loadError": "Benachrichtigungen konnten nicht geladen oder geändert werden. Bitte versuchen Sie es später erneut.",
    "unreadPrefix": "Neu:",
    "markRead": "Als gelesen markieren",
    "markBundleRead": "Alle als gelesen markieren",
    "markUnread": "Als ungelesen markieren",
    "markBundleUnread": "Alle als ungelesen markieren",
    "moreActions": "Weitere Aktionen",
    "delete": "Löschen",
    "deleteBundle": "Alle löschen",
    "chips": {
      "all": "Alle",
      "bug_reports": "Tickets",
      "documents": "Dokumente",
      "routines": "Routinen",
      "requests": "Anfragen",
      "shared": "Geteilt mit mir"
    },
    "meta": {
      "bug_reports": "Ticket",
      "documents": "Dokumente",
      "routines": "Routine",
      "requests": "Anfrage",
      "shared": "Geteilt mit Ihnen"
    },
    "days": {
      "today": "Heute",
      "yesterday": "Gestern",
      "thisWeek": "Diese Woche",
      "older": "Älter"
    },
    "when": {
      "justNow": "Jetzt",
      "minutes": "{{count}} Min.",
      "hours": "{{count}} Std."
    },
    "actions": {
      "open": "Öffnen",
      "review": "Prüfen",
      "reply": "Antworten"
    },
    "bundle": {
      "newReplies_one": "{{count}} neue Antwort zu {{subject}}",
      "newReplies_other": "{{count}} neue Antworten zu {{subject}}",
      "replies_one": "{{count}} Antwort zu {{subject}}",
      "replies_other": "{{count}} Antworten zu {{subject}}",
      "newUpdates_one": "{{count}} neue Benachrichtigung zu {{subject}}",
      "newUpdates_other": "{{count}} neue Benachrichtigungen zu {{subject}}",
      "updates_one": "{{count}} Benachrichtigung zu {{subject}}",
      "updates_other": "{{count}} Benachrichtigungen zu {{subject}}",
      "expand_one": "{{count}} anzeigen",
      "expand_other": "Alle {{count}} anzeigen",
      "collapse": "Ausblenden",
      "quoted": "„{{text}}“"
    },
    "empty": {
      "title": "Noch keine Benachrichtigungen",
      "text": "Hier erscheinen Antworten, Statusänderungen und fertige Verarbeitungen."
    },
    "emptyFiltered": {
      "title": "Alles erledigt",
      "text": "Keine neuen Benachrichtigungen."
    },
    "toast": {
      "region": "Neue Benachrichtigungen",
      "dismiss": "Hinweis schließen"
    },
    "listLabel": "Liste der Benachrichtigungen",
    "settings": {
      "open": "Benachrichtigungseinstellungen",
      "back": "Zurück zu den Benachrichtigungen",
      "title": "Einstellungen",
      "categoriesTitle": "Benachrichtigungen je Kategorie",
      "intro": "Legen Sie fest, wo Sie über neue Benachrichtigungen informiert werden. Die Einstellung gilt auf allen Ihren Geräten.",
      "category": "Kategorie",
      "channels": {
        "inApp": "In-App",
        "toast": "Toast"
      },
      "hints": {
        "bug_reports": "Antworten, Rückfragen, Status",
        "documents": "Verarbeitung fertig oder fehlgeschlagen",
        "routines": "Lauf beendet oder fehlgeschlagen",
        "requests": "Kontingent, Zugang, Freigaben",
        "shared": "Prompts, Sessions"
      },
      "switchLabel": {
        "inApp": "{{category}} in der Liste anzeigen",
        "toast": "{{category}} als Toast anzeigen"
      },
      "explain": {
        "inApp": "Die Benachrichtigung erscheint in dieser Liste und zählt zur Zahl an der Glocke. Ausgeschaltet bleibt sie gespeichert, wird aber nicht angezeigt.",
        "toast": "Ein kurzer Hinweis unten rechts, sobald eine neue Benachrichtigung eintrifft. Ausgeschaltet steht sie nur in der Liste."
      },
      "saveError": "Die Einstellung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
      "notLoaded": "Ihre Einstellungen werden noch geladen. Änderungen sind möglich, sobald sie geladen sind.",
      "cleanupTitle": "Aufräumen",
      "retention": "Gelesene Benachrichtigungen werden nach 90 Tagen automatisch gelöscht, ungelesene nach 180 Tagen."
    }
  },
  "recordingConsent": {
    "title": "Einwilligung zur Aufnahme",
    "startRecording": "Aufnahme starten",
    "tableConsent": "Einwilligung",
    "globalStatusHint": "Audio-Aufnahme läuft — klicken, um zum aufnehmenden Fenster zu wechseln",
    "noRecord": "kein Nachweis",
    "noRecordHint": "Für diese Aufnahme liegt kein Einwilligungs-Nachweis vor (vor Einführung der Funktion erstellt oder importierte Datei).",
    "microphone": {
      "description": "Diese Funktion nimmt Audio auf (Mikrofon, künftig ggf. auch Computer-Audio). Aufnahmen ohne Wissen und Zustimmung aller Beteiligten sind nicht zulässig. Die Bestätigung wird mit der Aufnahme dokumentiert.",
      "statement": "Ich bestätige, dass ich alle Teilnehmenden über die Aufnahme informiert habe und alle der Aufnahme zugestimmt haben."
    },
    "systemAudio": {
      "description": "Diese Aufnahme erfasst den gesamten Ton dieses Rechners, also auch alle Stimmen einer laufenden Konferenz. Das Konferenzsystem zeigt den anderen Teilnehmenden dabei keinen Aufnahmehinweis an — darüber zu informieren, liegt bei dir. Die Bestätigung wird mit der Aufnahme dokumentiert.",
      "statement": "Ich bestätige, dass ich alle Teilnehmenden über diese Aufnahme informiert habe und alle zugestimmt haben. Mir ist bewusst, dass ihnen im Konferenzsystem kein Aufnahmehinweis angezeigt wird und dass ich für die rechtskonforme Verwendung der Aufnahme verantwortlich bin."
    }
  },
  "audioRecorder": {
    "title": "Audio Recorder",
    "uploadStalledError": "Der Audio-Upload stockt — seit über einer Minute wurde kein Segment mehr hochgeladen. Bitte jetzt stoppen und abschließen, um die bisherige Aufnahme zu sichern.",
    "chunkUploadFailedWarning": "Ein Aufnahmesegment konnte nicht hochgeladen werden. In der fertigen Aufnahme könnte Audio fehlen.",
    "recorderError": "Bei der Aufnahme ist ein Problem aufgetreten. Bitte prüfen und ggf. stoppen und abschließen, um Audioverlust zu vermeiden.",
    "recordingSaved": "Aufnahme gespeichert",
    "recordingSavedDescription": "Die Aufnahme wurde erfolgreich gespeichert ({{duration}} Sekunden).",
    "interruptedSessionFound": "Unterbrochene Aufnahme gefunden",
    "segmentsCount": "{{count}} Segmente ({{duration}})",
    "resume": "Fortsetzen",
    "finalize": "Finalisieren",
    "discard": "Verwerfen",
    "recordingNameLabel": "Aufnahme-Name (optional)",
    "recordingNamePlaceholder": "z.B. Interview mit Expert XY",
    "segmentStatus": "Segment {{current}} • {{uploaded}} hochgeladen",
    "startRecording": "Aufnahme",
    "pause": "Pause",
    "stop": "Stopp",
    "continue": "Weiter",
    "finalizing": "Finalisiere...",
    "uploading": "Upload...",
    "recordings": "Aufnahmen",
    "recordingsCount": "Aufnahmen ({{count}})",
    "tableDate": "Datum",
    "deleteConfirm": "Möchten Sie \"{{title}}\" wirklich löschen?",
    "deleteWarning": "Diese Aktion kann nicht rückgängig gemacht werden",
    "editName": "Namen bearbeiten",
    "error": "Fehler",
    "saved": "Gespeichert",
    "playRecording": "Abspielen",
    "downloadRecording": "Herunterladen",
    "transcribe": "Transkribieren",
    "deleteRecording": "Löschen",
    "deleteFailed": "Die Aufnahme konnte nicht gelöscht werden. Bitte erneut versuchen.",
    "transcript": "Transkript",
    "stepEdit": "Bearbeiten",
    "stepAddToKnowledge": "Add to Knowledge",
    "tabEdit": "Bearbeiten",
    "tabPreview": "Vorschau",
    "editTranscript": "Transkript bearbeiten:",
    "transcriptPlaceholder": "Transkript...",
    "charactersCount": "{{count}} Zeichen",
    "selectKnowledgeArea": "Knowledge Area auswählen:",
    "selectKnowledgeAreaPlaceholder": "Knowledge Area wählen...",
    "knowledgeAreasAvailable": "{{count}} Knowledge Areas verfügbar",
    "documentTitle": "Dokumenten-Titel:",
    "documentTitlePlaceholder": "z.B. Interview Zusammenfassung",
    "documentPreview": "Vorschau des Dokuments:",
    "source": "Quelle",
    "duration": "Dauer",
    "seconds": "Sekunden",
    "copyToClipboard": "In Zwischenablage kopieren",
    "copied": "Kopiert",
    "saveChanges": "Änderungen speichern",
    "clickToConfirm": "Nochmal klicken zum Bestätigen",
    "retranscribe": "Neu transkribieren",
    "nextToKnowledge": "Weiter zu Knowledge →",
    "back": "← Zurück",
    "uploadingDocument": "Hochladen...",
    "addToKnowledge": "Zu Knowledge hinzufügen",
    "errorSavingTranscript": "Fehler beim Speichern des Transkripts",
    "errorAddingToKnowledge": "Fehler beim Hinzufügen zu Knowledge Area",
    "knowledgeAreaNoClient": "Knowledge Area hat keinen Client zugewiesen",
    "uploadAudio": "Hochladen",
    "uploadingFile": "Hochladen...",
    "uploadFailed": "Upload fehlgeschlagen",
    "noClientId": "Kein Client zugewiesen",
    "aiAssistant": {
      "title": "KI-Assistent",
      "layerQuestion": "Was soll ich bearbeiten?",
      "layer": {
        "summary": "Zusammenfassung",
        "transcript": "Transkript"
      },
      "layerHint": {
        "summary": "Formuliert die Zusammenfassung um. Das Transkript bleibt, wie es ist.",
        "transcript": "Korrigiert nur den Wortlaut: Was gesagt wurde, bleibt gesagt. Kürzen oder Umschreiben gibt es hier nicht."
      },
      "noSummary": "Noch keine Zusammenfassung. Sie entsteht über dem Transkript, sobald es eines gibt.",
      "shorten": "Kürzer",
      "expand": "Ausführlicher",
      "formal": "Förmlicher",
      "byTopic": "Nach Themen gliedern",
      "cleanup": "Bereinigen",
      "fixTerms": "Fachbegriffe korrigieren",
      "speakers": "Sprecher benennen",
      "speakerFrom": "Sprecher",
      "speakerChoose": "Sprecher wählen",
      "speakerTo": "Neuer Name",
      "speakerToPlaceholder": "z. B. Kunde",
      "rename": "Umbenennen",
      "processing": "Wird verarbeitet …",
      "progressParts": "Teil {{done}} von {{total}}",
      "discard": "Verwerfen",
      "placeholder": "Wählen Sie eine Aktion oder schreiben Sie eine eigene Anweisung.",
      "customPrompt": {
        "summary": "Eigene Anweisung an die Zusammenfassung",
        "transcript": "Eigene Anweisung an das Transkript"
      },
      "customPromptPlaceholder": {
        "summary": "z. B. Kosten und Förderung zuerst nennen",
        "transcript": "z. B. „Maier“ statt „Meier“"
      },
      "error": "Fehler bei der Verarbeitung. Bitte versuchen Sie es erneut.",
      "truncatedWarning": "Das Ergebnis ist deutlich kürzer als der Text und wurde vermutlich abgeschnitten. Prüfen Sie das Ende, bevor Sie es übernehmen: Übernehmen ersetzt den ganzen Text.",
      "applyAnyway": "Trotzdem übernehmen",
      "emptyResult": "Die KI hat geantwortet, aber keinen Text geliefert, meist weil das Budget aufgebraucht war. Bitte versuchen Sie es erneut.",
      "truncatedWarningMeasured": "Die KI hat gemeldet, dass ihr Ausgabe-Budget aufgebraucht war; das Ergebnis endet also mitten im Text. Prüfen Sie das Ende, bevor Sie es übernehmen: Übernehmen ersetzt den ganzen Text.",
      "customAction": "Eigene Anweisung",
      "proposalWhere": {
        "summary": "Der Vorschlag steht links in der Zusammenfassung",
        "transcript": "Der Vorschlag steht links im Transkript"
      },
      "proposalWhereHint": "Prüfen Sie die markierten Stellen. „Übernehmen“ und „Verwerfen“ gelten für den ganzen Vorschlag.",
      "renamed": "Umbenannt: {{from}} → {{to}}. Rückgängig über den Versionsverlauf."
    },
    "versionHistory": {
      "title": "Versionsverlauf",
      "version": "Version {{number}}",
      "sourceOriginal": "Original",
      "sourceManualEdit": "Manuelle Bearbeitung",
      "sourceAiRefine": "KI-Verfeinerung",
      "sourceRetranscribe": "Neu transkribiert",
      "sourceRestore": "Wiederhergestellt",
      "preview": "Vorschau",
      "restore": "Wiederherstellen",
      "restored": "Version wiederhergestellt",
      "words": "Wörter",
      "noVersions": "Kein Versionsverlauf vorhanden",
      "loading": "Versionen werden geladen...",
      "chars": "{{count}} Zeichen",
      "current": "Aktuell",
      "close": "Schließen"
    },
    "window": {
      "loading": "Transkript wird geladen …",
      "notFoundTitle": "Aufnahme nicht gefunden",
      "notFoundBody": "Diese Aufnahme gibt es nicht mehr, oder sie gehört zu einem anderen Konto. Schließe das Fenster und öffne die Aufnahme erneut aus der Liste.",
      "loadErrorTitle": "Transkript konnte nicht geladen werden",
      "loadErrorBody": "Die Verbindung zum Server ist fehlgeschlagen. Die Aufnahme ist nicht verloren — sie ist gerade nur nicht abrufbar. Schließe das Fenster und versuche es erneut.",
      "stepRecorded": "Aufgenommen",
      "unsaved": "Nicht gespeicherte Änderungen",
      "uploadSuccess": "Im Brain angelegt, in der Knowledge Area „{{area}}“. Die Aufnahme bleibt hier erhalten.",
      "openDocument": "Dokument öffnen"
    },
    "overview": {
      "searchPlaceholder": "Aufnahmen durchsuchen …",
      "sortNewest": "Neueste zuerst",
      "sortOldest": "Älteste zuerst",
      "sortLongest": "Längste zuerst",
      "sortTitle": "Nach Titel",
      "stageRecorded": "Aufgenommen",
      "stageTranscribing": "Wird transkribiert",
      "stageFailed": "Fehlgeschlagen",
      "stageTranscribed": "Transkribiert",
      "stageEdited": "Bearbeitet",
      "actionTranscribe": "Transkribieren",
      "actionRetry": "Erneut versuchen",
      "actionRunning": "Läuft …",
      "actionOpen": "Transkript öffnen",
      "emptyTitle": "Noch keine Aufnahmen",
      "emptyBody": "Starte oben eine Aufnahme oder lade eine vorhandene Audiodatei hoch. Transkript und Brain folgen danach im selben Ablauf.",
      "noMatchTitle": "Keine Aufnahme gefunden",
      "noMatchBody": "Für „{{query}}“ gibt es keinen Treffer.",
      "clearSearch": "Suche zurücksetzen",
      "errorTitle": "Aufnahmen konnten nicht geladen werden",
      "errorBody": "Die Verbindung zum Server ist fehlgeschlagen. Die vorhandenen Aufnahmen sind nicht verloren — sie sind gerade nur nicht abrufbar.",
      "reload": "Erneut laden"
    },
    "sourceLostNotice": "Die Audioquelle wurde beendet. Die Aufnahme bis zu diesem Zeitpunkt wurde gespeichert.",
    "sourceLabel": "Aufnahmequelle",
    "sourceMicrophone": "Mikrofon",
    "sourceMicrophoneSystem": "Mikrofon + System",
    "sourceSystemHint": "Nimmt zusätzlich den Ton dieses Rechners auf, also auch die anderen Teilnehmenden einer Konferenz. Wähle im Freigabe-Dialog „Gesamter Bildschirm“ und setze den Haken bei „Systemaudio teilen“. Bitte Kopfhörer verwenden — über Lautsprecher nimmt das Mikrofon den Konferenzton ein zweites Mal auf.",
    "systemAudioMissing": "Die Freigabe enthielt keinen Ton. Setze im Freigabe-Dialog den Haken bei „Systemaudio teilen“ — oder dein Browser kann den Rechner-Ton nicht teilen. Ohne ihn wird nur das Mikrofon aufgenommen.",
    "tryAgain": "Erneut versuchen",
    "narrowSurfaceWarning": "Du hast ein einzelnes Fenster oder einen Browser-Tab freigegeben. Aufgenommen wird nur dessen Ton, nicht der gesamte Rechner — für eine Konferenz wähle „Gesamter Bildschirm“.",
    "resumeWith": "Fortsetzen mit:",
    "stateIdle": "Bereit zur Aufnahme",
    "stateIdleHint": "Mikrofon und Quelle lassen sich vor dem Start wählen.",
    "stateRecording": "Aufnahme läuft",
    "stateRecordingHint": "Wird fortlaufend in Abschnitten gesichert — ein Absturz kostet höchstens die letzten Sekunden.",
    "statePaused": "Pausiert",
    "statePausedHint": "Die Aufnahme ist angehalten. Das Bisherige ist gesichert.",
    "stateSaving": "Wird gesichert",
    "stateSavingHint": "Der letzte Abschnitt wird übertragen. Bitte das Fenster offen lassen.",
    "jobStage": {
      "queued": "In Warteschlange …",
      "downloading": "Wird geladen",
      "converting": "Wird umgewandelt",
      "transcribing": "Wird transkribiert",
      "saving": "Wird gespeichert",
      "done": "Fertig"
    },
    "jobError": {
      "generic": "Die Transkription ist fehlgeschlagen. Bitte erneut versuchen.",
      "tooLong": "Die Aufnahme ist zu lang für die Transkription.",
      "unreadable": "Die Audiodatei konnte nicht gelesen werden.",
      "noSpeech": "In der Aufnahme wurde keine Sprache erkannt.",
      "busy": "Die Transkription konnte gerade nicht gestartet werden. Bitte in einigen Minuten erneut versuchen.",
      "timeout": "Die Transkription wurde unterbrochen. Bitte erneut versuchen.",
      "notFound": "Die Aufnahme wurde nicht gefunden. Bitte die Liste neu laden.",
      "limitExceeded": "Dein Token- oder Kostenlimit für diesen Zeitraum ist erreicht. Bitte wende dich an deinen Administrator."
    }
  },
  "window": {
    "restore": "Wiederherstellen",
    "minimize": "Minimieren",
    "maximize": "Maximieren",
    "close": "Schließen",
    "resize": {
      "right": "Fensterbreite rechts anpassen",
      "left": "Fensterbreite links anpassen",
      "bottom": "Fensterhöhe unten anpassen",
      "top": "Fensterhöhe oben anpassen",
      "bottomRight": "Fenstergröße unten rechts anpassen",
      "bottomLeft": "Fenstergröße unten links anpassen",
      "topRight": "Fenstergröße oben rechts anpassen",
      "topLeft": "Fenstergröße oben links anpassen"
    },
    "closeGuard": {
      "title": "Ungespeicherte Änderungen",
      "description": "In diesem Fenster gibt es Änderungen, die noch nicht gespeichert wurden. Beim Schließen gehen sie verloren.",
      "descriptionAll": "In {{count}} Fenstern gibt es Änderungen, die noch nicht gespeichert wurden. Beim Schließen gehen sie verloren.",
      "descriptionAll_one": "In einem Fenster gibt es Änderungen, die noch nicht gespeichert wurden. Beim Schließen gehen sie verloren.",
      "keepOpen": "Offen lassen",
      "discard": "Verwerfen und schließen"
    },
    "resizeSnapped": "Größe der angedockten Fenster anpassen"
  },
  "selectionTranslation": {
    "title": "Übersetzung",
    "translateToDe": "Deutsch",
    "translateToEn": "English",
    "translating": "Wird übersetzt...",
    "copyTranslation": "Kopieren",
    "copied": "Kopiert!",
    "error": "Übersetzung fehlgeschlagen",
    "retry": "Erneut versuchen",
    "close": "Schließen"
  },
  "agentToolbox": {
    "communicator2": {
      "subtabs": {
        "trace": "Per-Turn-Trace",
        "session": "Session-Trace",
        "feedback": "Bewertungen"
      },
      "map": {
        "placeholder": "Capability-Map — folgt (Phase D-4).",
        "intro": "Was das LLM für diesen Caller pro Turn sieht — nach Routing-Rolle gruppiert. „Kollabiert\" = eine Quelle/Corporate als ein Tool, „versteckt\" = interne Primitive. Rolle = Relevanz, nicht Zugriff.",
        "loadError": "Capability-Map konnte nicht geladen werden.",
        "empty": "Keine Tools sichtbar für diesen Caller-Type.",
        "collapsed": "kollabiert",
        "hidden": "versteckt",
        "hiddenHint": "Vom LLM verborgen — nur intern von Skills aufgerufen.",
        "editRights": "Rechte",
        "editRightsAll": "Rechte (alle {{count}})",
        "underlyingToggle": "{{count}} Endpoints anzeigen",
        "servesSource": "Bedient die Quelle {{name}}"
      },
      "trace": {
        "placeholder": "Per-Turn-Trace — folgt (Phase D-3).",
        "empty": "Noch keine Turns — jeder cdbChat-Turn erscheint hier.",
        "loadError": "Trace konnte nicht geladen werden.",
        "turnCount": "{{count}} Turns",
        "noneDirection": "Smalltalk / kein Tool",
        "skipped": "übersprungen",
        "curationOff": "aus",
        "curationPruned": "{{count}} entfernt",
        "curationHinted": "{{count}} Hinweis",
        "curationTriggered": "Trigger",
        "showInvocations": "Invocations anzeigen",
        "table": {
          "time": "Zeit",
          "status": "Status",
          "directions": "Layer-1-Richtungen",
          "calls": "Layer-2-Calls",
          "curation": "Kuration",
          "sources": "Quellen",
          "tools": "Tools",
          "rating": "Bewertung",
          "total": "Gesamt",
          "ttf": "Erstes Token"
        }
      },
      "session": {
        "pickerTitle": "Konversationen",
        "turnsLabel": "{{count}} Turns",
        "errorsLabel": "{{count}} Fehler",
        "loadError": "Konversationen konnten nicht geladen werden.",
        "empty": "Noch keine Konversationen — jede cdbChat-Unterhaltung erscheint hier.",
        "selectHint": "Wähle links eine Konversation, um ihren Verlauf zu sehen.",
        "traceEmpty": "Keine Turns für diese Konversation."
      },
      "feedback": {
        "lastDays": "{{count}} Tage",
        "loadError": "Bewertungen konnten nicht geladen werden.",
        "empty": "Noch keine Bewertungen — 👍/👎 im Chat erscheinen hier aggregiert.",
        "table": {
          "direction": "Layer-1-Richtung",
          "ratings": "👎 / Gesamt",
          "negativeRate": "👎-Quote",
          "topReason": "Häufigster Grund"
        }
      }
    },
    "capabilityRole": {
      "label": "Routing-Rolle",
      "hint": "Grobe Richtung für den Layered Router (Ebene 1). „Automatisch\" leitet aus Kategorie/Typ ab.",
      "auto": "Automatisch (aus Kategorie/Typ)",
      "internal_knowledge": "Internes Wissen",
      "public": "Öffentlich / Web",
      "structured_connector": "Strukturierter Connector",
      "action": "Aktion",
      "none": "Vom Routing ausschließen"
    },
    "tabs": {
      "label": "Agent Toolbox Tabs",
      "skills": "Skills",
      "manifest": "Tool-Manifest",
      "history": "Aufrufe",
      "performance": "Performance",
      "routing": "Routing-Strategie"
    },
    "info": {
      "skills": "Kuratierte TQS-Endpoints als Agent-Tools. Berechtigungen, Sichtbarkeit, sichtbare Felder — kontrolliert was der Agent rufen darf und was zurückkommt.",
      "manifest": "Tabelle aller live Agent-Tools mit Berechtigungen. Pro Tool: erst Clients zuweisen, dann Rollen aus diesen Clients freischalten. Leer = nur Admin sieht das Tool.",
      "history": "Audit-Trail aller Tool-Aufrufe — wer hat wann was gerufen, mit welchem Status. Skills + verbundene Systeme zusammen.",
      "performance": "Latenz-Baseline des cdbChat — p50/p95 pro Tag und pro Quellen-Kombination, server-seitig gemessen. Grundlage für den Smart-Routing-Vergleich.",
      "routing": "Konfiguration des Manifest-Kurators: Hinweis- und Pruning-Schwellen für die automatische Quellenwahl. Änderungen wirken ohne Deploy."
    },
    "performance": {
      "windowDays": "{{count}} Tage",
      "stable": "Stabil",
      "regressionFlag": "p95 heute > {{factor}}× Fenster-p95",
      "loadError": "Telemetrie konnte nicht geladen werden.",
      "empty": "Noch keine Turns im Zeitraum — jeder cdbChat-Turn füllt die Baseline.",
      "chartTitle": "Gesamtdauer pro Tag (p50/p95)",
      "comboTitle": "Latenz nach aktiven Quellen",
      "kpi": {
        "turns": "Turns",
        "errorRate": "{{rate}} % Fehler",
        "ttf": "Zeit bis erstes Token",
        "total": "Gesamtdauer",
        "tokens": "Tokens",
        "cacheShare": "{{share}} % aus Cache"
      },
      "table": {
        "sources": "Quellen",
        "noSources": "nur Memory",
        "ttfP50": "Erstes Token p50",
        "ttfP95": "Erstes Token p95",
        "totalP50": "Gesamt p50",
        "totalP95": "Gesamt p95"
      }
    },
    "routing": {
      "intro": "Der Kurator bewertet vor jedem Auto-Routing-Turn alle Tools des Manifests gegen die Frage. Hohe Scores werden dem Assistenten als Hinweis mitgegeben; niedrige Scores werden erst ab der Manifest-Mindestgröße entfernt. Änderungen wirken ohne Deploy auf den nächsten Turn.",
      "enabled": "Kurator aktiv",
      "enabledHint": "Aus = das LLM sieht das ungefilterte Manifest ohne Hinweise.",
      "tHigh": "Hinweis-Schwelle (t_high)",
      "tHighHint": "Ab diesem Score bekommt ein Tool einen \"wahrscheinlich relevant\"-Hinweis im Prompt.",
      "tLow": "Pruning-Schwelle (t_low)",
      "tLowHint": "Unter diesem Score wird ein Tool aus dem Manifest entfernt — nur bei großen Manifesten, nie für System-Skills.",
      "minTools": "Manifest-Mindestgröße für Pruning",
      "minToolsHint": "Pruning greift erst, wenn das Manifest mehr Tools enthält als diesen Wert.",
      "maxHints": "Maximale Hinweise pro Turn",
      "maxHintsHint": "Obergrenze für Tool-Hinweise im System-Prompt.",
      "invalidThresholds": "Pruning-Schwelle darf nicht über der Hinweis-Schwelle liegen.",
      "saved": "Gespeichert",
      "loadError": "Routing-Konfiguration konnte nicht geladen werden."
    },
    "lifecycle": {
      "draft": "Entwurf",
      "testing": "Test",
      "active": "Live"
    },
    "permissions": {
      "editTitle": "Berechtigungen für {{name}}",
      "clientsLabel": "Clients",
      "clientsHint": "Welche Clients dürfen dieses Tool nutzen. Leer = alle Clients (öffentlich, sofern auch keine Rolle gesetzt ist).",
      "rolesLabel": "Rollen",
      "rolesHintNoClient": "Ohne Client-Auswahl werden nur globale Rollen angezeigt. Wähle Clients oben, um deren Rollen freizuschalten. Leer = öffentlich (sofern auch keine Clients gesetzt sind).",
      "rolesHintOwner": "Rollen des Owner-Clients + globale Rollen. Leer = alle Nutzer des Owner-Clients dürfen das Tool nutzen.",
      "ownerInherited": "Client: {{name}} — geerbt von der Quelle (Owner-Client). Nur Caller dieses Clients erreichen dieses Tool; hier verfeinerst du bei Bedarf die Rollen innerhalb des Clients.",
      "rolesHintFiltered": "Zeigt globale Rollen + Rollen der gewählten Clients. Leer = kein Rollen-Filter; admin-only setzt du explizit über die Admin-Rolle.",
      "noClients": "Keine Clients verfügbar.",
      "noRoles": "Keine passenden Rollen verfügbar.",
      "global": "global",
      "cascadeHint": "Diese Auswahl wird auf alle {{count}} darunterliegenden Tools geschrieben und überschreibt deren Einzelrechte."
    },
    "skills": {
      "title": "Skills",
      "subtitle": "Kuratierte TQS-Endpoints als Agent-Tools — Permissions, Visibility, Response-Projection.",
      "totalCount": "{{count}} Skills",
      "loading": "Lade Skills...",
      "errorTitle": "Skills konnten nicht geladen werden",
      "empty": "Noch keine Skills registriert. Bald: \"Neuen Skill aus Endpoint anlegen\"-Wizard.",
      "createBtn": "Neuer Skill",
      "active": "aktiv",
      "inactive": "inaktiv",
      "ratePerMin": "{{count}}/min",
      "cols": {
        "name": "Name",
        "target": "Endpoint",
        "visibility": "Sichtbarkeit",
        "role": "Rolle",
        "params": "Params",
        "rateLimit": "Rate-Limit",
        "status": "Status"
      },
      "fields": {
        "name": "Name (muss tqs__ Prefix haben)",
        "description": "Beschreibung (für den Agent)",
        "descriptionPlaceholder": "Was tut dieser Skill? Wann sollte der Agent ihn nutzen?",
        "visibility": "Sichtbarkeit",
        "rateLimit": "Rate-Limit (pro Minute)",
        "status": "Status",
        "publicHint": "⚠ Backend rejected aktuell visibility=public, bis ALLOW_PUBLIC_SKILLS=true (siehe #316).",
        "nameInvalid": "Muss matchen: tqs__[a-z][a-z0-9_]* (Backend-CHECK-Constraint).",
        "publicSubmitBlocked": "visibility=public ist aktuell vom Backend geblockt (#316). Erst auf internal stellen oder ALLOW_PUBLIC_SKILLS=true setzen.",
        "visibilityPublicM2m": "öffentlich (M2M)"
      },
      "create": {
        "title": "Neuen Skill anlegen",
        "step1": "Schritt 1/3 — TQS-Endpoint wählen, der gewrappt werden soll.",
        "step2": "Schritt 2/3 — Name, Beschreibung, Visibility, Rate-Limit.",
        "step3": "Schritt 3/3 — Parameter konfigurieren (free / preset / context_binding).",
        "loadingEndpoints": "Lade verfügbare Endpoints...",
        "searchEndpoints": "Suchen — Pfad, Summary, Tag…",
        "endpointHint": "{{count}} skill-fähige Endpoints (Canonical-Dependency-Set: nur Routes mit AuthContext).",
        "noParams": "Dieser Endpoint hat keine Parameter.",
        "paramsHint": "Mode bestimmt, woher der Wert kommt: free = Agent-Input, preset = DB-fix, context_binding = aus AuthContext.",
        "submit": "Skill anlegen",
        "invalidJson": "Ungültiges JSON-Format",
        "alreadyWrapped": "bereits als Skill angelegt"
      },
      "edit": {
        "title": "Skill bearbeiten",
        "partialSaveError": "Skill-Metadaten gespeichert, aber das Update der Berechtigungen ist fehlgeschlagen: {{message}}. Bitte erneut speichern."
      },
      "permissions": {
        "title": "Zugriffsberechtigungen",
        "hint": "Wenn leer: kein Filter. Sonst: Caller braucht passende Rolle UND passenden Client (jeweils OR innerhalb der Liste).",
        "roles": "Erlaubte Rollen",
        "clients": "Erlaubte Clients",
        "noRoles": "Keine Rollen verfügbar.",
        "noClients": "Keine Clients verfügbar."
      },
      "delete": {
        "title": "Skill löschen?",
        "confirm": "Skill {{name}} wird permanent gelöscht. Audit-Rows in tool_invocations bleiben erhalten."
      },
      "test": {
        "title": "Test-Call (admin-only)",
        "run": "Skill rufen",
        "noFreeParams": "Skill hat keine free-Parameter — Test-Call wird ohne Args gemacht.",
        "result": "Ergebnis (projiziert):"
      },
      "detail": {
        "target": "Ziel-Endpoint",
        "category": "Kategorie",
        "visibility": "Sichtbarkeit & Status",
        "parameters": "Parameter ({{count}})",
        "noParams": "Keine Parameter konfiguriert.",
        "permission": "Permission-Gate",
        "requiredRole": "Required Role",
        "requiredKAs": "Required KAs",
        "requiredTwLevels": "Required TW-Levels",
        "noGate": "Kein Gate konfiguriert — alle Internal-User dürfen rufen.",
        "assignments": "Assignments ({{count}})",
        "projection": "Response-Projection",
        "noProjection": "Keine Projection — Skill kann nur via test_mode (Admin) gerufen werden.",
        "meta": "Metadaten",
        "created": "Erstellt",
        "updated": "Aktualisiert",
        "handler": "Capability-Handler",
        "presetLabel": "Fester Wert",
        "bindingLabel": "Bindung"
      },
      "handler": {
        "configLabel": "Handler-Konfiguration",
        "createBtn": "Anlegen",
        "createBtnShort": "Handler-Skill",
        "createSubtitle": "Kapselt eine serverseitige Capability als ein Tool. Wähle einen Handler-Typ aus dem Katalog.",
        "createTitle": "Handler-Skill anlegen",
        "descLabel": "Beschreibung",
        "invalidJson": "Ungültiges JSON im Feld „{{field}}\".",
        "loadingCatalog": "Lade Handler-Katalog...",
        "nameHint": "Muss dem Muster ^tqs__[a-z][a-z0-9_]*$ entsprechen.",
        "nameLabel": "Tool-Name",
        "noConfig": "Dieser Handler hat keine Konfiguration.",
        "projectionHint": "Pflicht vor dem Aufruf — ohne Projection lehnt das Backend die Invocation ab.",
        "projectionLabel": "Response-Projection (ein JSONPath pro Zeile)",
        "rateLabel": "Rate-Limit / min",
        "typeLabel": "Handler-Typ",
        "visibilityLabel": "Sichtbarkeit"
      },
      "modes": {
        "free": "frei (Agent-Eingabe)",
        "preset": "fest (in der Datenbank)",
        "context_binding": "aus Kontext (Auth)"
      },
      "params": {
        "mode": "Modus",
        "presetValue": "Fester Wert (JSON)",
        "contextSource": "Kontextquelle"
      }
    },
    "system": {
      "schema": {
        "autoGenerateHintOData": "Erzeugt die drei Tools query / find_rows / describe_tables in draft. Jeder Aufruf wird serverseitig als OData-Abfrage gerendert — Filter über mehrere Spalten, noch ohne Joins und Aggregation. Idempotent — bestehende operation_ids werden übersprungen.",
        "unreadableSets": "{{count}} Entity-Set(s) mit den hinterlegten Zugangsdaten nicht lesbar — nicht übernommen:",
        "unreadableSetsHint": "Das ist die Liste für den Betreiber des Systems: Leserechte ergänzen, dann erneut anwenden.",
        "browser": {
          "title": "Tabellen & Felder",
          "titleClasses": "Klassen & Eigenschaften",
          "filterPlaceholder": "Nach Name oder Beschreibung filtern …",
          "hint": "Beschreibungen sieht das Modell über describe_tables; die Display-Spalte ist das, was find_rows durchsucht und als Label zurückgibt. Beides überlebt ein erneutes Apply.",
          "noMatches": "Kein Treffer für „{{query}}“.",
          "noDescription": "Keine Beschreibung",
          "editDescription": "Beschreibung bearbeiten",
          "entityDescriptionLabel": "Beschreibung der Tabelle (für das Modell)",
          "saveFailed": "Speichern fehlgeschlagen.",
          "loadingAttributes": "Felder werden geladen …",
          "displayColumn": "Display-Spalte",
          "displayColumnHeuristic": "(automatisch wählen)",
          "attributesCount": "{{count}} Felder",
          "primaryKey": "Primärschlüssel",
          "columns": {
            "name": "Feld",
            "type": "Typ",
            "values": "Werte",
            "description": "Beschreibung"
          },
          "writeEndpoint": {
            "open": "Schreib-Endpunkt anlegen",
            "hint": "Legt einen Entwurf „POST /{{table}}“ an, über den Workflows nach Bestätigung im Chat Datensätze anlegen. Nur die angehakten Felder dürfen geschrieben werden – alles andere lehnt der Router ab.",
            "all": "Alle",
            "none": "Keine",
            "count": "{{count}} von {{total}} Feldern",
            "key": "Schlüsselfeld",
            "keyHint": "Schlüsselfelder kommen in jedem Fall in die Antwort, damit die Nummer des neuen Datensatzes zurückkommt. Felder, die die Quelle selbst vergibt (z. B. die Belegnummer), besser abwählen.",
            "create_one": "Entwurf mit {{count}} Feld anlegen",
            "create_other": "Entwurf mit {{count}} Feldern anlegen",
            "created": "Entwurf „{{operation}}“ angelegt. Im Reiter „Tools“ prüfen und aktivieren.",
            "exists": "Für diese Tabelle gibt es schon einen Schreib-Endpunkt.",
            "failed": "Der Endpunkt konnte nicht angelegt werden."
          }
        },
        "persistedTools": "Persistiert: {{count}} Tools",
        "toolsTitle": "Tools der Quelle",
        "toolParams": "Parameter",
        "toolFixed": "Fest",
        "toolExists": "Endpoint vorhanden",
        "counts": "Zahlen aus MCP",
        "countsBtn": "Zahlen nachziehen",
        "countsHint": "Holt Instanz- und Property-Zahlen aus dem Analytics-Tool einer angebundenen MCP-Quelle und schreibt sie an das Schema. Liest nur; kein Profiling. Dauert auf großen Graphmarts rund 30 Sekunden.",
        "countsNoMcp": "Kein aktives MCP-System angebunden — ohne das gibt es kein Analytics-Tool, das zählen könnte.",
        "countsSource": "MCP-System",
        "countsResult": "{{entities}} Klassen und {{attributes}} Properties aktualisiert ({{measured}} gezählt, Stand {{time}}).",
        "countsStatements": "Statements im Graphmart: {{count}}",
        "countsEmpty": "Ohne Instanzen: {{names}}",
        "countsUnmatched": "Gezählt, aber nicht im Schema: {{names}}",
        "apply": "Schema anwenden",
        "applyConfirmAction": "Schema anwenden",
        "applyConfirmBody": "Entities und Attribute werden persistiert (full-replace). Verschwundene Entities werden inkl. ihrer Attribute gelöscht; aktive Endpoints mit Refs auf entfernte Felder werden auf „broken\" geflippt und aus dem LLM-Manifest entfernt.",
        "applyConfirmTitle": "Schema anwenden?",
        "autoGenConfirmAction": "Generieren",
        "autoGenConfirmBody": "Bis zu {{max}} Templates werden in draft erzeugt. Existierende operation_ids werden übersprungen — der Aufruf ist idempotent. Aktivierung passiert manuell pro Endpoint.",
        "autoGenConfirmRegenerate": "Generieren + neu rollen",
        "autoGenConfirmTitle": "Templates generieren?",
        "autoGenerate": "Tools aus Schema erzeugen",
        "autoGenerateBtn": "Templates auto-generieren",
        "autoGenerateHint": "Erzeugt list/get/count/search-Templates pro Entity in draft. Idempotent — bestehende operation_ids werden übersprungen.",
        "connectionProbeFailed": "Verbindungstest fehlgeschlagen (HTTP {{status}}). DSN, Netzwerk-Erreichbarkeit oder Leserechte des RO-Users prüfen.",
        "diff": {
          "added": "Neu",
          "drift": "Schema-Drift erkannt ({{time}}):",
          "endpointsBroken_one": "{{count}} Endpoint auf broken geflippt — fehlende Refs.",
          "endpointsBroken_other": "{{count}} Endpoints auf broken geflippt — fehlende Refs.",
          "endpointsHealthy_one": "{{count}} Endpoint wieder funktionsfähig.",
          "endpointsHealthy_other": "{{count}} Endpoints wieder funktionsfähig.",
          "firstRun_one": "Erster Introspect: {{count}} Eintrag erfasst ({{time}}).",
          "firstRun_other": "Erster Introspect: {{count}} Einträge erfasst ({{time}}).",
          "noDrift_one": "Kein Drift — {{count}} Eintrag unverändert ({{time}}).",
          "noDrift_other": "Kein Drift — {{count}} Einträge unverändert ({{time}}).",
          "removed": "Entfernt",
          "unchanged": "Unverändert",
          "relationsAdded": "+ {{count}} Relationen",
          "relationsRemoved": "− {{count}} Relationen"
        },
        "hint": "Vorschau = Diff ohne Änderung. Anwenden = persistiert das Schema + Drift-Recheck aller Endpoints.",
        "introspect": "Schema-Introspect",
        "persistedClasses_one": "Persistiert: {{count}} Klasse",
        "persistedClasses_other": "Persistiert: {{count}} Klassen",
        "persistedTables_one": "Persistiert: {{count}} Tabelle",
        "persistedTables_other": "Persistiert: {{count}} Tabellen",
        "preview": "Schema-Vorschau",
        "regenerateHint": "Vorhandene Endpoints mit auto_generated=true UND hand_modified=false werden in-place auf das aktuelle Template-Default gerollt. Endpoint-IDs, Aktivierungsstatus und Admin-Permissions bleiben erhalten. Von Hand bearbeitete Tools werden übersprungen.",
        "regenerateLabel": "Bestehende auto-generierte Tools neu rollen",
        "title": "Schema",
        "unsupported": "Introspect ist für diesen Connector-Typ nicht verfügbar — Endpoints müssen manuell im Tools-Tab angelegt werden."
      },
      "activity": {
        "cols": {
          "tool": "Tool"
        },
        "empty": "Keine Invocations für dieses System mit den aktuellen Filtern.",
        "filterEndpoint": "Tool",
        "openGlobal": "In globaler History öffnen",
        "resetFilters": "Filter zurücksetzen",
        "title": "Aktivität"
      },
      "back": "Zurück",
      "backToList": "Zurück zur Übersicht",
      "connection": {
        "auth": "Authentifizierung",
        "authNote": "Credentials sind Fernet-verschlüsselt (ROUTER_AUTH_ENCRYPTION_KEY). Im Notfall: Passwort im externen System rotieren + Source via API aktualisieren.",
        "defaultPerms": "Standard-Berechtigungen für neue Tools",
        "defaultPermsEmpty": "Keine — neue Tools sind initial admin-only.",
        "defaultPermsHint": "Werden bei jedem neuen Endpoint (auto-generiert und manuell) als Permission-Rows kopiert. Bearbeiten über „Bearbeiten\" oben.",
        "deleteBody": "System „{{name}}\" und alle Tools darunter werden permanent gelöscht. Audit-Rows in tool_invocations bleiben erhalten.",
        "deleteTitle": "System löschen?",
        "metadata": "Connection-Metadaten",
        "noMetadata": "Keine non-secret Felder gespeichert.",
        "rotateBody": "Auth-Config (Token / Passwort / DSN) ist hier read-only. Rotation geht heute noch über die API direkt — ein eigener Workflow ist als Follow-up geplant.",
        "rotateTitle": "Credential-Rotation noch nicht im UI",
        "title": "Verbindung & Auth"
      },
      "notFound": "System nicht gefunden — eventuell wurde es gelöscht.",
      "overview": {
        "activeTools": "Live",
        "activityTitle": "Aktivität (letzte 50)",
        "brokenTools": "Defekt",
        "createdAt": "Erstellt",
        "draftTools": "Entwürfe",
        "lastHealthCheck": "Letzter Health-Check",
        "meta": "Metadaten",
        "notes": "Betriebshinweise",
        "successInvocations": "Erfolgreich",
        "successRate": "Erfolgsquote",
        "testingTools": "In Test",
        "toolsTitle": "Tools",
        "totalInvocations": "Aufrufe",
        "totalTools": "Gesamt",
        "updatedAt": "Aktualisiert",
        "viewActivity": "Aktivität öffnen",
        "viewTools": "Tools öffnen"
      },
      "review": {
        "bulkPartialError": "Fehler beim Status-Wechsel: {{message}}",
        "bulkSetTo": "Setzen:",
        "created": "erzeugt",
        "empty": "Noch keine auto-generierten Tools. Auto-Generate-Button oben ausführen, dann hier weiter.",
        "failed": "fehlgeschlagen",
        "failedEntities": "Entities mit Fehler: {{names}}",
        "lastRunTitle": "Letzter Auto-Generate-Lauf",
        "lifecycleNote": "Lifecycle: Entwurf → Test → Live. Das Backend erlaubt nur Vorwärts-Transitions, deshalb sind beide Schritte separate Bulk-Aktionen.",
        "noMatches": "Keine Tools mit aktuellem Filter.",
        "openDetails": "Details",
        "regenerated": "neu gerollt",
        "skipped": "übersprungen",
        "title": "Auto-generierte Tools",
        "generalGroup": "Allgemein"
      },
      "tools": {
        "bulkDelete": "Löschen",
        "bulkDeleteBody": "Die ausgewählten Tools werden permanent gelöscht. Die Aufruf-Historie bleibt erhalten.",
        "bulkDeleteTitle_one": "{{count}} Tool löschen?",
        "bulkDeleteTitle_other": "{{count}} Tools löschen?",
        "bulkSelected": "{{count}} ausgewählt",
        "bulkSetTo": "Status setzen:",
        "cols": {
          "health": "Zustand",
          "lastInvoked": "Letzter Aufruf",
          "operation": "Operation",
          "status": "Status"
        },
        "create": "Neues Tool",
        "createManual": "Manuell anlegen",
        "emptyHint": "Schnellster Weg: zum Schema-Tab wechseln und Auto-Generate verwenden — erzeugt list/get/count/search-Templates für jede Klasse oder Tabelle.",
        "emptyTitle": "Noch keine Tools für dieses System",
        "noMatches": "Keine Treffer mit aktuellen Filtern.",
        "search": "Suche (Operation-ID / Beschreibung)…",
        "title": "Tools",
        "selectAll": "Alle auswählen",
        "selectTool": "Tool {{name}} auswählen"
      },
      "tabs": {
        "overview": "Übersicht",
        "tools": "Tools",
        "schema": "Schema",
        "connection": "Verbindung & Auth",
        "activity": "Aktivität"
      }
    },
    "router": {
      "title": "Verbundene Systeme",
      "subtitle": "Externe Datenquellen (REST, Postgres, SPARQL). Credentials sind verschlüsselt; Roh-Responses gehen nie an den Agent.",
      "clientScope": {
        "label": "Client",
        "own": "Eigener Client",
        "hint": "Zeigt die Systeme dieses Clients und die geteilten Systeme, die jeder Client sieht."
      },
      "ownerBadgeHint": "Owner-Client — nur Caller dieses Clients sehen und nutzen die Tools dieser Quelle.",
      "sharedBadge": "geteilt",
      "sharedBadgeHint": "Kein Owner-Client gesetzt — die Quelle ist für ALLE Clients mit Router-Freischaltung nutzbar. Owner im Bearbeiten-Dialog setzen.",
      "active": "aktiv",
      "inactive": "inaktiv",
      "introspect": "introspect",
      "longRunning": "long-running",
      "connectorTypesTitle": "Connector-Typen",
      "connectorTypesHint": "Klick auf einen Connector-Typ, um ein neues System dieses Typs anzubinden.",
      "sourcesTitle": "Verbundene Systeme",
      "sourcesCount": "{{count}} System(e)",
      "empty": "Noch keine Systeme angebunden. Wähle oben einen Connector-Typ für den Wizard.",
      "cols": {
        "name": "Name",
        "type": "Type",
        "auth": "Auth",
        "health": "Health",
        "status": "Status"
      },
      "fields": {
        "name": "Name (Slug, lowercase, _, mind. 2 Zeichen)",
        "nameInvalid": "Muss matchen: ^[a-z][a-z0-9_]*$ (Backend-CHECK-Constraint).",
        "nameHint": "Wird als Prefix in Tool-Namen verwendet: {name}__{operation}.",
        "displayName": "Anzeigename",
        "description": "Beschreibung / Operational Notes",
        "descriptionPlaceholder": "Owner, Vault-Path für Credentials, Doku-Link, Use-Case…",
        "descriptionHint": "Tipp: PW-Recovery via \"Owner: …\" + \"Credentials in 1Password / Vault X\" hinterlegen.",
        "authMode": "Auth-Mode",
        "authModeFixed": "Auth-Mode",
        "status": "Status",
        "statusHint": "Inaktive Sources liefern keine Endpoints im Tool-Manifest.",
        "communicatorLabel": "Label in cdbChat",
        "communicatorLabelHint": "Wird in cdbChat als Badge neben jedem Tool-Call dieser Source und als Quellen-Tag unter der Antwort angezeigt. Leer = fällt auf den Anzeigenamen zurück.",
        "turnBudget": "Schritte pro Antwort",
        "turnMaxIterations": "Durchläufe",
        "turnMaxToolCalls": "Werkzeugaufrufe",
        "turnBudgetHint": "Für Systeme, deren Abfragen viele Schritte brauchen (z. B. Ranglisten über einen Graphen). Gilt ab dem ersten Aufruf dieses Systems in einer Antwort und erhöht nur. Leer = Standard ({{defaultIterations}} Durchläufe, {{defaultToolCalls}} Aufrufe), höchstens {{maxIterations}} bzw. {{maxToolCalls}}.",
        "turnBudgetInvalid": "Schritte pro Antwort: ganze Zahl von 1 bis {{maxIterations}} (Durchläufe) bzw. {{maxToolCalls}} (Aufrufe), oder leer lassen.",
        "communicatorColor": "Badge-Farbe",
        "communicatorPreview": "Vorschau:",
        "ownerClient": "Owner-Client",
        "ownerClientShared": "— geteilt (alle Clients) —",
        "ownerClientHint": "Harte Grenze: Mit Owner sehen und nutzen NUR Caller dieses Clients die Tools dieser Quelle — auch künftige Endpoints. Ohne Owner ist die Quelle mandantenübergreifend.",
        "ownerClientFixedHint": "Der Owner wird beim Verbinden festgelegt und ist danach fest — das System liegt in der Datenbank seines Clients. Für einen anderen Owner das System neu verbinden."
      },
      "create": {
        "title": "Neue Source — {{type}}",
        "step1": "Schritt 1/2 — Name, Beschreibung, Connection-Metadaten.",
        "step2": "Schritt 2/2 — Auth-Mode + Credentials. Werden Fernet-verschlüsselt gespeichert.",
        "connectionSection": "Connection-Metadaten",
        "authSection": "Credentials (werden verschlüsselt gespeichert)",
        "noAuthFields": "Auth-Mode {{mode}} braucht keine Felder.",
        "submit": "Source anlegen",
        "successHint": "Source angelegt. Tipp: Bei Postgres-Sources jetzt im Detail-Drawer auf \"Re-Introspect\" klicken, um Schema zu erfassen + Connection zu testen."
      },
      "edit": {
        "title": "Source bearbeiten",
        "authNote": "Auth-Config und Connection-Config sind hier nicht editierbar — Credential-Rotation kommt als eigener Workflow.",
        "connectionHint": "Achtung: Änderungen wirken sofort. Wenn sich z. B. der Ontologie-Namespace ändert, werden bestehende Slot-IRIs ungültig — bestehende Tools dann erneut prüfen.",
        "connectionSection": "Connection-Metadaten",
        "extraKeysHint": "Connector-spezifische Felder (nicht im Catalog-Schema deklariert, vom Backend per Konvention gelesen):"
      },
      "delete": {
        "title": "Source löschen?",
        "confirm": "Source \"{{name}}\" und alle Endpoints darunter werden permanent gelöscht. Audit-Rows in tool_invocations bleiben erhalten."
      },
      "detail": {
        "status": "Status",
        "lastHealthCheck": "Letzter Health-Check",
        "connection": "Connection-Metadaten",
        "noConnectionConfig": "Keine non-secret Connection-Felder gespeichert.",
        "auth": "Authentifizierung",
        "authNote": "Credentials sind Fernet-verschlüsselt (ROUTER_AUTH_ENCRYPTION_KEY). Im Notfall: PW im externen System rotieren + Source via PUT /sources/{id} updaten.",
        "notes": "Operational Notes",
        "introspect": "Schema-Introspect",
        "previewSchema": "Preview Schema",
        "applySchema": "Apply Schema",
        "introspectHint": "Preview = read-only Diff. Apply = persistiert Schema + Drift-Recheck aller Endpoints.",
        "introspectOk": "OK — {{count}} Tabellen entdeckt ({{time}})",
        "introspectFirstRun": "Initial introspect: {{count}} Tabellen erfasst ({{time}}).",
        "introspectFirstRunClasses": "Initial introspect: {{count}} Klassen erfasst ({{time}}).",
        "introspectNoDrift": "Kein Drift — {{count}} Tabellen unverändert ({{time}}).",
        "introspectNoDriftClasses": "Kein Drift — {{count}} Klassen unverändert ({{time}}).",
        "relationsAdded": "{{count}} Relations neu",
        "relationsRemoved": "{{count}} Relations entfernt",
        "introspectDrift": "Schema-Drift erkannt ({{time}}):",
        "previewNote": "Preview — nichts wurde gespeichert. Click \"Apply Schema\" um zu committen.",
        "appliedNote": "Schema persistiert. Aktive Endpoints wurden gegen das neue Schema gechecked.",
        "endpointsNowBroken": "{{count}} Endpoint(s) zu broken geflippt — fehlende Slot- oder JOIN-Refs.",
        "endpointsNowHealthy": "{{count}} Endpoint(s) recovered — Refs sind wieder gültig.",
        "autoGenerateHintStructured": "Erzeugt die drei serverseitig gerenderten Tools query / find_rows / describe_tables in draft (oder wahlweise das Per-Tabelle-Set). Idempotent — bestehende operation_ids werden übersprungen.",
        "familyStructured": "Strukturierte Tools (Standard)",
        "familyStructuredHint": "query, find_rows, describe_tables — Filter über mehrere Spalten, Joins entlang der Relationen mit Filtern auf beiden Seiten, Aggregation. Das Statement wird pro Aufruf serverseitig gegen das Schema gerendert.",
        "familyLegacy": "Per-Tabelle-Templates",
        "familyLegacyHint": "list / get_by_id / count / aggregate / search pro Tabelle plus ein Join-Template pro Relation — ein Filter pro Aufruf, Slots im Manifest.",
        "autoGenerateTemplates": "Auto-Generate Templates",
        "autoGenerateHint": "Erzeugt list/get_by_id/count/aggregate/search pro Entity in draft. Idempotent.",
        "autoGenerateResult": "{{created}} Templates erzeugt, {{skipped}} übersprungen ({{time}}).",
        "applyConfirmTitle": "Schema anwenden?",
        "applyConfirmBody": "Tabellen + Spalten werden persistiert (full-replace). Tabellen die nicht mehr in der Live-DB existieren werden inkl. ihrer Attribute gelöscht; aktive Endpoints mit Slot- oder JOIN-Refs auf entfernte Felder werden auf \"broken\" geflippt und aus dem LLM-Manifest entfernt.",
        "applyConfirmHint": "Tipp: zuerst \"Preview Schema\" klicken um den Diff vor dem Commit zu sehen.",
        "applyConfirmAction": "Schema anwenden",
        "autoGenConfirmTitle": "Templates generieren?",
        "autoGenConfirmBody": "Bis zu {{max}} Templates werden in draft erzeugt ({{entities}} Entities × bis zu 5 Templates pro Entity je nach Schema-Form). Existierende operation_ids werden übersprungen — der Aufruf ist idempotent. Aktivierung passiert manuell pro Endpoint im Detail-Drawer.",
        "autoGenConfirmBodySparql": "Bis zu {{max}} SPARQL-Templates werden in draft erzeugt ({{entities}} Klassen × list/get_by_uri/count/search, plus relations_<class> wenn die Klasse Object-Properties hat). Existierende operation_ids werden übersprungen — der Aufruf ist idempotent. Aktivierung passiert manuell pro Endpoint im Detail-Drawer.",
        "autoGenConfirmAction": "Generieren",
        "currentSchema": "Aktuell persistiert: {{count}} Tabellen.",
        "added": "Neu",
        "removed": "Entfernt",
        "unchanged": "Unverändert",
        "endpoints": "Endpoints ({{count}})",
        "noEndpoints": "Noch keine Endpoints. Auf \"Neuer Endpoint\" klicken um den Wizard zu starten.",
        "addEndpoint": "Neuer Endpoint",
        "meta": "Metadaten",
        "createdBy": "Erstellt von",
        "createdAt": "Erstellt",
        "updatedAt": "Aktualisiert"
      },
      "endpointCreate": {
        "title": "Neuer Endpoint — {{source}}",
        "step1": "Schritt 1 — Operation-ID + Beschreibung.",
        "step2": {
          "postgres": "Schritt 2 — SQL-Template.",
          "rest": "Schritt 2 — HTTP-Method + Path (+ optional Body-Template).",
          "sparql": "Schritt 2 — SPARQL-Query (POST wird automatisch gesetzt)."
        },
        "step3": {
          "slots": "Schritt 3 — Whitelist-Definition für jeden {{...}}-Platzhalter im Template."
        },
        "execSection": "Execution",
        "projectionSection": "Response-Projection (JSONPath-Whitelist)",
        "submit": "Endpoint anlegen (Status: draft)",
        "placeholdersBlock": "{{...}}-Placeholders ({{names}}) im Template/Path/Body — bitte entfernen, Endpoint anlegen, dann Slots im Detail-Drawer wiren. Backend würde den Save sonst direkt mit \"missing slot_definitions\" zurückweisen.",
        "step4": {
          "returns": "Schritt 4 — Optional: Result-Entity + Kardinalität als Hinweis."
        },
        "step5": {
          "execution": "Schritt 5 — Execution-Config + sichtbare Felder."
        }
      },
      "endpointFields": {
        "operationId": "Operation-ID (Slug, lowercase, _, mind. 2 Zeichen)",
        "operationIdInvalid": "Muss matchen: ^[a-z][a-z0-9_]*$ (Backend-CHECK-Constraint).",
        "operationIdHint": "Tool-Name im Manifest: {{src}}__{{op}}",
        "description": "Beschreibung (für den Agent — was tut, wann nutzen)",
        "descriptionPlaceholder": "Z.B. \"Listet aktive User pro Client. Nutze wenn nach User-Statistiken gefragt wird.\"",
        "method": "Method",
        "path": "Path",
        "pathHint": "Path-Params als {placeholder} markieren — werden später in den Endpoint-Params verdrahtet.",
        "sqlTemplate": "SQL-Template",
        "sqlHint": "Nur SELECT/WITH am Statement-Anfang — Backend lehnt sonst ab. Named-Params via :name; werden später in den Endpoint-Params verdrahtet.",
        "sqlNotReadOnly": "⚠ Statement startet nicht mit SELECT/WITH — Backend wird das ablehnen.",
        "bodyTemplate": "Body-Template (optional)",
        "bodyTemplateHint": "JSON-String mit {{slot}}-Placeholders für admin-kontrollierte Identifier (Cypher-Label, Mongo-$match-Spalte, …). Caller-Body-Params werden deep-merged.",
        "bodyTemplateMethodMismatch": "⚠ Method {{method}} sendet typischerweise keinen Body — Template wird ignoriert.",
        "bodyTemplateInvalidJson": "⚠ Kein gültiges JSON nach Slot-Substitution: {{error}}",
        "timeoutSeconds": "Timeout (Sekunden, max 600)",
        "rateLimit": "Rate-Limit (/min)",
        "resultRowCap": "Result Row Cap",
        "resultRowCapHint": "Hard-Cap — überzählige Rows werden gedroppt + truncated-Marker.",
        "longRunning": "Long-running (ARQ-async)",
        "requiresCatalogValidation": "Catalog-Validation (properties[])",
        "requiresCatalogValidationHint": "Freie properties[]-Payloads werden vor dem SPARQL-Build gegen den Property-Catalog validiert — Misses werden zur Rückfrage statt zu halluzinierten Pfaden.",
        "projectionHint": "Leer = nichts an LLM exposed (opt-in). Beispiele: $.id, $.results[*].name, $[*].user_count",
        "projectionEmpty": "⚠ Keine Projection definiert — Endpoint kann nur via /test (admin-only) gerufen werden.",
        "mcpTool": "Tool auf dem MCP-Server",
        "mcpToolHint": "Exakter Name auf dem Server (camelCase erlaubt) — nicht die Operation-ID, die das Modell sieht.",
        "mcpFixedArguments": "Feste Argumente (JSON-Objekt, optional)",
        "mcpFixedArgumentsHint": "Was hier steht, setzt die Quelle fest — das Modell kann es nicht überschreiben und bekommt es nicht als Parameter.",
        "isFallback": "Freie-Abfrage-Fallback",
        "isFallbackHint": "Dieser Endpoint erscheint im Chat erst, wenn ein Aufruf der Quelle, die er vertritt, im selben Turn leer zurückkam. Antworten daraus werden markiert. Nur einer pro vertretener Quelle.",
        "fallbackForSource": "Vertritt die Vorlagen von",
        "fallbackForOwnSource": "Eigene Quelle",
        "fallbackForSourceHint": "Der Connector gehört zur Quelle. Die freie Abfrage einer Graph-Quelle liegt deshalb auf dem MCP-System und vertritt hier die Graph-Quelle: sie erscheint, wenn deren Vorlagen nichts gefunden haben.",
        "callableFrom": "Aufrufbar",
        "callableFromChat": "Im Chat und in Workflows",
        "callableFromWorkflows": "Nur in Workflows",
        "callableFromHint": "Nur in Workflows: der Chat bietet den Endpoint nicht an, ein Workflow-Schritt ruft ihn weiter auf.",
        "callableFromLocked": "Dieser Endpoint schreibt in die Quelle. Er läuft nur als Workflow-Schritt, den eine Person bestätigt.",
        "sparqlHint": "SELECT / CONSTRUCT / ASK / DESCRIBE. Method=POST wird automatisch gesetzt. Slot-Whitelists via {{name}} (z. B. {{cls}} für Klassen-IRIs) — werden im nächsten Schritt definiert.",
        "sparqlNotStandard": "⚠ Query startet nicht mit PREFIX/SELECT/CONSTRUCT/ASK/DESCRIBE.",
        "sparqlPath": "Path-Override (optional)",
        "sparqlPathHint": "Leer lassen, um den auf System-Ebene konfigurierten Path zu nutzen. Hier setzen, wenn dieses Tool gegen ein anderes Dataset gehen soll.",
        "sparqlQuery": "SPARQL-Query"
      },
      "endpointEdit": {
        "title": "Endpoint bearbeiten",
        "returnsHint": "Beide Felder optional. Werden im Auto-Generate-Review-Tab zur Gruppierung genutzt.",
        "returnsSection": "Returns (Hinweis)"
      },
      "endpointDelete": {
        "title": "Endpoint löschen?",
        "confirm": "Endpoint \"{{op}}\" wird permanent gelöscht. Audit-Rows in tool_invocations bleiben erhalten."
      },
      "endpointDetail": {
        "queryBuilderHint": "Serverseitig gerendert: Das Statement entsteht pro Aufruf aus dem strukturierten Payload des Modells und dem introspektierten Schema (Tabellen, Spalten, Relationen, bekannte Werte). Kein Template, keine Slots — das gerenderte SQL steht im Test-Ergebnis und im Trace.",
        "renderedSql": "Gerendertes SQL:",
        "renderedRequest": "Gerenderte Anfrage:",
        "joinPath": "Join-Pfad:",
        "description": "Beschreibung",
        "shape": "Shape",
        "bodyTemplate": "Body-Template (slot-substituted, deep-merged with caller body):",
        "execution": "Execution-Config",
        "slots": "Slots ({{count}})",
        "params": "Parameter",
        "permissions": "Zugriffsberechtigungen",
        "projection": "Response-Projection",
        "healthBroken": "broken",
        "autoGenerated": "auto-generated",
        "brokenTitle": "Endpoint ist broken — wird nicht im Manifest exposed",
        "brokenFallback": "Schema-Drift seit letzter Schema-Apply. Slot-Definitions oder JOIN-Refs prüfen.",
        "lifecycle": "Lifecycle",
        "currentStatus": "Aktueller Status:",
        "transitionTo": "→ {{target}}",
        "atActive": "Endpoint ist aktiv im Manifest.",
        "lifecycleHint": "draft → testing → active (rückwärts blockiert). Nur active erscheint im Tool-Manifest.",
        "recentInvocations": "Letzte Invocations",
        "noInvocations": "Noch keine Invocations für diesen Endpoint.",
        "meta": "Metadaten",
        "createdBy": "Erstellt von",
        "createdAt": "Erstellt",
        "updatedAt": "Aktualisiert"
      },
      "errors": {
        "connectionProbeFailed": "Connection probe failed (HTTP {{status}}). DSN, Netzwerk-Reachability oder RO-User-Grants prüfen — Server-Logs haben Details.",
        "authFieldRequired": "Auth-Feld \"{{label}}\" ist erforderlich.",
        "unknownAuthMode": "Unbekannter Auth-Mode: {{mode}}",
        "paramDeleteFailed": "Param konnte nicht gelöscht werden: {{message}}"
      },
      "params": {
        "empty": "Keine Params definiert. Wenn das Template :placeholder bzw. {placeholder} hat, hier verdrahten.",
        "addBtn": "Param hinzufügen",
        "nameRequired": "Name ist erforderlich.",
        "fields": {
          "name": "Name",
          "location": "Location",
          "description": "Beschreibung (für den Agent)",
          "descriptionPlaceholder": "Was sollte der Agent hier reinschreiben?",
          "required": "Required",
          "attribute": "Quell-Attribut (optional)",
          "attributeInheritsType": "Datentyp wird vom Attribut übernommen ({{type}}).",
          "attributeNone": "(keins)",
          "dataType": "Datentyp",
          "dataTypeNone": "(nicht gesetzt)",
          "defaultValue": "Default-Wert (JSON, optional)",
          "defaultValueHint": "JSON-Literal. Strings in Quotes. Leer = kein Default — der Agent muss den Wert dann liefern."
        }
      },
      "slots": {
        "empty": "Keine Slots definiert. Wenn Template oder Path {{placeholder}} enthält, hier verdrahten.",
        "missing": "Template hat {{...}} ohne Slot-Definition: {{names}}. Slot anlegen oder Placeholder entfernen.",
        "orphan": "Slots ohne {{name}}-Verwendung im Template: {{names}}. Slot löschen oder Template ergänzen.",
        "addBtn": "Slot hinzufügen",
        "whitelistCount": "{{count}} Werte",
        "wizardHintTitle": "Slot-Whitelists fehlen noch",
        "wizardHintBody": "Erkannt: {{names}}. Nach Create im Endpoint-Detail-Drawer in Slots-Section pro Placeholder Whitelist setzen — sonst rejected der Backend-Validator den Save.",
        "types": {
          "column": "Spalte (column)",
          "table": "Tabelle (table)",
          "enum": "Enum (freie Literale)",
          "class": "Klasse (SPARQL class-IRI)",
          "predicate": "Predicate (SPARQL property-IRI)"
        },
        "fields": {
          "name": "Name",
          "type": "Typ",
          "description": "Beschreibung (für den Agent)",
          "descriptionPlaceholder": "Was wählt der Agent hier? z.B. \"Filter-Spalte\"",
          "required": "Required",
          "entity": "Entity (Tabelle)",
          "pickEntity": "— wählen —",
          "allowedColumns": "Spalten in Whitelist",
          "allowedEntities": "Entities in Whitelist",
          "allowedValues": "Erlaubte Werte (komma-separiert)",
          "allowedClassIris": "Klassen in Whitelist (volle IRIs)",
          "classIrisHint": "Connector wrappt die IRI automatisch in <…> — Template schreibt {{cls}} statt <{{cls}}>.",
          "noEntitiesYet": "Keine Klassen persistiert — erst „Apply Schema\" auf der Source ausführen.",
          "allowedPredicateIris": "Predicates in Whitelist (volle IRIs)",
          "predicateIrisHint": "Connector wrappt die IRI automatisch in <…> — Template schreibt {{pred}} statt <{{pred}}>.",
          "noRelationsYet": "Keine Object-Properties persistiert — Source apply-en oder Source hat keine Relations."
        },
        "errors": {
          "nameRequired": "Name ist erforderlich.",
          "nameFormat": "Name muss mit Kleinbuchstaben starten und nur a-z, 0-9, _ enthalten.",
          "duplicateName": "Ein Slot mit diesem Namen existiert bereits.",
          "entityRequired": "Entity wählen, auf die der Slot scoped ist.",
          "columnsRequired": "Mindestens eine Spalte in die Whitelist aufnehmen.",
          "entitiesRequired": "Mindestens eine Entity in die Whitelist aufnehmen.",
          "valuesRequired": "Mindestens einen Wert komma-separiert eintragen (z.B. ASC, DESC).",
          "enumValueShape": "Werte müssen Identifier-Shape haben (a-zA-Z_, dann a-zA-Z0-9_) — keine Leerzeichen oder Sonderzeichen. Ungültig: {{names}}",
          "classIrisRequired": "Mindestens eine Klasse in die Whitelist aufnehmen.",
          "predicateIrisRequired": "Mindestens ein Predicate in die Whitelist aufnehmen."
        },
        "allowed": "Erlaubte Werte",
        "description": "Beschreibung",
        "descriptionPlaceholder": "Optionale Erklärung für den Agent",
        "detectedInQuery": "Erkannte Platzhalter: {{names}} — werden im nächsten Schritt mit Whitelists belegt.",
        "entity": "Entity",
        "required": "Pflicht",
        "stepHint": "Jeder {{...}}-Platzhalter im Template muss eine Whitelist haben. Werte trennen mit Zeilenumbruch.",
        "type": "Typ",
        "entityNotPicked": "(noch nicht gewählt)"
      },
      "defaultPerms": {
        "title": "Standard-Berechtigungen für neue Endpoints",
        "hint": "Werden bei jedem neuen Endpoint (auto-generated und manuell) als Permission-Rows kopiert. Leer = nur Admin.",
        "empty": "Keine — neue Endpoints sind initial admin-only.",
        "addBtn": "Berechtigung hinzufügen",
        "kind": "Typ",
        "role": "Rolle",
        "client": "Client",
        "accessType": "Zugriff"
      },
      "endpointPerms": {
        "hint": "Welche Rollen und Clients sehen + dürfen diesen Endpoint nutzen. Leer = nur Admin. Mehrere Einträge = OR (ein Match reicht).",
        "empty": "Keine Permissions — der Endpoint ist aktuell nur für Admins sichtbar.",
        "addBtn": "Permission hinzufügen",
        "kind": "Typ",
        "role": "Rolle",
        "client": "Client",
        "accessType": "Zugriff"
      },
      "colors": {
        "default": "Standard",
        "blue": "Blau",
        "green": "Grün",
        "red": "Rot",
        "amber": "Amber",
        "violet": "Violett",
        "pink": "Pink",
        "cyan": "Cyan"
      },
      "connectBtn": "System verbinden",
      "connectFirst": "Erstes System verbinden",
      "connectorPicker": {
        "subtitle": "Wähle den Typ des Systems, das angebunden werden soll. Im nächsten Schritt werden Name, Verbindungsdaten und Auth konfiguriert.",
        "title": "Neues System verbinden"
      },
      "emptyHint": "Verbinde dein erstes externes System (REST-API, Postgres, SPARQL). Nach der Anbindung kannst du Tools auto-generieren oder manuell anlegen.",
      "emptyTitle": "Noch keine Systeme verbunden",
      "returns": {
        "cardinality": "Kardinalität",
        "cardinalityNone": "(unbekannt)",
        "entity": "Result-Entity",
        "entityHint": "Welche Entity / Klasse liefert dieses Tool? Bei Aggregaten (count_*) leer lassen.",
        "entityNone": "(unbekannt)",
        "hint": "Optional — hilft beim Gruppieren im Auto-Generate-Review und beim Schema-Hinting für den Agent. Beide Felder können leer bleiben.",
        "many": "Viele Zeilen (many)",
        "one": "Eine Zeile (1)"
      },
      "stats": {
        "active": "Aktiv",
        "connectorTypes": "Connector-Typen",
        "healthy": "Erreichbar",
        "neverProbed": "Noch nicht geprüft",
        "systems": "Systeme"
      },
      "systemCard": {
        "auth": "Auth",
        "brokenTools_one": "{{count}} defektes Tool",
        "brokenTools_other": "{{count}} defekte Tools",
        "open": "System {{name}} öffnen",
        "tools": "Tools"
      },
      "test": {
        "hint": "Nur Admin · umgeht Status & Rate-Limit · protokolliert als mode=test",
        "noInputs": "Keine Parameter oder Slots — direkt mit „Test ausführen\" starten.",
        "openInHistory": "In History öffnen",
        "params": "Parameter",
        "projected": "Projiziert (Agent-View)",
        "raw": "Raw (Audit-Row)",
        "run": "Test ausführen",
        "slots": "Slots",
        "title": "Testen"
      },
      "requiredBadge": "Pflicht",
      "deleteItem": "Löschen",
      "removePermission": "Berechtigung entfernen",
      "authFields": {
        "token": "Bearer-Token",
        "header": "Header-Name",
        "key": "API-Key",
        "username": "Benutzername",
        "password": "Passwort",
        "tokenUrl": "Token-URL",
        "clientId": "Client-ID",
        "clientSecret": "Client-Secret",
        "scope": "Scope (optional)",
        "dsn": "Connection-String (DSN)"
      }
    },
    "manifest": {
      "title": "Tool Manifest",
      "subtitle": "Vorschau dessen, was ein Caller im /agent/tools-Endpoint sehen würde. Skills + Router vereint, vendor-formatiert.",
      "subtitleEditable": "Tabelle aller aktiven Agent-Tools mit Berechtigungen. Pro Tool: erst Clients zuweisen, dann Rollen freischalten. Leer = öffentlich für alle authentifizierten User; admin-only wird explizit über eine Rolle gesetzt.",
      "simulateCaller": "Simuliere Caller-Type (Admin-Preview)",
      "useMyContext": "— eigener Context —",
      "filterClient": "Filter: Client",
      "allClients": "— alle Clients —",
      "externalM2mHint": "External M2M sieht NUR visibility=public Skills und KEINE Router-Tools (Hard rule für Credential-Hijack-Prävention).",
      "empty": "Keine Tools sichtbar für diesen Caller-Type.",
      "toolCount": "{{count}} Tools im Manifest",
      "toolCountFiltered": "{{shown}} von {{total}} Tools (Filter aktiv)",
      "params": "Parameter (was der Agent sieht):",
      "noParams": "Keine Parameter (Agent ruft ohne Argumente).",
      "cols": {
        "tool": "Tool",
        "kind": "Typ",
        "clients": "Clients",
        "roles": "Rollen"
      },
      "noFilterPublic": "Kein Filter gesetzt — öffentlich für alle",
      "public": "öffentlich",
      "editPermissions": "Berechtigungen bearbeiten"
    },
    "history": {
      "title": "Invocation History",
      "subtitle": "Audit-Trail aller Tool-Calls — Skills + Router. Zeigt Caller, Parameter, projizierte Response, Status.",
      "clientScopeHint": "Aufrufe liegen beim Mandanten der aufrufenden Person.",
      "filterSource": "Source-Type",
      "filterStatus": "Status",
      "empty": "Keine Invocations für die aktuelle Filterung — entweder keine Calls oder Filter zu eng.",
      "cols": {
        "time": "Zeit",
        "source": "Quelle",
        "mode": "Mode",
        "status": "Status",
        "duration": "Dauer",
        "caller": "Caller"
      },
      "detail": {
        "title": "Invocation-Details",
        "summary": "Zusammenfassung",
        "caller": "Caller",
        "params": "Params (Input)",
        "response": "Response (post-projection)",
        "workflowRun": "Workflow-Lauf",
        "error": "Fehler",
        "source": "Quelle",
        "mode": "Modus",
        "status": "Status",
        "duration": "Dauer",
        "time": "Zeit",
        "userId": "User-ID",
        "apiKeyId": "API-Key-ID",
        "client": "Client",
        "ka": "KA",
        "arqJob": "Hintergrund-Job (ARQ)"
      },
      "drillDown": {
        "label": "Gefiltert auf Tool",
        "clear": "Filter entfernen"
      },
      "sessionFilter": {
        "label": "Gefiltert auf Session",
        "turnLabel": "Turn",
        "turnPending": "Turn-genaue Filterung folgt mit dem tqs-Update — aktuell Session-weit.",
        "back": "Zurück zum Session-Trace"
      },
      "emptySession": "Keine Invocations für diese Session — entweder liefen keine Tool-Calls oder die Einträge wurden bereits durch die Aufbewahrungsfrist gelöscht.",
      "sourceTypes": {
        "routerRest": "System (REST/SPARQL)",
        "routerPostgres": "System (Postgres)",
        "workflow": "Workflow",
        "builtin": "cdbChat (integriert)"
      },
      "filterMode": "Modus",
      "filterSince": "Ab (since)",
      "filterUntil": "Bis (until)",
      "clearExtraFilters": "Extra-Filter zurücksetzen",
      "callerApiKey": "API-Key",
      "callerSystem": "System"
    },
    "chat": {
      "running": "Läuft…",
      "completed": "Erfolg",
      "failed": "Fehler",
      "skipped": "Übersprungen",
      "argsLabel": "Argumente",
      "resultLabel": "Ergebnis",
      "durationMs": "{{ms}} ms",
      "truncatedHint": "Ergebnis wurde serverseitig auf {{bytes}} Bytes gekürzt",
      "truncatedHintNoBytes": "Ergebnis wurde serverseitig gekürzt",
      "manifestTruncated": "{{shown}} von {{total}} verfügbaren Tools angezeigt",
      "progress": "Plant nächste Schritte… (Iteration {{iteration}} / {{budget}}, {{completed}} Tools fertig)",
      "loopExceeded": {
        "max_tool_calls": "Maximale Anzahl Tool-Aufrufe pro Turn erreicht ({{cap}})",
        "max_iterations": "Maximale Loop-Iterationen erreicht ({{cap}})"
      },
      "errorCodes": {
        "permission_denied": "Keine Berechtigung",
        "rate_limited": "Rate-Limit überschritten",
        "validation_error": "Ungültige Argumente",
        "tool_not_found": "Tool nicht gefunden",
        "internal_error": "Interner Fehler",
        "client_error": "Client-Fehler",
        "invalid_args_json": "Argumente waren kein gültiges JSON",
        "async_not_supported": "Hintergrund-Tools werden im Chat noch nicht unterstützt",
        "unknown_tool": "Tool nicht im Manifest",
        "loop_ended": "Loop beendet — Tool nicht abgeschlossen",
        "limit_exceeded": "Token- oder Kostenlimit erreicht"
      },
      "empty": "Keine Tool-Aufrufe in diesem Turn",
      "sourceTypes": {
        "skill": "Skill",
        "router_rest": "Router (REST)",
        "router_postgres": "Router (Postgres)",
        "builtin": "cdbChat (integriert)"
      }
    },
    "propertyCatalog": {
      "sectionTitle": "Property-Katalog ({{count}})",
      "reviewQueue": "{{count}} zu prüfen",
      "add": "Eintrag",
      "hint": "Der Katalog mapt User-Begriffe („Preisgruppe\") deterministisch auf Property-IRIs + Pfade. Auto-Derived Einträge werden vom Schema-Walk-LLM gelernt und sollten geprüft werden.",
      "empty": "Keine Einträge für diesen Filter. „Eintrag\" anklicken um manuell anzulegen.",
      "filterAll": "Alle Einträge",
      "filterReviewQueue": "Review-Queue (auto + validiert)",
      "filterAutoDerived": "Nur auto-discovered",
      "filterAutoValidated": "Nur system-validiert",
      "filterManual": "Manuell",
      "filterProfileDerived": "Aus Profilen",
      "filterSourceIntrospect": "Aus Schema",
      "promote": "Als „manual\" bestätigen",
      "aliasesLabel": "Aliase",
      "createTitle": "Neuer Katalog-Eintrag",
      "editTitle": "Katalog-Eintrag bearbeiten",
      "deleteTitle": "Katalog-Eintrag löschen?",
      "deleteBody": "Eintrag „{{label}}\" wird gelöscht. Skills, die ihn als Override referenziert haben, fallen zurück auf Catalog-Miss + Discovery.",
      "fieldIri": "Property-IRI (final value predicate)",
      "iriImmutable": "IRI ist Teil der Signature und kann nicht geändert werden — lösche den Eintrag und lege einen neuen an.",
      "fieldLabelDe": "Label DE",
      "fieldLabelEn": "Label EN",
      "fieldAliases": "Aliase (kommagetrennt oder pro Zeile)",
      "aliasesHint": "Werden automatisch lowercased + dedupliziert. Diese Begriffe machen den Resolver-Hit deterministisch.",
      "fieldDefinitionDe": "Definition DE",
      "fieldDefinitionEn": "Definition EN",
      "definitionHint": "Kommt aus der Ontologie (rdfs:comment) und wird dem Nutzer bei Rückfragen als Erklärung angezeigt. Nicht Teil des Tool-Manifests.",
      "fieldProvenance": "Herkunft",
      "usePathForm": "Multi-Hop-Pfad (für Indirection über Relations)",
      "fieldPathHops": "Pfad-Hops (Bridge → Final, in Reihenfolge)",
      "noHops": "Noch keine Hops — „Hop\" anklicken um den ersten Bridge-Predicate zu setzen.",
      "pathHint": "Letzter Hop ist der Value-Predicate. Constraints + komplexere Multi-Hops bequemer im Enrichment-Profile-Editor.",
      "errIriRequired": "Property-IRI ist Pflicht.",
      "resolvePlaceholder": "Resolve-Test: Begriffe komma-getrennt (z. B. „Preisgruppe, Milestone\")",
      "resolveMiss": "unbekannt",
      "resolveAmbiguous": "mehrdeutig",
      "suggestions": "Vorschläge",
      "noSubjectScope": "— ohne Subject-Scope —",
      "subjectScopeHint": "Optional: Subject-Class für Narrowing (#480). Leer = ohne Narrowing, zeigt den rohen Kandidaten-Satz.",
      "subjectScopeBadge": "Scope",
      "bulkSelectAll": "Alle prüfbaren ({{count}})",
      "bulkSelectAllAria": "Alle prüfbaren Einträge auswählen",
      "bulkSelectRowAria": "Eintrag „{{label}}\" für Bulk-Promote auswählen",
      "bulkPromote": "{{count}} bestätigen",
      "paginationRange": "{{from}}–{{to}} von {{total}}",
      "pageOf": "{{current}} / {{total}}",
      "prevPage": "← Zurück",
      "nextPage": "Weiter →",
      "addHop": "Hop",
      "inverse": "invers",
      "hopCount": "{{count}}-Hop"
    },
    "enrichmentProfiles": {
      "sectionTitle": "Enrichment-Profile ({{count}})",
      "add": "Neues Profil",
      "hint": "Profile bündeln Property-IRIs + Spalten-Labels für Bulk-Anreicherung (z. B. Excel-Upload). Werden vom Skill `enrich_excel` aufgelöst.",
      "empty": "Noch keine Profile. „Neues Profil\" anklicken um eines anzulegen.",
      "defaultBadge": "Default",
      "columnsCount": "{{count}} Spalten",
      "createTitle": "Neues Enrichment-Profil",
      "editTitle": "Enrichment-Profil bearbeiten",
      "deleteTitle": "Profil löschen?",
      "deleteBody": "Das Profil „{{name}}\" wird unwiderruflich gelöscht. Skills, die das Profil noch ausdrücklich per ID verwenden, fallen zurück auf das Default-Profil oder schlagen fehl.",
      "namePlaceholder": "z. B. vertrieb_default",
      "fields": {
        "identifierLabel": "Identifier-Spaltenname",
        "identifierLabelPlaceholder": "z. B. MLFB",
        "identifierLabelHint": "Fester Spaltenname für die Identifier-Spalte der erzeugten Excel. Wird genutzt, wenn der Chat keinen Namen mitgibt — bleibt so über Folge-Anfragen erhalten. Leer = generisch „Identifier\".",
        "subjectClass": "Subject-Klasse",
        "subjectClassHint": "Die RDF-Klasse, deren Instanzen angereichert werden (z. B. Produktvariante).",
        "matchPredicate": "Match-Prädikat",
        "matchPredicateNone": "(keins — Subjects sind direkt URIs)",
        "matchPredicateHint": "Datatype-Property gegen die die Excel-Zellen-Werte gematched werden (z. B. Label, MLFB-Code, SKU). „keins\" = Werte in der Excel sind bereits URIs.",
        "directProperties": "Direkte Properties (Datatype-Properties)",
        "directPropertiesHint": "Klick zum An-/Abschalten. Wert wird direkt am Subject gelesen (`?subject <prop> ?value`).",
        "indirectProperties": "1-Hop-Indirection (Object-Properties)",
        "indirectPropertiesHint": "Klick fügt eine Relation hinzu, deren Wert über ein „Wert-über\"-Prädikat aus dem verlinkten Knoten gezogen wird (z. B. hasPriceAT → priceValue, hasProductCategory → rdfs:label). Default ist rdfs:label, pro Eintrag unten überschreibbar.",
        "noAttributes": "Keine Datatype-Properties persistiert — „Apply Schema\" auf der Source ausführen.",
        "noRelations": "Keine Object-Properties persistiert — „Apply Schema\" auf der Source ausführen.",
        "outputColumns": "Output-Spalten (Reihenfolge + Label + Wert-über)",
        "labelPlaceholder": "Spalten-Header",
        "valueViaPlaceholder": "Wert-über-Prädikat (z. B. rdfs:label)",
        "directBadge": "direkt",
        "isDefault": "Als Default für diese Source markieren",
        "addConstraintHint": "Constraint hinzufügen (Zwischenknoten auf URI pinnen)",
        "addHop": "Hop hinzufügen",
        "addMultiHop": "Multi-Hop-Property hinzufügen",
        "constraintPredicatePlaceholder": "Prädikat-IRI",
        "constraintPrefix": "↳ wo",
        "constraintShort": "Constraint",
        "constraintValuePlaceholder": "Wert-IRI",
        "hopLabel": "Hop {{n}}",
        "hopPredicatePlaceholder": "Prädikat-IRI",
        "inverseHint": "Inverse: Tripel-Richtung umkehren (?next <p> ?prev statt ?prev <p> ?next)",
        "inverseLabel": "invers",
        "lastHopBindsValue": "Letzter Hop — sein Object-Term ist der Wert der Excel-Spalte.",
        "pathProperties": "Multi-Hop / Inverse / Constraint (erweiterte Indirection)",
        "pathPropertiesHint": "Für Pfade, die der einfache Direct/1-Hop-Picker nicht abdeckt: 2+ Hops, inverse Richtung (z. B. „?qd isQualityDatumOf ?subject\"), oder Filter auf den Zwischenknoten (z. B. „nur QualityDatums der Klasse X\"). Letzter Hop bindet den Wert.",
        "removeHop": "Hop entfernen"
      },
      "errors": {
        "nameRequired": "Name ist erforderlich.",
        "classRequired": "Subject-Klasse muss ausgewählt sein.",
        "atLeastOneProperty": "Mindestens eine Property auswählen.",
        "emptyLabel": "Alle Spalten-Labels müssen befüllt sein (leere Felder sind nicht erlaubt).",
        "duplicateEntry": "Doppelte Property-Konfiguration ({{iri}}, value_via={{via}}). Pro (Property, Wert-über) ist nur ein Eintrag erlaubt.",
        "constraintIncomplete": "Eintrag #{{idx}}, Hop #{{hop}}, Constraint #{{c}}: Prädikat und Wert sind beide erforderlich.",
        "hopMissingPredicate": "Eintrag #{{idx}}, Hop #{{hop}}: Prädikat-IRI ist erforderlich.",
        "pathEmpty": "Multi-Hop-Eintrag #{{idx}} hat keinen Hop. Mindestens ein Hop ist erforderlich."
      }
    },
    "toolDetail": {
      "access": {
        "body": "Berechtigungen für dieses Tool werden zentral im Tool-Manifest-Tab verwaltet — pro Tool kannst du dort Clients zuweisen und Rollen aus diesen Clients freischalten.",
        "hint": "Die Standard-Berechtigungen für neue Tools eines Systems werden im Tab „Verbindung & Auth\" gesetzt. Beim Anlegen eines Tools werden diese als Vorbelegung kopiert.",
        "openManifest": "Im Tool-Manifest öffnen",
        "title": "Zugriff"
      },
      "activity": {
        "empty": "Noch keine Aufrufe für dieses Tool.",
        "openGlobal": "In globaler History öffnen",
        "title": "Aktivität"
      },
      "agentView": {
        "hint": "JSON-Schema-Fragment aus dem Live-Manifest — exakt das, was bei einem Tool-Use-Call ankäme. Nur sichtbar, wenn das Tool live ist.",
        "missingFromManifest": "⚠ Tool ist Live, aber nicht im Manifest gefunden — möglicherweise wegen Sichtbarkeit / Berechtigungen. Zugriff prüfen.",
        "notLive": "⚠ Tool ist noch nicht Live und erscheint nicht im Manifest. Lifecycle in der Übersicht prüfen.",
        "title": "Was der Agent sieht"
      },
      "autoGeneratedTitle": "Auto-generiertes Tool",
      "back": "Zurück",
      "backToTools": "Zurück zur Tool-Übersicht",
      "broken": "defekt",
      "brokenFallback": "Schema-Drift seit letztem Anwenden. Slot- oder JOIN-Refs prüfen.",
      "brokenTitle": "Tool ist defekt — wird nicht ans Agent-Manifest ausgeliefert",
      "definition": {
        "bodyTemplate": "Body-Template (slot-substituiert, mit Caller-Body deep-merged):",
        "execution": "Execution-Config",
        "projection": "Sichtbare Felder",
        "projectionEmpty": "⚠ Keine sichtbaren Felder definiert — Tool kann nur als Admin-Test gerufen werden.",
        "returns": "Returns",
        "returnsEmpty": "Kein Returns-Hinweis gesetzt — über „Bearbeiten\" ergänzen.",
        "shape": "Shape",
        "title": "Definition",
        "timeout": "Timeout",
        "rateLimit": "Rate-Limit",
        "rowCap": "Zeilenlimit",
        "longRunning": "Lang laufend"
      },
      "delete": {
        "body": "Tool „{{op}}\" wird permanent gelöscht. Die Aufruf-Historie bleibt erhalten.",
        "title": "Tool löschen?"
      },
      "description": "Beschreibung",
      "jumpAccess": "Zugriff prüfen",
      "jumpActivity": "Aktivität öffnen",
      "jumpDefinition": "Definition öffnen",
      "jumpSlots": "Slots & Parameter öffnen",
      "lifecycle": "Lifecycle",
      "lifecycleHint": "Status kann jederzeit zwischen Entwurf, Test und Live gewechselt werden. Nur Live-Tools werden ans Agent-Manifest ausgeliefert — auf Entwurf zurücksetzen entspricht einem sofortigen Takedown.",
      "notFound": "Tool nicht gefunden — eventuell wurde es gelöscht.",
      "params": {
        "title": "Parameter"
      },
      "slots": {
        "collapse": "Weniger anzeigen",
        "edit": "Slots bearbeiten",
        "editorTitle": "Slots bearbeiten",
        "empty": "Keine Slots definiert.",
        "entityId": "Entity-Scope: {{id}}",
        "missing_one": "{{count}} Platzhalter ohne Slot-Definition: {{names}}",
        "missing_other": "{{count}} Platzhalter ohne Slot-Definition: {{names}}",
        "noValues": "⚠ Keine Werte definiert.",
        "orphan_one": "{{count}} Slot ohne Platzhalter im Template: {{names}}",
        "orphan_other": "{{count}} Slots ohne Platzhalter im Template: {{names}}",
        "showAll": "+ {{count}} anzeigen",
        "title": "Slots",
        "unusedTag": "verwaist",
        "valueCount_one": "{{count}} Wert",
        "valueCount_other": "{{count}} Werte",
        "deleteSlot": "Slot löschen"
      },
      "statusLabel": "Status:",
      "tools": "Tools",
      "tabs": {
        "overview": "Übersicht",
        "definition": "Definition",
        "slots": "Slots & Parameter",
        "access": "Zugriff",
        "activity": "Aktivität"
      },
      "longRunning": "lang laufend",
      "copy": "Kopieren"
    },
    "values": {
      "invocationStatus": {
        "success": "erfolgreich",
        "error": "Fehler",
        "timeout": "Zeitüberschreitung",
        "permission_denied": "keine Berechtigung",
        "rate_limited": "Rate-Limit erreicht",
        "validation_error": "ungültige Eingabe"
      },
      "invocationMode": {
        "sync": "synchron",
        "async": "asynchron",
        "test": "Test"
      },
      "sourceType": {
        "skill": "Skill",
        "router_rest": "System (REST)",
        "router_postgres": "System (Postgres)",
        "router_sparql": "System (SPARQL)",
        "builtin": "cdbChat (integriert)",
        "workflow": "Workflow"
      },
      "visibility": {
        "internal": "intern",
        "public": "öffentlich"
      },
      "health": {
        "healthy": "erreichbar",
        "unhealthy": "gestört",
        "unknown": "unbekannt",
        "broken": "defekt"
      },
      "turnStatus": {
        "ok": "OK",
        "error": "Fehler",
        "empty": "leer"
      },
      "callerType": {
        "internal_user": "Interner Nutzer (JWT)",
        "internal_service": "Interner Dienst (Service-Principal)",
        "external_m2m": "Extern M2M (API-Key)"
      },
      "accessType": {
        "invoke": "aufrufen",
        "test": "testen"
      },
      "provenance": {
        "manual": "manuell",
        "auto_validated": "automatisch, geprüft",
        "auto_derived": "automatisch abgeleitet",
        "profile_derived": "aus Profil",
        "source_introspect": "aus Introspect"
      },
      "assigneeKind": {
        "role": "Rolle",
        "client": "Client",
        "user": "Nutzer"
      }
    }
  },
  "activities": {
    "sidebarSection": "Aktivität",
    "sidebarEdit": "Bearbeiten",
    "sidebarAnalysis": "Auswertung",
    "menu": {
      "editActivity": "Quiz/Umfrage bearbeiten",
      "analyze": "Auswertung anzeigen",
      "downloadMarkdown": "Als Markdown herunterladen",
      "respond": "Aktivität ausfüllen",
      "addActivity": "Quiz/Umfrage hinzufügen"
    },
    "notFound": "Aktivität nicht gefunden",
    "loadFailed": "Aktivität konnte nicht geladen werden",
    "saveFailed": "Speichern fehlgeschlagen",
    "configSaved": "Konfiguration gespeichert",
    "submitFailed": "Übermittlung fehlgeschlagen",
    "submitting": "Wird übermittelt …",
    "submit": "Absenden",
    "yourAnswer": "Ihre Antwort",
    "yourDetails": "Ihre Daten",
    "name": "Name",
    "email": "E-Mail",
    "respondentInfoRequired": "Bitte Name und E-Mail angeben",
    "requiredFieldsMissing": "Pflichtfeld fehlt",
    "requiredHint": "* Pflichtfelder",
    "withdrawTitle": "Eingabe zurückziehen",
    "withdrawn": "Eingabe zurückgezogen — du kannst erneut teilnehmen",
    "withdrawFailed": "Zurückziehen fehlgeschlagen",
    "maxSelectionsHint": "Bitte maximal {{max}} Optionen wählen",
    "otherTextLabel": "Andere:",
    "otherTextPlaceholder": "Bitte angeben …",
    "passedTitle": "Bestanden!",
    "failedTitle": "Nicht bestanden",
    "submittedTitle": "Vielen Dank!",
    "thankYouMessage": "Ihre Antworten wurden übermittelt.",
    "passingScoreHint": "Bestehensgrenze: {{score}} %",
    "passingScoreUnit": "Prozent des erreichbaren Maximums (0–100).",
    "publicUnavailableTitle": "Aktivität nicht verfügbar",
    "publicUnavailableHint": "Der Link ist ungültig, abgelaufen oder die Aktivität wurde geschlossen.",
    "questionType": {
      "free_text": "Freitext",
      "single_choice": "Eine Antwort",
      "multiple_choice": "Mehrere Antworten",
      "rating": "Bewertung",
      "section_header": "Abschnitt"
    },
    "modeLabel": {
      "progress": "Schulung",
      "assessment": "Quiz / Test",
      "aggregate": "Umfrage"
    },
    "modeHint": {
      "progress": "Klassische Schulung — nur Fortschrittsmessung, keine Fragen.",
      "assessment": "Quiz mit richtigen/falschen Antworten und Pass/Fail je Teilnehmer.",
      "aggregate": "Umfrage mit aggregierter Statistik und KI-gestützter Auswertung."
    },
    "tracking": {
      "anonymous": "Antworten werden ohne Person gespeichert – es ist nur bekannt, wer teilgenommen hat.",
      "perUser": "Antworten werden pro Teilnehmer erfasst und ausgewertet."
    },
    "audienceType": "Zielgruppe",
    "audienceLabel": {
      "assigned_only": "Nur zugewiesene Nutzer",
      "all_client_users": "Alle Nutzer des Mandanten",
      "knowledge_area_access": "Knowledge-Area-Zugriff",
      "public_link": "Öffentlicher Link"
    },
    "status": {
      "draft": "Entwurf",
      "active": "Aktiv",
      "closed": "Geschlossen"
    },
    "status_column": "Status",
    "analysisStatus": {
      "pending": "Wartet",
      "running": "Läuft",
      "completed": "Fertig",
      "failed": "Fehlgeschlagen"
    },
    "questionText": "Fragetext",
    "questionTextPlaceholder": "Frage formulieren …",
    "points": "Punkte",
    "options": "Antwortmöglichkeiten",
    "addOption": "Hinzufügen",
    "addOptionPlaceholder": "Neue Option …",
    "maxSelections": "Maximal wählbar",
    "maxSelectionsUnlimited": "unbegrenzt",
    "allowOtherText": "Freitext-Option Andere erlauben",
    "scaleMin": "Skala min",
    "scaleMax": "Skala max",
    "sectionTitle": "Abschnittstitel",
    "sectionTitlePlaceholder": "z. B. Teil 1: Erwartungen",
    "sectionDescription": "Beschreibung",
    "markCorrect": "Als richtig markieren",
    "unmarkCorrect": "Markierung entfernen",
    "toggleCorrect": "Richtig/Falsch umschalten",
    "required": "Pflichtfeld",
    "configuration": "Konfiguration",
    "analysisMode": "Modus",
    "knowledgeArea": "Knowledge Area",
    "knowledgeAreaPlaceholder": "z. B. Marketing",
    "passingScore": "Bestehensgrenze (Punkte)",
    "deadline": "Frist",
    "collectRespondentInfo": "Name & E-Mail erfassen",
    "saveConfig": "Konfiguration speichern",
    "questions": "Fragen",
    "questionCount_one": "{{count}} Frage",
    "questionCount_other": "{{count}} Fragen",
    "questionCount": "{{count}} Fragen",
    "noQuestionsYet": "Noch keine Fragen — Frage hinzufügen oder aus Markdown importieren.",
    "addQuestion": "Frage hinzufügen",
    "saveQuestion": "Frage speichern",
    "newQuestionDefault": "Neue Frage",
    "importMarkdown": "Aus Markdown importieren",
    "exportMarkdown": "Markdown-Export",
    "markdownImported": "Markdown importiert",
    "markdownImportedDetail": "{{count}} Fragen erkannt ({{warnings}} Warnungen)",
    "markdownImportFailed": "Markdown-Import fehlgeschlagen",
    "markdownExportFailed": "Markdown-Export fehlgeschlagen",
    "addQuestionFailed": "Frage konnte nicht hinzugefügt werden",
    "updateQuestionFailed": "Frage konnte nicht aktualisiert werden",
    "deleteQuestionFailed": "Frage konnte nicht gelöscht werden",
    "activate": "Aktivieren",
    "close": "Schließen",
    "activated": "Aktiviert",
    "closed": "Geschlossen",
    "activateFailed": "Aktivierung fehlgeschlagen",
    "closeFailed": "Schließen fehlgeschlagen",
    "publicLinkLabel": "Öffentlicher Teilnehmer-Link",
    "publicShare": {
      "toggle": "Öffentlich teilbar (Link)",
      "toggleHint": "Erzeugt einen Link den du an externe Teilnehmer weitergibst. Sie geben ihre Email an — nur eingeladene Adressen kommen durch.",
      "dialogTitle": "Öffentlich teilen",
      "linkLabel": "Teilbarer Link",
      "howItWorks": "Externe Teilnehmer öffnen den Link, geben ihre E-Mail an und können nur ausfüllen, wenn sie über die Zuweisen-Funktion eingeladen wurden. Jede E-Mail kann nur einmal teilnehmen.",
      "offTitle": "Öffentliches Teilen ist aus",
      "offHint": "Aktiviere es um einen Link zu generieren. Beim Aktivieren wird der Quiz veröffentlicht — Bearbeitung der Fragen ist dann gesperrt, bis du den Quiz wieder zurück auf Entwurf setzt.",
      "noQuestionsHint": "Füge zuerst Fragen hinzu — ein leerer Quiz lässt sich nicht aktivieren.",
      "enable": "Öffentlich machen",
      "disable": "Öffentliches Teilen deaktivieren",
      "enabledToast": "Quiz ist jetzt öffentlich teilbar",
      "disabledToast": "Öffentliches Teilen deaktiviert — Link ist nicht mehr gültig",
      "enableFailed": "Aktivierung fehlgeschlagen",
      "disableFailed": "Deaktivierung fehlgeschlagen"
    },
    "publicGate": {
      "emailLabel": "Deine Email-Adresse",
      "emailPlaceholder": "name@firma.de",
      "emailHint": "Nutze die Adresse mit der du eingeladen wurdest.",
      "continue": "Weiter",
      "errorNotAssigned": "Diese Email wurde nicht eingeladen. Wende dich an die Person, die dir den Link geschickt hat.",
      "errorAlreadySubmitted": "Du hast bereits teilgenommen. Eine zweite Teilnahme ist nicht möglich.",
      "errorGeneric": "Email konnte nicht überprüft werden. Bitte erneut versuchen."
    },
    "editingLockedTitle": "Bearbeitung gesperrt",
    "editingLockedHint": "Diese Aktivität ist aktiv oder geschlossen. Setze sie über den Button oben rechts zurück auf Entwurf, um sie zu bearbeiten.",
    "evaluation": "Auswertung",
    "evaluationFromParent": "Auswertung des verknüpften Quizzes — von Training „{{parent}}“",
    "responseCount": "{{count}} Antworten",
    "completionRate": "{{rate}}% abgeschlossen",
    "tabs": {
      "participants": "Teilnehmer",
      "statistics": "Statistik",
      "aiReport": "KI-Report",
      "mine": "Meine"
    },
    "noSubmissionsYet": "Noch keine Antworten",
    "respondent": "Teilnehmer",
    "score": "Punkte",
    "passed": "Bestanden",
    "passedYes": "Ja",
    "passedNo": "Nein",
    "completedAt": "Abgegeben",
    "authenticatedUser": "Angemeldeter Nutzer",
    "anonymous": "Anonym",
    "completed": "Abgeschlossen",
    "inProgress": "Begonnen",
    "scoreDistribution": "Score-Verteilung",
    "meanScore": "Ø Score",
    "medianScore": "Median Score",
    "passRate": "Bestehensquote",
    "mean": "Mittel",
    "median": "Median",
    "range": "Bereich",
    "correctRate": "Richtig-Anteil: {{rate}}%",
    "otherTexts_one": "{{count}} freie Antwort",
    "otherTexts_other": "{{count}} freie Antworten",
    "otherTexts": "{{count}} freie Antworten",
    "word": "Wort",
    "frequency": "Häufigkeit",
    "noFreeTextAnswers": "Keine Freitextantworten",
    "lastAnalysis": "Letzte Auswertung",
    "lastUpdated": "aktualisiert {{time}}",
    "kpi": {
      "submissions": "Einreichungen",
      "completionRate": "Abschlussquote",
      "completedOf": "{{done}} von {{total}}",
      "passRate": "Bestehensquote",
      "avgScore": "Durchschnitts-Score",
      "questions": "Fragen",
      "uniqueRespondents": "Eindeutige Teilnehmer"
    },
    "respondentSource": {
      "internal": "Intern",
      "external": "Extern",
      "anonymous": "Anonym"
    },
    "noAnalysisYet": "Noch keine KI-Auswertung — auf Auswertung starten klicken.",
    "runAnalysis": "Auswertung starten",
    "analyzing": "Wird analysiert …",
    "analysisFailed": "Auswertung fehlgeschlagen",
    "analysisCompleted": "Auswertung abgeschlossen",
    "analysisStartFailed": "Auswertung konnte nicht gestartet werden",
    "summary": "Zusammenfassung",
    "sentiment": "Sentiment",
    "sentimentError": "Sentiment-Analyse fehlgeschlagen",
    "positive": "Positiv",
    "neutral": "Neutral",
    "negative": "Negativ",
    "fileTooLarge": "Datei zu groß (max. {{max}} KB)",
    "copyFailed": "Kopieren fehlgeschlagen",
    "copyManualHint": "Bitte den Link manuell aus dem Feld oben kopieren.",
    "ratingAriaLabel": "Bewertungs-Skala",
    "sentimentBarAriaLabel": "Sentiment-Verteilung: {{positive}} positiv, {{neutral}} neutral, {{negative}} negativ",
    "sidebarSurveys": "Quizzes & Umfragen",
    "surveyLibraryTitle": "Quizzes & Umfragen",
    "surveyLibraryHint": "Eigenständige Quizzes und Umfragen — keine Materialien nötig.",
    "newSurvey": "Neue Umfrage / Quiz",
    "newSurveyTitle": "Neue Umfrage oder Quiz erstellen",
    "noSurveysYet": "Noch keine Umfragen oder Quizzes — leg eine an.",
    "emptyAssigned": "Dir wurden noch keine Quizzes oder Umfragen zugewiesen",
    "emptyCompleted": "Du hast noch keine Quizzes oder Umfragen abgeschlossen",
    "createFirstSurvey": "Erste Umfrage erstellen",
    "createAndEdit": "Erstellen & öffnen",
    "createFailed": "Erstellen fehlgeschlagen",
    "noClientId": "Kein Mandant zugeordnet — Profil prüfen",
    "deleteConfirmTitle": "Umfrage löschen?",
    "deleteConfirmHint": "Diese Aktion ist nur für Entwürfe möglich und kann nicht rückgängig gemacht werden.",
    "deleted": "Gelöscht",
    "deleteFailed": "Löschen fehlgeschlagen",
    "titleColumn": "Titel",
    "typeColumn": "Typ",
    "descriptionColumn": "Beschreibung",
    "actions": "Aktionen",
    "surveyTitlePlaceholder": "z. B. Pre-Workshop Feedback",
    "surveyDescriptionPlaceholder": "Optionale Beschreibung für Teilnehmer",
    "kindLabel": {
      "training": "Schulung",
      "training_with_quiz": "Schulung + Quiz",
      "quiz": "Quiz",
      "survey": "Umfrage"
    },
    "quizSurveyColumn": "Quiz/Umfrage",
    "autoSaving": "Speichert …",
    "autoSaved": "Gespeichert",
    "dragHandle": "Reihenfolge ändern (Drag & Drop)",
    "reorderFailed": "Reihenfolge konnte nicht gespeichert werden",
    "editOption": "Zum Bearbeiten klicken",
    "duplicateOptionTitle": "Doppelte Option",
    "duplicateOption": "Diese Antwortoption existiert bereits",
    "activateBlockedIncomplete": "Bitte zuerst alle Fragen vervollständigen",
    "invalidReason": {
      "missingText": "Fragetext fehlt — wird gespeichert sobald vollständig",
      "missingOptions": "Antwortoptionen fehlen — wird gespeichert sobald vollständig",
      "correctNotInOptions": "Korrekte Antwort muss in den Optionen liegen",
      "singleChoiceTooManyCorrect": "Single-Choice darf nur eine korrekte Antwort haben",
      "missingScale": "Skalengrenzen fehlen — wird gespeichert sobald vollständig",
      "invalidScale": "Skala-Max muss größer als Skala-Min sein",
      "maxSelectionsOnlyForMC": "Max. Auswahl nur bei Multiple Choice erlaubt",
      "sectionHeaderHasOptions": "Abschnitts-Überschrift darf keine Optionen haben",
      "sectionHeaderEmpty": "Abschnitts-Überschrift benötigt Titel oder Beschreibung"
    },
    "fromLibrary": "Aus Bibliothek einfügen",
    "libTitle": "Frage-Bibliothek",
    "libSearchPlaceholder": "Suche nach Titel oder Text …",
    "libAllTypes": "Alle Typen",
    "libNoResults": "Keine Treffer.",
    "libEmpty": "Bibliothek ist leer — speichere eine Frage als Vorlage.",
    "libLoadFailed": "Bibliothek konnte nicht geladen werden",
    "libDeleteConfirm": "Diese Vorlage wirklich löschen? Bereits eingefügte Fragen bleiben erhalten.",
    "libDeleted": "Vorlage gelöscht",
    "libDeleteFailed": "Vorlage konnte nicht gelöscht werden",
    "libSaveAction": "Als Vorlage speichern",
    "libSaved": "Vorlage in Bibliothek gespeichert",
    "libSaveFailed": "Vorlage konnte nicht gespeichert werden",
    "libInserted": "Frage aus Bibliothek hinzugefügt",
    "lockedByAttachers_one": "Bearbeitung gesperrt — dieses Quiz ist an 1 Training angehängt:",
    "lockedByAttachers_other": "Bearbeitung gesperrt — dieses Quiz ist an {{count}} Trainings angehängt:",
    "lockedByAttachers": "Bearbeitung gesperrt — angehängt an {{count}} Training(s):",
    "unlock": "Bearbeitung erlauben",
    "unlocked": "Aktivität auf Entwurf zurückgesetzt",
    "unlockFailed": "Zurücksetzen fehlgeschlagen",
    "fillOutShort": "Ausfüllen",
    "done": "Fertig",
    "anonymousToggle": "Anonym beantworten lassen",
    "anonymousToggleHint": "Es wird festgehalten, wer teilgenommen hat – aber nicht, wer was geantwortet hat. Antworten zeigen weder Namen noch Uhrzeit.",
    "anonymousFrozen": "Kann nicht mehr geändert werden, sobald jemand geantwortet hat.",
    "anonymousRespondent": "Anonym",
    "hub": {
      "title": "Umfragen & Quiz",
      "subtitle": "Wissen prüfen oder Meinungen sammeln – ohne Material, mit eigenem Fragebogen",
      "kindAll": "Alle",
      "statusAll": "Alle Status",
      "kind": {
        "quiz": "Quiz",
        "survey": "Umfrage"
      },
      "status": {
        "draft": "Entwurf",
        "active": "Aktiv",
        "closed": "Geschlossen"
      },
      "view": {
        "manage": "Verwalten",
        "mine": "Für mich"
      },
      "kpi": {
        "active": "Aktiv",
        "activeHint": "nehmen Antworten an",
        "drafts": "Entwürfe",
        "draftsHint": "noch nicht veröffentlicht",
        "newAnswers": "Neue Antworten",
        "newAnswersHint": "in den letzten 7 Tagen",
        "silent": "Ohne Resonanz",
        "silentHint": "aktiv, aber unter 3 Antworten"
      },
      "columns": {
        "answers": "Antworten",
        "distribution": "Verteilung",
        "lastActivity": "Zuletzt"
      },
      "searchPlaceholder": "Titel suchen …",
      "noneFound": "Nichts passt zum Filter",
      "noneFoundHint": "Andere Art oder anderen Status wählen.",
      "emptyHint": "Mit „Neu anlegen“ oben rechts beginnt der erste Fragebogen.",
      "newLabel": "neu",
      "results": "Ergebnisse",
      "share": "Teilen",
      "newVersion": "Als neue Version bearbeiten",
      "passedShort": "{{rate}} % bestanden",
      "passedOf": "Bestanden (Grenze {{mark}} %)",
      "responseRate": "Rücklauf der Zugewiesenen",
      "ofAssigned": "{{answers}} von {{assigned}}",
      "publishFirst": "Veröffentlichen, damit die erste kommen kann.",
      "version": "Version {{number}}",
      "partOf": "Teil des Trainings „{{title}}“",
      "versionNote": "Version {{number}}. Antworten auf frühere Versionen bleiben erhalten und werden in der Auswertung getrennt angezeigt.",
      "answered": "Beantwortet",
      "dist": {
        "assigned": "{{count}} zugewiesen",
        "emails": "{{count}} E-Mails",
        "link": "Offener Link",
        "linkUntil": "Link bis {{date}}",
        "none": "noch nicht verteilt"
      },
      "new": {
        "title": "Neu anlegen",
        "hint": "Was soll es werden? Die Art bestimmt die Einstellungen und lässt sich später nicht wechseln.",
        "kindLabel": "Art",
        "submit": "Weiter zum Editor",
        "quizHint": "Wissen prüfen. Antworten sind richtig oder falsch.",
        "surveyHint": "Meinungen sammeln. Es gibt kein richtig oder falsch.",
        "quizPoint1": "Punkte je Frage, Bestehensgrenze",
        "quizPoint2": "Ergebnis je Person, Bestanden-Quote",
        "quizPoint3": "Nie anonym",
        "surveyPoint1": "Wahlweise anonym",
        "surveyPoint2": "Skalen, Freitext, Auswahl",
        "surveyPoint3": "Auswertung als Verteilung",
        "quizPlaceholder": "z. B. Datenschutz – Wissenscheck",
        "surveyPlaceholder": "z. B. Feedback zum Workshop"
      },
      "publish": {
        "title": "Veröffentlichen",
        "shareTitle": "Teilen",
        "hint": "„{{title}}“ – wer soll antworten können? Mehrere Wege sind möglich; jeder lässt sich einzeln beenden.",
        "way": {
          "open": "Öffentlicher Link",
          "openHint": "Jeder mit dem Link kann antworten – für Veranstaltungen und QR-Codes. Mit Ablaufdatum und Höchstzahl, jederzeit widerrufbar.",
          "assigned_link": "Zugewiesene Personen mit Link",
          "assigned_linkHint": "Für externe Teilnehmer ohne cdbOS-Login: Personen zuweisen und ihnen den Link schicken. Beim Öffnen wird die E-Mail-Adresse geprüft – nur Zugewiesene können antworten, jede Person einmal.",
          "assigned": "Zuweisen ohne Link",
          "assignedHint": "Interne User finden die Umfrage in webOS unter „Für mich“; jede Zuweisung hat einen Status und eine optionale Frist. Externe Teilnehmer erreichen Umfragen über „Zugewiesene Personen mit Link“.",
          "course": "In Schulung einbinden",
          "courseHint": "Als Baustein am Ende des letzten Kapitels eines Kurses – für Wissenscheck und Feedback innerhalb einer Schulung. Veröffentlicht wird der Kurs im Kurs-Editor."
        },
        "active": "aktiv",
        "assignedCount_one": "{{count}} zugewiesen",
        "assignedCount_other": "{{count}} zugewiesen",
        "choosePeople": "Personen wählen",
        "createOpenLink": "Offenen Link erzeugen",
        "expires": "Läuft ab",
        "maxUses": "Höchstens",
        "unlimited": "unbegrenzt",
        "copy": "Link kopieren",
        "copied": "Link kopiert",
        "coursePick": "Kurs auswählen",
        "courseAttach": "In Kurs einbinden",
        "courseNone": "Für diesen Client gibt es noch keinen Kurs.",
        "courseAlready": "Dieser Fragebogen ist bereits Teil von „{{title}}“.",
        "courseAttached": "Im Entwurf von „{{title}}“ ergänzt, am Ende von „{{chapter}}“. Veröffentlichen Sie den Kurs im Kurs-Editor, damit Teilnehmende ihn sehen.",
        "openCourse": "Kurs öffnen",
        "untitledChapter": "Kapitel {{number}}",
        "linkCreated": "Link erzeugt",
        "revoke": "Widerrufen",
        "revoked": "Link widerrufen – bestehende Antworten bleiben",
        "emailCount_one": "{{count}} Adresse",
        "emailCount_other": "{{count}} Adressen",
        "uses": "{{uses}} von {{max}} Teilnahmen",
        "until": "bis {{date}}",
        "quizOpenHint": "Ein Quiz über offenen Link fragt Name und E-Mail ab – ohne Person kein Ergebnis.",
        "liveNote": "Änderungen gelten sofort.",
        "freezeNote": "Danach lassen sich die Fragen nur noch über eine neue Version ändern.",
        "publishButton": "Veröffentlichen",
        "createAssignedLink": "Link für Zugewiesene erzeugen",
        "legacyEmailLists": "Frühere E-Mail-Listen-Links (können weiter genutzt oder beendet werden):"
      },
      "editor": {
        "savedAt": "Gespeichert {{time}}",
        "allSaved": "Alles gespeichert",
        "empty": "Noch leer. Die erste Frage legt los.",
        "addQuestion": "Frage",
        "addSection": "Abschnitt",
        "markdown": "Markdown",
        "newSection": "Neuer Abschnitt",
        "optionA": "Option 1",
        "optionB": "Option 2",
        "untitled": "Ohne Text",
        "moveUp": "Nach oben",
        "moveDown": "Nach unten",
        "question": "Frage",
        "questionN": "Frage {{n}}",
        "duplicate": "Frage duplizieren",
        "firstQuestion": "Erste Frage anlegen",
        "firstQuestionHint": "Links „Frage“ wählen oder den KI-Assistenten fragen – der Typ lässt sich danach ändern.",
        "descriptionPlaceholder": "Worum geht es, wie lange dauert es?",
        "passMark": "Bestehensgrenze",
        "showResult": "Ergebnis anzeigen",
        "showResultHint": "Teilnehmer sehen Punkte und bestanden / nicht bestanden",
        "showCorrect": "Richtige Antworten zeigen",
        "showCorrectHint": "nach dem Absenden",
        "collectHint": "Für Antworten über einen Link ohne Konto",
        "deadlineHint": "optional – danach nimmt sie keine Antworten mehr an",
        "shuffle": "Fragen mischen",
        "shuffleHint": "Reihenfolge je Teilnehmer zufällig",
        "quizNote": "Ein Quiz ist nie anonym – das Ergebnis gehört zur Person und zu ihrem Zertifikat.",
        "surveyNote": "Eine Umfrage vergibt keine Punkte. Für „richtig / falsch“ ein Quiz anlegen.",
        "frozenTitle_one": "Veröffentlicht, {{count}} Antwort liegt vor. Die Fragen dieser Version lassen sich nicht mehr ändern.",
        "frozenTitle_other": "Veröffentlicht, {{count}} Antworten liegen vor. Die Fragen dieser Version lassen sich nicht mehr ändern.",
        "frozenHint": "Titel und Beschreibung kannst du weiter ändern. Wenn du Fragen änderst, entsteht Version {{next}}; die bisherigen Antworten bleiben bei Version {{current}}. Bis du Version {{next}} veröffentlichst, nimmt der Fragebogen keine Antworten an.",
        "newVersionOpened": "Version {{number}} als Entwurf angelegt. Die Fragen wurden übernommen."
      },
      "assistant": {
        "button": "KI-Assistent",
        "title": "KI-Assistent für Fragen",
        "quizHint": "Beschreibe Thema, Zielgruppe und Schwierigkeit – du bekommst Quizfragen mit richtigen Antworten und Punkten zur Auswahl.",
        "surveyHint": "Beschreibe, was du erfahren willst – du bekommst Umfragefragen (Skalen, Auswahl, Freitext) zur Auswahl.",
        "quizPlaceholder": "z. B. fünf Fragen zu den Pflichten für Hochrisiko-KI-Systeme, mittelschwer, für Fachfremde",
        "surveyPlaceholder": "z. B. Zufriedenheit mit dem Onboarding: Vorbereitung, Ansprechpartner, Material",
        "count": "Anzahl",
        "context": "Aus Training",
        "noContext": "kein Training",
        "ask": "Vorschlagen",
        "askAgain": "Neu vorschlagen",
        "nothing": "Der Assistent hat nichts Brauchbares vorgeschlagen – anders formulieren.",
        "failed": "Vorschläge fehlgeschlagen",
        "points_one": "{{count}} Punkt",
        "points_other": "{{count}} Punkte",
        "insert_one": "{{count}} übernehmen",
        "insert_other": "{{count}} übernehmen",
        "inserted_one": "{{count}} Frage übernommen",
        "inserted_other": "{{count}} Fragen übernommen",
        "footnote": "Läuft auf dem Zwischenmodell und zählt zum Token-Verbrauch (Tätigkeit „Fragen-Assistent“)."
      }
    },
    "results": {
      "versions": "Versionen",
      "versionTab": "Version {{number}} · {{count}}",
      "versionLabel": "Version {{number}}",
      "download": "Herunterladen",
      "downloadPdf": "PDF-Bericht",
      "downloadPdfHint": "Diese Ansicht als Dokument – Zahlen, Themen, Bericht",
      "downloadXlsx": "Excel · Rohdaten",
      "downloadXlsxHint": "Eine Zeile je Abgabe, mit Person",
      "downloadXlsxAnonHint": "Eine Zeile je Abgabe – anonym, ohne Person",
      "downloadMd": "Markdown · Bericht",
      "downloadMdHint": "Für Wiki oder E-Mail",
      "downloadFailed": "Download fehlgeschlagen",
      "kpiAnswers": "Antworten",
      "kpiPassed": "Bestanden",
      "kpiCompletion": "Abgeschlossen",
      "kpiResponseRate": "Rücklauf",
      "kpiScale": "Ø Skala",
      "passHint": "Grenze {{mark}} % · Ø {{mean}} Punkte",
      "noTarget": "kein Soll – Link oder ohne Zuweisung",
      "scaleHint": "von {{max}} · Median {{median}}",
      "newSince_one": "+{{count}} seit der letzten Analyse",
      "newSince_other": "+{{count}} seit der letzten Analyse",
      "allAnalysed": "alle ausgewertet",
      "notAnalysed": "noch keine Analyse",
      "analysedAt": "Analyse vom {{date}}",
      "refreshAnalysis": "Analyse aktualisieren",
      "startAnalysis": "Analyse starten",
      "tabs": {
        "questions": "Fragen",
        "report": "KI-Bericht",
        "participants": "Teilnehmer"
      },
      "correctShort": "{{rate}} % richtig",
      "opinionNote": "Meinungsfrage, kein richtig/falsch",
      "otherTexts_one": "{{count}} Nennung „Andere“",
      "otherTexts_other": "{{count}} Nennungen „Andere“",
      "otherTextsHeading": "Freitext bei „Andere“",
      "scaleLabel": "Skala {{min}}–{{max}}",
      "highShare": "{{share}} % in der oberen Hälfte",
      "themes": "KI-Themen",
      "themesPending": "Noch keine Themen – „Analyse aktualisieren“ liest alle Antworten.",
      "themesFailed": "Die Themen-Analyse dieser Frage ist fehlgeschlagen – erneut aktualisieren.",
      "themesAt": "Themen aus Analyse vom {{date}}",
      "themesStale_one": "{{count}} neue Antwort noch nicht enthalten",
      "themesStale_other": "{{count}} neue Antworten noch nicht enthalten",
      "themeFoot": "{{count}} Antworten zu diesem Thema · {{sentiment}}",
      "unassigned": "Einzelstimmen ohne Thema",
      "sentiment": {
        "positive": "positiv",
        "neutral": "neutral",
        "negative": "kritisch"
      },
      "reportSource": "Bericht aus Zahlen und Themen",
      "reportAt": "Analyse vom {{date}} über {{count}} Antworten",
      "reportNote": "Der Bericht zitiert nur Werte aus der Statistik und den Themen der Freitext-Analyse – keine erfundenen Zahlen, keine Stichprobe.",
      "noReport": "Noch kein Bericht – „Analyse starten“ wertet Freitext aus und schreibt den Bericht (Zwischenmodell, zählt zum Token-Verbrauch).",
      "participantsHint": "Quiz mit Person: Punkte, bestanden, Zeitpunkt.",
      "participantsAnon": "Anonyme Umfrage: nur Zeitpunkte, keine Personen – auch nicht im Export."
    }
  },
  "desktop": {
    "loadingApps": "Lade Desktop-Apps...",
    "loadAppsFailed": "Deine Desktop-Apps konnten nicht geladen werden."
  },
  "voiceInput": {
    "partialLoss_one": "Ein Teil der Aufnahme konnte nicht erkannt werden und fehlt im Text.",
    "partialLoss_other": "{{count}} Teile der Aufnahme konnten nicht erkannt werden und fehlen im Text.",
    "transcribing": "Transkribiere …",
    "apply": "Übernehmen",
    "cancel": "Verwerfen",
    "start": "Sprachaufnahme starten",
    "recording": "Aufnahme läuft …",
    "sendNow": "Absenden",
    "listening": "Sprich einfach los …"
  },
  "standalone": {
    "navAria": "App-Navigation",
    "toDesktop": "Zum Desktop",
    "settingsDescription": "Sprache und Erscheinungsbild",
    "themeLight": "Hell",
    "themeDark": "Dunkel",
    "settings": {
      "title": "Einstellungen",
      "generalTitle": "Allgemein",
      "communicatorHint": "Wie der Assistent dich anspricht und antwortet."
    }
  },
  "documentLink": {
    "loading": "Dokument wird geöffnet …",
    "denied": {
      "title": "Du kannst dieses Dokument nicht öffnen",
      "message": "Der Link ist gültig, aber dein Konto hat keinen Zugriff auf dieses Dokument. Wende dich an die Person, die dir den Link geschickt hat."
    },
    "error": {
      "title": "Dokument gerade nicht erreichbar",
      "message": "Der Link konnte nicht aufgelöst werden. Versuch es später noch einmal."
    },
    "noHost": {
      "title": "Keine passende Anwendung freigeschaltet",
      "message": "Für dein Konto ist weder der Desktop noch der Chat freigeschaltet. Ohne eine der beiden lässt sich das Dokument nicht anzeigen."
    }
  },
  "sharedFile": {
    "loading": "Datei wird geladen …",
    "invalid": {
      "title": "Dieser Link gilt nicht mehr",
      "message": "Er wurde widerrufen, die Datei wurde gelöscht, oder der Link ist unvollständig. Frag die Person, die ihn geschickt hat, nach einem neuen."
    },
    "error": {
      "title": "Das hat gerade nicht geklappt",
      "message": "Die Datei konnte nicht geladen werden. Versuch es in einem Moment noch einmal."
    },
    "header": {
      "sharedBy": "Mit dir geteilt · {{size}}",
      "sharedByNamed": "Geteilt von {{name}} · {{size}}",
      "own": "Deine eigene Datei · {{size}}"
    },
    "unsupported": "Für dieses Dateiformat gibt es keine Vorschau. Der Link ist in Ordnung — bitte die Person, die geteilt hat, um ein anderes Format."
  },
  "video": {
    "player": {
      "region": "Videoplayer",
      "regionNamed": "Videoplayer: {{name}}",
      "play": "Abspielen",
      "pause": "Pausieren",
      "mute": "Ton aus",
      "unmute": "Ton an",
      "fullscreen": "Vollbild",
      "exitFullscreen": "Vollbild beenden",
      "seek": "Wiedergabeposition",
      "volume": "Lautstärke",
      "captions": "Untertitel",
      "loading": "Video wird geladen …",
      "unplayable": "Dieses Video kann der Browser nicht abspielen (z. B. HEVC). Die Verarbeitung ist davon nicht betroffen – laden Sie die Datei herunter, um sie anzusehen.",
      "loadFailed": "Das Video konnte nicht geladen werden.",
      "retry": "Erneut versuchen",
      "download": "Herunterladen",
      "jumpTo": "Im Video zu {{time}} springen",
      "tooLargeToPlay": "Dieses Video lässt sich hier nur per Streaming abspielen, und das bietet der Server noch nicht an. Über {{maxMb}} MB lädt der Browser es nicht als Ganzes – laden Sie es herunter, um es anzusehen.",
      "downloadTooLarge": "Dieser Browser kann Dateien über {{maxMb}} MB nicht direkt auf die Festplatte speichern. Bitte nutzen Sie für den Download Chrome oder Edge.",
      "downloadFailed": "Der Download ist fehlgeschlagen."
    },
    "facts": {
      "heading": "Über dieses Video",
      "duration": "Dauer {{time}}",
      "speakers_one": "{{count}} Sprecher",
      "speakers_other": "{{count}} Sprecher",
      "noAudio": "ohne Ton",
      "provenance": "Transkript maschinell erstellt · Bildbeschreibungen KI-generiert",
      "summaryLabel": "KI-Einordnung",
      "summaryHint": "Von der KI aus Transkript und Bildern zusammengefasst – bitte am Video prüfen.",
      "chapters": "Kapitel (KI-generiert)"
    },
    "sources": {
      "video": "Video",
      "transcriptMachine": "Transkript maschinell",
      "frameAi": "Bild KI-beschrieben",
      "provenanceHint": "Aus einem Video: gesprochener Text wurde maschinell transkribiert, Bilder wurden von einer KI beschrieben."
    },
    "upload": {
      "hashing": "Prüfsumme wird berechnet … {{percent}} %",
      "uploading": "Hochladen {{percent}} % ({{loaded}} von {{total}})",
      "completing": "Wird abgeschlossen …",
      "retrying": "Verbindung unterbrochen – neuer Versuch … {{percent}} %",
      "paused": "Angehalten bei {{percent}} % – kann fortgesetzt werden",
      "pause": "Upload anhalten",
      "resume": "Upload fortsetzen",
      "abort": "Upload abbrechen",
      "tooLarge": "Die Datei ist zu groß (höchstens {{maxMb}} MB).",
      "unsupported": "Dieses Format ({{extension}}) kann die Knowledge Area nicht verarbeiten.",
      "videosDisabled": "Videos werden in dieser Umgebung noch nicht verarbeitet.",
      "tooLargeWithoutBlocks": "Videos über {{maxMb}} MB nimmt dieser Server noch nicht an – der fortsetzbare Upload für große Dateien ist hier nicht aktiv.",
      "errors": {
        "knowledgeAreaNotFound": "Die Knowledge Area wurde nicht gefunden.",
        "clientNotFound": "Der Mandant dieser Knowledge Area wurde nicht gefunden.",
        "userContextRequired": "Für diesen Upload fehlt die Anmeldung als Benutzer.",
        "invalidRequest": "Der Server hat die Upload-Anfrage als ungültig abgelehnt.",
        "uploadClosed": "Dieser Upload wurde bereits beendet.",
        "emptyFile": "Die Datei ist leer.",
        "generic": "Der Upload wurde vom Server abgelehnt (Status {{status}})."
      }
    },
    "progress": {
      "probe": "Video wird geprüft",
      "transcription": "Transkription",
      "frames": "Bilder werden erkannt",
      "vision": "Bilder werden beschrieben",
      "markdown": "Text wird erstellt",
      "other": "Video wird verarbeitet",
      "indexing": "Wird für die Suche aufbereitet",
      "withPercent": "{{label}} – {{percent}} %",
      "stage": {
        "probing": "Video wird geprüft",
        "extracting_audio": "Ton wird herausgelöst",
        "transcribing": "Transkription läuft",
        "detecting_slides": "Folien werden erkannt",
        "describing_frames": "Bilder werden beschrieben",
        "building_markdown": "Text wird erstellt",
        "indexing": "Wird für die Suche aufbereitet"
      }
    },
    "brainStatus": {
      "uploading": "Wird hochgeladen"
    },
    "verifier": {
      "hint": "Video · Transkript maschinell · Bildbeschreibungen KI · Auto-Verify aus",
      "locate": "Stelle im Video finden",
      "locating": "Suche im Transkript …",
      "locateUnavailable": "Suche im Video ist auf diesem Server noch nicht verfügbar.",
      "locateNone": "Keine passende Stelle gefunden.",
      "searchHits": "Suchtreffer",
      "searchHitHint": "Gefunden per Textsuche im Transkript – nicht unbedingt die Stelle, aus der die Aussage stammt."
    }
  },
  "tickets": {
    "rail": {
      "label": "Tickets",
      "labelUnread_one": "Tickets – {{count}} mit neuer Antwort",
      "labelUnread_other": "Tickets – {{count}} mit neuen Antworten"
    }
  },
  "harness": {
    "title": "cdbHARNESS · Prototyp",
    "subtitle": "Prototyp",
    "intro": "Ein Team aus Agents arbeitet auf deinen Auftrag im Chat: Wissen prüfen oder Dateien erstellen. Erst deine Freigabe ändert das Brain.",
    "knowledgeArea": "Wissensbereich",
    "pickArea": "Wissensbereich wählen",
    "cancel": "Abbrechen",
    "export": "Lauf exportieren",
    "phase": {
      "idle": "Bereit",
      "loading": "Offene Fakten werden geladen …",
      "turn": "{{role}} arbeitet · Paket {{batch}} von {{batches}}",
      "done": "Lauf fertig",
      "cancelled": "Lauf abgebrochen",
      "error": "Fehler: {{message}}",
      "working": "{{role}} arbeitet"
    },
    "roles": {
      "pruefer": "Prüfer",
      "redakteur": "Redakteur",
      "rechercheur": "Rechercheur",
      "autor": "Autor",
      "frei": "Freie Rolle"
    },
    "counts": "{{facts}} Fakten geprüft · {{ok}} bestätigt · {{contra}} Widerspruch · {{none}} ohne Beleg · {{proposals}} Vorschläge",
    "quality": "{{format}} Antworten ohne gültiges Format · {{rejected}} Einträge verworfen",
    "empty": {
      "idle": "Schreib dem Team unten einen Auftrag in deinen Worten, zum Beispiel „Prüft alles zu E-47 an der FL-300“. Mit @Name fragst du einen Agent direkt.",
      "noTeam": "Noch kein Team. Lege im Reiter Teams eines an.",
      "noArea": "Das Team „{{team}}“ hat noch keinen Wissensbereich. Lege ihn im Reiter Teams fest.",
      "idleProject": "Schreib dem Team unten einen Auftrag, zum Beispiel „Erstellt eine Kundenpräsentation zu E-47 an der FL-300“. Der Rechercheur sammelt, der Autor erstellt die Datei. Mit @Name sprichst du einen Agent direkt an.",
      "idleChain": "Die Kette arbeitet in dieser Reihenfolge: {{steps}}. Schreib unten einen Auftrag; jeder Agent bekommt ihn und die Ergebnisse der Vorgänger. Mit @Name sprichst du einen Agent direkt an."
    },
    "actions": {
      "verify": "Bestätigen",
      "update": "Korrigieren",
      "reject": "Ablehnen"
    },
    "sources": "Quellen",
    "approve": "Freigeben",
    "dismiss": "Verwerfen",
    "decision": {
      "approved": "Freigegeben, im Brain übernommen",
      "dismissed": "Verworfen, nichts geändert",
      "failed": "Freigabe fehlgeschlagen: {{message}}"
    },
    "footer": "Prototyp v0.5 · nur für Admins · nur mit synthetischen Daten auf Staging testen. Wissenspflege höchstens 24 Fakten je Auftrag, Ketten höchstens 6 Schritte. Der Gruppenchat wird nicht gespeichert, die Runden und Dateien jedes Agents stehen in seinem eigenen Chat.",
    "byAgents": "von {{editor}} formuliert, von {{checker}} geprüft, Freigabe durch dich",
    "save": "Speichern",
    "delete": "Löschen",
    "tabs": {
      "chat": "Gruppenchat",
      "agents": "Agents",
      "teams": "Teams"
    },
    "models": {
      "gpt-6_1-sol": "gpt-6.1-sol (Denken)",
      "gpt-6-luna": "gpt-6-luna (Menge)"
    },
    "chat": {
      "team": "Team",
      "checkerSummary": "Paket {{batch}} von {{batches}}: {{facts}} Fakten geprüft · {{ok}} bestätigt · {{contra}} Widerspruch · {{none}} ohne Beleg",
      "formatError": "Die Antwort hatte kein gültiges Format und wurde nicht übernommen.",
      "emptyAnswer": "Keine Antwort erhalten.",
      "openInChat": "Im Chat öffnen",
      "askLabel": "Rückfrage an:",
      "placeholder": "Auftrag an das Team, z. B. „Prüft alles zu E-47“, oder @{{name}} mit einer Rückfrage",
      "send": "Senden",
      "mentionHint": "Sprich einen Agent des Teams mit @Name an, zum Beispiel über die Knöpfe oben.",
      "noMatch": "Keine offenen Fakten zu „{{words}}“ gefunden (von {{total}} offenen). Formuliere den Auftrag mit anderen Wörtern.",
      "noOpenFacts": "In diesem Wissensbereich gibt es keine offenen Fakten.",
      "handoff": "Übergabe an {{name}}.",
      "runBusy": "Das Team arbeitet gerade an einem Auftrag. Warte oder brich ihn ab; Rückfragen mit @Name gehen jederzeit.",
      "queued": "{{name}} antwortet nach der laufenden Runde.",
      "recheckSummary_one": "{{count}} Fakt nachgeprüft.",
      "recheckSummary_other": "{{count}} Fakten nachgeprüft.",
      "editorSummary_one": "{{count}} Vorschlag formuliert. Bitte prüfe und gib frei.",
      "editorSummary_other": "{{count}} Vorschläge formuliert. Bitte prüfe und gib frei.",
      "editorSummaryWithQuestions_one": "{{count}} Vorschlag formuliert. Rückfragen an {{name}}: {{questions}}.",
      "editorSummaryWithQuestions_other": "{{count}} Vorschläge formuliert. Rückfragen an {{name}}: {{questions}}.",
      "factsSelected_one": "{{count}} offener Fakt passt zum Auftrag (von {{total}}, Suchwörter: {{words}})",
      "factsSelected_other": "{{count}} offene Fakten passen zum Auftrag (von {{total}}, Suchwörter: {{words}})",
      "factsLoaded_one": "{{count}} offener Fakt geladen",
      "factsLoaded_other": "{{count}} offene Fakten geladen",
      "noFile": "{{name}} hat keine Datei erstellt. Frag mit @{{name}} nach, zum Beispiel „bitte als Word-Dokument“.",
      "placeholderProject": "Auftrag an das Team, z. B. „Erstellt eine Kundenpräsentation zu E-47“, oder @{{name}} mit einer Änderung",
      "placeholderChain": "Auftrag an die Kette, oder @{{name}} mit einer Nachricht",
      "savedTasks": "Aufträge:",
      "fillHint": "Ersetze die Teile in {geschweiften Klammern} und sende ab.",
      "fillPlaceholders": "Bitte noch ausfüllen: {{parts}}",
      "attach": "Datei an den Auftrag hängen (höchstens {{max}})",
      "removeFile": "{{name}} entfernen",
      "uploading": "Wird hochgeladen …"
    },
    "agents": {
      "intro": "Jeder Agent entsteht aus einer Basisrolle. Die freie Rolle bestimmst du ganz über die zusätzlichen Regeln, zum Beispiel „Du bist Vertriebsassistent und schreibst Angebote“. Name, Modell, Regeln und Fähigkeiten legst du fest. Gespeichert wird in deinen Einstellungen.",
      "baseRole": "Basisrolle",
      "name": "Name",
      "model": "Modell",
      "instructions": "Zusätzliche Regeln",
      "instructionsPlaceholder": "Zum Beispiel: Achte besonders auf Zahlen und Fristen.",
      "create": "Agent anlegen",
      "usedBy": "In Teams: {{teams}}. Erst dort ersetzen, dann löschen.",
      "features": "Fähigkeiten aus dem Chat",
      "feature": {
        "corporate": "Wissensbereich des Teams",
        "web": "Websuche",
        "externalSystems": "Externe Systeme",
        "deepResearch": "Recherche-Modus",
        "microsoft365": "Mail und Kalender (Microsoft 365)"
      },
      "webDepth": "Tiefe",
      "depth": {
        "auto": "automatisch",
        "quick": "schnell",
        "deep": "gründlich"
      },
      "workflow": "Startet den Workflow",
      "noWorkflow": "keinen",
      "noWorkflows": "Für dich sind keine Workflows freigeschaltet.",
      "featuresNote": "Diese Schalter prüft der Server. Dateien (Word, PowerPoint, Excel, HTML, Bild, BPMN) kann jeder Agent erstellen wie der Chat; einzelne Werkzeuge abschalten geht erst mit einem Agent-Profil im TQS. In der Wissenspflege prüfen Prüfer und Redakteur immer nur gegen den Wissensbereich. Ausnahme: Mail und Kalender kommen mit deinem verbundenen Konto; dieser Schalter sagt dem Agent nur, ob er sie nutzen darf.",
      "microsoft365": {
        "ready": "Liest Mails und Termine und legt Entwürfe an, sendet aber nie. Anweisungen in Mails befolgt der Agent nicht.",
        "notConnected": "Dein Microsoft-365-Konto ist nicht verbunden. Verbinde es in cdbChat unter Einstellungen, Verbundene Konten (Mail oder Kalender).",
        "unavailable": "Mail und Kalender sind für deine Organisation nicht freigeschaltet."
      }
    },
    "teams": {
      "intro": "Ein Team hat einen Typ. Wissenspflege: ein Prüfer und ein Redakteur prüfen offene Fakten, du gibst frei. Projekt: ein Rechercheur sammelt, ein Autor erstellt die Datei, ein Prüfer kann gegenlesen. Kette: beliebige Agents in fester Reihenfolge, jeder baut auf der Vorarbeit auf.",
      "name": "Name",
      "newPlaceholder": "Neues Team",
      "create": "Team anlegen",
      "approval": "Freigabe",
      "approvalYou": "immer durch dich",
      "kind": "Teamtyp",
      "kinds": {
        "wissenspflege": "Wissenspflege",
        "projekt": "Projekt",
        "kette": "Kette"
      },
      "optional": "optional",
      "none": "keiner",
      "step": "Schritt {{n}}",
      "up": "Nach oben",
      "down": "Nach unten",
      "removeStep": "Schritt entfernen",
      "addStep": "Schritt hinzufügen (höchstens {{max}})",
      "brandKit": "Brand-Kit für Dateien",
      "brandKitAsChat": "Wie im Chat (deine Auswahl, sonst Organisation)",
      "brandKitNone": "Ohne Brand-Kit",
      "brandKitGone": "Gewähltes Kit nicht mehr verfügbar",
      "tasks": "Gespeicherte Aufträge",
      "tasksHint": "Erscheinen im Gruppenchat als Knöpfe über dem Eingabefeld. Teile in {geschweiften Klammern} füllst du vor dem Senden aus, z. B. „Prüft alles zu {Produkt}“.",
      "taskTitle": "Titel",
      "taskText": "Auftrag",
      "taskTitlePlaceholder": "z. B. Wochenprüfung",
      "taskTextPlaceholder": "z. B. Prüft alles zu {Produkt}",
      "addTask": "Auftrag hinzufügen",
      "removeTask": "Auftrag entfernen",
      "seedTasks": {
        "check": "Thema prüfen",
        "presentation": "Kundenpräsentation"
      }
    },
    "projectCounts_one": "{{count}} Datei erstellt",
    "projectCounts_other": "{{count}} Dateien erstellt",
    "conflict": {
      "title": "Widerspruch · bitte entscheiden",
      "intro": "{{checker}} und {{editor}} konnten das nicht auflösen. Was gilt? Erst deine Entscheidung ändert das Brain.",
      "evidence": "Beleg des Prüfers",
      "newText": "Fakt, wie er gelten soll",
      "correct": "Korrigieren",
      "keep": "Bestätigen wie er ist",
      "reject": "Ablehnen",
      "later": "Später",
      "open_one": "{{count}} Widerspruch zu entscheiden",
      "open_other": "{{count}} Widersprüche zu entscheiden",
      "decided": {
        "update": "Korrigiert, im Brain übernommen",
        "verify": "Bestätigt, im Brain übernommen",
        "reject": "Abgelehnt, im Brain übernommen",
        "later": "Zurückgestellt, nichts geändert"
      }
    }
  },
  "control": {
    "title": "cdbControl",
    "scope": "Alle Aufgaben gelten für den ganzen Mandanten.",
    "loading": "Aufgaben werden geladen …",
    "loadError": "Die Aufgaben konnten nicht geladen werden.",
    "retry": "Erneut versuchen",
    "empty": "Noch keine Aufgaben. Legen Sie die erste an oder übernehmen Sie Aufgaben aus einer Aufnahme im Knowledge Extractor.",
    "noMatch": "Keine Aufgabe passt zu den Filtern.",
    "notFound": "Diese Aufgabe gibt es nicht mehr.",
    "back": "Zurück zur Übersicht",
    "noDue": "Ohne Deadline",
    "overdue": "überfällig",
    "ai": "KI",
    "unknownPerson": "Unbekannte Person",
    "visibleFor": "Sichtbar für: alle im Mandanten",
    "moveTo": "Nach „{{status}}“ verschieben",
    "nav": {
      "all": "Alle Aufgaben",
      "new": "Aufgabe anlegen",
      "later": "Später",
      "mine": "Meine Aufgaben",
      "departments": "Abteilungen",
      "documents": "Aus Dokumenten"
    },
    "view": {
      "list": "Liste",
      "board": "Kanban"
    },
    "tiles": {
      "overdue": "Überfällig",
      "dueThisWeek": "Diese Woche fällig",
      "unassigned": "Ohne Verantwortliche",
      "newFromRecordings": "Neu aus Aufnahmen"
    },
    "filter": {
      "origin": "Herkunft",
      "origins": {
        "all": "Alle",
        "recording": "Aufnahmen",
        "manual": "Manuell"
      },
      "everyone": "Alle",
      "unassigned": "Nicht zugewiesen",
      "showDone": "Erledigte zeigen"
    },
    "fields": {
      "title": "Aufgabe",
      "description": "Beschreibung",
      "source": "Quelle",
      "assignee": "Verantwortlich",
      "due": "Deadline",
      "status": "Status"
    },
    "status": {
      "open": "Offen",
      "in_progress": "In Arbeit",
      "done": "Erledigt"
    },
    "origin": {
      "manual": "Von Hand",
      "recordingGone": "Aufnahme gelöscht",
      "recordingUntitled": "Aufnahme ohne Titel"
    },
    "form": {
      "heading": "Aufgabe anlegen",
      "titlePlaceholder": "Was ist zu tun?",
      "submit": "Aufgabe anlegen",
      "cancel": "Abbrechen",
      "failed": "Die Aufgabe konnte nicht angelegt werden. Bitte versuchen Sie es erneut.",
      "originHint": "Von Hand angelegt, ohne Quelle. Aufgaben aus Aufnahmen übernehmen Sie im Knowledge Extractor."
    },
    "detail": {
      "fromRecording": "Aus der Aufnahme „{{title}}“ abgeleitet",
      "passage": "Stelle {{at}}",
      "derivedFrom": "Abgeleitet aus",
      "origin": "Herkunft",
      "recordedOn": "Aufgenommen am {{date}}",
      "aiHint": "Von der KI vorgeschlagen, übernommen von {{name}}",
      "openRecording": "Im Knowledge Extractor öffnen",
      "manual": "Von Hand angelegt von {{name}} am {{date}}, ohne Quelle.",
      "history": "Verlauf",
      "saveFailed": "Die Änderung konnte nicht gespeichert werden."
    },
    "history": {
      "created": "Aufgabe angelegt",
      "filed": "Aus der Aufnahme übernommen",
      "status": "Status: {{to}}",
      "assignee": "Verantwortlich: {{to}}",
      "due": "Deadline: {{to}}",
      "dueCleared": "Deadline entfernt",
      "title": "Titel geändert",
      "description": "Beschreibung geändert"
    }
  },
  "wissenshaus": {
    "title": "Was im Brain passiert ist",
    "loading": "Das Haus wird gebaut …",
    "organisation": "Organisation",
    "organisationHint": "Organisation wechseln (nur für Admins; auf Production mit Staff-Freischaltung)",
    "ownOrganisation": "Eigene Organisation",
    "rangeLabel": "Zeitraum",
    "range": {
      "heute": "Heute",
      "woche": "Letzte 7 Tage",
      "monat": "Letzte 30 Tage"
    },
    "lead": {
      "heute_one": "Heute kam {{count}} neues Dokument dazu.",
      "heute_other": "Heute kamen {{count}} neue Dokumente dazu.",
      "woche_one": "In den letzten 7 Tagen kam {{count}} neues Dokument dazu.",
      "woche_other": "In den letzten 7 Tagen kamen {{count}} neue Dokumente dazu.",
      "monat_one": "In den letzten 30 Tagen kam {{count}} neues Dokument dazu.",
      "monat_other": "In den letzten 30 Tagen kamen {{count}} neue Dokumente dazu."
    },
    "stand": "Stand {{date}}",
    "houseCrumb": "{{name}} · ganzes Haus",
    "house": "Ganzes Haus",
    "aiSummary": "KI-Zusammenfassung",
    "summaryPending": "Die KI-Zusammenfassung kommt mit dem nächsten Ausbau. Bis dahin zeigt das Haus die Zahlen aus den Dokumenten.",
    "stats": {
      "newDocuments": "neue Dokumente",
      "newFacts": "neue Fakten im Graphen",
      "chat": "Fragen im Chat",
      "activeRooms": "Räume mit Bewegung"
    },
    "connections": {
      "title": "Zusammenhänge zwischen Räumen",
      "pruefen": "Bitte prüfen",
      "zus": "Zusammenhang",
      "luecke": "Lücke"
    },
    "moved": "Was sich in den Räumen bewegt hat",
    "docsShort_one": "+{{count}} Dok.",
    "docsShort_other": "+{{count}} Dok.",
    "noAccess": "kein Zugang",
    "lockedNotice": "Du hast keinen Zugang zu diesem Raum. Den Zugang vergibt die Verwaltung der Bereiche.",
    "rightsNote": "Das Haus zeigt nur deine Organisation und die Bereiche, die du betreten darfst. Wer weniger Rechte hat, sieht weniger.",
    "nothingNew": "In diesem Zeitraum ist nichts Neues eingegangen.",
    "topicsPending": "Die Themen eines Bereichs kommen mit dem nächsten Ausbau aus dem Wissensgraphen.",
    "hintHouse": "Ziehen zum Drehen · Klick auf einen Raum geht hinein · Klick auf Baum, Kran oder Infowand erklärt sie",
    "hintRoom": "Klick auf eine Leinwand öffnet sie im Panel · Esc geht zurück",
    "stageLabel": "Isometrisches Haus mit den Wissensbereichen als Räume. Alle Inhalte stehen auch im Panel.",
    "day": {
      "today": "heute",
      "yesterday": "gestern",
      "ago_one": "vor {{count}} Tag",
      "ago_other": "vor {{count}} Tagen"
    },
    "room": {
      "area": "Wissensbereich",
      "forAll": "für alle offen",
      "documents_one": "{{count}} Dokument",
      "documents_other": "{{count}} Dokumente",
      "owner": "gepflegt von {{owner}}",
      "latest": "Neueste Dokumente",
      "topicsTitle": "Worüber hier gerade gesprochen wird"
    },
    "screen": {
      "neu": "Neu eingegangen",
      "themen": "Themen",
      "ai": "KI",
      "nothingNew": "Nichts Neues im Zeitraum",
      "noTopics": "Themen kommen mit dem nächsten Ausbau aus dem Wissensgraphen.",
      "forAll": "für alle",
      "digestFallback": "{{docs}} neue Dokumente, {{facts}} neue Fakten. Die KI-Zusammenfassung folgt.",
      "mentions_one": "{{count}} Erwähnung",
      "mentions_other": "{{count}} Erwähnungen",
      "sign": "Wissenshaus · {{open}} Bereiche offen · {{locked}} verschlossen",
      "building": "Haus {{letter}}",
      "flag": "Wissenshaus"
    },
    "tour": {
      "title": "Rundgang",
      "start": "Rundgang starten",
      "hint": "alle Räume mit Neuigkeiten nacheinander, gut fürs Teammeeting",
      "progress": "{{name}} · {{index}} von {{total}}",
      "pause": "Pause",
      "resume": "Weiter",
      "stop": "Beenden",
      "none": "Im gewählten Zeitraum gibt es keine Neuigkeiten."
    },
    "view": {
      "title": "Ansicht",
      "motion": "Bewegung",
      "voll": "Voll",
      "ruhig": "Ruhig",
      "aus": "Aus",
      "light": "Licht",
      "auto": "Jetzt",
      "tag": "Tag",
      "abend": "Abend",
      "note": "„Ruhig“ spart Rechenleistung: Ringe und Fäden bewegen sich, aber die Menschen bleiben stehen, es fallen keine Dokumente, kein Schnee und kein Laub, Wolken, Kräne und Windräder stehen still, und die Fahne auch. „Aus“ hält alles an und zeichnet nur neu, wenn du etwas tust. „Passend“ nimmt das Hausdesign deiner Organisation. Windräder sind nur Schmuck.",
      "season": "Jahreszeit",
      "seasons": {
        "fruehling": "Frühling",
        "sommer": "Sommer",
        "herbst": "Herbst",
        "winter": "Winter"
      },
      "design": "Hausdesign",
      "designs": {
        "auto": "Passend",
        "modern": "Modern",
        "backstein": "Backstein",
        "holz": "Holz"
      },
      "wind": "Windräder",
      "windOptions": {
        "aus": "Aus",
        "an": "An"
      }
    },
    "error": {
      "load": "Das Wissenshaus konnte nicht geladen werden.",
      "noOrganisation": "Dein Konto gehört zu keiner Organisation. Ohne Organisation gibt es kein Wissenshaus.",
      "forbidden": "Diese Organisation kannst du nicht öffnen. Für eine fremde Organisation brauchst du eine aktive Staff-Freischaltung.",
      "retry": "Erneut versuchen",
      "webgl": "Dieser Browser kann die 3D-Ansicht nicht zeigen. Alle Inhalte stehen im Panel."
    },
    "askRoom": "Frag den Raum",
    "askRoomHint": "Öffnet cdbChat daneben. Die erste Frage sucht nur in diesem Wissensbereich.",
    "legend": {
      "title": "Legende",
      "heading": "Was bedeutet was?",
      "ring": "Ring am Boden: neue Dokumente im Zeitraum, je größer, desto mehr",
      "screens": "Drei Leinwände an der Rückwand: Zusammenfassung, neu Eingegangenes und Themen. Der Streifen darunter leuchtet orange, wenn es Neues gibt",
      "threads": "Lichtfaden: Zusammenhang zwischen Räumen, rot heißt bitte prüfen. Ein Klick zeigt, worum es geht",
      "locked": "Geschlossener grauer Raum: kein Zugang, nur der Name ist zu sehen",
      "lamps": "Abends brennt Licht, wo heute gearbeitet wurde; Laternen und Logo am Eingang leuchten",
      "cards": "Papier von oben: ein hochgeladenes Dokument kommt an (nur bei Bewegung „Voll“)",
      "people": "Menschen: sitzen und gehen in Räumen mit neuen Dokumenten, Besuch kommt zum Eingang. Ein Platzhalter, später nach den Fragen im Chat",
      "tree": "Wissensbaum neben dem Haus: wächst mit den neuen Fakten im Graphen, mehr Themen geben mehr Kronen",
      "crane": "Kran: ein Bereich im Aufbau, noch unter 400 Dokumenten",
      "infowall": "Infowand auf dem Dach: neue Dokumente, neue Fakten und Räume mit Bewegung im Zeitraum"
    },
    "objects": {
      "inRange": {
        "heute": "heute",
        "woche": "in den letzten 7 Tagen",
        "monat": "in den letzten 30 Tagen"
      },
      "tree": {
        "title": "Wissensbaum",
        "text_one": "Er wächst mit den neuen Fakten im Graphen: {{facts}} neuer Fakt {{range}}. Die Kronen stehen für {{topics}} Themen in den Bereichen. Die fallenden Blätter sind nur Schmuck.",
        "text_other": "Er wächst mit den neuen Fakten im Graphen: {{facts}} neue Fakten {{range}}. Die Kronen stehen für {{topics}} Themen in den Bereichen. Die fallenden Blätter sind nur Schmuck."
      },
      "crane": {
        "title": "{{name}} im Aufbau",
        "text_one": "Dieser Bereich hat erst {{total}} Dokument, weniger als 400. Der Kran verschwindet, sobald er gewachsen ist.",
        "text_other": "Dieser Bereich hat erst {{total}} Dokumente, weniger als 400. Der Kran verschwindet, sobald er gewachsen ist."
      },
      "infowall": {
        "title": "Infowand",
        "text": "Zeigt die Zahlen des gewählten Zeitraums für das ganze Haus: neue Dokumente, neue Fakten im Graphen und Räume mit Bewegung. Eine KI-Zusammenfassung kommt später dazu."
      },
      "cafe": {
        "title": "Kaffeebar",
        "text": "Nur Schmuck: ein Treffpunkt im Foyer. Sie zeigt keine Daten."
      },
      "clouds": {
        "title": "Wolken",
        "text": "Nur Schmuck, sie zeigen keine Daten."
      },
      "wind": {
        "title": "Windräder",
        "text": "Nur Schmuck. Unter „Ansicht“ lassen sie sich ein- und ausschalten."
      },
      "van": {
        "title": "Lieferwagen",
        "text_one": "{{docs}} neues Dokument {{range}}. Ist ein hochgeladenes darunter, trägt ab und zu jemand ein Paket ins Haus (nur bei Bewegung „Voll“).",
        "text_other": "{{docs}} neue Dokumente {{range}}. Sind hochgeladene darunter, trägt ab und zu jemand ein Paket ins Haus (nur bei Bewegung „Voll“)."
      },
      "people": {
        "title": "Menschen",
        "text": "Platzhalter: Wie viele Menschen im Haus sitzen und gehen, richtet sich nach den neuen Dokumenten im Zeitraum, später nach den Fragen im Chat."
      }
    },
    "answerUsed": "Die Antwort im Chat stützt sich auf:",
    "answerUsedClose": "Hinweis schließen"
  },
  "externalApp": {
    "openInTab": "Im neuen Tab öffnen",
    "loading": "Seite wird geladen …",
    "emptyHint": "Bleibt das Fenster leer, erlaubt die Seite keine Einbettung.",
    "slowTitle": "Die Seite lädt nicht",
    "slowBody": "Vielleicht erlaubt sie keine Einbettung oder braucht eine Anmeldung, die im Fenster nicht funktioniert. Im neuen Tab klappt es meist.",
    "cannotFrameTitle": "Diese Adresse lässt sich nicht im Fenster öffnen",
    "cannotFrameBody": "Im Fenster laufen nur https-Seiten von einer anderen Adresse als cdbOS. Öffnen Sie die App im neuen Tab.",
    "tabModeBody": "Diese App ist auf „Im Browser-Tab“ eingestellt."
  },
  "documentVersions": {
    "badge": {
      "current": "v{{version}}",
      "superseded": "Ältere Version (v{{version}})",
      "archived": "Archiviert (v{{version}})",
      "currentHint": "Aktuelle Version {{version}} dieses Dokuments",
      "supersededHint": "Abgelöste Version {{version}}: bleibt durchsuchbar, wird aber nachrangig gewertet",
      "archivedHint": "Archivierte Version {{version}}: nicht mehr in der Suche, weiterhin herunterladbar"
    },
    "showOlder": "Ältere Versionen anzeigen",
    "section": {
      "title": "Versionen",
      "empty": "Keine weiteren Versionen",
      "download": "Herunterladen",
      "uploadNew": "Neue Version hochladen",
      "state": {
        "current": "aktuell",
        "superseded": "abgelöst",
        "archived": "archiviert"
      },
      "loadFailed": "Versionen konnten nicht geladen werden."
    },
    "delete": {
      "chain_one": "Dokument löschen",
      "chain_other": "Alle {{count}} Versionen löschen",
      "versionOnly": "Nur diese Version löschen – v{{version}} wird wieder aktuell",
      "reprocessHint": "v{{version}} ist archiviert und wird dafür neu verarbeitet; sie ist erst danach wieder in der Suche.",
      "olderOnly": "Nur diese ältere Version wird gelöscht. Die aktuelle Version bleibt unverändert."
    }
  }
}
